(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("mobx"), require("mobxReact"), require("comsMobx"), require("weaPortalPublic"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ecCom", "antd", "ReactDOM", "mobx", "mobxReact", "comsMobx", "weaPortalPublic", "loadjs"], factory);
	else if(typeof exports === 'object')
		exports["weaPortalPublic"] = factory(require("React"), require("ecCom"), require("antd"), require("ReactDOM"), require("mobx"), require("mobxReact"), require("comsMobx"), require("weaPortalPublic"), require("loadjs"));
	else
		root["weaPortalPublic"] = factory(root["React"], root["ecCom"], root["antd"], root["ReactDOM"], root["mobx"], root["mobxReact"], root["comsMobx"], root["weaPortalPublic"], root["loadjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_93__, __WEBPACK_EXTERNAL_MODULE_158__, __WEBPACK_EXTERNAL_MODULE_159__, __WEBPACK_EXTERNAL_MODULE_165__, __WEBPACK_EXTERNAL_MODULE_428__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpweaPortalPublic"];
/******/ 	window["webpackJsonpweaPortalPublic"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		24: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = (window[__webpack_require__.v] || "") + __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + ".chunk.js?v=" + {"0":"3edf99c3","1":"c5f2cdb5","2":"28ac3353","3":"646b5b5f","4":"6e08920c","5":"797121f8","6":"dd6d95c0","7":"ea35cf54","8":"7c165616","9":"7ea4de89","10":"6e9c33e3","11":"e7c6a8e1","12":"5c37cc59","13":"eddaba30","14":"2c14fdcf","15":"3aa525a7","16":"5db34f21","17":"9c0e1cf2","18":"b4ab70bc","19":"3068eade","20":"0acce1da","21":"a125dd01","22":"3b6f7fc0","23":"9206e626"}[chunkId] + "";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/spa/portal/public/";
/******/
/******/ 	// __webpack_content_path__
/******/ 	__webpack_require__.v = "ecologyContentPath";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 243);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _typeof2 = __webpack_require__(55);
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _setPrototypeOf = __webpack_require__(100);
var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
var _create = __webpack_require__(101);
var _create2 = _interopRequireDefault(_create);
var _typeof2 = __webpack_require__(55);
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }
    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _defineProperty = __webpack_require__(77);
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
                descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _assign = __webpack_require__(57);
var _assign2 = _interopRequireDefault(_assign);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = _assign2.default || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (false) {
    var ReactIs = require('react-is');
    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
}
else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = __webpack_require__(354)();
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(109), __esModule: true };


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number')
    __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
    ? window : typeof self != 'undefined' && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();
if (typeof __g == 'number')
    __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(22)(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(8);
var ctx = __webpack_require__(56);
var hide = __webpack_require__(20);
var has = __webpack_require__(13);
var PROTOTYPE = 'prototype';
var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL)
        source = name;
    for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key))
            continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
            // bind timers to global for call from export context
            : IS_BIND && own ? ctx(out, global)
                // wrap global constructors for prevent change them in library
                : IS_WRAP && target[key] == out ? (function (C) {
                    var F = function (a, b, c) {
                        if (this instanceof C) {
                            switch (arguments.length) {
                                case 0: return new C();
                                case 1: return new C(a);
                                case 2: return new C(a, b);
                            }
                            return new C(a, b, c);
                        }
                        return C.apply(this, arguments);
                    };
                    F[PROTOTYPE] = C[PROTOTYPE];
                    return F;
                    // make static versions for prototype methods
                })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key])
                hide(expProto, key, out);
        }
    }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(63);
var toPrimitive = __webpack_require__(42);
var dP = Object.defineProperty;
exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE)
        try {
            return dP(O, P, Attributes);
        }
        catch (e) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes)
        throw TypeError('Accessors not supported!');
    if ('value' in Attributes)
        O[P] = Attributes.value;
    return O;
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _defineProperty = __webpack_require__(77);
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = function (obj, key, value) {
    if (key in obj) {
        (0, _defineProperty2.default)(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(41)('wks');
var uid = __webpack_require__(30);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';
var $exports = module.exports = function (name) {
    return store[name] || (store[name] =
        USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};
$exports.store = store;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var createDesc = __webpack_require__(26);
module.exports = __webpack_require__(10) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
    object[key] = value;
    return object;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(67);
var defined = __webpack_require__(39);
module.exports = function (it) {
    return IObject(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = function (exec) {
    try {
        return !!exec();
    }
    catch (e) {
        return true;
    }
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(19);
module.exports = function (it) {
    if (!isObject(it))
        throw TypeError(it + ' is not an object!');
    return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(169);
/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(39);
module.exports = function (it) {
    return Object(defined(it));
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
module.exports = isArray;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(66);
var enumBugKeys = __webpack_require__(45);
module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */
(function () {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg)
                continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') {
                classes.push(arg);
            }
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) {
                    classes.push(inner);
                }
            }
            else if (argType === 'object') {
                for (var key in arg) {
                    if (hasOwn.call(arg, key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
        return classes.join(' ');
    }
    if (typeof module !== 'undefined' && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    }
    else if (true) {
        // register as 'classnames', consistent with npm package name
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else {
        window.classNames = classNames;
    }
}());


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */
var warning = function () { };
if (false) {
    warning = function (condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for (var key = 2; key < len; key++) {
            args[key - 2] = arguments[key];
        }
        if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' +
                'message argument');
        }
        if (format.length < 10 || (/^[s\W]*$/).test(format)) {
            throw new Error('The warning format should be able to uniquely identify this ' +
                'warning. Please, use a more descriptive format than: ' + format);
        }
        if (!condition) {
            var argIndex = 0;
            var message = 'Warning: ' +
                format.replace(/%s/g, function () {
                    return args[argIndex++];
                });
            if (typeof console !== 'undefined') {
                console.error(message);
            }
            try {
                // This error was thrown as a convenience so that you can use this stack
                // to find the callsite that caused this warning to fire.
                throw new Error(message);
            }
            catch (x) { }
        }
    };
}
module.exports = warning;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/**
 * 添加多级路径
 *
 * @param {*} url
 */var addContentPath=exports.addContentPath=function addContentPath(url){var ecologyContentPath=window.ecologyContentPath;if(url&&ecologyContentPath){if(url.startsWith('/')&&!url.startsWith(ecologyContentPath)){url=ecologyContentPath+url;}}return url;};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
exports.default = function (obj, keys) {
    var target = {};
    for (var i in obj) {
        if (keys.indexOf(i) >= 0)
            continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i))
            continue;
        target[i] = obj[i];
    }
    return target;
};


/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(12).f;
var has = __webpack_require__(13);
var TAG = __webpack_require__(18)('toStringTag');
module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG))
        def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
    if (it == undefined)
        throw TypeError("Can't call method on  " + it);
    return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(41)('keys');
var uid = __webpack_require__(30);
module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: core.version,
    mode: __webpack_require__(27) ? 'pure' : 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(19);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
    if (!isObject(it))
        return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))
        return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))
        return val;
    throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(23);
var dPs = __webpack_require__(117);
var enumBugKeys = __webpack_require__(45);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var Empty = function () { };
var PROTOTYPE = 'prototype';
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(59)('iframe');
    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    __webpack_require__(102).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--)
        delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    }
    else
        result = createDict();
    return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = ('constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf').split(',');


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(18);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(27);
var wksExt = __webpack_require__(46);
var defineProperty = __webpack_require__(12).f;
module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol))
        defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(263), getValue = __webpack_require__(268);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(6);
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
function isWebpackReady(getModuleIds) {
    if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
        return false;
    }
    return getModuleIds().every(function (moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
    });
}
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function (loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function (err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function (key) {
            var result = load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            }
            else {
                state.loading = true;
            }
            promises.push(result.promise);
            result.promise.then(function (res) {
                state.loaded[key] = res;
            }).catch(function (err) {
                state.error = err;
            });
        });
    }
    catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function (res) {
        state.loading = false;
        return res;
    }).catch(function (err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function render(loaded, props) {
    return React.createElement(resolve(loaded), props);
}
function createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) {
        throw new Error("react-loadable requires a `loading` component");
    }
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) {
            res = loadFn(opts.loader);
        }
        return res.promise;
    }
    ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") {
        READY_INITIALIZERS.push(function () {
            if (isWebpackReady(opts.webpack)) {
                return init();
            }
        });
    }
    return _temp = _class = function (_React$Component) {
        _inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            _classCallCheck(this, LoadableComponent);
            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function () {
                _this.setState({ error: null, loading: true, timedOut: false });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) {
                opts.modules.forEach(function (moduleName) {
                    _this2.context.loadable.report(moduleName);
                });
            }
            if (!res.loading) {
                return;
            }
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this.setState({ pastDelay: true });
                }
                else {
                    this._delay = setTimeout(function () {
                        _this2.setState({ pastDelay: true });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(function () {
                    _this2.setState({ timedOut: true });
                }, opts.timeout);
            }
            var update = function update() {
                if (!_this2._mounted) {
                    return;
                }
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function () {
                update();
            }).catch(function (err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) {
                return React.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                    retry: this.retry
                });
            }
            else if (this.state.loaded) {
                return opts.render(this.state.loaded, this.props);
            }
            else {
                return null;
            }
        };
        return LoadableComponent;
    }(React.Component), _class.contextTypes = {
        loadable: PropTypes.shape({
            report: PropTypes.func.isRequired
        })
    }, _temp;
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function LoadableMap(opts) {
    if (typeof opts.render !== "function") {
        throw new Error("LoadableMap requires a `render(loaded, props)` function");
    }
    return createLoadableComponent(loadMap, opts);
}
Loadable.Map = LoadableMap;
var Capture = function (_React$Component2) {
    _inherits(Capture, _React$Component2);
    function Capture() {
        _classCallCheck(this, Capture);
        return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return React.Children.only(this.props.children);
    };
    return Capture;
}(React.Component);
Capture.propTypes = {
    report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
    loadable: PropTypes.shape({
        report: PropTypes.func.isRequired
    }).isRequired
};
Loadable.Capture = Capture;
function flushInitializers(initializers) {
    var promises = [];
    while (initializers.length) {
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function () {
        if (initializers.length) {
            return flushInitializers(initializers);
        }
    });
}
Loadable.preloadAll = function () {
    return new Promise(function (resolve, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
    });
};
Loadable.preloadReady = function () {
    return new Promise(function (resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = Loadable;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransform3dSupported = isTransform3dSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;
exports.getLeft = getLeft;
exports.getTop = getTop;
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
function toArray(children) {
    // allow [c,[a,b]]
    var c = [];
    _react2['default'].Children.forEach(children, function (child) {
        if (child) {
            c.push(child);
        }
    });
    return c;
}
function getActiveIndex(children, activeKey) {
    var c = toArray(children);
    for (var i = 0; i < c.length; i++) {
        if (c[i].key === activeKey) {
            return i;
        }
    }
    return -1;
}
function getActiveKey(children, index) {
    var c = toArray(children);
    return c[index].key;
}
function setTransform(style, v) {
    style.transform = v;
    style.webkitTransform = v;
    style.mozTransform = v;
}
function isTransform3dSupported(style) {
    return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}
function setTransition(style, v) {
    style.transition = v;
    style.webkitTransition = v;
    style.MozTransition = v;
}
function getTransformPropValue(v) {
    return {
        transform: v,
        WebkitTransform: v,
        MozTransform: v
    };
}
function isVertical(tabBarPosition) {
    return tabBarPosition === 'left' || tabBarPosition === 'right';
}
function getTransformByIndex(index, tabBarPosition) {
    var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
    return translate + '(' + -index * 100 + '%) translateZ(0)';
}
function getMarginStyle(index, tabBarPosition) {
    var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
    return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}
function getStyle(el, property) {
    return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}
function setPxStyle(el, value, vertical) {
    value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
    setTransform(el.style, 'translate3d(' + value + ')');
}
function getDataAttr(props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
}
function toNum(style, property) {
    return +style.getPropertyValue(property).replace('px', '');
}
function getTypeValue(start, current, end, tabNode, wrapperNode) {
    var total = getStyle(wrapperNode, 'padding-' + start);
    if (!tabNode || !tabNode.parentNode) {
        return total;
    }
    var childNodes = tabNode.parentNode.childNodes;
    Array.prototype.some.call(childNodes, function (node) {
        var style = window.getComputedStyle(node);
        if (node !== tabNode) {
            total += toNum(style, 'margin-' + start);
            total += node[current];
            total += toNum(style, 'margin-' + end);
            if (style.boxSizing === 'content-box') {
                total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
            }
            return false;
        }
        // We need count current node margin
        // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
        total += toNum(style, 'margin-' + start);
        return true;
    });
    return total;
}
function getLeft(tabNode, wrapperNode) {
    return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}
function getTop(tabNode, wrapperNode) {
    return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}


/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _iterator = __webpack_require__(113);
var _iterator2 = _interopRequireDefault(_iterator);
var _symbol = __webpack_require__(123);
var _symbol2 = _interopRequireDefault(_symbol);
var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(95);
module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined)
        return fn;
    switch (length) {
        case 1: return function (a) {
            return fn.call(that, a);
        };
        case 2: return function (a, b) {
            return fn.call(that, a, b);
        };
        case 3: return function (a, b, c) {
            return fn.call(that, a, b, c);
        };
    }
    return function ( /* ...args */) {
        return fn.apply(that, arguments);
    };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(137), __esModule: true };


/***/ }),
/* 58 */
/***/ (function(module, exports) {

var toString = {}.toString;
module.exports = function (it) {
    return toString.call(it).slice(8, -1);
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(19);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
    return is ? document.createElement(it) : {};
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(31);
var createDesc = __webpack_require__(26);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(42);
var has = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(63);
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE)
        try {
            return gOPD(O, P);
        }
        catch (e) { /* empty */ }
    if (has(O, P))
        return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var g;
// This works in non-strict mode
g = (function () {
    return this;
})();
try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
}
catch (e) {
    // This works if the window reference is available
    if (typeof window === "object")
        g = window;
}
// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}
module.exports = g;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(13);
var toObject = __webpack_require__(25);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO))
        return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
    }
    return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10) && !__webpack_require__(22)(function () {
    return Object.defineProperty(__webpack_require__(59)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(27);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(65);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(37);
var $iterCreate = __webpack_require__(116);
var setToStringTag = __webpack_require__(38);
var getPrototypeOf = __webpack_require__(62);
var ITERATOR = __webpack_require__(18)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function () { return this; };
module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
        if (!BUGGY && kind in proto)
            return proto[kind];
        switch (kind) {
            case KEYS: return function keys() { return new Constructor(this, kind); };
            case VALUES: return function values() { return new Constructor(this, kind); };
        }
        return function entries() { return new Constructor(this, kind); };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function')
                hide(IteratorPrototype, ITERATOR, returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() { return $native.call(this); };
    }
    // Define iterator
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
    }
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
        };
        if (FORCED)
            for (key in methods) {
                if (!(key in proto))
                    redefine(proto, key, methods[key]);
            }
        else
            $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(13);
var toIObject = __webpack_require__(21);
var arrayIndexOf = __webpack_require__(118)(false);
var IE_PROTO = __webpack_require__(40)('IE_PROTO');
module.exports = function (object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O)
        if (key != IE_PROTO)
            has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i)
        if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
        }
    return result;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(58);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(66);
var hiddenKeys = __webpack_require__(45).concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70), getRawTag = __webpack_require__(264), objectToString = __webpack_require__(265);
/** `Object#toString` result references. */
var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
}
module.exports = baseGetTag;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(24);
/** Built-in value references. */
var Symbol = root.Symbol;
module.exports = Symbol;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(85);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) {
        return value;
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
module.exports = toKey;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _objectWithoutProperties2 = __webpack_require__(35);
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames2 = __webpack_require__(32);
var _classnames3 = _interopRequireDefault(_classnames2);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var TabBarRootNode = function (_React$Component) {
    (0, _inherits3['default'])(TabBarRootNode, _React$Component);
    function TabBarRootNode() {
        (0, _classCallCheck3['default'])(this, TabBarRootNode);
        return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
    }
    (0, _createClass3['default'])(TabBarRootNode, [{
            key: 'render',
            value: function render() {
                var _props = this.props, prefixCls = _props.prefixCls, onKeyDown = _props.onKeyDown, className = _props.className, extraContent = _props.extraContent, style = _props.style, tabBarPosition = _props.tabBarPosition, children = _props.children, restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);
                var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
                var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
                var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
                var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
                var newChildren = children;
                if (extraContent) {
                    newChildren = [(0, _react.cloneElement)(extraContent, {
                            key: 'extra',
                            style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
                        }), (0, _react.cloneElement)(children, { key: 'content' })];
                    newChildren = topOrBottom ? newChildren : newChildren.reverse();
                }
                return _react2['default'].createElement('div', (0, _extends3['default'])({
                    role: 'tablist',
                    className: cls,
                    tabIndex: '0',
                    ref: this.props.saveRef('root'),
                    onKeyDown: onKeyDown,
                    style: style
                }, (0, _utils.getDataAttr)(restProps)), newChildren);
            }
        }]);
    return TabBarRootNode;
}(_react2['default'].Component);
exports['default'] = TabBarRootNode;
TabBarRootNode.propTypes = {
    prefixCls: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    style: _propTypes2['default'].object,
    tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
    children: _propTypes2['default'].node,
    extraContent: _propTypes2['default'].node,
    onKeyDown: _propTypes2['default'].func,
    saveRef: _propTypes2['default'].func
};
TabBarRootNode.defaultProps = {
    prefixCls: '',
    className: '',
    style: {},
    tabBarPosition: 'top',
    extraContent: null,
    children: null,
    onKeyDown: function onKeyDown() { },
    saveRef: function saveRef() { }
};
module.exports = exports['default'];


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var SaveRef = function (_React$Component) {
    (0, _inherits3['default'])(SaveRef, _React$Component);
    function SaveRef() {
        var _ref;
        var _temp, _this, _ret;
        (0, _classCallCheck3['default'])(this, SaveRef);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
            return _this[name];
        }, _this.saveRef = function (name) {
            return function (node) {
                if (node) {
                    _this[name] = node;
                }
            };
        }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }
    (0, _createClass3['default'])(SaveRef, [{
            key: 'render',
            value: function render() {
                return this.props.children(this.saveRef, this.getRef);
            }
        }]);
    return SaveRef;
}(_react2['default'].Component);
exports['default'] = SaveRef;
SaveRef.propTypes = {
    children: _propTypes2['default'].func
};
SaveRef.defaultProps = {
    children: function children() {
        return null;
    }
};
module.exports = exports['default'];


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyFromChildrenIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMenuIdFromSubMenuEventKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = loopMenuItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = loopMenuItemRecursively;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return menuAllProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function noop() { }
function getKeyFromChildrenIndex(child, menuEventKey, index) {
    var prefix = menuEventKey || '';
    return child.key || prefix + 'item_' + index;
}
function getMenuIdFromSubMenuEventKey(eventKey) {
    return eventKey + '-menu-';
}
function loopMenuItem(children, cb) {
    var index = -1;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
        index++;
        if (c && c.type && c.type.isMenuItemGroup) {
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(c.props.children, function (c2) {
                index++;
                cb(c2, index);
            });
        }
        else {
            cb(c, index);
        }
    });
}
function loopMenuItemRecursively(children, keys, ret) {
    /* istanbul ignore if */
    if (!children || ret.find) {
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (c) {
        if (c) {
            var construct = c.type;
            if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
                return;
            }
            if (keys.indexOf(c.key) !== -1) {
                ret.find = true;
            }
            else if (c.props.children) {
                loopMenuItemRecursively(c.props.children, keys, ret);
            }
        }
    });
}
var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements',
    // the following keys found need to be removed from test regression
    'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme'];


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(111), __esModule: true };


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(250), __esModule: true };


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(294), Map = __webpack_require__(142), Promise = __webpack_require__(295), Set = __webpack_require__(228), WeakMap = __webpack_require__(296), baseGetTag = __webpack_require__(69), toSource = __webpack_require__(170);
/** `Object#toString` result references. */
var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
    getTag = function (value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString: return dataViewTag;
                case mapCtorString: return mapTag;
                case promiseCtorString: return promiseTag;
                case setCtorString: return setTag;
                case weakMapCtorString: return weakMapTag;
            }
        }
        return result;
    };
}
module.exports = getTag;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(253), listCacheDelete = __webpack_require__(254), listCacheGet = __webpack_require__(255), listCacheHas = __webpack_require__(256), listCacheSet = __webpack_require__(257);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(141);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
        if (eq(array[length][0], key)) {
            return length;
        }
    }
    return -1;
}
module.exports = assocIndexOf;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49);
/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(277);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
}
module.exports = getMapData;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(177), baseKeys = __webpack_require__(211), isArrayLike = __webpack_require__(162);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(69), isObjectLike = __webpack_require__(51);
/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
}
module.exports = isSymbol;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(181), baseAssignValue = __webpack_require__(182);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
        var key = props[index];
        var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined;
        if (newValue === undefined) {
            newValue = source[key];
        }
        if (isNew) {
            baseAssignValue(object, key, newValue);
        }
        else {
            assignValue(object, key, newValue);
        }
    }
    return object;
}
module.exports = copyObject;


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
    /**
     * MAC_ENTER
     */
    MAC_ENTER: 3,
    /**
     * BACKSPACE
     */
    BACKSPACE: 8,
    /**
     * TAB
     */
    TAB: 9,
    /**
     * NUMLOCK on FF/Safari Mac
     */
    NUM_CENTER: 12,
    /**
     * ENTER
     */
    ENTER: 13,
    /**
     * SHIFT
     */
    SHIFT: 16,
    /**
     * CTRL
     */
    CTRL: 17,
    /**
     * ALT
     */
    ALT: 18,
    /**
     * PAUSE
     */
    PAUSE: 19,
    /**
     * CAPS_LOCK
     */
    CAPS_LOCK: 20,
    /**
     * ESC
     */
    ESC: 27,
    /**
     * SPACE
     */
    SPACE: 32,
    /**
     * PAGE_UP
     */
    PAGE_UP: 33,
    /**
     * PAGE_DOWN
     */
    PAGE_DOWN: 34,
    /**
     * END
     */
    END: 35,
    /**
     * HOME
     */
    HOME: 36,
    /**
     * LEFT
     */
    LEFT: 37,
    /**
     * UP
     */
    UP: 38,
    /**
     * RIGHT
     */
    RIGHT: 39,
    /**
     * DOWN
     */
    DOWN: 40,
    /**
     * PRINT_SCREEN
     */
    PRINT_SCREEN: 44,
    /**
     * INSERT
     */
    INSERT: 45,
    /**
     * DELETE
     */
    DELETE: 46,
    /**
     * ZERO
     */
    ZERO: 48,
    /**
     * ONE
     */
    ONE: 49,
    /**
     * TWO
     */
    TWO: 50,
    /**
     * THREE
     */
    THREE: 51,
    /**
     * FOUR
     */
    FOUR: 52,
    /**
     * FIVE
     */
    FIVE: 53,
    /**
     * SIX
     */
    SIX: 54,
    /**
     * SEVEN
     */
    SEVEN: 55,
    /**
     * EIGHT
     */
    EIGHT: 56,
    /**
     * NINE
     */
    NINE: 57,
    /**
     * QUESTION_MARK
     */
    QUESTION_MARK: 63,
    /**
     * A
     */
    A: 65,
    /**
     * B
     */
    B: 66,
    /**
     * C
     */
    C: 67,
    /**
     * D
     */
    D: 68,
    /**
     * E
     */
    E: 69,
    /**
     * F
     */
    F: 70,
    /**
     * G
     */
    G: 71,
    /**
     * H
     */
    H: 72,
    /**
     * I
     */
    I: 73,
    /**
     * J
     */
    J: 74,
    /**
     * K
     */
    K: 75,
    /**
     * L
     */
    L: 76,
    /**
     * M
     */
    M: 77,
    /**
     * N
     */
    N: 78,
    /**
     * O
     */
    O: 79,
    /**
     * P
     */
    P: 80,
    /**
     * Q
     */
    Q: 81,
    /**
     * R
     */
    R: 82,
    /**
     * S
     */
    S: 83,
    /**
     * T
     */
    T: 84,
    /**
     * U
     */
    U: 85,
    /**
     * V
     */
    V: 86,
    /**
     * W
     */
    W: 87,
    /**
     * X
     */
    X: 88,
    /**
     * Y
     */
    Y: 89,
    /**
     * Z
     */
    Z: 90,
    /**
     * META
     */
    META: 91,
    /**
     * WIN_KEY_RIGHT
     */
    WIN_KEY_RIGHT: 92,
    /**
     * CONTEXT_MENU
     */
    CONTEXT_MENU: 93,
    /**
     * NUM_ZERO
     */
    NUM_ZERO: 96,
    /**
     * NUM_ONE
     */
    NUM_ONE: 97,
    /**
     * NUM_TWO
     */
    NUM_TWO: 98,
    /**
     * NUM_THREE
     */
    NUM_THREE: 99,
    /**
     * NUM_FOUR
     */
    NUM_FOUR: 100,
    /**
     * NUM_FIVE
     */
    NUM_FIVE: 101,
    /**
     * NUM_SIX
     */
    NUM_SIX: 102,
    /**
     * NUM_SEVEN
     */
    NUM_SEVEN: 103,
    /**
     * NUM_EIGHT
     */
    NUM_EIGHT: 104,
    /**
     * NUM_NINE
     */
    NUM_NINE: 105,
    /**
     * NUM_MULTIPLY
     */
    NUM_MULTIPLY: 106,
    /**
     * NUM_PLUS
     */
    NUM_PLUS: 107,
    /**
     * NUM_MINUS
     */
    NUM_MINUS: 109,
    /**
     * NUM_PERIOD
     */
    NUM_PERIOD: 110,
    /**
     * NUM_DIVISION
     */
    NUM_DIVISION: 111,
    /**
     * F1
     */
    F1: 112,
    /**
     * F2
     */
    F2: 113,
    /**
     * F3
     */
    F3: 114,
    /**
     * F4
     */
    F4: 115,
    /**
     * F5
     */
    F5: 116,
    /**
     * F6
     */
    F6: 117,
    /**
     * F7
     */
    F7: 118,
    /**
     * F8
     */
    F8: 119,
    /**
     * F9
     */
    F9: 120,
    /**
     * F10
     */
    F10: 121,
    /**
     * F11
     */
    F11: 122,
    /**
     * F12
     */
    F12: 123,
    /**
     * NUMLOCK
     */
    NUMLOCK: 144,
    /**
     * SEMICOLON
     */
    SEMICOLON: 186,
    /**
     * DASH
     */
    DASH: 189,
    /**
     * EQUALS
     */
    EQUALS: 187,
    /**
     * COMMA
     */
    COMMA: 188,
    /**
     * PERIOD
     */
    PERIOD: 190,
    /**
     * SLASH
     */
    SLASH: 191,
    /**
     * APOSTROPHE
     */
    APOSTROPHE: 192,
    /**
     * SINGLE_QUOTE
     */
    SINGLE_QUOTE: 222,
    /**
     * OPEN_SQUARE_BRACKET
     */
    OPEN_SQUARE_BRACKET: 219,
    /**
     * BACKSLASH
     */
    BACKSLASH: 220,
    /**
     * CLOSE_SQUARE_BRACKET
     */
    CLOSE_SQUARE_BRACKET: 221,
    /**
     * WIN_KEY
     */
    WIN_KEY: 224,
    /**
     * MAC_FF_META
     */
    MAC_FF_META: 224,
    /**
     * WIN_IME
     */
    WIN_IME: 229,
    // ======================== Function ========================
    /**
     * whether text and modified key is entered at the same time.
     */
    isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
            keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
            return false;
        } // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch (keyCode) {
            case KeyCode.ALT:
            case KeyCode.CAPS_LOCK:
            case KeyCode.CONTEXT_MENU:
            case KeyCode.CTRL:
            case KeyCode.DOWN:
            case KeyCode.END:
            case KeyCode.ESC:
            case KeyCode.HOME:
            case KeyCode.INSERT:
            case KeyCode.LEFT:
            case KeyCode.MAC_FF_META:
            case KeyCode.META:
            case KeyCode.NUMLOCK:
            case KeyCode.NUM_CENTER:
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAUSE:
            case KeyCode.PRINT_SCREEN:
            case KeyCode.RIGHT:
            case KeyCode.SHIFT:
            case KeyCode.UP:
            case KeyCode.WIN_KEY:
            case KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
     * whether character is entered.
     */
    isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
            return true;
        }
        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
            return true;
        }
        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
            return true;
        } // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
            return true;
        }
        switch (keyCode) {
            case KeyCode.SPACE:
            case KeyCode.QUESTION_MARK:
            case KeyCode.NUM_PLUS:
            case KeyCode.NUM_MINUS:
            case KeyCode.NUM_PERIOD:
            case KeyCode.NUM_DIVISION:
            case KeyCode.SEMICOLON:
            case KeyCode.DASH:
            case KeyCode.EQUALS:
            case KeyCode.COMMA:
            case KeyCode.PERIOD:
            case KeyCode.SLASH:
            case KeyCode.APOSTROPHE:
            case KeyCode.SINGLE_QUOTE:
            case KeyCode.OPEN_SQUARE_BRACKET:
            case KeyCode.BACKSLASH:
            case KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _warning = __webpack_require__(33);
var _warning2 = _interopRequireDefault(_warning);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var TabBarTabsNode = function (_React$Component) {
    (0, _inherits3['default'])(TabBarTabsNode, _React$Component);
    function TabBarTabsNode() {
        (0, _classCallCheck3['default'])(this, TabBarTabsNode);
        return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
    }
    (0, _createClass3['default'])(TabBarTabsNode, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, children = _props.panels, activeKey = _props.activeKey, prefixCls = _props.prefixCls, tabBarGutter = _props.tabBarGutter, saveRef = _props.saveRef, tabBarPosition = _props.tabBarPosition, renderTabBarNode = _props.renderTabBarNode;
                var rst = [];
                _react2['default'].Children.forEach(children, function (child, index) {
                    if (!child) {
                        return;
                    }
                    var key = child.key;
                    var cls = activeKey === key ? prefixCls + '-tab-active' : '';
                    cls += ' ' + prefixCls + '-tab';
                    var events = {};
                    if (child.props.disabled) {
                        cls += ' ' + prefixCls + '-tab-disabled';
                    }
                    else {
                        events = {
                            onClick: _this2.props.onTabClick.bind(_this2, key)
                        };
                    }
                    var ref = {};
                    if (activeKey === key) {
                        ref.ref = saveRef('activeTab');
                    }
                    var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
                    var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : 'marginRight', gutter);
                    (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
                    var node = _react2['default'].createElement('div', (0, _extends3['default'])({
                        role: 'tab',
                        'aria-disabled': child.props.disabled ? 'true' : 'false',
                        'aria-selected': activeKey === key ? 'true' : 'false'
                    }, events, {
                        className: cls,
                        key: key,
                        style: style
                    }, ref), child.props.tab);
                    if (renderTabBarNode) {
                        node = renderTabBarNode(node);
                    }
                    rst.push(node);
                });
                return _react2['default'].createElement('div', { ref: saveRef('navTabsContainer') }, rst);
            }
        }]);
    return TabBarTabsNode;
}(_react2['default'].Component);
exports['default'] = TabBarTabsNode;
TabBarTabsNode.propTypes = {
    activeKey: _propTypes2['default'].string,
    panels: _propTypes2['default'].node,
    prefixCls: _propTypes2['default'].string,
    tabBarGutter: _propTypes2['default'].number,
    onTabClick: _propTypes2['default'].func,
    saveRef: _propTypes2['default'].func,
    renderTabBarNode: _propTypes2['default'].func,
    tabBarPosition: _propTypes2['default'].string
};
TabBarTabsNode.defaultProps = {
    panels: [],
    prefixCls: [],
    tabBarGutter: null,
    onTabClick: function onTabClick() { },
    saveRef: function saveRef() { }
};
module.exports = exports['default'];


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = exports.connect = exports.Provider = undefined;
var _Provider2 = __webpack_require__(393);
var _Provider3 = _interopRequireDefault(_Provider2);
var _connect2 = __webpack_require__(394);
var _connect3 = _interopRequireDefault(_connect2);
var _create2 = __webpack_require__(397);
var _create3 = _interopRequireDefault(_create2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.Provider = _Provider3.default;
exports.connect = _connect3.default;
exports.create = _create3.default;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */
(function () {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
            var arg = arguments[i];
            if (!arg)
                continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') {
                classes.push(arg);
            }
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) {
                    classes.push(inner);
                }
            }
            else if (argType === 'object') {
                for (var key in arg) {
                    if (hasOwn.call(arg, key) && arg[key]) {
                        classes.push(key);
                    }
                }
            }
        }
        return classes.join(' ');
    }
    if (typeof module !== 'undefined' && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    }
    else if (true) {
        // register as 'classnames', consistent with npm package name
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return classNames;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else {
        window.classNames = classNames;
    }
}());


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_93__;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) {
            return false;
        }
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
        }
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') {
            return false;
        }
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !==
            'abcdefghijklmnopqrst') {
            return false;
        }
        return true;
    }
    catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (it) {
    if (typeof it != 'function')
        throw TypeError(it + ' is not a function!');
    return it;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(115)(true);
// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(64)(String, 'String', function (iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length)
        return { value: undefined, done: true };
    point = $at(O, index);
    this._i += point.length;
    return { value: point, done: false };
});


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(331);
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(11);
var core = __webpack_require__(8);
var fails = __webpack_require__(22);
module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(132), __esModule: true };


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(135), __esModule: true };


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120);
var global = __webpack_require__(9);
var hide = __webpack_require__(20);
var Iterators = __webpack_require__(37);
var TO_STRING_TAG = __webpack_require__(18)('toStringTag');
var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
    'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
    'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
    'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
    'TextTrackList,TouchList').split(',');
for (var i = 0; i < DOMIterables.length; i++) {
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG])
        hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 104 */
/***/ (function(module, exports) {



/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(24), stubFalse = __webpack_require__(291);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 106 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
    var Ctor = value && value.constructor, proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
    return value === proto;
}
module.exports = isPrototype;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (module) {
    if (!module.webpackPolyfill) {
        module.deprecate = function () { };
        module.paths = [];
        // module.parent = undefined by default
        if (!module.children)
            module.children = [];
        Object.defineProperty(module, "loaded", {
            enumerable: true,
            get: function () {
                return module.l;
            }
        });
        Object.defineProperty(module, "id", {
            enumerable: true,
            get: function () {
                return module.i;
            }
        });
        module.webpackPolyfill = 1;
    }
    return module;
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
    return function (value) {
        return func(value);
    };
}
module.exports = baseUnary;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
module.exports = __webpack_require__(8).Object.getPrototypeOf;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(25);
var $getPrototypeOf = __webpack_require__(62);
__webpack_require__(99)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
        return $getPrototypeOf(toObject(it));
    };
});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112);
var $Object = __webpack_require__(8).Object;
module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(11);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperty: __webpack_require__(12).f });


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(114), __esModule: true };


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
__webpack_require__(103);
module.exports = __webpack_require__(46).f('iterator');


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(39);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
    return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l)
            return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
            ? TO_STRING ? s.charAt(i) : a
            : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(44);
var descriptor = __webpack_require__(26);
var setToStringTag = __webpack_require__(38);
var IteratorPrototype = {};
// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(20)(IteratorPrototype, __webpack_require__(18)('iterator'), function () { return this; });
module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
    setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(12);
var anObject = __webpack_require__(23);
var getKeys = __webpack_require__(29);
module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i)
        dP.f(O, P = keys[i++], Properties[P]);
    return O;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(21);
var toLength = __webpack_require__(97);
var toAbsoluteIndex = __webpack_require__(119);
module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el)
            while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value)
                    return true;
                // Array#indexOf ignores holes, Array#includes - not
            }
        else
            for (; length > index; index++)
                if (IS_INCLUDES || index in O) {
                    if (O[index] === el)
                        return IS_INCLUDES || index || 0;
                }
        return !IS_INCLUDES && -1;
    };
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(121);
var step = __webpack_require__(122);
var Iterators = __webpack_require__(37);
var toIObject = __webpack_require__(21);
// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(64)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
    }
    if (kind == 'keys')
        return step(0, index);
    if (kind == 'values')
        return step(0, O[index]);
    return step(0, [index, O[index]]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function () { };


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
    return { value: value, done: !!done };
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(124), __esModule: true };


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
__webpack_require__(104);
__webpack_require__(130);
__webpack_require__(131);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(9);
var has = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(10);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(65);
var META = __webpack_require__(126).KEY;
var $fails = __webpack_require__(22);
var shared = __webpack_require__(41);
var setToStringTag = __webpack_require__(38);
var uid = __webpack_require__(30);
var wks = __webpack_require__(18);
var wksExt = __webpack_require__(46);
var wksDefine = __webpack_require__(47);
var enumKeys = __webpack_require__(127);
var isArray = __webpack_require__(128);
var anObject = __webpack_require__(23);
var isObject = __webpack_require__(19);
var toObject = __webpack_require__(25);
var toIObject = __webpack_require__(21);
var toPrimitive = __webpack_require__(42);
var createDesc = __webpack_require__(26);
var _create = __webpack_require__(44);
var gOPNExt = __webpack_require__(129);
var $GOPD = __webpack_require__(60);
var $GOPS = __webpack_require__(48);
var $DP = __webpack_require__(12);
var $keys = __webpack_require__(29);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
        get: function () { return dP(this, 'a', { value: 7 }).a; }
    })).a != 7;
}) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc)
        delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto)
        dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function (tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
} : function (it) {
    return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto)
        $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
        if (!D.enumerable) {
            if (!has(it, HIDDEN))
                dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
        }
        else {
            if (has(it, HIDDEN) && it[HIDDEN][key])
                it[HIDDEN][key] = false;
            D = _create(D, { enumerable: createDesc(0, false) });
        }
        return setSymbolDesc(it, key, D);
    }
    return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i)
        $defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))
        return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))
        return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))
        D.enumerable = true;
    return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
        if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)
            result.push(key);
    }
    return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
        if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))
            result.push(AllSymbols[key]);
    }
    return result;
};
// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
    $Symbol = function Symbol() {
        if (this instanceof $Symbol)
            throw TypeError('Symbol is not a constructor!');
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function (value) {
            if (this === ObjectProto)
                $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag))
                this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter)
            setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
        return wrap(tag);
    };
    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(68).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(31).f = $propertyIsEnumerable;
    $GOPS.f = $getOwnPropertySymbols;
    if (DESCRIPTORS && !__webpack_require__(27)) {
        redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }
    wksExt.f = function (name) {
        return wrap(wks(name));
    };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
for (var es6Symbols = (
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables').split(','), j = 0; es6Symbols.length > j;)
    wks(es6Symbols[j++]);
for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;)
    wksDefine(wellKnownSymbols[k++]);
$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function (key) {
        return has(SymbolRegistry, key += '')
            ? SymbolRegistry[key]
            : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym))
            throw TypeError(sym + ' is not a symbol!');
        for (var key in SymbolRegistry)
            if (SymbolRegistry[key] === sym)
                return key;
    },
    useSetter: function () { setter = true; },
    useSimple: function () { setter = false; }
});
$export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [it];
        var i = 1;
        var replacer, $replacer;
        while (arguments.length > i)
            args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!isObject(replacer) && it === undefined || isSymbol(it))
            return; // IE8 returns string on undefined
        if (!isArray(replacer))
            replacer = function (key, value) {
                if (typeof $replacer == 'function')
                    value = $replacer.call(this, key, value);
                if (!isSymbol(value))
                    return value;
            };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
    }
});
// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(20)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(30)('meta');
var isObject = __webpack_require__(19);
var has = __webpack_require__(13);
var setDesc = __webpack_require__(12).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
    return true;
};
var FREEZE = !__webpack_require__(22)(function () {
    return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
    setDesc(it, META, { value: {
            i: 'O' + ++id,
            w: {} // weak collections IDs
        } });
};
var fastKey = function (it, create) {
    // return primitive with prefix
    if (!isObject(it))
        return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it))
            return 'F';
        // not necessary to add metadata
        if (!create)
            return 'E';
        // add missing metadata
        setMeta(it);
        // return object ID
    }
    return it[META].i;
};
var getWeak = function (it, create) {
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it))
            return true;
        // not necessary to add metadata
        if (!create)
            return false;
        // add missing metadata
        setMeta(it);
        // return hash weak collections IDs
    }
    return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META))
        setMeta(it);
    return it;
};
var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(31);
module.exports = function (it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;
        while (symbols.length > i)
            if (isEnum.call(it, key = symbols[i++]))
                result.push(key);
    }
    return result;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(58);
module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(21);
var gOPN = __webpack_require__(68).f;
var toString = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function (it) {
    try {
        return gOPN(it);
    }
    catch (e) {
        return windowNames.slice();
    }
};
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('asyncIterator');


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('observable');


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133);
module.exports = __webpack_require__(8).Object.setPrototypeOf;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(11);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(134).set });


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(19);
var anObject = __webpack_require__(23);
var check = function (O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null)
        throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
        function (test, buggy, set) {
            try {
                set = __webpack_require__(56)(Function.call, __webpack_require__(60).f(Object.prototype, '__proto__').set, 2);
                set(test, []);
                buggy = !(test instanceof Array);
            }
            catch (e) {
                buggy = true;
            }
            return function setPrototypeOf(O, proto) {
                check(O, proto);
                if (buggy)
                    O.__proto__ = proto;
                else
                    set(O, proto);
                return O;
            };
        }({}, false) : undefined),
    check: check
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(136);
var $Object = __webpack_require__(8).Object;
module.exports = function create(P, D) {
    return $Object.create(P, D);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(11);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(44) });


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(11);
$export($export.S + $export.F, 'Object', { assign: __webpack_require__(139) });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(10);
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(31);
var toObject = __webpack_require__(25);
var IObject = __webpack_require__(67);
var $assign = Object.assign;
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(22)(function () {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) { B[k] = k; });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while (aLen > index) {
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key))
                T[key] = S[key];
        }
    }
    return T;
} : $assign;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(80), stackClear = __webpack_require__(258), stackDelete = __webpack_require__(259), stackGet = __webpack_require__(260), stackHas = __webpack_require__(261), stackSet = __webpack_require__(262);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
    return value === other || (value !== value && other !== other);
}
module.exports = eq;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49), root = __webpack_require__(24);
/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');
module.exports = Map;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(269), mapCacheDelete = __webpack_require__(276), mapCacheGet = __webpack_require__(278), mapCacheHas = __webpack_require__(279), mapCacheSet = __webpack_require__(280);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(288), stubArray = __webpack_require__(176);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
        return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length &&
        (type == 'number' ||
            (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}
module.exports = isIndex;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
    return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(169);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */
var nodeUtil = (function () {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
            return types;
        }
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    }
    catch (e) { }
}());
module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(149), toKey = __webpack_require__(71);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while (object != null && index < length) {
        object = object[toKey(path[index++])];
    }
    return (index && index == length) ? object : undefined;
}
module.exports = baseGet;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(28), isKey = __webpack_require__(150), stringToPath = __webpack_require__(300), toString = __webpack_require__(303);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
    if (isArray(value)) {
        return value;
    }
    return isKey(value, object) ? [value] : stringToPath(toString(value));
}
module.exports = castPath;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(28), isSymbol = __webpack_require__(85);
/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
    if (isArray(value)) {
        return false;
    }
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' ||
        value == null || isSymbol(value)) {
        return true;
    }
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
}
module.exports = isKey;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(177), baseKeysIn = __webpack_require__(335), isArrayLike = __webpack_require__(162);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(172);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransform3dSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["b"] = getDataAttr;
/* unused harmony export getLeft */
/* unused harmony export getTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


function toArray(children) {
    // allow [c,[a,b]]
    var c = [];
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
        if (child) {
            c.push(child);
        }
    });
    return c;
}
function getActiveIndex(children, activeKey) {
    var c = toArray(children);
    for (var i = 0; i < c.length; i++) {
        if (c[i].key === activeKey) {
            return i;
        }
    }
    return -1;
}
function getActiveKey(children, index) {
    var c = toArray(children);
    return c[index].key;
}
function setTransform(style, v) {
    style.transform = v;
    style.webkitTransform = v;
    style.mozTransform = v;
}
function isTransform3dSupported(style) {
    return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
}
function setTransition(style, v) {
    style.transition = v;
    style.webkitTransition = v;
    style.MozTransition = v;
}
function getTransformPropValue(v) {
    return {
        transform: v,
        WebkitTransform: v,
        MozTransform: v
    };
}
function isVertical(tabBarPosition) {
    return tabBarPosition === 'left' || tabBarPosition === 'right';
}
function getTransformByIndex(index, tabBarPosition) {
    var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
    return translate + '(' + -index * 100 + '%) translateZ(0)';
}
function getMarginStyle(index, tabBarPosition) {
    var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}
function getStyle(el, property) {
    return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
}
function setPxStyle(el, value, vertical) {
    value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
    setTransform(el.style, 'translate3d(' + value + ')');
}
function getDataAttr(props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
}
function toNum(style, property) {
    return +style.getPropertyValue(property).replace('px', '');
}
function getTypeValue(start, current, end, tabNode, wrapperNode) {
    var total = getStyle(wrapperNode, 'padding-' + start);
    if (!tabNode || !tabNode.parentNode) {
        return total;
    }
    var childNodes = tabNode.parentNode.childNodes;
    Array.prototype.some.call(childNodes, function (node) {
        var style = window.getComputedStyle(node);
        if (node !== tabNode) {
            total += toNum(style, 'margin-' + start);
            total += node[current];
            total += toNum(style, 'margin-' + end);
            if (style.boxSizing === 'content-box') {
                total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
            }
            return false;
        }
        // We need count current node margin
        // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
        total += toNum(style, 'margin-' + start);
        return true;
    });
    return total;
}
function getLeft(tabNode, wrapperNode) {
    return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
}
function getTop(tabNode, wrapperNode) {
    return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames2 = __webpack_require__(32);
var _classnames3 = _interopRequireDefault(_classnames2);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
function _componentDidUpdate(component, init) {
    var _component$props = component.props, styles = _component$props.styles, panels = _component$props.panels, activeKey = _component$props.activeKey;
    var rootNode = component.props.getRef('root');
    var wrapNode = component.props.getRef('nav') || rootNode;
    var inkBarNode = component.props.getRef('inkBar');
    var activeTab = component.props.getRef('activeTab');
    var inkBarNodeStyle = inkBarNode.style;
    var tabBarPosition = component.props.tabBarPosition;
    var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
    if (init) {
        // prevent mount animation
        inkBarNodeStyle.display = 'none';
    }
    if (activeTab) {
        var tabNode = activeTab;
        var transformSupported = (0, _utils.isTransform3dSupported)(inkBarNodeStyle);
        // Reset current style
        (0, _utils.setTransform)(inkBarNodeStyle, '');
        inkBarNodeStyle.width = '';
        inkBarNodeStyle.height = '';
        inkBarNodeStyle.left = '';
        inkBarNodeStyle.top = '';
        inkBarNodeStyle.bottom = '';
        inkBarNodeStyle.right = '';
        if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
            var left = (0, _utils.getLeft)(tabNode, wrapNode);
            var width = tabNode.offsetWidth;
            // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
            // It means no css working, then ink bar should not have width until css is loaded
            // Fix https://github.com/ant-design/ant-design/issues/7564
            if (width === rootNode.offsetWidth) {
                width = 0;
            }
            else if (styles.inkBar && styles.inkBar.width !== undefined) {
                width = parseFloat(styles.inkBar.width, 10);
                if (width) {
                    left += (tabNode.offsetWidth - width) / 2;
                }
            }
            // use 3d gpu to optimize render
            if (transformSupported) {
                (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
            }
            else {
                inkBarNodeStyle.left = left + 'px';
            }
            inkBarNodeStyle.width = width + 'px';
        }
        else {
            var top = (0, _utils.getTop)(tabNode, wrapNode, true);
            var height = tabNode.offsetHeight;
            if (styles.inkBar && styles.inkBar.height !== undefined) {
                height = parseFloat(styles.inkBar.height, 10);
                if (height) {
                    top += (tabNode.offsetHeight - height) / 2;
                }
            }
            if (transformSupported) {
                (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
                inkBarNodeStyle.top = '0';
            }
            else {
                inkBarNodeStyle.top = top + 'px';
            }
            inkBarNodeStyle.height = height + 'px';
        }
    }
    inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
}
var InkTabBarNode = function (_React$Component) {
    (0, _inherits3['default'])(InkTabBarNode, _React$Component);
    function InkTabBarNode() {
        (0, _classCallCheck3['default'])(this, InkTabBarNode);
        return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
    }
    (0, _createClass3['default'])(InkTabBarNode, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;
                // ref https://github.com/ant-design/ant-design/issues/8678
                // ref https://github.com/react-component/tabs/issues/135
                // InkTabBarNode need parent/root ref for calculating position
                // since parent componentDidMount triggered after child componentDidMount
                // we're doing a quick fix here to use setTimeout to calculate position
                // after parent/root component mounted
                this.timeout = setTimeout(function () {
                    _componentDidUpdate(_this2, true);
                }, 0);
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                _componentDidUpdate(this);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                clearTimeout(this.timeout);
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames;
                var _props = this.props, prefixCls = _props.prefixCls, styles = _props.styles, inkBarAnimated = _props.inkBarAnimated;
                var className = prefixCls + '-ink-bar';
                var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
                return _react2['default'].createElement('div', {
                    style: styles.inkBar,
                    className: classes,
                    key: 'inkBar',
                    ref: this.props.saveRef('inkBar')
                });
            }
        }]);
    return InkTabBarNode;
}(_react2['default'].Component);
exports['default'] = InkTabBarNode;
InkTabBarNode.propTypes = {
    prefixCls: _propTypes2['default'].string,
    styles: _propTypes2['default'].object,
    inkBarAnimated: _propTypes2['default'].bool,
    saveRef: _propTypes2['default'].func
};
InkTabBarNode.defaultProps = {
    prefixCls: '',
    inkBarAnimated: true,
    styles: {},
    saveRef: function saveRef() { }
};
module.exports = exports['default'];


/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_158__;

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_159__;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(290), isObjectLike = __webpack_require__(51);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () { return arguments; }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(292), baseUnary = __webpack_require__(108), nodeUtil = __webpack_require__(147);
/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(168), isLength = __webpack_require__(146);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(281), isObjectLike = __webpack_require__(51);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
        return true;
    }
    if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames2 = __webpack_require__(32);
var _classnames3 = _interopRequireDefault(_classnames2);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var TabContent = function (_React$Component) {
    (0, _inherits3['default'])(TabContent, _React$Component);
    function TabContent() {
        (0, _classCallCheck3['default'])(this, TabContent);
        return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
    }
    (0, _createClass3['default'])(TabContent, [{
            key: 'getTabPanes',
            value: function getTabPanes() {
                var props = this.props;
                var activeKey = props.activeKey;
                var children = props.children;
                var newChildren = [];
                _react2['default'].Children.forEach(children, function (child) {
                    if (!child) {
                        return;
                    }
                    var key = child.key;
                    var active = activeKey === key;
                    newChildren.push(_react2['default'].cloneElement(child, {
                        active: active,
                        destroyInactiveTabPane: props.destroyInactiveTabPane,
                        rootPrefixCls: props.prefixCls
                    }));
                });
                return newChildren;
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames;
                var props = this.props;
                var prefixCls = props.prefixCls, children = props.children, activeKey = props.activeKey, className = props.className, tabBarPosition = props.tabBarPosition, animated = props.animated, animatedWithMargin = props.animatedWithMargin;
                var style = props.style;
                var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
                if (animated) {
                    var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
                    if (activeIndex !== -1) {
                        var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
                        style = (0, _extends3['default'])({}, style, animatedStyle);
                    }
                    else {
                        style = (0, _extends3['default'])({}, style, {
                            display: 'none'
                        });
                    }
                }
                return _react2['default'].createElement('div', {
                    className: classes,
                    style: style
                }, this.getTabPanes());
            }
        }]);
    return TabContent;
}(_react2['default'].Component);
exports['default'] = TabContent;
TabContent.propTypes = {
    animated: _propTypes2['default'].bool,
    animatedWithMargin: _propTypes2['default'].bool,
    prefixCls: _propTypes2['default'].string,
    children: _propTypes2['default'].node,
    activeKey: _propTypes2['default'].string,
    style: _propTypes2['default'].any,
    tabBarPosition: _propTypes2['default'].string,
    className: _propTypes2['default'].string
};
TabContent.defaultProps = {
    animated: true
};
module.exports = exports['default'];


/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_165__;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ecCom=__webpack_require__(15);__webpack_require__(245);var _MaterialLibLeft=__webpack_require__(248);var _MaterialLibLeft2=_interopRequireDefault(_MaterialLibLeft);var _MaterialLibRight=__webpack_require__(249);var _MaterialLibRight2=_interopRequireDefault(_MaterialLibRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MaterialLib=function(_React$Component){(0,_inherits3.default)(MaterialLib,_React$Component);function MaterialLib(props){(0,_classCallCheck3.default)(this,MaterialLib);var _this=(0,_possibleConstructorReturn3.default)(this,(MaterialLib.__proto__||(0,_getPrototypeOf2.default)(MaterialLib)).call(this,props));_this.state={visible:true,hasRight:false,dir:'image/',maxUploadSize:100};_this.setVisible=_this.setVisible.bind(_this);_this.setDir=_this.setDir.bind(_this);return _this;}(0,_createClass3.default)(MaterialLib,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;_ecCom.WeaTools.callApi('/api/portal/materialLib/getRightStatus','GET',{}).then(function(result){_this2.setState({hasRight:result.right_status==1,maxUploadSize:result.maxUploadSize});});}},{key:'render',value:function render(){var _props=this.props,multiCheck=_props.multiCheck,isShow=_props.isShow;var _state=this.state,visible=_state.visible,hasRight=_state.hasRight,dir=_state.dir,maxUploadSize=_state.maxUploadSize;return visible?_react2.default.createElement(_ecCom.WeaLeftRightLayout,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLeftRightLayout@bssxqj',leftWidth:260,showLeft:true,leftCom:_react2.default.createElement(_MaterialLibLeft2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MaterialLibLeft@30pmmh',hasRight:hasRight,setDir:this.setDir}),children:_react2.default.createElement(_MaterialLibRight2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MaterialLibRight@pb3kc7',ref:'mlr',hasRight:hasRight,dir:dir,multiCheck:multiCheck,onLoading:this.props.onLoading,isShow:isShow,maxUploadSize:maxUploadSize})}):'';}},{key:'setVisible',value:function setVisible(visible){this.setState({visible:visible});}},{key:'setDir',value:function setDir(dir){this.setState({dir:dir});}},{key:'getCheckedFiles',value:function getCheckedFiles(){return this.refs.mlr.getCheckedFiles();}}]);return MaterialLib;}(_react2.default.Component);exports.default=MaterialLib;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(251), baseMatchesProperty = __webpack_require__(298), identity = __webpack_require__(212), isArray = __webpack_require__(28), property = __webpack_require__(308);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') {
        return value;
    }
    if (value == null) {
        return identity;
    }
    if (typeof value == 'object') {
        return isArray(value)
            ? baseMatchesProperty(value[0], value[1])
            : baseMatches(value);
    }
    return property(value);
}
module.exports = baseIteratee;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(69), isObject = __webpack_require__(50);
/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 170 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        }
        catch (e) { }
        try {
            return (func + '');
        }
        catch (e) { }
    }
    return '';
}
module.exports = toSource;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(226), arraySome = __webpack_require__(284), cacheHas = __webpack_require__(227);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
    }
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
    }
    var index = -1, result = true, seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while (++index < arrLength) {
        var arrValue = array[index], othValue = other[index];
        if (customizer) {
            var compared = isPartial
                ? customizer(othValue, arrValue, index, other, array, stack)
                : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
            if (compared) {
                continue;
            }
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                }
            })) {
                result = false;
                break;
            }
        }
        else if (!(arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(24);
/** Built-in value references. */
var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(174), getSymbols = __webpack_require__(144), keys = __webpack_require__(84);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(175), isArray = __webpack_require__(28);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
        array[offset + index] = values[index];
    }
    return array;
}
module.exports = arrayPush;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
    return [];
}
module.exports = stubArray;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(289), isArguments = __webpack_require__(160), isArray = __webpack_require__(28), isBuffer = __webpack_require__(105), isIndex = __webpack_require__(145), isTypedArray = __webpack_require__(161);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
            // Safari 9 has enumerable `arguments.length` in strict mode.
            key == 'length' ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == 'offset' || key == 'parent')) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                // Skip index properties.
                isIndex(key, length)))) {
            result.push(key);
        }
    }
    return result;
}
module.exports = arrayLikeKeys;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
    return function (arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
    return function (object) {
        if (object == null) {
            return false;
        }
        return object[key] === srcValue &&
            (srcValue !== undefined || (key in Object(object)));
    };
}
module.exports = matchesStrictComparable;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(182), eq = __webpack_require__(141);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
        (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
    }
}
module.exports = assignValue;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(231);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
    }
    else {
        object[key] = value;
    }
}
module.exports = baseAssignValue;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(175), getPrototype = __webpack_require__(184), getSymbols = __webpack_require__(144), stubArray = __webpack_require__(176);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
    var result = [];
    while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(178);
/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sentinel__ = __webpack_require__(186);












var TabPane = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);
    function TabPane() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TabPane);
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
    }
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TabPane, [{
            key: 'render',
            value: function render() {
                var _classnames;
                var _props = this.props, id = _props.id, className = _props.className, destroyInactiveTabPane = _props.destroyInactiveTabPane, active = _props.active, forceRender = _props.forceRender, rootPrefixCls = _props.rootPrefixCls, style = _props.style, children = _props.children, placeholder = _props.placeholder, restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);
                this._isActived = this._isActived || active;
                var prefixCls = rootPrefixCls + '-tabpane';
                var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
                var isRender = destroyInactiveTabPane ? active : this._isActived;
                var shouldRender = isRender || forceRender;
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["a" /* SentinelConsumer */], null, function (_ref) {
                    var sentinelStart = _ref.sentinelStart, sentinelEnd = _ref.sentinelEnd, setPanelSentinelStart = _ref.setPanelSentinelStart, setPanelSentinelEnd = _ref.setPanelSentinelEnd;
                    // Create sentinel
                    var panelSentinelStart = void 0;
                    var panelSentinelEnd = void 0;
                    if (active && shouldRender) {
                        panelSentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
                            setRef: setPanelSentinelStart,
                            prevElement: sentinelStart
                        });
                        panelSentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sentinel__["c" /* default */], {
                            setRef: setPanelSentinelEnd,
                            nextElement: sentinelEnd
                        });
                    }
                    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                        style: style,
                        role: 'tabpanel',
                        'aria-hidden': active ? 'false' : 'true',
                        className: cls,
                        id: id
                    }, Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* getDataAttr */])(restProps)), panelSentinelStart, shouldRender ? children : placeholder, panelSentinelEnd);
                });
            }
        }]);
    return TabPane;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (TabPane);
TabPane.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    forceRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    placeholder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
    rootPrefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};
TabPane.defaultProps = {
    placeholder: null
};


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SentinelProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentinelConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_create_react_context__);




/* eslint-disable jsx-a11y/no-noninteractive-tabindex */




var SentinelContext = __WEBPACK_IMPORTED_MODULE_7_create_react_context___default()({});
var SentinelProvider = SentinelContext.Provider;
var SentinelConsumer = SentinelContext.Consumer;
var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };
var Sentinel = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Sentinel, _React$Component);
    function Sentinel() {
        var _ref;
        var _temp, _this, _ret;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Sentinel);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
            var target = _ref2.target, which = _ref2.which, shiftKey = _ref2.shiftKey;
            var _this$props = _this.props, nextElement = _this$props.nextElement, prevElement = _this$props.prevElement;
            if (which !== __WEBPACK_IMPORTED_MODULE_6_rc_util_es_KeyCode__["a" /* default */].TAB || document.activeElement !== target)
                return;
            // Tab next
            if (!shiftKey && nextElement) {
                nextElement.focus();
            }
            // Tab prev
            if (shiftKey && prevElement) {
                prevElement.focus();
            }
        }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Sentinel, [{
            key: 'render',
            value: function render() {
                var setRef = this.props.setRef;
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
                    tabIndex: 0,
                    ref: setRef,
                    style: sentinelStyle,
                    onKeyDown: this.onKeyDown,
                    role: 'presentation'
                });
            }
        }]);
    return Sentinel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
Sentinel.propTypes = {
    setRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    prevElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    nextElement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["c"] = (Sentinel);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames5 = __webpack_require__(32);
var _classnames6 = _interopRequireDefault(_classnames5);
var _debounce = __webpack_require__(375);
var _debounce2 = _interopRequireDefault(_debounce);
var _resizeObserverPolyfill = __webpack_require__(236);
var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var ScrollableTabBarNode = function (_React$Component) {
    (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);
    function ScrollableTabBarNode(props) {
        (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);
        var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));
        _this.prevTransitionEnd = function (e) {
            if (e.propertyName !== 'opacity') {
                return;
            }
            var container = _this.props.getRef('container');
            _this.scrollToActiveTab({
                target: container,
                currentTarget: container
            });
        };
        _this.scrollToActiveTab = function (e) {
            var activeTab = _this.props.getRef('activeTab');
            var navWrap = _this.props.getRef('navWrap');
            if (e && e.target !== e.currentTarget || !activeTab) {
                return;
            }
            // when not scrollable or enter scrollable first time, don't emit scrolling
            var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
            _this.lastNextPrevShown = _this.isNextPrevShown();
            if (!needToSroll) {
                return;
            }
            var activeTabWH = _this.getScrollWH(activeTab);
            var navWrapNodeWH = _this.getOffsetWH(navWrap);
            var offset = _this.offset;
            var wrapOffset = _this.getOffsetLT(navWrap);
            var activeTabOffset = _this.getOffsetLT(activeTab);
            if (wrapOffset > activeTabOffset) {
                offset += wrapOffset - activeTabOffset;
                _this.setOffset(offset);
            }
            else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
                offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
                _this.setOffset(offset);
            }
        };
        _this.prev = function (e) {
            _this.props.onPrevClick(e);
            var navWrapNode = _this.props.getRef('navWrap');
            var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
            var offset = _this.offset;
            _this.setOffset(offset + navWrapNodeWH);
        };
        _this.next = function (e) {
            _this.props.onNextClick(e);
            var navWrapNode = _this.props.getRef('navWrap');
            var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
            var offset = _this.offset;
            _this.setOffset(offset - navWrapNodeWH);
        };
        _this.offset = 0;
        _this.state = {
            next: false,
            prev: false
        };
        return _this;
    }
    (0, _createClass3['default'])(ScrollableTabBarNode, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;
                this.componentDidUpdate();
                this.debouncedResize = (0, _debounce2['default'])(function () {
                    _this2.setNextPrev();
                    _this2.scrollToActiveTab();
                }, 200);
                this.resizeObserver = new _resizeObserverPolyfill2['default'](this.debouncedResize);
                this.resizeObserver.observe(this.props.getRef('container'));
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var props = this.props;
                if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
                    this.setOffset(0);
                    return;
                }
                var nextPrev = this.setNextPrev();
                // wait next, prev show hide
                /* eslint react/no-did-update-set-state:0 */
                if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
                    this.setState({}, this.scrollToActiveTab);
                }
                else if (!prevProps || props.activeKey !== prevProps.activeKey) {
                    // can not use props.activeKey
                    this.scrollToActiveTab();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.resizeObserver) {
                    this.resizeObserver.disconnect();
                }
                if (this.debouncedResize && this.debouncedResize.cancel) {
                    this.debouncedResize.cancel();
                }
            }
        }, {
            key: 'setNextPrev',
            value: function setNextPrev() {
                var navNode = this.props.getRef('nav');
                var navTabsContainer = this.props.getRef('navTabsContainer');
                var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
                // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
                // https://github.com/ant-design/ant-design/issues/13423
                var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
                var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
                var offset = this.offset;
                var minOffset = containerWH - navNodeWH;
                var _state = this.state, next = _state.next, prev = _state.prev;
                if (minOffset >= 0) {
                    next = false;
                    this.setOffset(0, false);
                    offset = 0;
                }
                else if (minOffset < offset) {
                    next = true;
                }
                else {
                    next = false;
                    // Fix https://github.com/ant-design/ant-design/issues/8861
                    // Test with container offset which is stable
                    // and set the offset of the nav wrap node
                    var realOffset = navWrapNodeWH - navNodeWH;
                    this.setOffset(realOffset, false);
                    offset = realOffset;
                }
                if (offset < 0) {
                    prev = true;
                }
                else {
                    prev = false;
                }
                this.setNext(next);
                this.setPrev(prev);
                return {
                    next: next,
                    prev: prev
                };
            }
        }, {
            key: 'getOffsetWH',
            value: function getOffsetWH(node) {
                var tabBarPosition = this.props.tabBarPosition;
                var prop = 'offsetWidth';
                if (tabBarPosition === 'left' || tabBarPosition === 'right') {
                    prop = 'offsetHeight';
                }
                return node[prop];
            }
        }, {
            key: 'getScrollWH',
            value: function getScrollWH(node) {
                var tabBarPosition = this.props.tabBarPosition;
                var prop = 'scrollWidth';
                if (tabBarPosition === 'left' || tabBarPosition === 'right') {
                    prop = 'scrollHeight';
                }
                return node[prop];
            }
        }, {
            key: 'getOffsetLT',
            value: function getOffsetLT(node) {
                var tabBarPosition = this.props.tabBarPosition;
                var prop = 'left';
                if (tabBarPosition === 'left' || tabBarPosition === 'right') {
                    prop = 'top';
                }
                return node.getBoundingClientRect()[prop];
            }
        }, {
            key: 'setOffset',
            value: function setOffset(offset) {
                var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var target = Math.min(0, offset);
                if (this.offset !== target) {
                    this.offset = target;
                    var navOffset = {};
                    var tabBarPosition = this.props.tabBarPosition;
                    var navStyle = this.props.getRef('nav').style;
                    var transformSupported = (0, _utils.isTransform3dSupported)(navStyle);
                    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
                        if (transformSupported) {
                            navOffset = {
                                value: 'translate3d(0,' + target + 'px,0)'
                            };
                        }
                        else {
                            navOffset = {
                                name: 'top',
                                value: target + 'px'
                            };
                        }
                    }
                    else if (transformSupported) {
                        navOffset = {
                            value: 'translate3d(' + target + 'px,0,0)'
                        };
                    }
                    else {
                        navOffset = {
                            name: 'left',
                            value: target + 'px'
                        };
                    }
                    if (transformSupported) {
                        (0, _utils.setTransform)(navStyle, navOffset.value);
                    }
                    else {
                        navStyle[navOffset.name] = navOffset.value;
                    }
                    if (checkNextPrev) {
                        this.setNextPrev();
                    }
                }
            }
        }, {
            key: 'setPrev',
            value: function setPrev(v) {
                if (this.state.prev !== v) {
                    this.setState({
                        prev: v
                    });
                }
            }
        }, {
            key: 'setNext',
            value: function setNext(v) {
                if (this.state.next !== v) {
                    this.setState({
                        next: v
                    });
                }
            }
        }, {
            key: 'isNextPrevShown',
            value: function isNextPrevShown(state) {
                if (state) {
                    return state.next || state.prev;
                }
                return this.state.next || this.state.prev;
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames, _classnames2, _classnames3, _classnames4;
                var _state2 = this.state, next = _state2.next, prev = _state2.prev;
                var _props = this.props, prefixCls = _props.prefixCls, scrollAnimated = _props.scrollAnimated, navWrapper = _props.navWrapper, prevIcon = _props.prevIcon, nextIcon = _props.nextIcon;
                var showNextPrev = prev || next;
                var prevButton = _react2['default'].createElement('span', {
                    onClick: prev ? this.prev : null,
                    unselectable: 'unselectable',
                    className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
                    onTransitionEnd: this.prevTransitionEnd
                }, prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' }));
                var nextButton = _react2['default'].createElement('span', {
                    onClick: next ? this.next : null,
                    unselectable: 'unselectable',
                    className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
                }, nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' }));
                var navClassName = prefixCls + '-nav';
                var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
                return _react2['default'].createElement('div', {
                    className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
                    key: 'container',
                    ref: this.props.saveRef('container')
                }, prevButton, nextButton, _react2['default'].createElement('div', { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') }, _react2['default'].createElement('div', { className: prefixCls + '-nav-scroll' }, _react2['default'].createElement('div', { className: navClasses, ref: this.props.saveRef('nav') }, navWrapper(this.props.children)))));
            }
        }]);
    return ScrollableTabBarNode;
}(_react2['default'].Component);
exports['default'] = ScrollableTabBarNode;
ScrollableTabBarNode.propTypes = {
    activeKey: _propTypes2['default'].string,
    getRef: _propTypes2['default'].func.isRequired,
    saveRef: _propTypes2['default'].func.isRequired,
    tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
    prefixCls: _propTypes2['default'].string,
    scrollAnimated: _propTypes2['default'].bool,
    onPrevClick: _propTypes2['default'].func,
    onNextClick: _propTypes2['default'].func,
    navWrapper: _propTypes2['default'].func,
    children: _propTypes2['default'].node,
    prevIcon: _propTypes2['default'].node,
    nextIcon: _propTypes2['default'].node
};
ScrollableTabBarNode.defaultProps = {
    tabBarPosition: 'left',
    prefixCls: '',
    scrollAnimated: true,
    onPrevClick: function onPrevClick() { },
    onNextClick: function onNextClick() { },
    navWrapper: function navWrapper(ele) {
        return ele;
    }
};
module.exports = exports['default'];


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(377);
/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(189);
/** Built-in value references. */
var Symbol = root.Symbol;
module.exports = Symbol;


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hammer__ = __webpack_require__(386);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Hammer__["a" /* default */]);


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.storeShape = undefined;
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var storeShape = exports.storeShape = _propTypes2.default.shape({
    subscribe: _propTypes2.default.func.isRequired,
    setState: _propTypes2.default.func.isRequired,
    getState: _propTypes2.default.func.isRequired
});


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) {
        this.setState(state);
    }
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    finally {
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) {
        throw new Error('Can only polyfill class components');
    }
    if (typeof Component.getDerivedStateFromProps !== 'function' &&
        typeof prototype.getSnapshotBeforeUpdate !== 'function') {
        return Component;
    }
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') {
        foundWillMountName = 'componentWillMount';
    }
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
        foundWillMountName = 'UNSAFE_componentWillMount';
    }
    if (typeof prototype.componentWillReceiveProps === 'function') {
        foundWillReceivePropsName = 'componentWillReceiveProps';
    }
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
        foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    }
    if (typeof prototype.componentWillUpdate === 'function') {
        foundWillUpdateName = 'componentWillUpdate';
    }
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
        foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    }
    if (foundWillMountName !== null ||
        foundWillReceivePropsName !== null ||
        foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function'
            ? 'getDerivedStateFromProps()'
            : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
            componentName +
            ' uses ' +
            newApiName +
            ' but also contains the following legacy lifecycles:' +
            (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
            (foundWillReceivePropsName !== null
                ? '\n  ' + foundWillReceivePropsName
                : '') +
            (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
            '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
            'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') {
            throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        }
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag
                ? this.__reactInternalSnapshot
                : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}



/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveKey;
/* unused harmony export saveRef */
/* unused harmony export SubPopupMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DOMWrap__ = __webpack_require__(399);













function allDisabled(arr) {
    if (!arr.length) {
        return true;
    }
    return arr.every(function (c) {
        return !!c.props.disabled;
    });
}
function updateActiveKey(store, menuId, activeKey) {
    var _extends2;
    var state = store.getState();
    store.setState({
        activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.activeKey, (_extends2 = {}, _extends2[menuId] = activeKey, _extends2))
    });
}
function getEventKey(props) {
    // when eventKey not available ,it's menu and return menu id '0-menu-'
    return props.eventKey || '0-menu-';
}
function getActiveKey(props, originalActiveKey) {
    var activeKey = originalActiveKey;
    var children = props.children, eventKey = props.eventKey;
    if (activeKey) {
        var found = void 0;
        Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
            if (c && !c.props.disabled && activeKey === Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i)) {
                found = true;
            }
        });
        if (found) {
            return activeKey;
        }
    }
    activeKey = null;
    if (props.defaultActiveFirst) {
        Object(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* loopMenuItem */])(children, function (c, i) {
            if (!activeKey && c && !c.props.disabled) {
                activeKey = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(c, eventKey, i);
            }
        });
        return activeKey;
    }
    return activeKey;
}
function saveRef(c) {
    if (c) {
        var index = this.instanceArray.indexOf(c);
        if (index !== -1) {
            // update component if it's already inside instanceArray
            this.instanceArray[index] = c;
        }
        else {
            // add component if it's not in instanceArray yet;
            this.instanceArray.push(c);
        }
    }
}
var SubPopupMenu = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SubPopupMenu, _React$Component);
    function SubPopupMenu(props) {
        var _extends3;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubPopupMenu);
        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        props.store.setState({
            activeKey: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props.store.getState().activeKey, (_extends3 = {}, _extends3[props.eventKey] = getActiveKey(props, props.activeKey), _extends3))
        });
        _this.instanceArray = [];
        return _this;
    }
    SubPopupMenu.prototype.componentDidMount = function componentDidMount() {
        // invoke customized ref to expose component to mixin
        if (this.props.manualRef) {
            this.props.manualRef(this);
        }
    };
    SubPopupMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return this.props.visible || nextProps.visible;
    };
    SubPopupMenu.prototype.componentDidUpdate = function componentDidUpdate() {
        var props = this.props;
        var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
        var activeKey = getActiveKey(props, originalActiveKey);
        if (activeKey !== originalActiveKey) {
            updateActiveKey(props.store, getEventKey(props), activeKey);
        }
    };
    // all keyboard events callbacks run from here at first
    SubPopupMenu.prototype.render = function render() {
        var _this2 = this;
        var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);
        this.instanceArray = [];
        var className = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
        var domProps = {
            className: className,
            // role could be 'select' and by default set to menu
            role: props.role || 'menu'
        };
        if (props.id) {
            domProps.id = props.id;
        }
        if (props.focusable) {
            domProps.tabIndex = '0';
            domProps.onKeyDown = this.onKeyDown;
        }
        var prefixCls = props.prefixCls, eventKey = props.eventKey, visible = props.visible;
        __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
            return delete props[key];
        });
        // Otherwise, the propagated click event will trigger another onClick
        delete props.onClick;
        return (
        // ESLint is not smart enough to know that the type of `children` was checked.
        /* eslint-disable */
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__DOMWrap__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
            tag: 'ul',
            hiddenClassName: prefixCls + '-hidden',
            visible: visible
        }, domProps), __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(props.children, function (c, i) {
            return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
        }))
        /*eslint-enable */
        );
    };
    return SubPopupMenu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
SubPopupMenu.propTypes = {
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
        getState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
        setState: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
    }),
    // adding in refactor
    focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
    triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['click', 'hover']),
    inlineIndent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
    manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubPopupMenu.defaultProps = {
    prefixCls: 'rc-menu',
    className: '',
    mode: 'vertical',
    level: 1,
    inlineIndent: 24,
    visible: true,
    focusable: true,
    style: {},
    manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onKeyDown = function (e, callback) {
        var keyCode = e.keyCode;
        var handled = void 0;
        _this3.getFlatInstanceArray().forEach(function (obj) {
            if (obj && obj.props.active && obj.onKeyDown) {
                handled = obj.onKeyDown(e);
            }
        });
        if (handled) {
            return 1;
        }
        var activeItem = null;
        if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN) {
            activeItem = _this3.step(keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP ? -1 : 1);
        }
        if (activeItem) {
            e.preventDefault();
            updateActiveKey(_this3.props.store, getEventKey(_this3.props), activeItem.props.eventKey);
            if (typeof callback === 'function') {
                callback(activeItem);
            }
            return 1;
        }
    };
    this.onItemHover = function (e) {
        var key = e.key, hover = e.hover;
        updateActiveKey(_this3.props.store, getEventKey(_this3.props), hover ? key : null);
    };
    this.onDeselect = function (selectInfo) {
        _this3.props.onDeselect(selectInfo);
    };
    this.onSelect = function (selectInfo) {
        _this3.props.onSelect(selectInfo);
    };
    this.onClick = function (e) {
        _this3.props.onClick(e);
    };
    this.onOpenChange = function (e) {
        _this3.props.onOpenChange(e);
    };
    this.onDestroy = function (key) {
        /* istanbul ignore next */
        _this3.props.onDestroy(key);
    };
    this.getFlatInstanceArray = function () {
        return _this3.instanceArray;
    };
    this.getOpenTransitionName = function () {
        return _this3.props.openTransitionName;
    };
    this.step = function (direction) {
        var children = _this3.getFlatInstanceArray();
        var activeKey = _this3.props.store.getState().activeKey[getEventKey(_this3.props)];
        var len = children.length;
        if (!len) {
            return null;
        }
        if (direction < 0) {
            children = children.concat().reverse();
        }
        // find current activeIndex
        var activeIndex = -1;
        children.every(function (c, ci) {
            if (c && c.props.eventKey === activeKey) {
                activeIndex = ci;
                return false;
            }
            return true;
        });
        if (!_this3.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
            return undefined;
        }
        var start = (activeIndex + 1) % len;
        var i = start;
        do {
            var child = children[i];
            if (!child || child.props.disabled) {
                i = (i + 1) % len;
            }
            else {
                return child;
            }
        } while (i !== start);
        return null;
    };
    this.renderCommonMenuItem = function (child, i, extraProps) {
        var state = _this3.props.store.getState();
        var props = _this3.props;
        var key = Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* getKeyFromChildrenIndex */])(child, props.eventKey, i);
        var childProps = child.props;
        var isActive = key === state.activeKey;
        var newChildProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
            mode: props.mode,
            level: props.level,
            inlineIndent: props.inlineIndent,
            renderMenuItem: _this3.renderMenuItem,
            rootPrefixCls: props.prefixCls,
            index: i,
            parentMenu: props.parentMenu,
            // customized ref function, need to be invoked manually in child's componentDidMount
            manualRef: childProps.disabled ? undefined : Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_createChainedFunction__["a" /* default */])(child.ref, saveRef.bind(_this3)),
            eventKey: key,
            active: !childProps.disabled && isActive,
            multiple: props.multiple,
            onClick: function onClick(e) {
                (childProps.onClick || __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */])(e);
                _this3.onClick(e);
            },
            onItemHover: _this3.onItemHover,
            openTransitionName: _this3.getOpenTransitionName(),
            openAnimation: props.openAnimation,
            subMenuOpenDelay: props.subMenuOpenDelay,
            subMenuCloseDelay: props.subMenuCloseDelay,
            forceSubMenuRender: props.forceSubMenuRender,
            onOpenChange: _this3.onOpenChange,
            onDeselect: _this3.onDeselect,
            onSelect: _this3.onSelect,
            builtinPlacements: props.builtinPlacements
        }, extraProps);
        if (props.mode === 'inline') {
            newChildProps.triggerSubMenuAction = 'click';
        }
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, newChildProps);
    };
    this.renderMenuItem = function (c, i, subMenuKey) {
        /* istanbul ignore if */
        if (!c) {
            return null;
        }
        var state = _this3.props.store.getState();
        var extraProps = {
            openKeys: state.openKeys,
            selectedKeys: state.selectedKeys,
            triggerSubMenuAction: _this3.props.triggerSubMenuAction,
            subMenuKey: subMenuKey
        };
        return _this3.renderCommonMenuItem(c, i, extraProps);
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["connect"])()(SubPopupMenu));


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
    var node = n;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
    /* eslint camelcase: 2 */
    var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
    } : cb;
    return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) {
        return a1[0] === a2[0];
    }
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    for (var placement in builtinPlacements) {
        if (builtinPlacements.hasOwnProperty(placement)) {
            if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
                return prefixCls + '-placement-' + placement;
            }
        }
    }
    return '';
}
function saveRef(name, component) {
    this[name] = component;
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(201);












var defaultKey = 'rc_animate_' + Date.now();
function getChildrenFromProps(props) {
    var children = props.children;
    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
        if (!children.key) {
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
                key: defaultKey
            });
        }
    }
    return children;
}
function noop() { }
var Animate = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);
    // eslint-disable-line
    function Animate(props) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);
        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
        _initialiseProps.call(_this);
        _this.currentlyAnimatingKeys = {};
        _this.keysToEnter = [];
        _this.keysToLeave = [];
        _this.state = {
            children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
        };
        _this.childrenRefs = {};
        return _this;
    }
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _this2 = this;
                var showProp = this.props.showProp;
                var children = this.state.children;
                if (showProp) {
                    children = children.filter(function (child) {
                        return !!child.props[showProp];
                    });
                }
                children.forEach(function (child) {
                    if (child) {
                        _this2.performAppear(child.key);
                    }
                });
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this3 = this;
                this.nextProps = nextProps;
                var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
                var props = this.props;
                // exclusive needs immediate response
                if (props.exclusive) {
                    Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
                        _this3.stop(key);
                    });
                }
                var showProp = props.showProp;
                var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
                // last props children if exclusive
                var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
                // in case destroy in showProp mode
                var newChildren = [];
                if (showProp) {
                    currentChildren.forEach(function (currentChild) {
                        var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
                        var newChild = void 0;
                        if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
                            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
                        }
                        else {
                            newChild = nextChild;
                        }
                        if (newChild) {
                            newChildren.push(newChild);
                        }
                    });
                    nextChildren.forEach(function (nextChild) {
                        if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
                            newChildren.push(nextChild);
                        }
                    });
                }
                else {
                    newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
                }
                // need render to avoid update
                this.setState({
                    children: newChildren
                });
                nextChildren.forEach(function (child) {
                    var key = child && child.key;
                    if (child && currentlyAnimatingKeys[key]) {
                        return;
                    }
                    var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
                    if (showProp) {
                        var showInNext = child.props[showProp];
                        if (hasPrev) {
                            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
                            if (!showInNow && showInNext) {
                                _this3.keysToEnter.push(key);
                            }
                        }
                        else if (showInNext) {
                            _this3.keysToEnter.push(key);
                        }
                    }
                    else if (!hasPrev) {
                        _this3.keysToEnter.push(key);
                    }
                });
                currentChildren.forEach(function (child) {
                    var key = child && child.key;
                    if (child && currentlyAnimatingKeys[key]) {
                        return;
                    }
                    var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
                    if (showProp) {
                        var showInNow = child.props[showProp];
                        if (hasNext) {
                            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
                            if (!showInNext && showInNow) {
                                _this3.keysToLeave.push(key);
                            }
                        }
                        else if (showInNow) {
                            _this3.keysToLeave.push(key);
                        }
                    }
                    else if (!hasNext) {
                        _this3.keysToLeave.push(key);
                    }
                });
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                var keysToEnter = this.keysToEnter;
                this.keysToEnter = [];
                keysToEnter.forEach(this.performEnter);
                var keysToLeave = this.keysToLeave;
                this.keysToLeave = [];
                keysToLeave.forEach(this.performLeave);
            }
        }, {
            key: 'isValidChildByKey',
            value: function isValidChildByKey(currentChildren, key) {
                var showProp = this.props.showProp;
                if (showProp) {
                    return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
                }
                return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
            }
        }, {
            key: 'stop',
            value: function stop(key) {
                delete this.currentlyAnimatingKeys[key];
                var component = this.childrenRefs[key];
                if (component) {
                    component.stop();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var props = this.props;
                this.nextProps = props;
                var stateChildren = this.state.children;
                var children = null;
                if (stateChildren) {
                    children = stateChildren.map(function (child) {
                        if (child === null || child === undefined) {
                            return child;
                        }
                        if (!child.key) {
                            throw new Error('must set key for <rc-animate> children');
                        }
                        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */], {
                            key: child.key,
                            ref: function ref(node) {
                                _this4.childrenRefs[child.key] = node;
                            },
                            animation: props.animation,
                            transitionName: props.transitionName,
                            transitionEnter: props.transitionEnter,
                            transitionAppear: props.transitionAppear,
                            transitionLeave: props.transitionLeave
                        }, child);
                    });
                }
                var Component = props.component;
                if (Component) {
                    var passedProps = props;
                    if (typeof Component === 'string') {
                        passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                            className: props.className,
                            style: props.style
                        }, props.componentProps);
                    }
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, passedProps, children);
                }
                return children[0] || null;
            }
        }]);
    return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
Animate.isAnimate = true;
Animate.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
    transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
    transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
    animation: {},
    component: 'span',
    componentProps: {},
    transitionEnter: true,
    transitionLeave: true,
    transitionAppear: false,
    onEnd: noop,
    onEnter: noop,
    onLeave: noop,
    onAppear: noop
};
var _initialiseProps = function _initialiseProps() {
    var _this5 = this;
    this.performEnter = function (key) {
        // may already remove by exclusive
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
        }
    };
    this.performAppear = function (key) {
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
        }
    };
    this.handleDoneAdding = function (key, type) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key];
        // if update on exclusive mode, skip check
        if (props.exclusive && props !== _this5.nextProps) {
            return;
        }
        var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
        if (!_this5.isValidChildByKey(currentChildren, key)) {
            // exclusive will not need this
            _this5.performLeave(key);
        }
        else if (type === 'appear') {
            if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
                props.onAppear(key);
                props.onEnd(key, true);
            }
        }
        else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
            props.onEnter(key);
            props.onEnd(key, true);
        }
    };
    this.performLeave = function (key) {
        // may already remove by exclusive
        if (_this5.childrenRefs[key]) {
            _this5.currentlyAnimatingKeys[key] = true;
            _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
        }
    };
    this.handleDoneLeaving = function (key) {
        var props = _this5.props;
        delete _this5.currentlyAnimatingKeys[key];
        // if update on exclusive mode, skip check
        if (props.exclusive && props !== _this5.nextProps) {
            return;
        }
        var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
        // in case state change is too fast
        if (_this5.isValidChildByKey(currentChildren, key)) {
            _this5.performEnter(key);
        }
        else {
            var end = function end() {
                if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
                    props.onLeave(key);
                    props.onEnd(key, false);
                }
            };
            if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
                _this5.setState({
                    children: currentChildren
                }, end);
            }
            else {
                end();
            }
        }
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));


/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = function (arr, obj) {
    if (arr.indexOf)
        return arr.indexOf(obj);
    for (var i = 0; i < arr.length; ++i) {
        if (arr[i] === obj)
            return i;
    }
    return -1;
};


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
    isAppearSupported: function isAppearSupported(props) {
        return props.transitionName && props.transitionAppear || props.animation.appear;
    },
    isEnterSupported: function isEnterSupported(props) {
        return props.transitionName && props.transitionEnter || props.animation.enter;
    },
    isLeaveSupported: function isLeaveSupported(props) {
        return props.transitionName && props.transitionLeave || props.animation.leave;
    },
    allowAppearCallback: function allowAppearCallback(props) {
        return props.transitionAppear || props.animation.appear;
    },
    allowEnterCallback: function allowEnterCallback(props) {
        return props.transitionEnter || props.animation.enter;
    },
    allowLeaveCallback: function allowLeaveCallback(props) {
        return props.transitionLeave || props.animation.leave;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (util);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);






var LazyRenderBox = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);
    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }
    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return nextProps.hiddenClassName || nextProps.visible;
    };
    LazyRenderBox.prototype.render = function render() {
        var _props = this.props, hiddenClassName = _props.hiddenClassName, visible = _props.visible, props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);
        if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
            if (!visible && hiddenClassName) {
                props.className += ' ' + hiddenClassName;
            }
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
        }
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
    };
    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);
LazyRenderBox.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);


/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = {
    MODE_NUMBER: 1 << 0,
    MODE_ALPHA_NUM: 1 << 1,
    MODE_8BIT_BYTE: 1 << 2,
    MODE_KANJI: 1 << 3
};


/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var math = __webpack_require__(207);
function QRPolynomial(num, shift) {
    if (num.length == undefined) {
        throw new Error(num.length + "/" + shift);
    }
    var offset = 0;
    while (offset < num.length && num[offset] == 0) {
        offset++;
    }
    this.num = new Array(num.length - offset + shift);
    for (var i = 0; i < num.length - offset; i++) {
        this.num[i] = num[i + offset];
    }
}
QRPolynomial.prototype = {
    get: function (index) {
        return this.num[index];
    },
    getLength: function () {
        return this.num.length;
    },
    multiply: function (e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for (var i = 0; i < this.getLength(); i++) {
            for (var j = 0; j < e.getLength(); j++) {
                num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
            }
        }
        return new QRPolynomial(num, 0);
    },
    mod: function (e) {
        if (this.getLength() - e.getLength() < 0) {
            return this;
        }
        var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
        var num = new Array(this.getLength());
        for (var i = 0; i < this.getLength(); i++) {
            num[i] = this.get(i);
        }
        for (var i = 0; i < e.getLength(); i++) {
            num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
        }
        // recursive call
        return new QRPolynomial(num, 0).mod(e);
    }
};
module.exports = QRPolynomial;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

var QRMath = {
    glog: function (n) {
        if (n < 1) {
            throw new Error("glog(" + n + ")");
        }
        return QRMath.LOG_TABLE[n];
    },
    gexp: function (n) {
        while (n < 0) {
            n += 255;
        }
        while (n >= 256) {
            n -= 255;
        }
        return QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++) {
    QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
    QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
        ^ QRMath.EXP_TABLE[i - 5]
        ^ QRMath.EXP_TABLE[i - 6]
        ^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
    QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}
module.exports = QRMath;


/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, exports) {

/*
    MIT License http://www.opensource.org/licenses/mit-license.php
    Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
    var list = [];
    // return the list of modules as css string
    list.toString = function toString() {
        return this.map(function (item) {
            var content = cssWithMappingToString(item, useSourceMap);
            if (item[2]) {
                return "@media " + item[2] + "{" + content + "}";
            }
            else {
                return content;
            }
        }).join("");
    };
    // import a list of modules into the list
    list.i = function (modules, mediaQuery) {
        if (typeof modules === "string")
            modules = [[null, modules, ""]];
        var alreadyImportedModules = {};
        for (var i = 0; i < this.length; i++) {
            var id = this[i][0];
            if (typeof id === "number")
                alreadyImportedModules[id] = true;
        }
        for (i = 0; i < modules.length; i++) {
            var item = modules[i];
            // skip already imported module
            // this implementation is not 100% perfect for weird media query combinations
            //  when a module is imported multiple times with different media queries.
            //  I hope this will never occur (Hey this way we have smaller bundles)
            if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                    item[2] = mediaQuery;
                }
                else if (mediaQuery) {
                    item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
                }
                list.push(item);
            }
        }
    };
    return list;
};
function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || '';
    var cssMapping = item[3];
    if (!cssMapping) {
        return content;
    }
    if (useSourceMap && typeof btoa === 'function') {
        var sourceMapping = toComment(cssMapping);
        var sourceURLs = cssMapping.sources.map(function (source) {
            return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
        });
        return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }
    return [content].join('\n');
}
// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
    // eslint-disable-next-line no-undef
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
    return '/*# ' + data + ' */';
}


/***/ }),
/* 210 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function (value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(106), nativeKeys = __webpack_require__(293);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
    if (!isPrototype(object)) {
        return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
        }
    }
    return result;
}
module.exports = baseKeys;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
    return value;
}
module.exports = identity;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);__webpack_require__(321);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TabPane=_antd.Tabs.TabPane;var getLabel=_ecCom.WeaLocaleProvider.getLabel;var E8_SYS_COLORS=['#0070c1','#cc3432','#5c64c2','#50833b','#874d19','#f46f43','#22c9b2','#b24079','#83686c','#666f81','#627f7e'];var WeaThemeCenter=function(_React$Component){(0,_inherits3.default)(WeaThemeCenter,_React$Component);function WeaThemeCenter(props){(0,_classCallCheck3.default)(this,WeaThemeCenter);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaThemeCenter.__proto__||(0,_getPrototypeOf2.default)(WeaThemeCenter)).call(this,props));_this.state={visible:false,loading:false,tabKey:'',tabKey2:'',themes:[],curTheme:{},hasRight:false,searchName:''};_this.onLoad=function(searchName,isSetCurrentTab){_this.setState({visible:true,loading:true});_ecCom.WeaTools.callApi('/api/portal/themeCenter/getAllThemes','GET',{searchName:searchName}).then(function(result){var _result$data=result.data,data=_result$data===undefined?{}:_result$data;var _data$curTheme=data.curTheme,curTheme=_data$curTheme===undefined?{}:_data$curTheme;var templatetype=curTheme.templatetype,layout=curTheme.layout;_this.setState((0,_extends3.default)({loading:false,tabKey2:isSetCurrentTab?layout=='5'||templatetype=='ECustom'||templatetype=='tsECustom'?'ts':'ecology':_this.state.tabKey2},data));});};_this.onSearch=function(value){_this.setState({searchName:value});_this.onLoad(value,false);};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onSetting=_this.onSetting.bind(_this);_this.onThemeChange=_this.onThemeChange.bind(_this);_this.onColorChange=_this.onColorChange.bind(_this);return _this;}(0,_createClass3.default)(WeaThemeCenter,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,tabKey2=_state.tabKey2,_state$themes=_state.themes,themes=_state$themes===undefined?[]:_state$themes,_state$curTheme=_state.curTheme,curTheme=_state$curTheme===undefined?{}:_state$curTheme,hasRight=_state.hasRight,searchName=_state.searchName;var templateid_cur=curTheme.templateid,templatetype_cur=curTheme.templatetype,color_cur=curTheme.color,layout_cur=curTheme.layout,type=curTheme.type;var operationComp=[_react2.default.createElement(_ecCom.WeaInputSearch,{style:{width:'146px',height:'30px','vertical-align':'top','margin-right':hasRight?'0px':'18px'},value:searchName,onSearch:this.onSearch})];if(hasRight){operationComp.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@0uxxbm',type:'primary',size:'small',style:{margin:'0 18px 5px',borderRadius:'2px'},onClick:this.onSetting},getLabel(633,'管理')));}var tabComp=_react2.default.createElement(_antd.Tabs,{ecId:(this&&this.props&&this.props.ecId||'')+'_Tabs@qqju5b',type:'card',activeKey:tabKey2,onChange:function onChange(key){return _this2.setState({tabKey2:key});},tabBarExtraContent:operationComp},themes.map(function(themeType){var key=themeType.key,name=themeType.name,_themeType$data=themeType.data,data=_themeType$data===undefined?[]:_themeType$data;var colorComp=null;if(templatetype_cur=='ecology8'&&tabKey2=='ecology'){var colorSelectedStyle={};if(color_cur){var _color=color_cur.replace(/[^0-9]/ig,'');var _index=_color==''?0:parseInt(_color);colorSelectedStyle={display:'block',left:50*_index+41,backgroundColor:E8_SYS_COLORS[_index]};}colorComp=_react2.default.createElement('div',{className:'wea-theme-center-colors'},_react2.default.createElement('div',{className:'wea-theme-center-color-selected',style:colorSelectedStyle}),E8_SYS_COLORS.map(function(item,index){return _react2.default.createElement('div',{key:index,className:'wea-theme-center-color',style:{backgroundColor:item},'data-index':index==0?'':index,onClick:_this2.onColorChange});}));}return _react2.default.createElement(TabPane,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_TabPane@8paygj@'+key,tab:name,key:key},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_WeaNewScroll@f0m8rb@'+key,height:templatetype_cur=='ecology8'&&tabKey2=='ecology'?327:373},_react2.default.createElement('div',{className:'wea-theme-center-items'},data.map(function(theme,index){var templateid=theme.templateid,templatetype=theme.templatetype,layout=theme.layout,color=theme.color;var previewComp='';if(templatetype=='ecology8'){previewComp=_react2.default.createElement('div',{className:'wea-theme-center-preview',dangerouslySetInnerHTML:{__html:theme.preview}});}else{previewComp=_react2.default.createElement('div',{className:'wea-theme-center-preview'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(theme.preview),alt:theme.name}));}var selectedComp='';// if (((templatetype_cur == 'ecology8' || templatetype == 'ECustom') && templateid_cur == templateid && templatetype_cur == templatetype) || (templatetype_cur == 'ecology9' && templatetype_cur == templatetype && ((color_cur && color_cur != '' && color && color != '' && color_cur == color) || ((!color_cur || color_cur == '') && (!color || color == '') && templateid_cur == templateid))) || (layout == '5' && layout == layout_cur)) {
if(templatetype_cur&&templateid==templateid_cur&&templatetype==templatetype_cur||!templatetype_cur&&type=='layout'&&layout==layout_cur){selectedComp=_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)('/wui/theme/ecology9/image/colors/selected.png'),alt:'',className:'wea-theme-center-selected'});}return _react2.default.createElement('div',{key:index,className:'wea-theme-center-item',onClick:function onClick(){return _this2.onThemeChange(theme);}},previewComp,_react2.default.createElement('div',{className:'wea-theme-center-skin-title',title:theme.name},theme.name),_react2.default.createElement('div',{className:'wea-theme-center-template-title',title:theme.templateName},theme.templateName),selectedComp);}))),colorComp);}));return _react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@ue6657',visible:visible,loading:loading,title:getLabel(27714,'主题中心'),icon:'wevicon-theme-center',iconBgcolor:'#a7adb5',style:{width:644,height:435},parentClassName:'wea-theme-center',mask:false,zIndex:100,hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{className:'wea-theme-center-body'},tabComp));}},{key:'onShow',value:function onShow(){var searchName=this.state.searchName;this.onLoad(searchName,true);}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@5affwf',type:'primary',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onOk',value:function onOk(){this.setState({visible:false,searchName:''});}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,searchName:''});}},{key:'onSetting',value:function onSetting(){window.open((0,_pathUtil.addContentPath)('/spa/portal/static4engine/engine.html#/portalengine/portalmaintenance/mainportal'),'_blank');}},{key:'onThemeChange',value:function onThemeChange(theme){var _this3=this;var type=theme.type,templatetype=theme.templatetype;var location=this.props.location;theme.location=location;if(type=='preview'){var redirectUrl=theme.url;var width=screen.availWidth-10;var height=screen.availHeight-60;var szFeatures='top=0,';szFeatures+='left=0,';szFeatures+='width='+width+',';szFeatures+='height='+height+',';szFeatures+='directories=no,';szFeatures+='status=yes,';szFeatures+='menubar=no,';szFeatures+='scrollbars=yes,';szFeatures+='resizable=yes';window.open((0,_pathUtil.addContentPath)(redirectUrl),'',szFeatures);}else{this.setState({loading:true});doThemeAction('onThemeChange',theme,function(){return _this3.setState({visible:false,loading:false,curTheme:theme,searchName:''});});}}},{key:'onColorChange',value:function onColorChange(e){var _this4=this;var location=this.props.location;var $obj=jQuery(e.target);var index=$obj.attr('data-index');jQuery('.wea-theme-center-color-img').css('background','url('+(0,_pathUtil.addContentPath)('/wui/theme/ecology8/page/images/skin/color'+index+'_wev8.png')+')');jQuery('.wea-theme-center-color-selected').css({display:'block','background-color':$obj.css('background-color')}).animate({left:$obj.position().left-5});this.setState({loading:true});doThemeAction('onColorChange',{color:'left'+index,location:location},function(){return _this4.setState({visible:false,loading:false});});}}]);return WeaThemeCenter;}(_react2.default.Component);exports.default=WeaThemeCenter;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);var _comsMobx=__webpack_require__(159);__webpack_require__(326);var _Add=__webpack_require__(328);var _Add2=_interopRequireDefault(_Add);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var WeaTable=_comsMobx.WeaTableNew.WeaTable,TableStore=_comsMobx.WeaTableNew.TableStore;var tableStore=new TableStore();var WeaPortalShare=function(_React$Component){(0,_inherits3.default)(WeaPortalShare,_React$Component);function WeaPortalShare(props){(0,_classCallCheck3.default)(this,WeaPortalShare);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaPortalShare.__proto__||(0,_getPrototypeOf2.default)(WeaPortalShare)).call(this,props));_this.state={visible:props.visible||false,title:props.title||getLabel(82752,'共享范围'),type:props.type||{},selectedRowKeys:[]};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenus=_this.getRightMenus.bind(_this);_this.getRowSelection=_this.getRowSelection.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onLoad=_this.onLoad.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onDelete=_this.onDelete.bind(_this);return _this;}(0,_createClass3.default)(WeaPortalShare,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,title=_state.title,type=_state.type,keys=_state.selectedRowKeys;var disabled=!(keys&&keys.length);return _react2.default.createElement(_react2.default.Fragment,{ecId:(this&&this.props&&this.props.ecId||'')+'_React.Fragment@bu0qe2'},_react2.default.createElement('div',{className:'wea-portal-share',onClick:function onClick(){return _this2.onLoad(type);}},this.props.children),_react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@4pn2rw',visible:visible,title:title,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:800,height:510},hasScroll:true,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaRightMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@x5i6ej',datas:this.getRightMenus()},_react2.default.createElement(_ecCom.WeaTab,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTab@7fp7ze',buttons:[_react2.default.createElement(_ecCom.WeaButtonIcon,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaButtonIcon@qphu8c',buttonType:'add',type:'primary',onClick:this.onAdd}),_react2.default.createElement(_ecCom.WeaButtonIcon,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaButtonIcon@5ruicf',buttonType:'del',type:'primary',disabled:disabled,onClick:this.onDelete})]}),_react2.default.createElement(_Add2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_Add@kszf1i',ref:function ref(add){return _this2.addRef=add;},title:getLabel(611,'添加')+title,onSave:this.onSave}),_react2.default.createElement(WeaTable,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTable@swrwaw',comsWeaTableStore:tableStore,rowSelection:this.getRowSelection(),scroll:{y:380}}))));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_ecCom.WeaMoreButton,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMoreButton@4i51km',datas:this.getRightMenus()}));return buttons;}},{key:'getRightMenus',value:function getRightMenus(){var keys=this.state.selectedRowKeys;var rightMenus=[];rightMenus.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Add-to-o'}),content:getLabel(611,'添加'),onClick:this.onAdd});rightMenus.push({key:'2',disabled:!(keys&&keys.length),icon:_react2.default.createElement('i',{className:'icon-coms-Batch-delete'}),content:getLabel(32136,'批量删除'),onClick:this.onDelete});return rightMenus;}},{key:'getRowSelection',value:function getRowSelection(){var _self=this;return{onChange:function onChange(selectedRowKeys){_self.setState({selectedRowKeys:selectedRowKeys});}};}},{key:'onCancel',value:function onCancel(){var onCancelCallback=this.props.onCancelCallback;this.setState({visible:false,selectedRowKeys:[]});tableStore.setSelectedRowKeys([]);tableStore.tableUpdate({datas:[]});if(onCancelCallback){onCancelCallback();}}},{key:'onLoad',value:function onLoad(type){var _this3=this;var title=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.state.title;this.setState({visible:true,title:title,type:type});_ecCom.WeaTools.callApi('/api/portal/customshare/getCustomShareData','POST',(0,_extends3.default)({},type)).then(function(result){tableStore.getDatas(result.sessionkey,1);_this3.setState({selectedRowKeys:[]});});}},{key:'onAdd',value:function onAdd(){this.addRef.onLoad();}},{key:'onSave',value:function onSave(){var _this4=this;var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var type=this.state.type;_ecCom.WeaTools.callApi('/api/portal/customshare/setCustomShareData','POST',(0,_extends3.default)({},type,data)).then(function(result){if(result.status==='success'){_antd.message.success(getLabel(83885,'操作成功！'));_this4.addRef.onCancel();_this4.onLoad(type);var callback=_this4.props.callback;if(callback&&typeof callback=='function'){callback();}}else{_antd.message.warning(getLabel(83912,'操作失败！'));}});}},{key:'onDelete',value:function onDelete(){var _this5=this;var _state2=this.state,type=_state2.type,_state2$selectedRowKe=_state2.selectedRowKeys,selectedRowKeys=_state2$selectedRowKe===undefined?[]:_state2$selectedRowKe;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(385625,'确定要删除选择的记录吗？'),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/customshare/delCustomShareData','POST',(0,_extends3.default)({ids:selectedRowKeys.join(',')},type)).then(function(result){if(result.status==='success'){_antd.message.success(getLabel(83885,'操作成功！'));_this5.onLoad(type);var callback=_this5.props.callback;if(callback&&typeof callback=='function'){callback();}}else{_antd.message.warning(getLabel(83912,'操作失败！'));}});}});}}]);return WeaPortalShare;}(_react2.default.Component);exports.default=WeaPortalShare;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(356);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaSystemSetting=loadable(function(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 459));});var Index=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_initialiseProps.call(_this);var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible};return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible,style=_state.style;var _props$callbackFn=this.props.callbackFn,callbackFn=_props$callbackFn===undefined?{}:_props$callbackFn;return display=='page'||visible?_react2.default.createElement(WeaSystemSetting,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSystemSetting@9etnma'},this.props,{display:display,visible:visible,style:style,onShow:this.onShow,callbackFn:callbackFn})):null;}}]);return Index;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.onShow=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this2.setState({visible:visible,style:style});};this.onHide=function(){_this2.setState({visible:false});};},_temp);exports.default=Index;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(358);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaPlugin=loadable(function(){return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 460));});var Index=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_initialiseProps.call(_this);var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible};return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible,style=_state.style;return display=='page'||visible?_react2.default.createElement(WeaPlugin,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaPlugin@omh03k'},this.props,{display:display,visible:visible,style:style,onShow:this.onShow})):null;}}]);return Index;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.onShow=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this2.setState({visible:visible,style:style});};this.onHide=function(){_this2.setState({visible:false});};},_temp);exports.default=Index;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(359);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaNonStandard=loadable(function(){return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 461));});var Index=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_initialiseProps.call(_this);var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible};return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible;return display=='page'||visible?_react2.default.createElement(WeaNonStandard,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNonStandard@o84oif'},this.props,{display:display,visible:visible,onShow:this.onShow})):null;}}]);return Index;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.onShow=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this2.setState({visible:visible});};this.onHide=function(){_this2.setState({visible:false});};},_temp);exports.default=Index;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _ecCom=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaLicense=loadable(function(){return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 462));});var WeaLicenseCluster=loadable(function(){return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 465));});var Index=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_initialiseProps.call(_this);var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible,isCluster:false};visible&&_this.isCluster();return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible,style=_state.style,isCluster=_state.isCluster;if(display=='page'||visible){if(isCluster){return _react2.default.createElement(WeaLicenseCluster,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicenseCluster@i86wp4'},this.props,{display:display,visible:visible,style:style,onHide:this.onHide}));}return _react2.default.createElement(WeaLicense,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicense@1wb7am'},this.props,{display:display,visible:visible,style:style,onHide:this.onHide}));}return null;}}]);return Index;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.onShow=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this2.isCluster(visible,style);};this.onHide=function(){_this2.setState({visible:false});};this.isCluster=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_ecCom.WeaTools.callApi('/api/system/license/isCluster','POST').then(function(result){_this2.setState({visible:visible,style:style,isCluster:result.isCluster});});};},_temp);exports.default=Index;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(233);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaLicenseSubmit=loadable(function(){return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 463));});var WeaLicenseSubmitCluster=loadable(function(){return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 464));});var Index=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_this.onShow=function(){var addr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';_this.setState({visible:true,addr:addr});};_this.onHide=function(){_this.setState({visible:false});};var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible,addr:''};return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible,addr=_state.addr;if(display=='page'||visible){if(addr){return _react2.default.createElement(WeaLicenseSubmitCluster,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicenseSubmitCluster@e69ywi'},this.props,{display:display,visible:visible,addr:addr,onHide:this.onHide}));}return _react2.default.createElement(WeaLicenseSubmit,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaLicenseSubmit@3aksg7'},this.props,{display:display,visible:visible,onHide:this.onHide}));}return null;}}]);return Index;}(_react2.default.Component);exports.default=Index;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _class,_temp,_initialiseProps;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);__webpack_require__(360);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};var WeaVersion=loadable(function(){return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 466));});var Index=(_temp=_class=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_initialiseProps.call(_this);var _props$location=props.location,location=_props$location===undefined?{}:_props$location,_props$visible=props.visible,visible=_props$visible===undefined?false:_props$visible;var _location$query=location.query,query=_location$query===undefined?{}:_location$query;var _query$display=query.display,display=_query$display===undefined?'':_query$display;_this.state={display:display,visible:visible};return _this;}(0,_createClass3.default)(Index,[{key:'render',value:function render(){var _state=this.state,display=_state.display,visible=_state.visible,style=_state.style;return display=='page'||visible?_react2.default.createElement(WeaVersion,(0,_extends3.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaVersion@865sih'},this.props,{display:display,visible:visible,style:style,onShow:this.onShow})):null;}}]);return Index;}(_react2.default.Component),_initialiseProps=function _initialiseProps(){var _this2=this;this.onShow=function(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var style=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this2.setState({visible:visible,style:style});};this.onHide=function(){_this2.setState({visible:false});};},_temp);exports.default=Index;

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);var _MaterialLib=__webpack_require__(166);var _MaterialLib2=_interopRequireDefault(_MaterialLib);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var WeaMaterialLib=function(_React$Component){(0,_inherits3.default)(WeaMaterialLib,_React$Component);function WeaMaterialLib(props){(0,_classCallCheck3.default)(this,WeaMaterialLib);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaMaterialLib.__proto__||(0,_getPrototypeOf2.default)(WeaMaterialLib)).call(this,props));_this.state={visible:false,loading:false,value:_this.props.value};_this.getButtons=_this.getButtons.bind(_this);_this.onLoading=_this.onLoading.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onClear=_this.onClear.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onShow=_this.onShow.bind(_this);_this.onChange=_this.onChange.bind(_this);return _this;}(0,_createClass3.default)(WeaMaterialLib,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({value:nextProps.value});}},{key:'render',value:function render(){var _props=this.props,type=_props.type,value=_props.value,disabled=_props.disabled,multiCheck=_props.multiCheck,isShow=_props.isShow;var _state=this.state,visible=_state.visible,loading=_state.loading;var displayComp=_react2.default.createElement('div',null);if(type=='button'){displayComp=_react2.default.createElement('div',{onClick:this.onShow},this.props.children);}else{displayComp=_react2.default.createElement(_ecCom.WeaInputSearch,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInputSearch@2waixn',style:{width:'100%'},value:value,onSearchChange:this.onChange,onSearch:this.onShow});}if(disabled){displayComp=_react2.default.createElement(_ecCom.WeaInput,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInput@2o4hnh',value:value,disabled:true});}return _react2.default.createElement('div',null,displayComp,_react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@rtq1x2',visible:visible,loading:loading,title:getLabel(32467,'图片素材库'),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:document.body.clientWidth-300,height:document.body.clientHeight-200},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_MaterialLib2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MaterialLib@nb74gv',ref:'ml',multiCheck:multiCheck,onLoading:this.onLoading,isShow:isShow})));}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@3hql1e',type:'primary',onClick:this.onOk},getLabel(826,'确定')));// buttons.push(<Button type="primary" onClick={this.onClear}>{getLabel(311, '清除')}</Button>);
buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@8rlnif',type:'ghost',onClick:this.onCancel},getLabel(31129,'取消')));return buttons;}},{key:'onLoading',value:function onLoading(loading){this.setState({loading:loading});}},{key:'onShow',value:function onShow(){this.setState({visible:true});this.refs.ml&&this.refs.ml.setVisible({visible:true});}},{key:'onOk',value:function onOk(){var checkedFiles=this.refs.ml.getCheckedFiles();if(checkedFiles&&checkedFiles.length){var filepaths=checkedFiles.map(function(item){return item.filepath;});this.onChange(filepaths.join(','));this.refs.ml.setVisible(false);this.setState({visible:false});}else{_antd.message.warning(getLabel(84570,'请选择目标！'));}}},{key:'onClear',value:function onClear(){this.onChange('');this.refs.ml.setVisible(false);this.setState({visible:false,value:''});}},{key:'onCancel',value:function onCancel(){this.refs.ml.setVisible(false);this.setState({visible:false});}},{key:'onChange',value:function onChange(value){this.props.onChange(value);}}]);return WeaMaterialLib;}(_react2.default.Component);exports.default=WeaMaterialLib;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(225), baseIteratee = __webpack_require__(167), toInteger = __webpack_require__(311);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) {
        index = nativeMax(length + index, 0);
    }
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array)) {
            return index;
        }
    }
    return -1;
}
module.exports = baseFindIndex;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(143), setCacheAdd = __webpack_require__(282), setCacheHas = __webpack_require__(283);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while (++index < length) {
        this.add(values[index]);
    }
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49), root = __webpack_require__(24);
/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');
module.exports = Set;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while (++index < length) {
        result[index] = iteratee(array[index], index, array);
    }
    return result;
}
module.exports = arrayMap;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(167), basePullAt = __webpack_require__(316);
/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
    var result = [];
    if (!(array && array.length)) {
        return result;
    }
    var index = -1, indexes = [], length = array.length;
    predicate = baseIteratee(predicate, 3);
    while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
        }
    }
    basePullAt(array, indexes);
    return result;
}
module.exports = remove;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49);
var defineProperty = (function () {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    }
    catch (e) { }
}());
module.exports = defineProperty;


/***/ }),
/* 232 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
        array[index] = source[index];
    }
    return array;
}
module.exports = copyArray;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _rcTabs=__webpack_require__(235);var _rcTabs2=_interopRequireDefault(_rcTabs);var _TabBar=__webpack_require__(372);var _TabBar2=_interopRequireDefault(_TabBar);var _InkTabBar=__webpack_require__(373);var _InkTabBar2=_interopRequireDefault(_InkTabBar);var _ScrollableTabBar=__webpack_require__(374);var _ScrollableTabBar2=_interopRequireDefault(_ScrollableTabBar);var _ScrollableInkTabBar=__webpack_require__(237);var _ScrollableInkTabBar2=_interopRequireDefault(_ScrollableInkTabBar);var _SwipeableInkTabBar=__webpack_require__(384);var _SwipeableInkTabBar2=_interopRequireDefault(_SwipeableInkTabBar);var _TabContent=__webpack_require__(164);var _TabContent2=_interopRequireDefault(_TabContent);var _SwipeableTabContent=__webpack_require__(389);var _SwipeableTabContent2=_interopRequireDefault(_SwipeableTabContent);__webpack_require__(192);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaPortalRcTabs={Tabs:_rcTabs2.default,TabPane:_rcTabs.TabPane,TabBar:_TabBar2.default,InkTabBar:_InkTabBar2.default,ScrollableTabBar:_ScrollableTabBar2.default,ScrollableInkTabBar:_ScrollableInkTabBar2.default,SwipeableInkTabBar:_SwipeableInkTabBar2.default,TabContent:_TabContent2.default,SwipeableTabContent:_SwipeableTabContent2.default};exports.default=WeaPortalRcTabs;

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);



/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) {
                ctx = null;
            }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();
/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();
// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});
// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return (target instanceof getWindowOf(target).SVGElement &&
            typeof target.getBBox === 'function');
    };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());
var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());
var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();
/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(61)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = __webpack_require__(35);
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _InkTabBarNode = __webpack_require__(154);
var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);
var _TabBarTabsNode = __webpack_require__(88);
var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
var _TabBarRootNode = __webpack_require__(72);
var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
var _ScrollableTabBarNode = __webpack_require__(187);
var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);
var _SaveRef = __webpack_require__(73);
var _SaveRef2 = _interopRequireDefault(_SaveRef);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var ScrollableInkTabBar = function (_React$Component) {
    (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);
    function ScrollableInkTabBar() {
        (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
    }
    (0, _createClass3['default'])(ScrollableInkTabBar, [{
            key: 'render',
            value: function render() {
                var _props = this.props, renderTabBarNode = _props.children, restProps = (0, _objectWithoutProperties3['default'])(_props, ['children']);
                return _react2['default'].createElement(_SaveRef2['default'], null, function (saveRef, getRef) {
                    return _react2['default'].createElement(_TabBarRootNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, restProps), _react2['default'].createElement(_ScrollableTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps), _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)), _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps))));
                });
            }
        }]);
    return ScrollableInkTabBar;
}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */
exports['default'] = ScrollableInkTabBar;
ScrollableInkTabBar.propTypes = {
    children: _propTypes2['default'].func
};
module.exports = exports['default'];


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _ecCom=__webpack_require__(15);var _weaAddnotice=__webpack_require__(244);var _weaAddnotice2=_interopRequireDefault(_weaAddnotice);var _weaMateriallib=__webpack_require__(223);var _weaMateriallib2=_interopRequireDefault(_weaMateriallib);var _MaterialLib=__webpack_require__(166);var _MaterialLib2=_interopRequireDefault(_MaterialLib);var _weaThemeCenter=__webpack_require__(213);var _weaThemeCenter2=_interopRequireDefault(_weaThemeCenter);var _weaThemeLayout=__webpack_require__(323);var _weaThemeLayout2=_interopRequireDefault(_weaThemeLayout);var _weaPortalShare=__webpack_require__(214);var _weaPortalShare2=_interopRequireDefault(_weaPortalShare);var _weaMenu=__webpack_require__(329);var _weaMenu2=_interopRequireDefault(_weaMenu);var _reactLoadable=__webpack_require__(52);var _reactLoadable2=_interopRequireDefault(_reactLoadable);var _weaSystemSetting=__webpack_require__(215);var _weaSystemSetting2=_interopRequireDefault(_weaSystemSetting);var _weaPlugin=__webpack_require__(216);var _weaPlugin2=_interopRequireDefault(_weaPlugin);var _weaNonStandard=__webpack_require__(217);var _weaNonStandard2=_interopRequireDefault(_weaNonStandard);var _weaLicense=__webpack_require__(218);var _weaLicense2=_interopRequireDefault(_weaLicense);var _weaLicenseSubmit=__webpack_require__(219);var _weaLicenseSubmit2=_interopRequireDefault(_weaLicenseSubmit);var _weaVersion=__webpack_require__(220);var _weaVersion2=_interopRequireDefault(_weaVersion);var _weaPortalRcTabs=__webpack_require__(234);var _weaPortalRcTabs2=_interopRequireDefault(_weaPortalRcTabs);var _weaPortalRcMenu=__webpack_require__(390);var _weaPortalRcMenu2=_interopRequireDefault(_weaPortalRcMenu);var _weaLoginPop=__webpack_require__(426);var _weaLoginPop2=_interopRequireDefault(_weaLoginPop);__webpack_require__(439);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import WeaPortalUtils from './components/wea-portal-utils';
// 尚未按需加载的
var loadable=function loadable(loader){var loading=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(){return null;};return(0,_reactLoadable2.default)({loader:loader,loading:loading});};// 已经按需加载的
var WeaPortalLayout=loadable(function(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 468));});var WeaExportElements=loadable(function(){return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 469));});var WeaElementPreview=loadable(function(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 470));});var WeaFavourite=loadable(function(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 456));});var WeaPortalReactSlider=loadable(function(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 471));});var WeaPortalAlert=loadable(function(){return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 472));});var WeaPortalNoRight=loadable(function(){return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 473));});var WeaPortalQuickSearch=loadable(function(){return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 474));});var WeaPortalToolbar=loadable(function(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 475));});var WeaPortalToolbarMore=loadable(function(){return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 476));});var WeaPortalAccount=loadable(function(){return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 477));});var WeaPortalAccountList=loadable(function(){return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 457));});var WeaPortalAccountMenu=loadable(function(){return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 458));});var WeaPortalElementTabs=loadable(function(){return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 478));});var WeaPortalStyleBrowser=loadable(function(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 479));});var WeaPortalFloatArea=loadable(function(){return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 480));});// 登录弹窗
window.doLoginPop=function(){var isPortal=window.top.location.hash.indexOf('/main/portal')>-1||window.top.location.hash.indexOf('menuIds=0')>-1;if(window.hasloginpop){}else if(self!=top&&!self.hasloginpop){window.top.location.href=window.top.location.origin+window.top.location.pathname;}else{var div=document.createElement('div');document.body.appendChild(div);ReactDOM.render(React.createElement(_weaLoginPop2.default,{visible:true,from:'login'}),div);}};module.exports={WeaAddNotice:_weaAddnotice2.default,WeaMaterialLib:_weaMateriallib2.default,MaterialLib:_MaterialLib2.default,WeaThemeCenter:_weaThemeCenter2.default,WeaThemeLayout:_weaThemeLayout2.default,WeaPortalShare:_weaPortalShare2.default,WeaPortalLayout:WeaPortalLayout,WeaExportElements:WeaExportElements,WeaElementPreview:WeaElementPreview,WeaMenu:_weaMenu2.default,WeaPlugin:_weaPlugin2.default,WeaNonStandard:_weaNonStandard2.default,WeaLicense:_weaLicense2.default,WeaLicenseSubmit:_weaLicenseSubmit2.default,WeaSystemSetting:_weaSystemSetting2.default,WeaVersion:_weaVersion2.default,WeaLoginPop:_weaLoginPop2.default,WeaFavourite:WeaFavourite,// WeaPortalUtils,
WeaPortalRcTabs:_weaPortalRcTabs2.default,WeaPortalRcMenu:_weaPortalRcMenu2.default,WeaPortalReactSlider:WeaPortalReactSlider,WeaPortalAlert:WeaPortalAlert,WeaPortalNoRight:WeaPortalNoRight,WeaPortalQuickSearch:WeaPortalQuickSearch,WeaPortalToolbar:WeaPortalToolbar,WeaPortalToolbarMore:WeaPortalToolbarMore,WeaPortalAccount:WeaPortalAccount,WeaPortalAccountList:WeaPortalAccountList,WeaPortalAccountMenu:WeaPortalAccountMenu,WeaPortalElementTabs:WeaPortalElementTabs,WeaPortalStyleBrowser:WeaPortalStyleBrowser,WeaPortalFloatArea:WeaPortalFloatArea};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var WeaAddNotice=function(_React$Component){(0,_inherits3.default)(WeaAddNotice,_React$Component);function WeaAddNotice(props){(0,_classCallCheck3.default)(this,WeaAddNotice);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaAddNotice.__proto__||(0,_getPrototypeOf2.default)(WeaAddNotice)).call(this,props));_this.state={visible:false,isView:false,id:'',title:'',imgsrc:'',content:'',isNew:true};_this.onSetState=_this.onSetState.bind(_this);_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenu=_this.getRightMenu.bind(_this);_this.onRightMenuClick=_this.onRightMenuClick.bind(_this);_this.onUploadChange=_this.onUploadChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.onDel=_this.onDel.bind(_this);return _this;}(0,_createClass3.default)(WeaAddNotice,[{key:'onSetState',value:function onSetState(state){this.setState(state);}},{key:'onDel',value:function onDel(){var _this2=this;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(15097,'确定要删除吗？'),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/noticeadd/delNotice','POST',{id:_this2.state.id}).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);}else{_antd.message.success(getLabel(83472,'删除成功！'));_this2.props.handleRefresh();_this2.setState({visible:false});}});}});}},{key:'getButtons',value:function getButtons(){var btns=[];if(this.props.canAddNotice){if(this.state.isView){btns.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@p3bule',type:'primary',onClick:this.onSetState.bind(this,{isNew:false,isView:false})},getLabel(26473,'编辑')));btns.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@oi3pg1',onClick:this.onDel},getLabel(91,'删除')));}else{btns.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@asrjs1',type:'primary',onClick:this.handleSubmit},getLabel(826,'确定')));}}btns.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@a73ktw',onClick:this.onSetState.bind(this,{isNew:false,visible:false,id:'',title:'',imgsrc:'',content:''})},getLabel(31129,'取消')));return btns;}},{key:'getRightMenu',value:function getRightMenu(){var btns=[];if(this.props.canAddNotice){if(this.state.isView){btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),key:'edit',content:getLabel(26473,'编辑')});btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),key:'del',content:getLabel(91,'删除')});}else{btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),key:'save',content:getLabel(30986,'保存')});}}btns.push({icon:_react2.default.createElement('i',{className:'icon-coms-go-back'}),key:'cancel',content:getLabel(31129,'取消')});return btns;}},{key:'onUploadChange',value:function onUploadChange(ids,lists){if(lists[lists.length-1]){this.setState({imgsrc:lists[0].filelink});}}},{key:'onRightMenuClick',value:function onRightMenuClick(key){switch(key){case'edit':this.onSetState({isNew:true,isView:false});break;case'del':this.onDel();break;case'save':this.handleSubmit();break;case'cancel':this.this.onSetState();break;}}},{key:'handleSubmit',value:function handleSubmit(){var _this3=this;var _state=this.state,id=_state.id,title=_state.title,content=_state.content,imgsrc=_state.imgsrc,isNew=_state.isNew;var _props=this.props,eid=_props.eid,handleRefresh=_props.handleRefresh;if(!title.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(388025,'标题不能为空')});return;}if(!content.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(515653,'内容不能为空')});return;}if(!imgsrc.trim()){_antd.Modal.error({title:getLabel(15172,'系统提示'),content:getLabel(388026,'图片不能为空')});return;}_ecCom.WeaTools.callApi('/api/portal/noticeadd/addNotice','POST',{id:id,eid:eid,title:title,content:content,imgsrc:imgsrc}).then(function(result){if(result.status=='2'){_antd.message.error(result.errormsg);}else{if(isNew){_antd.message.success(getLabel(83880,'添加成功！'));}else if(!isNew){_antd.message.success(getLabel(387621,'修改成功！'));}handleRefresh();_this3.setState({visible:false,id:'',title:'',imgsrc:'',content:''});}});}},{key:'render',value:function render(){var _this4=this;var _state2=this.state,visible=_state2.visible,isView=_state2.isView,id=_state2.id,title=_state2.title,content=_state2.content,imgsrc=_state2.imgsrc;return _react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@scq26k',title:isView?getLabel(388027,'查看公告'):id?getLabel(388028,'编辑公告'):getLabel(131679,'发布公告'),visible:visible,closable:true,onCancel:this.onSetState.bind(this,{visible:false,id:'',title:'',imgsrc:'',content:''}),icon:'icon-coms-portal',iconBgcolor:'#1a57a0',maskClosable:false,buttons:this.getButtons(),style:{width:'694px',height:'577px'}},_react2.default.createElement(_ecCom.WeaRightMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@kfsynq',datas:this.getRightMenu(),onClick:this.onRightMenuClick},isView?_react2.default.createElement('div',{className:'newnotice-view-container',style:{overflow:'auto',maxHeight:'100%',maxWidth:'100%',margin:'20px'},dangerouslySetInnerHTML:{__html:content}}):_react2.default.createElement('div',{className:'newnotice-add-container'},_react2.default.createElement('div',{className:'newnotice-add-picture'},_react2.default.createElement(_ecCom.WeaUpload,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@0i3k3p',ref:imgsrc,uploadId:'noticeUpload',maxFilesNumber:'1',uploadUrl:'/api/portal/noticeadd/uploadImg',category:'0',viewAttr:'2',multiSelection:false,limitType:'png,gif,jpeg,jpg,bmp',onChange:this.onUploadChange,showClearAll:true},_react2.default.createElement('div',{className:'newnotice-add-picture-icon'},_react2.default.createElement('img',{className:imgsrc?'portal-element-newnotice-add-img':'portal-element-newnotice-add-icon',src:(0,_pathUtil.addContentPath)(imgsrc||'/page/element/newNotice/resource/image/new.png'),title:getLabel(124841,'添加图片'),alt:''}))),_react2.default.createElement('div',{className:'newnotice-add-picture-tip'},getLabel(388029,'建议尺寸:900像素*500像素'))),_react2.default.createElement('div',{className:'newnotice-add-title'},_react2.default.createElement('div',{className:'newnotice-add-name'},getLabel(24986,'标题')),_react2.default.createElement('div',{className:'newnotice-add-name'},_react2.default.createElement(_ecCom.WeaInput,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInput@57mtj5',viewAttr:3,value:title,onChange:function onChange(value){return _this4.onSetState({title:value});}}))),_react2.default.createElement('div',{className:'newnotice-add-text'},_react2.default.createElement('div',{className:'newnotice-add-name'},getLabel(1265,'正文')),_react2.default.createElement(_ecCom.WeaRichText,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRichText@gcqg2b',ref:'WeaRichText',value:content,ckConfig:{toolbar:[{name:'document',items:['Source']},{name:'basicstyles',items:['Bold','Italic','Underline','Strike']},{name:'styles',items:['Format','Font','FontSize']},{name:'colors',items:['TextColor','BGColor']},{name:'paragraph',items:['NumberedList','BulletedList','-','Outdent','Indent','-','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']},{name:'links',items:['Link','Unlink','Anchor']},{name:'insert',items:['Image','Flash','Table','HorizontalRule','SpecialChar']},{name:'clipboard',items:['Undo','Redo']},{name:'tools',items:['Maximize']}],extraPlugins:'autogrow',height:247,autoGrow_minHeight:247,autoGrow_maxHeight:247,removePlugins:'resize',uploadUrl:'/api/portal/fileupload/uploadfile'},onChange:function onChange(value){return _this4.onSetState({content:value});}})))));}}]);return WeaAddNotice;}(_react2.default.Component);exports.default=WeaAddNotice;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(246);

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */
module.exports = function (css) {
    // get current location
    var location = typeof window !== "undefined" && window.location;
    if (!location) {
        throw new Error("fixUrls requires window.location");
    }
    // blank or null?
    if (!css || typeof css !== "string") {
        return css;
    }
    var baseUrl = location.protocol + "//" + location.host;
    var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
    // convert each url(...)
    /*
    This regular expression is just a way to recursively match brackets within
    a string.

     /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
       (  = Start a capturing group
         (?:  = Start a non-capturing group
             [^)(]  = Match anything that isn't a parentheses
             |  = OR
             \(  = Match a start parentheses
                 (?:  = Start another non-capturing groups
                     [^)(]+  = Match anything that isn't a parentheses
                     |  = OR
                     \(  = Match a start parentheses
                         [^)(]*  = Match anything that isn't a parentheses
                     \)  = Match a end parentheses
                 )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
     \)  = Match a close parens

     /gi  = Get all matches, not the first.  Be case insensitive.
     */
    var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
        // strip quotes (if they exist)
        var unquotedOrigUrl = origUrl
            .trim()
            .replace(/^"(.*)"$/, function (o, $1) { return $1; })
            .replace(/^'(.*)'$/, function (o, $1) { return $1; });
        // already a full url? no change
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
            return fullMatch;
        }
        // convert the url to a full url
        var newUrl;
        if (unquotedOrigUrl.indexOf("//") === 0) {
            //TODO: should we add protocol?
            newUrl = unquotedOrigUrl;
        }
        else if (unquotedOrigUrl.indexOf("/") === 0) {
            // path should be relative to the base url
            newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
        }
        else {
            // path should be relative to current directory
            newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
        }
        // send back the fixed url(...)
        return "url(" + JSON.stringify(newUrl) + ")";
    });
    // send back the fixed css
    return fixedCss;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MaterialLibLeft=function(_React$Component){(0,_inherits3.default)(MaterialLibLeft,_React$Component);function MaterialLibLeft(props){(0,_classCallCheck3.default)(this,MaterialLibLeft);var _this=(0,_possibleConstructorReturn3.default)(this,(MaterialLibLeft.__proto__||(0,_getPrototypeOf2.default)(MaterialLibLeft)).call(this,props));_this.state={datas:[]};_this.onSelect=_this.onSelect.bind(_this);_this.getDirs=_this.getDirs.bind(_this);_this.onLoadData=_this.onLoadData.bind(_this);_this.onAdd=_this.onAdd.bind(_this);_this.onEdit=_this.onEdit.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onValidate=_this.onValidate.bind(_this);return _this;}(0,_createClass3.default)(MaterialLibLeft,[{key:'componentWillMount',value:function componentWillMount(){this.getDirs();}},{key:'render',value:function render(){var hasRight=this.props.hasRight;var datas=this.state.datas;return _react2.default.createElement('div',{className:'portal-p4e-mll'},_react2.default.createElement('div',{className:'portal-p4e-mll-top'},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@7g6yy8',type:'bars'}),_react2.default.createElement('span',{style:{marginLeft:'5px'}},getLabel(385079,'全部目录'))),_react2.default.createElement('div',{className:'portal-p4e-mll-middle'},_react2.default.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@kvg8rd',height:'100%'},_react2.default.createElement(_ecCom.WeaTree,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTree@yx3rnw',datas:datas,loadData:this.onLoadData,onSelect:this.onSelect,onAdd:this.onAdd,onEdit:this.onEdit// editHandler={this.onEdit}
// onDelete={this.onDelete}
,deleteHandler:this.onDelete,validate:this.onValidate}))),hasRight?_react2.default.createElement('div',{className:'portal-p4e-mll-bottom'},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@ocyun3',type:'exclamation-circle-o'}),_react2.default.createElement('span',{style:{marginLeft:'5px'}},getLabel(387215,'目录名称只能包含字母和数字'))):'');}},{key:'onSelect',value:function onSelect(dirs){this.props.setDir(dirs[0]);}},{key:'getDirs',value:function getDirs(){var _this2=this;_ecCom.WeaTools.callApi('/api/portal/materialLib/getDirs','GET',{}).then(function(result){_this2.setState({datas:result.datas||[]});});}},{key:'onLoadData',value:function onLoadData(node){return _ecCom.WeaTools.callApi('/api/portal/materialLib/getDirs','GET',{dir:node.dir});}},{key:'onAdd',value:function onAdd(value,node){return _ecCom.WeaTools.callApi('/api/portal/materialLib/addDir','POST',{dir:node.dir,dirname:value});}},{key:'onEdit',value:function onEdit(value,node){if(node.isDefaultFile){_antd.message.error('系统默认目录不支持编辑！！');}else{return _ecCom.WeaTools.callApi('/api/portal/materialLib/renameDir','POST',{pdir:node.parentId,dir:node.dir,dirname:value});}}},{key:'onDelete',value:function onDelete(item){var _this3=this;if(item.isDefaultFile){_antd.message.error('系统默认目录不支持删除！！');}else{_antd.Modal.confirm({title:getLabel(19085,'消息提醒'),content:getLabel(501356,'确定要删除该目录下所有目录以及文件吗'),onOk:function onOk(){_ecCom.WeaTools.callApi('/api/portal/materialLib/deleteDir','POST',{dir:item.dir});_this3.setState({datas:[]});_this3.getDirs();}});}}},{key:'onValidate',value:function onValidate(node){if(!node.name.toLowerCase().match(/^[0-9A-Za-z]+$/)){_antd.message.warning(getLabel(387215,'目录名称只能包含字母和数字'));return false;}return true;}}]);return MaterialLibLeft;}(_react2.default.Component);exports.default=MaterialLibLeft;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _stringify=__webpack_require__(78);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _findIndex=__webpack_require__(224);var _findIndex2=_interopRequireDefault(_findIndex);var _remove=__webpack_require__(230);var _remove2=_interopRequireDefault(_remove);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);var _comsMobx=__webpack_require__(159);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var MaterialLibRight=function(_React$Component){(0,_inherits3.default)(MaterialLibRight,_React$Component);function MaterialLibRight(props){(0,_classCallCheck3.default)(this,MaterialLibRight);var _this=(0,_possibleConstructorReturn3.default)(this,(MaterialLibRight.__proto__||(0,_getPrototypeOf2.default)(MaterialLibRight)).call(this,props));_this.state={data:[],pageCurrent:1,pageSize:10,pageTotal:0,checkedFiles:[],edit:false,file:{},isPanelShow:false,form:new _comsMobx.WeaForm(),searchKey:'',condition:[]};_this.onUploading=_this.onUploading.bind(_this);_this.getFiles=_this.getFiles.bind(_this);_this.onPageCurrentChange=_this.onPageCurrentChange.bind(_this);_this.onPageSizeChange=_this.onPageSizeChange.bind(_this);_this.onCheckAll=_this.onCheckAll.bind(_this);_this.onCheck=_this.onCheck.bind(_this);_this.onEdit=_this.onEdit.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onDelete=_this.onDelete.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.getCheckedFiles=_this.getCheckedFiles.bind(_this);_this.imageCarousel=_this.imageCarousel.bind(_this);_this.initForm=_this.initForm.bind(_this);return _this;}(0,_createClass3.default)(MaterialLibRight,[{key:'componentDidMount',value:function componentDidMount(){this.initForm();}},{key:'componentWillMount',value:function componentWillMount(){this.getFiles(this.props.dir);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.dir!=this.props.dir){var form=this.state.form;form.resetForm();this.updateInputValue('');this.getFiles(nextProps.dir);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var input=this.refs.input;input&&input.focus();}// 图片放大轮播
},{key:'imageCarousel',value:function imageCarousel(imgObj,e){var isShow=this.props.isShow;if(!isShow)return;var imgPool=[];var indexNum=0;jQuery('.portal-p4e-mlt-img').each(function(){var imgsrc=jQuery(this).attr('data-imgsrc')?jQuery(this).attr('data-imgsrc'):jQuery(this).attr('src');imgPool.push(imgsrc);});var imgsrc=jQuery(e.target).attr('src');for(var i=0;i<imgPool.length;i++){if(imgsrc==imgPool[i]){indexNum=i;break;}}if(window.IMCarousel){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);}else{load(['/social/js/drageasy/drageasy.js','/social/js/bootstrap/js/bootstrap.js?v=20171218','/social/im/js/IMUtil_wev8.js','/social/js/imcarousel/imcarousel.js'],'imcarouselJS',function(){window.IMCarousel.showImgScanner4Pool(true,imgPool,indexNum,null,window.top);});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,hasRight=_props.hasRight,dir=_props.dir,_props$multiCheck=_props.multiCheck,multiCheck=_props$multiCheck===undefined?false:_props$multiCheck;var _state=this.state,_state$data=_state.data,data=_state$data===undefined?[]:_state$data,pageCurrent=_state.pageCurrent,pageSize=_state.pageSize,pageTotal=_state.pageTotal,checkedFiles=_state.checkedFiles,edit=_state.edit,file=_state.file,isPanelShow=_state.isPanelShow,form=_state.form,searchKey=_state.searchKey;var checkedCount=checkedFiles.length;var checkedAll=checkedCount==data.length&&data.length>0;var disabled=checkedCount==0;var row=[],col=[];for(var i=0,len=data.length;i<len;i++){col.push(data[i]);if(i%5==4||i==len-1){row.push(col);col=[];}}return _react2.default.createElement('div',{className:'portal-p4e-mlr'},hasRight?_react2.default.createElement('div',{className:'portal-p4e-mlr-top'},multiCheck&&_react2.default.createElement('div',{className:'portal-p4e-mlr-chk'},_react2.default.createElement(_antd.Checkbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_Checkbox@jq1j19',checked:checkedAll,onChange:function onChange(e){return _this2.onCheckAll(e.target.checked);}},getLabel(131965,'全选'))),_react2.default.createElement('div',{className:'portal-p4e-mlr-btns',style:{position:'absolute',right:'350px'}},_react2.default.createElement(_ecCom.WeaUpload,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaUpload@3ox9sz',uploadId:'uploadFile',uploadUrl:'/api/portal/materialLib/uploadFile?dir='+dir,category:'string',multiSelection:true,maxUploadSize:this.props.maxUploadSize,showClearAll:false,autoUpload:true,limitType:'jpg,jpeg,gif,ico,bmp,png,flv,mp3,swf,mp4,wmv,ogg,webm',onUploading:this.onUploading,onChange:function onChange(){return _this2.getFiles(dir);},style:{display:'inline-block',paddingTop:0}},_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@lmz1fq',type:'primary',className:'portal-p4e-mlr-btn'},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@n7zr7n',type:'plus'}))),_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@r88p37',type:'primary',disabled:disabled,className:'portal-p4e-mlr-btn',style:disabled?{backgroundColor:'#d8d8d8',zIndex:'999'}:{zIndex:'999'},onClick:function onClick(){return _this2.onBatchDelete();}},_react2.default.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@xesbvs',type:'minus'}))),_react2.default.createElement(_ecCom.WeaTab,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTab@dbbsfq',datas:[],showSearchAd:isPanelShow,setShowSearchAd:function setShowSearchAd(bool){return _this2.setPanelStatus(bool);},hideSearchAd:function hideSearchAd(){return _this2.setPanelStatus(false);},searchType:['base','advanced'],buttonsAd:this.getTabButtonsAd(),style:{marginTop:'-7px',height:'47px'},searchsAd:form.render({},{onChange:function onChange(v){if(v.filename){_this2.updateInputValue(v.filename.value);}},onEnterSearch:function onEnterSearch(){_this2.getFiles();_this2.setPanelStatus(false);}}),searchsBaseValue:searchKey,onSearch:function onSearch(){return _this2.onPageCurrentChange(1);},onSearchChange:function onSearchChange(v){return _this2.updateInputValue(v);}})):_react2.default.createElement('div',{className:'portal-p4e-mlr-top'},_react2.default.createElement(_ecCom.WeaTab,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaTab@zvzqa4',datas:[],showSearchAd:isPanelShow,setShowSearchAd:function setShowSearchAd(bool){return _this2.setPanelStatus(bool);},hideSearchAd:function hideSearchAd(){return _this2.setPanelStatus(false);},searchType:['base','advanced'],buttonsAd:this.getTabButtonsAd(),style:{marginTop:'-7px',height:'47px'},searchsAd:form.render({},{onChange:function onChange(v){if(v.filename){_this2.updateInputValue(v.filename.value);}},onEnterSearch:function onEnterSearch(){_this2.getFiles();_this2.setPanelStatus(false);}}),searchsBaseValue:searchKey,onSearch:function onSearch(){return _this2.onPageCurrentChange(1);},onSearchChange:function onSearchChange(v){return _this2.updateInputValue(v);}})),_react2.default.createElement('div',{className:'portal-p4e-mlr-middle'},row&&row.length?_react2.default.createElement('div',{className:'portal-p4e-mlt-table'},row.map(function(row,index){return _react2.default.createElement('ul',{key:index,className:'portal-p4e-mlt-tr'},row.map(function(col){var checked=(0,_findIndex2.default)(checkedFiles,function(item){return item.id==col.id;})!=-1;return _react2.default.createElement('li',{key:col.id,className:'portal-p4e-mlt-td'},_react2.default.createElement('div',{className:'portal-p4e-mlt-item',style:checked?{border:'1px solid #408de2'}:{}},_react2.default.createElement('div',{className:'portal-p4e-mlt-chk',onClick:function onClick(){return _this2.onCheck(col);}},_react2.default.createElement(_antd.Checkbox,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Checkbox@mf3s65@'+col.id,checked:checked})),_react2.default.createElement('div',{className:'portal-p4e-mlt-preview'},_react2.default.createElement('img',{className:'portal-p4e-mlt-img',src:(0,_pathUtil.addContentPath)('/weaver/weaver.splitepage.transform.SptmForThumbnail?filerealpath='+col.filepath.substring(1)+'&time='+Date.now()),onClick:function onClick(e){return _this2.imageCarousel(_this2,e);},alt:''})),hasRight?_react2.default.createElement('div',{className:'portal-p4e-mlt-opt'},_react2.default.createElement('span',{className:'portal-p4e-mlt-title'},col.id==file.id?edit?_react2.default.createElement('input',{ref:'input',defaultValue:col.filename,onClick:function onClick(e){return e.stopPropagation();},onChange:_this2.onChange,onKeyDown:function onKeyDown(e){e.stopPropagation();if(e.keyCode==13){_this2.onSave();}}}):file.filename_new+'.'+col.filetype:col.filename+'.'+col.filetype),col.id==file.id&&edit?_react2.default.createElement('span',{className:'portal-p4e-mlt-edit',onClick:function onClick(e){e.stopPropagation();_this2.onSave();}},_react2.default.createElement('i',{className:'icon-coms-complete',title:getLabel(555,'完成')})):_react2.default.createElement('span',{className:'portal-p4e-mlt-edit',onClick:function onClick(e){e.stopPropagation();_this2.onEdit(col);}},_react2.default.createElement('i',{className:'icon-coms-edit',title:getLabel(26473,'编辑')})),col.id==file.id&&edit?_react2.default.createElement('span',{className:'portal-p4e-mlt-delete',onClick:function onClick(e){e.stopPropagation();_this2.onCancel();}},_react2.default.createElement('i',{className:'icon-coms-Reset',title:getLabel(23757,'撤销')})):_react2.default.createElement('span',{className:'portal-p4e-mlt-delete',onClick:function onClick(e){e.stopPropagation();_this2.onDelete(col.id);}},_react2.default.createElement('i',{className:'icon-coms-delete',title:getLabel(91,'删除')}))):_react2.default.createElement('div',{className:'portal-p4e-mlt-opt'},_react2.default.createElement('span',{className:'portal-p4e-mlt-title2'},col.filename+'.'+col.filetype))));}));}),_react2.default.createElement('div',{style:{clear:'both'}}),_react2.default.createElement('div',{style:{position:'absolute',right:0,margin:'10px'}},_react2.default.createElement(_antd.Pagination,{ecId:(this&&this.props&&this.props.ecId||'')+'_Pagination@uro54g',showSizeChanger:true,showQuickJumper:true,current:pageCurrent,pageSize:pageSize,total:pageTotal,showTotal:function showTotal(total){return getLabel(18609,'共')+' '+total+' '+getLabel(18256,'条');},pageSizeOptions:['10','20','50','100'],onChange:this.onPageCurrentChange,onShowSizeChange:this.onPageSizeChange}))):_react2.default.createElement('div',{className:'ant-table-placeholder'},_react2.default.createElement('i',{className:'anticon anticon-frown'}),getLabel(83553,'暂无数据'))));}},{key:'onUploading',value:function onUploading(state){if(state=='uploading'){this.props.onLoading(true);}else if(state=='uploaded'){this.props.onLoading(false);}}},{key:'setPanelStatus',value:function setPanelStatus(bool){this.setState({isPanelShow:bool});}},{key:'initForm',value:function initForm(){var _this3=this;var form=this.state.form;_ecCom.WeaTools.callApi('/api/portal/materialLib/GetSearchConditionItems','POST',{}).then(function(result){form.setCondition([result.conditioninfo]);_this3.setState({condition:result.conditioninfo});});}},{key:'getTabButtonsAd',value:function getTabButtonsAd(){var _this4=this;var form=this.state.form;return[_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@0689bc',type:'primary',onClick:function onClick(){_this4.onPageCurrentChange(1);_this4.setPanelStatus(false);}},getLabel(197,'搜索','label')),_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@s4rggh',type:'ghost',onClick:function onClick(){form.resetForm();_this4.updateInputValue('');}},getLabel(2022,'重置','label')),_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@1o8mlx',type:'ghost',onClick:function onClick(){return _this4.setPanelStatus(false);}},getLabel(31129,'取消','label'))];}},{key:'updateInputValue',value:function updateInputValue(){var v=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var form=this.state.form;this.setState({searchKey:v});form.updateFields({filename:v});}// getFilesKey = () => {
//     const {form, searchKey } = this.state
//     const params = form.getFormParams();
//     params.word = searchKey;
//     API.getWordLogKey(params).then((res) => {
//         this.loading = false;
//         if (res.stat us) {
//             this.tableStore.getDatas(res.sessionkey);
//             if (!this.title && res.title) {
//                 this.title = res.title;
//             }
//         } else {
//             message.error(res);
//         }
//     });
// }
},{key:'getFiles',value:function getFiles(dir,pageCurrent,pageSize){var _this5=this;var form=this.state.form;var params=form.getFormParams();var filename=params.filename,uploaddate=params.uploaddate;// console.log(typeof(uploaddate))
// console.log(typeof(uploaddate)!='undefined')
var _array=null;if(typeof uploaddate!='undefined'){_array=$.parseJSON((0,_stringify2.default)(uploaddate));}var array0='0';var startime='';var endtime='';if(_array!=null){array0=_array[0];}if(array0==='6'){startime=_array[1];endtime=_array[2];}// console.log(uploaddate[0],"====")
this.props.onLoading(true);_ecCom.WeaTools.callApi('/api/portal/materialLib/getFiles','GET',{dir:dir||this.props.dir,pageCurrent:pageCurrent||this.state.pageCurrent,pageSize:pageSize||this.state.pageSize,filename:filename,uploaddate:array0,startTime:startime,endTime:endtime}).then(function(result){_this5.setState({data:result.data,pageTotal:result.count,checkedFiles:[],edit:false,file:{}});_this5.props.onLoading(false);});}},{key:'onPageCurrentChange',value:function onPageCurrentChange(pageCurrent){this.setState({pageCurrent:pageCurrent});var dir=this.props.dir;var pageSize=this.state.pageSize;this.getFiles(dir,pageCurrent,pageSize);}},{key:'onPageSizeChange',value:function onPageSizeChange(current,pageSize){this.setState({pageSize:pageSize,pageCurrent:1});var dir=this.props.dir;this.getFiles(dir,1,pageSize);}},{key:'onCheckAll',value:function onCheckAll(checked){var _state$data2=this.state.data,data=_state$data2===undefined?[]:_state$data2;var checkedFiles=[];if(checked){data.forEach(function(item){checkedFiles.push(item);});}this.setState({checkedFiles:checkedFiles});}},{key:'onCheck',value:function onCheck(file){var _props$multiCheck2=this.props.multiCheck,multiCheck=_props$multiCheck2===undefined?false:_props$multiCheck2;var checkedFiles=this.state.checkedFiles;if((0,_findIndex2.default)(checkedFiles,function(item){return item.id==file.id;})!=-1){(0,_remove2.default)(checkedFiles,function(item){return item.id==file.id;});}else if(multiCheck){checkedFiles.push(file);}else{checkedFiles=[file];}this.setState({checkedFiles:checkedFiles});}},{key:'onEdit',value:function onEdit(){var file=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};this.setState({edit:true,file:(0,_extends3.default)({},file,{filename_new:file.filename})});}},{key:'onChange',value:function onChange(e){var file=this.state.file;this.setState({file:(0,_extends3.default)({},file,{filename_new:e.target.value})});}},{key:'onSave',value:function onSave(){var _this6=this;var file=this.state.file;var _file$filename_new=file.filename_new,filename_new=_file$filename_new===undefined?'':_file$filename_new;if(filename_new.trim()==''){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else if(!filename_new.toLowerCase().match(/^[0-9A-Za-z]+$/)){_antd.message.warning(getLabel(387216,'文件名称只能包含字母和数字'));}else{this.props.onLoading(true);this.setState({edit:false});_ecCom.WeaTools.callApi('/api/portal/materialLib/renameFile','POST',(0,_extends3.default)({},file)).then(function(result){if(result.api_status){_antd.message.success(getLabel(83885,'操作成功！'));_this6.getFiles();}else{_antd.message.warning(getLabel(83912,'操作失败！'));}_this6.props.onLoading(false);});}}},{key:'onDelete',value:function onDelete(id){var _this7=this;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(15097,'确定要删除吗？'),onOk:function onOk(){_this7.doDelete(id);}});}},{key:'onBatchDelete',value:function onBatchDelete(){var _this8=this;var _state$checkedFiles=this.state.checkedFiles,checkedFiles=_state$checkedFiles===undefined?[]:_state$checkedFiles;var chkIds=checkedFiles.map(function(item){return item.id;});var ids=chkIds.join(',');_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(385625,'确定要删除选择的记录吗？'),onOk:function onOk(){_this8.doDelete(ids);}});}},{key:'doDelete',value:function doDelete(ids){var _this9=this;this.props.onLoading(true);_ecCom.WeaTools.callApi('/api/portal/materialLib/deleteFile','POST',{ids:ids}).then(function(result){if(result.api_status){_antd.message.success(getLabel(83885,'操作成功'));_this9.onPageCurrentChange(1);}else{_antd.message.warning(getLabel(83912,'操作失败'));}_this9.props.onLoading(false);});}},{key:'onCancel',value:function onCancel(){this.setState({edit:false,file:{}});}},{key:'getCheckedFiles',value:function getCheckedFiles(){return this.state.checkedFiles;}}]);return MaterialLibRight;}(_react2.default.Component);exports.default=MaterialLibRight;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) {
    return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(252), getMatchData = __webpack_require__(297), matchesStrictComparable = __webpack_require__(180);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    }
    return function (object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(140), baseIsEqual = __webpack_require__(163);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) {
        return !length;
    }
    object = Object(object);
    while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
            ? data[1] !== object[data[0]]
            : !(data[0] in object)) {
            return false;
        }
    }
    while (++index < length) {
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) {
                return false;
            }
        }
        else {
            var stack = new Stack;
            if (customizer) {
                var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result)) {
                return false;
            }
        }
    }
    return true;
}
module.exports = baseIsMatch;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);
/** Used for built-in method references. */
var arrayProto = Array.prototype;
/** Built-in value references. */
var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
        data.pop();
    }
    else {
        splice.call(data, index, 1);
    }
    --this.size;
    return true;
}
module.exports = listCacheDelete;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(81);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([key, value]);
    }
    else {
        data[index][1] = value;
    }
    return this;
}
module.exports = listCacheSet;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(80);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(80), Map = __webpack_require__(142), MapCache = __webpack_require__(143);
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(168), isMasked = __webpack_require__(266), isObject = __webpack_require__(50), toSource = __webpack_require__(170);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */
var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
    funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
        return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    }
    catch (e) { }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
module.exports = getRawTag;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(267);
/** Used to detect methods masquerading as native. */
var maskSrcKey = (function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
}());
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
}
module.exports = isMasked;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(24);
/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(270), ListCache = __webpack_require__(80), Map = __webpack_require__(142);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(271), hashDelete = __webpack_require__(272), hashGet = __webpack_require__(273), hashHas = __webpack_require__(274), hashSet = __webpack_require__(275);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}
module.exports = hashHas;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(82);
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
}
module.exports = isKeyable;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(83);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(140), equalArrays = __webpack_require__(171), equalByTag = __webpack_require__(285), equalObjects = __webpack_require__(287), getTag = __webpack_require__(79), isArray = __webpack_require__(28), isBuffer = __webpack_require__(105), isTypedArray = __webpack_require__(161);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
            return false;
        }
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) {
        return false;
    }
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (predicate(array[index], index, array)) {
            return true;
        }
    }
    return false;
}
module.exports = arraySome;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70), Uint8Array = __webpack_require__(172), eq = __webpack_require__(141), equalArrays = __webpack_require__(171), mapToArray = __webpack_require__(286), setToArray = __webpack_require__(210);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */
var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
        case dataViewTag:
            if ((object.byteLength != other.byteLength) ||
                (object.byteOffset != other.byteOffset)) {
                return false;
            }
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if ((object.byteLength != other.byteLength) ||
                !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
                return false;
            }
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == (other + '');
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
                return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) {
                return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
    }
    return false;
}
module.exports = equalByTag;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function (value, key) {
        result[++index] = [key, value];
    });
    return result;
}
module.exports = mapToArray;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(173);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
        return false;
    }
    var index = objLength;
    while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
        }
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) {
            var compared = isPartial
                ? customizer(othValue, objValue, key, other, object, stack)
                : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
            ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
            : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
                typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
        }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
            result[resIndex++] = value;
        }
    }
    return result;
}
module.exports = arrayFilter;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
        result[index] = iteratee(index);
    }
    return result;
}
module.exports = baseTimes;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(69), isObjectLike = __webpack_require__(51);
/** `Object#toString` result references. */
var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
    return false;
}
module.exports = stubFalse;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(69), isLength = __webpack_require__(146), isObjectLike = __webpack_require__(51);
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
    typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
        typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
            typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
                typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
    typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
        typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
            typedArrayTags[errorTag] = typedArrayTags[funcTag] =
                typedArrayTags[mapTag] = typedArrayTags[numberTag] =
                    typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
                        typedArrayTags[setTag] = typedArrayTags[stringTag] =
                            typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(178);
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49), root = __webpack_require__(24);
/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');
module.exports = DataView;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49), root = __webpack_require__(24);
/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');
module.exports = Promise;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(49), root = __webpack_require__(24);
/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(179), keys = __webpack_require__(84);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object), length = result.length;
    while (length--) {
        var key = result[length], value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}
module.exports = getMatchData;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(163), get = __webpack_require__(299), hasIn = __webpack_require__(305), isKey = __webpack_require__(150), isStrictComparable = __webpack_require__(179), matchesStrictComparable = __webpack_require__(180), toKey = __webpack_require__(71);
/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
    }
    return function (object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
            ? hasIn(object, path)
            : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(148);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(301);
/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
    }
    string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
    });
    return result;
});
module.exports = stringToPath;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(302);
/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
    var result = memoize(func, function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
        }
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(143);
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
    if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    var memoized = function () {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
            return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(304);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70), arrayMap = __webpack_require__(229), isArray = __webpack_require__(28), isSymbol = __webpack_require__(85);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') {
        return value;
    }
    if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
    }
    if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
    }
    var result = (value + '');
    return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}
module.exports = baseToString;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(306), hasPath = __webpack_require__(307);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(149), isArguments = __webpack_require__(160), isArray = __webpack_require__(28), isIndex = __webpack_require__(145), isLength = __webpack_require__(146), toKey = __webpack_require__(71);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
            break;
        }
        object = object[key];
    }
    if (result || ++index != length) {
        return result;
    }
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
}
module.exports = hasPath;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(309), basePropertyDeep = __webpack_require__(310), isKey = __webpack_require__(150), toKey = __webpack_require__(71);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
    return function (object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(148);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
    return function (object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(312);
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? (remainder ? result - remainder : result) : 0;
}
module.exports = toInteger;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(313);
/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
    if (!value) {
        return value === 0 ? value : 0;
    }
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(314), isObject = __webpack_require__(50), isSymbol = __webpack_require__(85);
/** Used as references for various `Number` constants. */
var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    if (isSymbol(value)) {
        return NAN;
    }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
}
module.exports = toNumber;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(315);
/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
    return string
        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
        : string;
}
module.exports = baseTrim;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) { }
    return index;
}
module.exports = trimmedEndIndex;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(317), isIndex = __webpack_require__(145);
/** Used for built-in method references. */
var arrayProto = Array.prototype;
/** Built-in value references. */
var splice = arrayProto.splice;
/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
    var length = array ? indexes.length : 0, lastIndex = length - 1;
    while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
                splice.call(array, index, 1);
            }
            else {
                baseUnset(array, index);
            }
        }
    }
    return array;
}
module.exports = basePullAt;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(149), last = __webpack_require__(318), parent = __webpack_require__(319), toKey = __webpack_require__(71);
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(148), baseSlice = __webpack_require__(320);
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) {
        start = -start > length ? 0 : (length + start);
    }
    end = end > length ? length : end;
    if (end < 0) {
        end += length;
    }
    length = start > end ? 0 : ((end - start) >>> 0);
    start >>>= 0;
    var result = Array(length);
    while (++index < length) {
        result[index] = array[index + start];
    }
    return result;
}
module.exports = baseSlice;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(322);

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);__webpack_require__(324);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var WeaThemeLayout=function(_React$Component){(0,_inherits3.default)(WeaThemeLayout,_React$Component);function WeaThemeLayout(props){(0,_classCallCheck3.default)(this,WeaThemeLayout);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaThemeLayout.__proto__||(0,_getPrototypeOf2.default)(WeaThemeLayout)).call(this,props));_this.state={visible:false,loading:false,layouts:[],curLayout:{}};_this.getButtons=_this.getButtons.bind(_this);_this.onOk=_this.onOk.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onChange=_this.onChange.bind(_this);return _this;}(0,_createClass3.default)(WeaThemeLayout,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,loading=_state.loading,_state$layouts=_state.layouts,layouts=_state$layouts===undefined?[]:_state$layouts,_state$curLayout=_state.curLayout,curLayout=_state$curLayout===undefined?{}:_state$curLayout;return _react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@n5me39',visible:visible,loading:loading,title:getLabel(385781,'布局选择'),icon:'icon-coms-plate',iconBgcolor:'#a7adb5',style:{width:730},parentClassName:'wea-theme-layout',zIndex:100,buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement('div',{className:'wea-theme-layout-body'},layouts.map(function(layout){var key=layout.key,type=layout.type,name=layout.name;var isSelected=type==curLayout.type;var selectedClassName=isSelected?'wea-theme-layout-selected':'';return _react2.default.createElement('div',{key:key,className:'wea-theme-layout-item '+selectedClassName,title:name},_react2.default.createElement('div',{className:'wea-theme-layout-img',onClick:function onClick(){return _this2.onChange(layout);}},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)('/wui/theme/ecology9/image/layout/layout'+key+'.png'),alt:''})),_react2.default.createElement('div',{className:'wea-theme-layout-name'},name),isSelected?_react2.default.createElement(_antd.Icon,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Icon@c42ca7@'+key,type:'check-circle',className:'wea-theme-layout-icon'}):'');})));}},{key:'onShow',value:function onShow(){var _this3=this;var isSetting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var curLayout=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};this.setState({visible:true,loading:true,isSetting:isSetting});_ecCom.WeaTools.callApi('/api/portal/themeCenter/getAllLayouts','GET',{}).then(function(result){var _result$data=result.data,data=_result$data===undefined?{}:_result$data;if(isSetting){_this3.setState((0,_extends3.default)({loading:false},data,{curLayout:curLayout}));}else{_this3.setState((0,_extends3.default)({loading:false},data));}});}},{key:'getButtons',value:function getButtons(){var isSetting=this.state.isSetting;var buttons=[];isSetting&&buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@j2j1pd',type:'primary',onClick:this.onOk},getLabel(83446,'确定')));buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@69xb1d',type:'primary',onClick:this.onCancel},getLabel(309,'关闭')));return buttons;}},{key:'onOk',value:function onOk(){var curLayout=this.state.curLayout;this.props.onChange(curLayout);this.setState({visible:false});}},{key:'onCancel',value:function onCancel(){this.setState({visible:false});}},{key:'onChange',value:function onChange(layout){var isSetting=this.state.isSetting;this.setState({curLayout:layout});!isSetting&&doThemeAction('onLayoutChange',layout);}}]);return WeaThemeLayout;}(_react2.default.Component);exports.default=WeaThemeLayout;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(325);

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(327);

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _extends3=__webpack_require__(5);var _extends4=_interopRequireDefault(_extends3);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Add=function(_React$Component){(0,_inherits3.default)(Add,_React$Component);(0,_createClass3.default)(Add,[{key:'componentWillMount',value:function componentWillMount(){this.getYyfqData();}}]);function Add(props){(0,_classCallCheck3.default)(this,Add);var _this=(0,_possibleConstructorReturn3.default)(this,(Add.__proto__||(0,_getPrototypeOf2.default)(Add)).call(this,props));_this.state={visible:props.visible||false,title:props.title||getLabel(611,'添加'),valueFlag:false,data:{sharetype:'1',sharevalue:'',isIncludeSub:'0',sharelevel:'0',appointvalue:'',securityminlevel:0,securitymaxlevel:100}};_this.getButtons=_this.getButtons.bind(_this);_this.getRightMenus=_this.getRightMenus.bind(_this);_this.onCancel=_this.onCancel.bind(_this);_this.onLoad=_this.onLoad.bind(_this);_this.onShareTypeChange=_this.onShareTypeChange.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.getYyfqData=_this.getYyfqData.bind(_this);return _this;}(0,_createClass3.default)(Add,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var title=nextProps.title;if(title){this.setState({title:title});}}},{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,title=_state.title,data=_state.data,valueFlag=_state.valueFlag;var sharetype=data.sharetype,isIncludeSub=data.isIncludeSub,sharelevel=data.sharelevel,securityminlevel=data.securityminlevel,securitymaxlevel=data.securitymaxlevel;var colProps={labelCol:{span:6},wrapperCol:{span:18}};return _react2.default.createElement(_ecCom.WeaDialog,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaDialog@3mzzj9',visible:visible,title:title,icon:'icon-coms-portal',iconBgcolor:'#1a57a0',style:{width:500},buttons:this.getButtons(),onCancel:this.onCancel},_react2.default.createElement(_ecCom.WeaRightMenu,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaRightMenu@2gozul',datas:this.getRightMenus()},_react2.default.createElement('div',{className:'wea-portal-share-add'},_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends4.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@bry885',label:getLabel(21956,'对象类型')},colProps),valueFlag==true?_react2.default.createElement(_ecCom.WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@jintk2',style:{width:'150px'},options:[{key:'1',showname:getLabel(179,'人力资源')},{key:'2',showname:getLabel(33553,'分部')},{key:'3',showname:getLabel(27511,'部门')},{key:'6',showname:getLabel(122,'角色')},{key:'8',showname:getLabel(6086,'岗位')}],value:sharetype,onChange:function onChange(value){return _this2.onShareTypeChange(value);}}):_react2.default.createElement(_ecCom.WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@v1u3x0',style:{width:'150px'},options:[{key:'1',showname:getLabel(179,'人力资源')},{key:'2',showname:getLabel(33553,'分部')},{key:'3',showname:getLabel(27511,'部门')},{key:'6',showname:getLabel(122,'角色')},{key:'7',showname:getLabel(1340,'所有人')},{key:'8',showname:getLabel(6086,'岗位')}],value:sharetype,onChange:function onChange(value){return _this2.onShareTypeChange(value);}})),sharetype!=='7'&&_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends4.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@xr3qh1',label:getLabel(106,'对象')},colProps),sharetype==='1'&&_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@gfu7kx',title:getLabel(516509,'多人力资源'),type:17,key:17,icon:'icon-coms-hrm',iconBgcolor:'#217346',isSingle:false,viewAttr:3,onChange:function onChange(ids){return _this2.onChange('sharevalue',ids);}}),sharetype==='2'&&_react2.default.createElement(_antd.Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@fm0pwo',gutter:16},_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@x95wig',span:16},_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@lxu65k',key:194,title:getLabel(516508,'多分部'),type:194,icon:'icon-coms-hrm',iconBgcolor:'#217346',isSingle:false,tabs:[{key:'2',name:getLabel(384541,'按组织架构'),selected:false},{key:'1',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1},isSearch:true}],viewAttr:3,onChange:function onChange(ids){return _this2.onChange('sharevalue',ids);}})),_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@2wbenp',span:8},_react2.default.createElement(_ecCom.WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@k9bgw4',value:isIncludeSub,content:getLabel(125963,'含下级'),onChange:function onChange(value){return _this2.onChange('isIncludeSub',value);}}))),sharetype==='3'&&_react2.default.createElement(_antd.Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@rpt3af',gutter:16},_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@2bp1pe',span:16},_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@v89c9x',key:57,title:getLabel(516507,'多部门'),type:57,icon:'icon-coms-hrm',iconBgcolor:'#217346',isSingle:false,tabs:[{key:'2',name:getLabel(384541,'按组织架构'),selected:false},{key:'1',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1},isSearch:true}],viewAttr:3,onChange:function onChange(ids){return _this2.onChange('sharevalue',ids);}})),_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@kftdq0',span:8},_react2.default.createElement(_ecCom.WeaCheckbox,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaCheckbox@q1s0dj',value:isIncludeSub,content:getLabel(125963,'含下级'),onChange:function onChange(value){return _this2.onChange('isIncludeSub',value);}}))),sharetype==='6'&&_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@jstgde',title:getLabel(122,'角色'),key:267,quickSearchName:'rolesmark',type:267,iconBgcolor:'rgb(179, 46, 55)',isSingle:true,viewAttr:3,onChange:function onChange(ids){return _this2.onChange('sharevalue',ids);}}),sharetype==='8'&&_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@18ec8t',title:getLabel(516510,'多岗位'),key:278,type:278,isSingle:false,viewAttr:3,onChange:function onChange(ids){return _this2.onChange('sharevalue',ids);}})),sharetype==='6'&&_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends4.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@34it5d',label:getLabel(21958,'角色级别')},colProps),_react2.default.createElement(_ecCom.WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@0466nu',style:{width:'150px'},options:[{key:'0',showname:getLabel(27511,'部门')},{key:'1',showname:getLabel(33553,'分部')},{key:'2',showname:getLabel(140,'总部')}],value:sharelevel,onChange:function onChange(value){return _this2.onChange('sharelevel',value);}})),sharetype==='8'&&_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends4.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@8rg5fk',label:getLabel(28169,'岗位级别')},colProps),_react2.default.createElement(_antd.Row,{ecId:(this&&this.props&&this.props.ecId||'')+'_Row@pfk30s',gutter:16},_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@mx106o',span:8},_react2.default.createElement(_ecCom.WeaSelect,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaSelect@argm1j',style:{width:'150px'},options:[{key:'0',showname:getLabel(140,'总部')},{key:'1',showname:getLabel(19437,'指定分部')},{key:'2',showname:getLabel(19438,'指定部门')}],value:sharelevel,onChange:function onChange(value){return _this2.onChange('sharelevel',value);}})),_react2.default.createElement(_antd.Col,{ecId:(this&&this.props&&this.props.ecId||'')+'_Col@xpgxtm',span:16},sharelevel==='1'&&_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@im4hbj',key:194,title:getLabel(516508,'多分部'),type:194,icon:'icon-coms-hrm',iconBgcolor:'#217346',isSingle:false,tabs:[{key:'2',name:getLabel(384541,'按组织架构'),selected:false},{key:'1',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1},isSearch:true}],viewAttr:3,onChange:function onChange(ids){return _this2.onChange('appointvalue',ids);}}),sharelevel==='2'&&_react2.default.createElement(_ecCom.WeaBrowser,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaBrowser@58pdbp',key:57,title:getLabel(516507,'多部门'),type:57,icon:'icon-coms-hrm',iconBgcolor:'#217346',isSingle:false,tabs:[{key:'2',name:getLabel(384541,'按组织架构'),selected:false},{key:'1',name:getLabel(130619,'按列表'),selected:false,dataParams:{list:1},isSearch:true}],viewAttr:3,onChange:function onChange(ids){return _this2.onChange('appointvalue',ids);}})))),sharetype!=='1'&&sharetype!=='8'&&_react2.default.createElement(_ecCom.WeaFormItem,(0,_extends4.default)({ecId:(this&&this.props&&this.props.ecId||'')+'_WeaFormItem@ifyfaz',label:getLabel(683,'安全级别')},colProps),_react2.default.createElement(_ecCom.WeaInputNumber,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInputNumber@65a1a9',value:securityminlevel,onChange:function onChange(value){return _this2.onChange('securityminlevel',value);}}),_react2.default.createElement('span',{style:{display:'inline-block',width:'10px',textAlign:'center'}},'-'),_react2.default.createElement(_ecCom.WeaInputNumber,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaInputNumber@3j4gr5',value:securitymaxlevel,onChange:function onChange(value){return _this2.onChange('securitymaxlevel',value);}})))));}/* 获取是否禁用“所有人”权限范围 */},{key:'getYyfqData',value:function getYyfqData(){var _this3=this;_ecCom.WeaTools.callApi('/api/hrm/common/appDetachDisableAll','get').then(function(result){if(result.status==true){_this3.setState({valueFlag:result.appDetachDisableAll});}});}},{key:'getButtons',value:function getButtons(){var buttons=[];buttons.push(_react2.default.createElement(_antd.Button,{ecId:(this&&this.props&&this.props.ecId||'')+'_Button@s0ow08',type:'primary',onClick:this.onSave},getLabel(30986,'保存')));buttons.push(_react2.default.createElement(_ecCom.WeaMoreButton,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaMoreButton@7nqn0g',datas:this.getRightMenus()}));return buttons;}},{key:'getRightMenus',value:function getRightMenus(){var rightMenus=[];rightMenus.push({key:'1',icon:_react2.default.createElement('i',{className:'icon-coms-Preservation'}),content:getLabel(30986,'保存'),onClick:this.onSave});return rightMenus;}},{key:'onCancel',value:function onCancel(){this.setState({visible:false,data:{sharetype:'1',sharevalue:'',isIncludeSub:'0',sharelevel:'0',appointvalue:'',securityminlevel:0,securitymaxlevel:100}});}},{key:'onLoad',value:function onLoad(){this.setState({visible:true});}},{key:'onShareTypeChange',value:function onShareTypeChange(sharetype){this.setState({data:{sharetype:sharetype,sharevalue:'',isIncludeSub:'0',sharelevel:'0',appointvalue:'',securityminlevel:0,securitymaxlevel:100}});}},{key:'onChange',value:function onChange(key,value){var _state$data=this.state.data,data=_state$data===undefined?{}:_state$data;this.setState({data:(0,_extends4.default)({},data,(0,_defineProperty3.default)({},key,value))});}},{key:'onSave',value:function onSave(){var _state$data2=this.state.data,data=_state$data2===undefined?{}:_state$data2;var sharetype=data.sharetype,sharevalue=data.sharevalue,sharelevel=data.sharelevel,appointvalue=data.appointvalue;if(sharetype!=='7'&&!sharevalue.trim()||sharetype==='8'&&sharelevel!=='0'&&!appointvalue.trim()){_antd.message.warning(getLabel(15859,'必要信息不完整！'));}else{this.props.onSave(data);}}}]);return Add;}(_react2.default.Component);exports.default=Add;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(78);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(16);var _MenuInline=__webpack_require__(330);var _MenuInline2=_interopRequireDefault(_MenuInline);var _MenuVertical=__webpack_require__(353);var _MenuVertical2=_interopRequireDefault(_MenuVertical);var _cloneDeep=__webpack_require__(98);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _ecCom=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Step=_ecCom.WeaIntro.Step;var WeaMenu=function(_React$Component){(0,_inherits3.default)(WeaMenu,_React$Component);function WeaMenu(props){(0,_classCallCheck3.default)(this,WeaMenu);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaMenu.__proto__||(0,_getPrototypeOf2.default)(WeaMenu)).call(this,props));_this.state={mode:props.mode||'inline',defaultSelectedKey:props.defaultSelectedKey||'',datas:props.datas||[],verticalWidth:props.verticalWidth||50,inlineWidth:props.inlineWidth||190,menuHeight:jQuery(document.body).height()-55-props.translatepageheight,fontSize:props.fontSize,translatepage:props.translatepage||''};return _this;}(0,_createClass3.default)(WeaMenu,[{key:'resetHeigth',value:function resetHeigth(){var portalThemeStore=this.props.portalThemeStore;var translatepage=portalThemeStore.translatepage;var transheight=translatepage=='1'?30:0;this.setState({menuHeight:jQuery(document.body).height()-55-transheight});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;jQuery(window).resize(function(){_this2._reactInternalInstance!==undefined&&_this2.resetHeigth();});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if((0,_stringify2.default)(this.props.datas)!==(0,_stringify2.default)(nextProps.datas)||this.props.defaultSelectedKey!==nextProps.defaultSelectedKey&&this.state.defaultSelectedKey!==nextProps.defaultSelectedKey||this.props.fontSize!==nextProps.fontSize){// 计算出openKeys
this.setState({datas:nextProps.datas||[],defaultSelectedKey:nextProps.defaultSelectedKey||'',fontSize:nextProps.fontSize,inlineWidth:nextProps.inlineWidth||190});}if(this.props.mode!=nextProps.mode){this.setState({mode:nextProps.mode});}}},{key:'render',value:function render(){var _state=this.state,mode=_state.mode,datas=_state.datas,verticalWidth=_state.verticalWidth,inlineWidth=_state.inlineWidth,defaultSelectedKey=_state.defaultSelectedKey,menuHeight=_state.menuHeight,fontSize=_state.fontSize,translatepage=_state.translatepage;var newDatas=this.setTreeKey('',datas);var _props=this.props,addonBefore=_props.addonBefore,addonAfter=_props.addonAfter,addonBeforeHeight=_props.addonBeforeHeight,addonAfterHeight=_props.addonAfterHeight,clickBlock=_props.clickBlock,needSwitch=_props.needSwitch;var style={width:mode=='vertical'?verticalWidth:inlineWidth};var conHeightNum=(needSwitch?40:0)+(!!addonBeforeHeight&&mode=='inline'?addonBeforeHeight:0)+(!!addonAfterHeight&&mode=='inline'?addonAfterHeight:0);return React.createElement('div',{style:{height:'100%'}},React.createElement('div',{className:'wea-menu wea-menu-'+mode,style:style},needSwitch?React.createElement(Step,{ecId:(this&&this.props&&this.props.ecId||'')+'_Step@mdptnf',id:'portal-intro2'},React.createElement('div',{id:'portal-intro2',className:'wea-menu-switch',onClick:this.onModeChange.bind(this,mode)},React.createElement(_antd.Icon,{ecId:(this&&this.props&&this.props.ecId||'')+'_Icon@8pl7bj',type:mode=='vertical'?'menu-unfold':'menu-fold'}))):'',!!addonBefore&&mode=='inline'?addonBefore:'',React.createElement(_ecCom.WeaNewScroll,{ecId:(this&&this.props&&this.props.ecId||'')+'_WeaNewScroll@gzghth',height:menuHeight-conHeightNum,scrollId:'menuScrollWrapper'},mode==='inline'?React.createElement(_MenuInline2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MenuInline@7m6crn',mode:mode,datas:newDatas,inlineWidth:inlineWidth,verticalWidth:verticalWidth,fontSize:fontSize,clickBlock:clickBlock,defaultSelectedKey:defaultSelectedKey,onSelect:this.onSelect.bind(this),onModeChange:this.onModeChange.bind(this),onOpenCallback:this.onOpenCallback.bind(this)}):React.createElement(_MenuVertical2.default,{ecId:(this&&this.props&&this.props.ecId||'')+'_MenuVertical@kt2bfx',mode:mode,datas:this.getVerticalDatas(newDatas),inlineWidth:inlineWidth,verticalWidth:verticalWidth,fontSize:fontSize,clickBlock:clickBlock,defaultSelectedKey:defaultSelectedKey,onSelect:this.onSelect.bind(this),onModeChange:this.onModeChange.bind(this),translatepage:translatepage})),!!addonAfter&&mode=='inline'?addonAfter:''));}},{key:'onOpenCallback',value:function onOpenCallback(){if(typeof this.props.onOpenCallback=='function'){this.props.onOpenCallback();}}},{key:'onModeChange',value:function onModeChange(mode){// console.log("mode:",mode);
var _state2=this.state,inlineWidth=_state2.inlineWidth,verticalWidth=_state2.verticalWidth;var newMode=mode=='inline'?'vertical':'inline';var newWidth=newMode=='inline'?inlineWidth:verticalWidth;this.setState({mode:newMode});if(typeof this.props.onModeChange=='function'){this.props.onModeChange(newMode,newWidth);}}},{key:'onSelect',value:function onSelect(key,data,type){// console.log("key:",key," data:",data,"type",type);
this.setState({defaultSelectedKey:key});if(typeof this.props.onSelect=='function'){this.props.onSelect(key,data,type);}}},{key:'setTreeKey',value:function setTreeKey(pKey,datas){// console.log("datas:",datas);
var that=this;var newDatas=new Array();for(var i=0;i<datas.length;i++){var data=datas[i];data.treeKey=pKey!=''?pKey+'{$}'+data.id:data.id;if(data.child&&data.child.length>0){data.child=that.setTreeKey(data.treeKey,data.child);}newDatas.push(data);}return newDatas;}},{key:'getVerticalDatas',value:function getVerticalDatas(datas){// console.log("datas:",datas);
var newDatas=new Array();for(var i=0;i<datas.length;i++){var data=datas[i];var newData=(0,_cloneDeep2.default)(data);newData.child=[];var newDataNoChild=(0,_cloneDeep2.default)(newData);newDataNoChild.id='verTop_'+newDataNoChild.id;if(data.child){newData.child=[newDataNoChild].concat(data.child);}else{newData.child=[newDataNoChild];}newDatas.push(newData);// newDataNoChild.child = [cloneDeep(datas[i])];
// newDatas.push(newDataNoChild);
}// console.log("newDatas:",newDatas);
return newDatas;}}]);return WeaMenu;}(React.Component);exports.default=WeaMenu;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assign=__webpack_require__(57);var _assign2=_interopRequireDefault(_assign);var _stringify=__webpack_require__(78);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(16);var _cloneDeep=__webpack_require__(98);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SubMenu=_antd.Menu.SubMenu;var ItemMenu=_antd.Menu.Item;var WeaMenuInline=function(_React$Component){(0,_inherits3.default)(WeaMenuInline,_React$Component);function WeaMenuInline(props){(0,_classCallCheck3.default)(this,WeaMenuInline);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaMenuInline.__proto__||(0,_getPrototypeOf2.default)(WeaMenuInline)).call(this,props));var openKeys=_this.getOpenKeys(props.defaultSelectedKey,props.datas);// console.log("openKeys1:",openKeys);
_this.state={mode:props.mode||'Inline',datas:props.datas||[],inlineWidth:props.inlineWidth||197,verticalWidth:props.verticalWidth||61,fontSize:props.fontSize,openKeys:openKeys||[],selectedKey:props.defaultSelectedKey||'',// 包含SubMenu，只做单选
defaultSelectedKey:props.defaultSelectedKey||'',// 包含SubMenu，只做单选
canClick:true,selectedType:0};return _this;}(0,_createClass3.default)(WeaMenuInline,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// console.log('datas:',this.props.datas,nextProps.datas,this.props.datas.toString() !== nextProps.datas.toString());
// console.log('defaultSelectedKey',this.props.defaultSelectedKey,nextProps.defaultSelectedKey,this.props.defaultSelectedKey !== nextProps.defaultSelectedKey);
// console.log('defaultSelectedKey',this.state.defaultSelectedKey,nextProps.defaultSelectedKey,this.state.defaultSelectedKey !== nextProps.defaultSelectedKey);
var openKeys=this.getOpenKeys(nextProps.defaultSelectedKey,nextProps.datas);if((0,_stringify2.default)(this.props.datas)!==(0,_stringify2.default)(nextProps.datas)||this.props.defaultSelectedKey!==nextProps.defaultSelectedKey&&this.state.defaultSelectedKey!==nextProps.defaultSelectedKey||this.props.fontSize!==nextProps.fontSize){// 计算出openKeys
var newProps={datas:nextProps.datas||[],fontSize:nextProps.fontSize,openKeys:openKeys||[],defaultSelectedKey:nextProps.defaultSelectedKey||'',selectedKey:nextProps.defaultSelectedKey||''};// if(this.props.defaultSelectedKey !== nextProps.defaultSelectedKey&&this.state.defaultSelectedKey !== nextProps.defaultSelectedKey)
//    newProps.openKeys = this.getOpenKeys(nextProps.defaultSelectedKey,nextProps.datas);
this.setState(newProps);}}},{key:'render',value:function render(){var _state=this.state,mode=_state.mode,datas=_state.datas,verticalWidth=_state.verticalWidth;var _state2=this.state,openKeys=_state2.openKeys,selectedType=_state2.selectedType;var that=this;return React.createElement(_antd.Menu,{ecId:(this&&this.props&&this.props.ecId||'')+'_Menu@fc6gtr',inlineIndent:verticalWidth/2-9,mode:mode,openKeys:selectedType==1?[]:openKeys,selectedKeys:[],onOpen:function onOpen(e){that.changeOpen(e.openKeys);},onClose:function onClose(e){that.changeClose(e.openKeys);},onClick:function onClick(e){that.changeSelectedKey(e.key,that.getDataByKey(e.key,datas),0);}},this.renderMenuItem(datas,1));}},{key:'getOpenKeys',value:function getOpenKeys(key,datas){var data=this.getDataByKey(key,datas);var treeKey=data.treeKey;var treeKeyArr=treeKey?treeKey.split('{$}'):[];// console.log("treeKey:",treeKey," treeKeyArr:",treeKeyArr);
return treeKeyArr;}},{key:'onModeChange',value:function onModeChange(){var mode=this.state.mode;if(typeof this.props.onModeChange=='function'){this.props.onModeChange(mode);}}},{key:'getDataByKey',value:function getDataByKey(key,datas){var that=this;var obj='';for(var i=0;i<datas.length&&obj=='';i++){if(datas[i].id==key){obj=(0,_cloneDeep2.default)(datas[i]);}if(obj==''&&datas[i].child&&datas[i].child.length>0){obj=that.getDataByKey(key,datas[i].child);}}return obj;}},{key:'changeSelectedKey',value:function changeSelectedKey(key,data,type){if(window.event&&window.event.shiftKey){window.open((0,_pathUtil.addContentPath)(data.fullrouteurl||data.url),'_blank');return;}if(data&&data.target!='mainFrame'){window.open((0,_pathUtil.addContentPath)(data.fullrouteurl||data.url),data.target);return;}var canClick=this.state.canClick;var clickBlock=this.props.clickBlock;var that=this;// let d = new Date();
// console.log(canClick,d.getTime());
if(canClick){this.setState({canClick:false,selectedKey:key,selectedType:type});if(typeof this.props.onSelect=='function'){this.props.onSelect(key,data,type);}setTimeout(function(){that.setState({canClick:true});},clickBlock||300);}}},{key:'changeOpen',value:function changeOpen(openKeys){this.setState({openKeys:openKeys});if(typeof this.props.onOpenCallback=='function'){this.props.onOpenCallback();}}},{key:'changeClose',value:function changeClose(openKeys){this.setState({openKeys:openKeys});}},{key:'renderMenuItem',value:function renderMenuItem(datas,level){var _this2=this;var selectedClassName='wea-menu-selected';var that=this;var _state3=this.state,selectedKey=_state3.selectedKey,canClick=_state3.canClick;var datasArr=new Array();var _loop=function _loop(i){var data=datas[i];var isSubMenu=data.child&&data.child.length>0;var isSelected=selectedKey==data.id||'verTop_'+selectedKey==data.id;if(data.isInlineHide!=='true'){if(isSubMenu){datasArr.push(React.createElement(SubMenu,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SubMenu@0x72ew@'+data.id,disabled:!canClick,selectedClassName:isSelected?selectedClassName:'',key:data.id,onTitleClick:function onTitleClick(e){that.changeSelectedKey(e.key,data,0);},title:that.renderTitle(data,level)},that.renderMenuItem(data.child,level+1)));}else{datasArr.push(React.createElement(ItemMenu,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_ItemMenu@8u33tz@'+data.id,className:isSelected?selectedClassName:'',key:data.id},that.renderTitle(data,level)));}}};for(var i=0;i<datas.length;i++){_loop(i);}return datasArr;}},{key:'renderTitle',value:function renderTitle(data,level){var _state4=this.state,verticalWidth=_state4.verticalWidth,fontSize=_state4.fontSize;var that=this;var needIcon=level==1;var underLineStyle=data.hasUnderLine=='true'?{borderBottom:'1px solid #bbb'}:{};var topLineStyle=data.hasTopLine=='true'?{borderTop:'1px solid #bbb'}:{};var borderStyle=(0,_assign2.default)({position:'relative',height:'42px'},underLineStyle,topLineStyle);var outStyle={position:'absolute',display:'inline-block',width:needIcon?'calc(100% - 50px)':'90%',height:'42px'};var innerStyle={display:'inline-block',maxWidth:data.countId?'calc(100% - 40px)':'92%',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis'};var tagStyle=data.tagColor?{display:'inline-block',width:'10px',height:'10px',border:'1px solid #bbb',backgroundColor:data.tagColor,verticalAlign:'16px'}:{};var countStyle=data.countId?{display:'inline-block',width:'40px',overflow:'hidden'}:{};var iconMarginR=verticalWidth/2-9;var iconCom=data.iconType=='2'&&data.iconImgSrc?React.createElement('img',{src:(0,_pathUtil.addContentPath)(data.iconImgSrc),alt:'',className:'wea-menu-title-icon',style:{display:'inline-block',width:'18px',height:'18px',verticalAlign:'-4px',marginRight:iconMarginR},title:data.titleUrlName||'',onClick:function onClick(e){data.titleUrlIcon&&data.titleUrlName&&that.changeSelectedKey(data.id,data,1);data.titleUrlIcon&&data.titleUrlName&&e.stopPropagation();}}):data.icon?React.createElement('i',{className:'wea-menu-title-icon wevicon '+data.icon,style:{display:'inline-block',fontSize:'18px',verticalAlign:'middle',marginRight:iconMarginR},title:data.titleUrlName||'',onClick:function onClick(e){data.titleUrlIcon&&data.titleUrlName&&that.changeSelectedKey(data.id,data,1);data.titleUrlIcon&&data.titleUrlName&&e.stopPropagation();}}):React.createElement('i',{className:'wea-menu-title-icon wevicon wevicon-menu-default wevicon-menu-'+data.levelid,style:{display:'inline-block',fontSize:'18px',verticalAlign:'middle',marginRight:iconMarginR},title:data.titleUrlName||'',onClick:function onClick(e){data.titleUrlIcon&&data.titleUrlName&&that.changeSelectedKey(data.id,data,1);data.titleUrlIcon&&data.titleUrlName&&e.stopPropagation();}});var urlIconCom=data.titleUrlIcon&&!data.titleUrlName?React.createElement('img',{src:(0,_pathUtil.addContentPath)(data.titleUrlIcon),alt:'',className:'wea-menu-url-icon',style:{width:16,height:16,position:'absolute',right:20,top:13},onClick:function onClick(e){that.changeSelectedKey(data.id,data,1);e.stopPropagation();}}):null;return React.createElement('div',{'data-id':data.numId,style:borderStyle},needIcon?iconCom:'',React.createElement('div',{title:data.name,className:'wea-menu-tip-out',style:outStyle},data.tagColor&&React.createElement('span',{style:tagStyle}),React.createElement('span',{className:'wea-menu-tip-inner wea-menu-title wea-f'+fontSize,style:innerStyle},data.name),data.countId&&React.createElement('span',{id:data.countId,style:countStyle})),React.createElement('span',{id:'num_'+data.numId,style:{position:'absolute',top:0,right:0}}),urlIconCom);}}]);return WeaMenuInline;}(React.Component);exports.default=WeaMenuInline;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(140), arrayEach = __webpack_require__(332), assignValue = __webpack_require__(181), baseAssign = __webpack_require__(333), baseAssignIn = __webpack_require__(334), cloneBuffer = __webpack_require__(337), copyArray = __webpack_require__(232), copySymbols = __webpack_require__(338), copySymbolsIn = __webpack_require__(339), getAllKeys = __webpack_require__(173), getAllKeysIn = __webpack_require__(340), getTag = __webpack_require__(79), initCloneArray = __webpack_require__(341), initCloneByTag = __webpack_require__(342), initCloneObject = __webpack_require__(347), isArray = __webpack_require__(28), isBuffer = __webpack_require__(105), isMap = __webpack_require__(349), isObject = __webpack_require__(50), isSet = __webpack_require__(351), keys = __webpack_require__(84), keysIn = __webpack_require__(151);
/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */
var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
    cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
        cloneableTags[boolTag] = cloneableTags[dateTag] =
            cloneableTags[float32Tag] = cloneableTags[float64Tag] =
                cloneableTags[int8Tag] = cloneableTags[int16Tag] =
                    cloneableTags[int32Tag] = cloneableTags[mapTag] =
                        cloneableTags[numberTag] = cloneableTags[objectTag] =
                            cloneableTags[regexpTag] = cloneableTags[setTag] =
                                cloneableTags[stringTag] = cloneableTags[symbolTag] =
                                    cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
                                        cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
    cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== undefined) {
        return result;
    }
    if (!isObject(value)) {
        return value;
    }
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
            return copyArray(value, result);
        }
    }
    else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
            result = (isFlat || isFunc) ? {} : initCloneObject(value);
            if (!isDeep) {
                return isFlat
                    ? copySymbolsIn(value, baseAssignIn(result, value))
                    : copySymbols(value, baseAssign(result, value));
            }
        }
        else {
            if (!cloneableTags[tag]) {
                return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) {
        return stacked;
    }
    stack.set(value, result);
    if (isSet(value)) {
        value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
    }
    else if (isMap(value)) {
        value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
    }
    var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function (subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
            break;
        }
    }
    return array;
}
module.exports = arrayEach;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86), keys = __webpack_require__(84);
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86), keysIn = __webpack_require__(151);
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50), isPrototype = __webpack_require__(106), nativeKeysIn = __webpack_require__(336);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
    if (!isObject(object)) {
        return nativeKeysIn(object);
    }
    var isProto = isPrototype(object), result = [];
    for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
        }
    }
    return result;
}
module.exports = baseKeysIn;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
        for (var key in Object(object)) {
            result.push(key);
        }
    }
    return result;
}
module.exports = nativeKeysIn;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(24);
/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
        return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86), getSymbols = __webpack_require__(144);
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86), getSymbolsIn = __webpack_require__(183);
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(174), getSymbolsIn = __webpack_require__(183), keysIn = __webpack_require__(151);
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(152), cloneDataView = __webpack_require__(343), cloneRegExp = __webpack_require__(344), cloneSymbol = __webpack_require__(345), cloneTypedArray = __webpack_require__(346);
/** `Object#toString` result references. */
var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(152);
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(70);
/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(152);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(348), getPrototype = __webpack_require__(184), isPrototype = __webpack_require__(106);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
}
module.exports = initCloneObject;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(50);
/** Built-in value references. */
var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function () {
    function object() { }
    return function (proto) {
        if (!isObject(proto)) {
            return {};
        }
        if (objectCreate) {
            return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}());
module.exports = baseCreate;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(350), baseUnary = __webpack_require__(108), nodeUtil = __webpack_require__(147);
/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(79), isObjectLike = __webpack_require__(51);
/** `Object#toString` result references. */
var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(352), baseUnary = __webpack_require__(108), nodeUtil = __webpack_require__(147);
/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(79), isObjectLike = __webpack_require__(51);
/** `Object#toString` result references. */
var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stringify=__webpack_require__(78);var _stringify2=_interopRequireDefault(_stringify);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _antd=__webpack_require__(16);var _cloneDeep=__webpack_require__(98);var _cloneDeep2=_interopRequireDefault(_cloneDeep);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SubMenu=_antd.Menu.SubMenu;var ItemMenu=_antd.Menu.Item;var WeaMenuVertical=function(_React$Component){(0,_inherits3.default)(WeaMenuVertical,_React$Component);function WeaMenuVertical(props){(0,_classCallCheck3.default)(this,WeaMenuVertical);var _this=(0,_possibleConstructorReturn3.default)(this,(WeaMenuVertical.__proto__||(0,_getPrototypeOf2.default)(WeaMenuVertical)).call(this,props));_this.state={mode:props.mode||'vertical',datas:props.datas||[],inlineWidth:props.inlineWidth||197,verticalWidth:props.verticalWidth||61,fontSize:props.fontSize,selectedKey:props.defaultSelectedKey||'',// 包含SubMenu，只做单选
defaultSelectedKey:props.defaultSelectedKey||'',// 包含SubMenu，只做单选
canClick:true,translatepage:props.translatepage||''};_this.changeheight=_this.changeheight.bind(_this);return _this;}(0,_createClass3.default)(WeaMenuVertical,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// console.log("nextProps:",nextProps);
if((0,_stringify2.default)(this.props.datas)!==(0,_stringify2.default)(nextProps.datas)||this.props.defaultSelectedKey!==nextProps.defaultSelectedKey&&this.state.defaultSelectedKey!==nextProps.defaultSelectedKey||this.props.fontSize!==nextProps.fontSize){var key=nextProps.defaultSelectedKey&&nextProps.defaultSelectedKey.indexOf('verTop_')===0?nextProps.defaultSelectedKey.substring(7):nextProps.defaultSelectedKey;this.setState({datas:nextProps.datas||[],fontSize:nextProps.fontSize,defaultSelectedKey:nextProps.defaultSelectedKey||'',selectedKey:key||''});}}},{key:'changeheight',value:function changeheight(){var asdh=$('#menuScrollWrapper').height();$('.wea-menu-vertical .ant-menu-vertical .ant-menu-submenu>.ant-menu-sub').css({maxHeight:asdh,overflow:'auto'});}},{key:'render',value:function render(){var _state=this.state,mode=_state.mode,datas=_state.datas;var selectedKey=this.state.selectedKey;var that=this;return React.createElement(_antd.Menu,{ecId:(this&&this.props&&this.props.ecId||'')+'_Menu@zj2muk',openAnimation:function openAnimation(){},inlineIndent:14,mode:mode,selectedKeys:[selectedKey]// onOpen={(e)=>{that.changeOpen(e.openKeys)}}
// onClose={(e)=>{that.changeOpen(e.openKeys)}}
,onClick:function onClick(e){that.changeSelectedKey(e.key,that.getDataByKey(e.key,datas),0);}},this.renderMenuItem(datas,1));}},{key:'onModeChange',value:function onModeChange(){var mode=this.state.mode;if(typeof this.props.onModeChange=='function'){this.props.onModeChange(mode);}}},{key:'changeSelectedKey',value:function changeSelectedKey(key,data,type){if(window.event&&window.event.shiftKey){window.open((0,_pathUtil.addContentPath)(data.fullrouteurl||data.url),'_blank');return;}if(data&&data.target!='mainFrame'){window.open((0,_pathUtil.addContentPath)(data.fullrouteurl||data.url),data.target);return;}var canClick=this.state.canClick;var clickBlock=this.props.clickBlock;var that=this;// let d = new Date();
// console.log(canClick,d.getTime());
if(canClick){if(key&&key.indexOf('verTop_')===0){key=key.substring(7);}this.setState({canClick:false,selectedKey:key});if(typeof this.props.onSelect=='function'){this.props.onSelect(key,data,type);}setTimeout(function(){that.setState({canClick:true});},clickBlock||300);}}},{key:'getDataByKey',value:function getDataByKey(key,datas){var that=this;var obj='';for(var i=0;i<datas.length&&obj=='';i++){if(datas[i].id==key){obj=(0,_cloneDeep2.default)(datas[i]);}if(obj==''&&datas[i].child&&datas[i].child.length>0){obj=that.getDataByKey(key,datas[i].child);}}return obj;}},{key:'renderMenuItem',value:function renderMenuItem(datas,level){var _this2=this;var selectedClassName='wea-menu-selected';var that=this;var selectedKey=this.state.selectedKey;var datasArr=new Array();var _loop=function _loop(i){var data=datas[i];var isSubMenu=data.child&&data.child.length>0;var isSelected=selectedKey==data.id||'verTop_'+selectedKey==data.id;if(data.isVerticalHide!=='true'){if(isSubMenu){datasArr.push(React.createElement(SubMenu,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_SubMenu@ky9qs6@'+data.id,selectedClassName:(isSelected?selectedClassName:'')+(level==1?' wea-menu-submenu-title':''),onMouseEnter:_this2.changeheight,key:data.id,ifFixed:true,onTitleClick:function onTitleClick(e){that.changeSelectedKey(e.key,data,0);},title:that.renderTitle(data,level)},that.renderMenuItem(data.child,level+1)));if(level==2&&i==0&&!data.isVerticalHide){datasArr.push(React.createElement(_antd.Menu.Divider,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_Menu.Divider@yulrrd@'+data.id}));}}else{datasArr.push(React.createElement(ItemMenu,{ecId:(_this2&&_this2.props&&_this2.props.ecId||'')+'_ItemMenu@7slee2@'+data.id,className:isSelected?selectedClassName:'',onMouseEnter:_this2.changeheight,key:data.id},that.renderTitle(data,level)));}}};for(var i=0;i<datas.length;i++){_loop(i);}return datasArr;}},{key:'renderTitle',value:function renderTitle(data,level){var _state2=this.state,fontSize=_state2.fontSize,translatepage=_state2.translatepage;var needImg=level==1;var img=data.iconType=='2'&&data.iconImgSrc?React.createElement('img',{'data-id':data.numId,src:(0,_pathUtil.addContentPath)(data.iconImgSrc),alt:'',style:{width:'18px',height:'18px',verticalAlign:'-4px'}}):data.icon?React.createElement('i',{'data-id':data.numId,style:{fontSize:'18px',verticalAlign:'middle',margin:'auto'},className:'wevicon '+data.icon}):React.createElement('i',{'data-id':data.numId,style:{fontSize:'18px',verticalAlign:'middle',margin:'auto'},className:'wevicon wevicon-menu-default wevicon-menu-'+data.levelid});if(level>1){return React.createElement('span',{'data-id':data.numId,className:'wea-menu-title wea-f'+fontSize,style:{paddingRight:'20px',verticalAlign:'middle'}},translatepage=='1'?data.fname?data.fname:data.name:data.name);}return needImg?img:'';}}]);return WeaMenuVertical;}(React.Component);exports.default=WeaMenuVertical;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = __webpack_require__(355);
function emptyFunction() { }
function emptyFunctionWithReset() { }
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
        }
        var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use PropTypes.checkPropTypes() to call them. ' +
            'Read more at http://fb.me/use-check-prop-types');
        err.name = 'Invariant Violation';
        throw err;
    }
    ;
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    ;
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(357);

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__KeyCode__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabPane__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Sentinel__ = __webpack_require__(186);















function noop() { }
function getDefaultActiveKey(props) {
    var activeKey = void 0;
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
        if (child && !activeKey && !child.props.disabled) {
            activeKey = child.key;
        }
    });
    return activeKey;
}
function activeKeyIsValid(props, key) {
    var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
        return child && child.key;
    });
    return keys.indexOf(key) >= 0;
}
var Tabs = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);
    function Tabs(props) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);
        var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
        _initialiseProps.call(_this);
        var activeKey = void 0;
        if ('activeKey' in props) {
            activeKey = props.activeKey;
        }
        else if ('defaultActiveKey' in props) {
            activeKey = props.defaultActiveKey;
        }
        else {
            activeKey = getDefaultActiveKey(props);
        }
        _this.state = {
            activeKey: activeKey
        };
        return _this;
    }
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ('activeKey' in nextProps) {
                    this.setState({
                        activeKey: nextProps.activeKey
                    });
                }
                else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
                    // https://github.com/ant-design/ant-design/issues/7093
                    this.setState({
                        activeKey: getDefaultActiveKey(nextProps)
                    });
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.destroy = true;
                __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
            }
            // Sentinel for tab index
        }, {
            key: 'updateSentinelContext',
            value: function updateSentinelContext() {
                var _this2 = this;
                if (this.destroy)
                    return;
                __WEBPACK_IMPORTED_MODULE_10_raf___default.a.cancel(this.sentinelId);
                this.sentinelId = __WEBPACK_IMPORTED_MODULE_10_raf___default()(function () {
                    _this2.forceUpdate();
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames;
                var props = this.props;
                var prefixCls = props.prefixCls, navWrapper = props.navWrapper, tabBarPosition = props.tabBarPosition, className = props.className, renderTabContent = props.renderTabContent, renderTabBar = props.renderTabBar, destroyInactiveTabPane = props.destroyInactiveTabPane, restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);
                var cls = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), _classnames));
                this.tabBar = renderTabBar();
                var tabBar = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
                    prefixCls: prefixCls,
                    navWrapper: navWrapper,
                    key: 'tabBar',
                    onKeyDown: this.onNavKeyDown,
                    tabBarPosition: tabBarPosition,
                    onTabClick: this.onTabClick,
                    panels: props.children,
                    activeKey: this.state.activeKey
                });
                var tabContent = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
                    prefixCls: prefixCls,
                    tabBarPosition: tabBarPosition,
                    activeKey: this.state.activeKey,
                    destroyInactiveTabPane: destroyInactiveTabPane,
                    children: props.children,
                    onChange: this.setActiveKey,
                    key: 'tabContent'
                });
                var sentinelStart = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
                    key: 'sentinelStart',
                    setRef: this.setSentinelStart,
                    nextElement: this.panelSentinelStart
                });
                var sentinelEnd = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["c" /* default */], {
                    key: 'sentinelEnd',
                    setRef: this.setSentinelEnd,
                    prevElement: this.panelSentinelEnd
                });
                var contents = [];
                if (tabBarPosition === 'bottom') {
                    contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
                }
                else {
                    contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
                }
                return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Sentinel__["b" /* SentinelProvider */], {
                    value: {
                        sentinelStart: this.sentinelStart,
                        sentinelEnd: this.sentinelEnd,
                        setPanelSentinelStart: this.setPanelSentinelStart,
                        setPanelSentinelEnd: this.setPanelSentinelEnd
                    }
                }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                    className: cls,
                    style: props.style
                }, Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getDataAttr */])(restProps), {
                    onScroll: this.onScroll
                }), contents));
            }
        }]);
    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onTabClick = function (activeKey, e) {
        if (_this3.tabBar.props.onTabClick) {
            _this3.tabBar.props.onTabClick(activeKey, e);
        }
        _this3.setActiveKey(activeKey);
    };
    this.onNavKeyDown = function (e) {
        var eventKeyCode = e.keyCode;
        if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].DOWN) {
            e.preventDefault();
            var nextKey = _this3.getNextActiveKey(true);
            _this3.onTabClick(nextKey);
        }
        else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_11__KeyCode__["a" /* default */].UP) {
            e.preventDefault();
            var previousKey = _this3.getNextActiveKey(false);
            _this3.onTabClick(previousKey);
        }
    };
    this.onScroll = function (_ref) {
        var target = _ref.target, currentTarget = _ref.currentTarget;
        if (target === currentTarget && target.scrollLeft > 0) {
            target.scrollLeft = 0;
        }
    };
    this.setSentinelStart = function (node) {
        _this3.sentinelStart = node;
    };
    this.setSentinelEnd = function (node) {
        _this3.sentinelEnd = node;
    };
    this.setPanelSentinelStart = function (node) {
        if (node !== _this3.panelSentinelStart) {
            _this3.updateSentinelContext();
        }
        _this3.panelSentinelStart = node;
    };
    this.setPanelSentinelEnd = function (node) {
        if (node !== _this3.panelSentinelEnd) {
            _this3.updateSentinelContext();
        }
        _this3.panelSentinelEnd = node;
    };
    this.setActiveKey = function (activeKey) {
        if (_this3.state.activeKey !== activeKey) {
            if (!('activeKey' in _this3.props)) {
                _this3.setState({
                    activeKey: activeKey
                });
            }
            _this3.props.onChange(activeKey);
        }
    };
    this.getNextActiveKey = function (next) {
        var activeKey = _this3.state.activeKey;
        var children = [];
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this3.props.children, function (c) {
            if (c && !c.props.disabled) {
                if (next) {
                    children.push(c);
                }
                else {
                    children.unshift(c);
                }
            }
        });
        var length = children.length;
        var ret = length && children[0].key;
        children.forEach(function (child, i) {
            if (child.key === activeKey) {
                if (i === length - 1) {
                    ret = children[0].key;
                }
                else {
                    ret = children[i + 1].key;
                }
            }
        });
        return ret;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Tabs);
Tabs.propTypes = {
    destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    navWrapper: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
    prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};
Tabs.defaultProps = {
    prefixCls: 'rc-tabs',
    destroyInactiveTabPane: false,
    onChange: noop,
    navWrapper: function navWrapper(arg) {
        return arg;
    },
    tabBarPosition: 'top',
    children: null,
    style: {}
};
Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_12__TabPane__["a" /* default */];


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(363), root = typeof window === 'undefined' ? global : window, vendors = ['moz', 'webkit'], suffix = 'AnimationFrame', raf = root['request' + suffix], caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
for (var i = 0; !raf && i < vendors.length; i++) {
    raf = root[vendors[i] + 'Request' + suffix];
    caf = root[vendors[i] + 'Cancel' + suffix]
        || root[vendors[i] + 'CancelRequest' + suffix];
}
// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
    var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
    raf = function (callback) {
        if (queue.length === 0) {
            var _now = now(), next = Math.max(0, frameDuration - (_now - last));
            last = next + _now;
            setTimeout(function () {
                var cp = queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                queue.length = 0;
                for (var i = 0; i < cp.length; i++) {
                    if (!cp[i].cancelled) {
                        try {
                            cp[i].callback(last);
                        }
                        catch (e) {
                            setTimeout(function () { throw e; }, 0);
                        }
                    }
                }
            }, Math.round(next));
        }
        queue.push({
            handle: ++id,
            callback: callback,
            cancelled: false
        });
        return id;
    };
    caf = function (handle) {
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].handle === handle) {
                queue[i].cancelled = true;
            }
        }
    };
}
module.exports = function (fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn);
};
module.exports.cancel = function () {
    caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
    if (!object) {
        object = root;
    }
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function () {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
        module.exports = function () {
            return performance.now();
        };
    }
    else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
        module.exports = function () {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = process.hrtime;
        getNanoSeconds = function () {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = process.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    }
    else if (Date.now) {
        module.exports = function () {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    }
    else {
        module.exports = function () {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(this);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(364)))

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        }
        else {
            cachedSetTimeout = defaultSetTimout;
        }
    }
    catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        }
        else {
            cachedClearTimeout = defaultClearTimeout;
        }
    }
    catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
}());
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    }
    catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        }
        catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    }
    catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        }
        catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    }
    else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}
function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() { }
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function (name) { return []; };
process.binding = function (name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function () { return '/'; };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () { return 0; };


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * LEFT
     */
    LEFT: 37,
    /**
     * UP
     */
    UP: 38,
    /**
     * RIGHT
     */
    RIGHT: 39,
    /**
     * DOWN
     */
    DOWN: 40 // also NUM_SOUTH
});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _implementation = __webpack_require__(367);
var _implementation2 = _interopRequireDefault(_implementation);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _gud = __webpack_require__(368);
var _gud2 = _interopRequireDefault(_gud);
var _warning = __webpack_require__(369);
var _warning2 = _interopRequireDefault(_warning);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    }
    else {
        return x !== x && y !== y;
    }
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function (h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function (handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
    var Provider = function (_Component) {
        _inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            _classCallCheck(this, Provider);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if (objectIs(oldValue, newValue)) {
                    changedBits = 0; // No change
                }
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    if (false) {
                        (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
                    }
                    changedBits |= 0;
                    if (changedBits !== 0) {
                        this.emitter.set(nextProps.value, changedBits);
                    }
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function (_Component2) {
        _inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            _classCallCheck(this, Consumer);
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }
            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function (newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) {
                    _this2.setState({ value: _this2.getValue() });
                }
            }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
                : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) {
                this.context[contextProp].on(this.onUpdate);
            }
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
                : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) {
                this.context[contextProp].off(this.onUpdate);
            }
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) {
                return this.context[contextProp].get();
            }
            else {
                return defaultValue;
            }
        };
        Consumer.prototype.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
exports.default = createReactContext;
module.exports = exports['default'];


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow

var key = '__global_unique_id__';
module.exports = function () {
    return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var emptyFunction = __webpack_require__(370);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */
var warning = emptyFunction;
if (false) {
    var printWarning = function printWarning(format) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') {
            console.error(message);
        }
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        }
        catch (x) { }
    };
    warning = function warning(condition, format) {
        if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
        }
        if (format.indexOf('Failed Composite propType: ') === 0) {
            return; // Ignore CompositeComponent proptype check.
        }
        if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
            }
            printWarning.apply(undefined, [format].concat(args));
        }
    };
}
module.exports = warning;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
function makeEmptyFunction(arg) {
    return function () {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() { };
emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
    return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
};
module.exports = emptyFunction;


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(153);










var TabContent = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);
    function TabContent() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
    }
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TabContent, [{
            key: 'getTabPanes',
            value: function getTabPanes() {
                var props = this.props;
                var activeKey = props.activeKey;
                var children = props.children;
                var newChildren = [];
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
                    if (!child) {
                        return;
                    }
                    var key = child.key;
                    var active = activeKey === key;
                    newChildren.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
                        active: active,
                        destroyInactiveTabPane: props.destroyInactiveTabPane,
                        rootPrefixCls: props.prefixCls
                    }));
                });
                return newChildren;
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames;
                var props = this.props;
                var prefixCls = props.prefixCls, children = props.children, activeKey = props.activeKey, className = props.className, tabBarPosition = props.tabBarPosition, animated = props.animated, animatedWithMargin = props.animatedWithMargin;
                var style = props.style;
                var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
                if (animated) {
                    var activeIndex = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getActiveIndex */])(children, activeKey);
                    if (activeIndex !== -1) {
                        var animatedStyle = animatedWithMargin ? Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* getMarginStyle */])(activeIndex, tabBarPosition) : Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* getTransformPropValue */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition));
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
                    }
                    else {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
                            display: 'none'
                        });
                    }
                }
                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', {
                    className: classes,
                    style: style
                }, this.getTabPanes());
            }
        }]);
    return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (TabContent);
TabContent.propTypes = {
    animated: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    animatedWithMargin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    tabBarPosition: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
TabContent.defaultProps = {
    animated: true
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _TabBarRootNode = __webpack_require__(72);
var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
var _TabBarTabsNode = __webpack_require__(88);
var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
var _SaveRef = __webpack_require__(73);
var _SaveRef2 = _interopRequireDefault(_SaveRef);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
/* eslint-disable react/prefer-stateless-function */
var TabBar = function (_React$Component) {
    (0, _inherits3['default'])(TabBar, _React$Component);
    function TabBar() {
        (0, _classCallCheck3['default'])(this, TabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (TabBar.__proto__ || Object.getPrototypeOf(TabBar)).apply(this, arguments));
    }
    (0, _createClass3['default'])(TabBar, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                return _react2['default'].createElement(_SaveRef2['default'], null, function (saveRef) {
                    return _react2['default'].createElement(_TabBarRootNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props), _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props)));
                });
            }
        }]);
    return TabBar;
}(_react2['default'].Component);
exports['default'] = TabBar;
module.exports = exports['default'];


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _InkTabBarNode = __webpack_require__(154);
var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);
var _TabBarTabsNode = __webpack_require__(88);
var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
var _TabBarRootNode = __webpack_require__(72);
var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
var _SaveRef = __webpack_require__(73);
var _SaveRef2 = _interopRequireDefault(_SaveRef);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
/* eslint-disable react/prefer-stateless-function */
var InkTabBar = function (_React$Component) {
    (0, _inherits3['default'])(InkTabBar, _React$Component);
    function InkTabBar() {
        (0, _classCallCheck3['default'])(this, InkTabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (InkTabBar.__proto__ || Object.getPrototypeOf(InkTabBar)).apply(this, arguments));
    }
    (0, _createClass3['default'])(InkTabBar, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                return _react2['default'].createElement(_SaveRef2['default'], null, function (saveRef, getRef) {
                    return _react2['default'].createElement(_TabBarRootNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props), _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ onTabClick: _this2.props.onTabClick, saveRef: saveRef }, _this2.props)), _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props)));
                });
            }
        }]);
    return InkTabBar;
}(_react2['default'].Component);
exports['default'] = InkTabBar;
InkTabBar.propTypes = {
    onTabClick: _propTypes2['default'].func
};
InkTabBar.defaultProps = {
    onTabClick: function onTabClick() { }
};
module.exports = exports['default'];


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _ScrollableTabBarNode = __webpack_require__(187);
var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);
var _TabBarRootNode = __webpack_require__(72);
var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
var _TabBarTabsNode = __webpack_require__(88);
var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
var _SaveRef = __webpack_require__(73);
var _SaveRef2 = _interopRequireDefault(_SaveRef);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var ScrollableTabBar = function (_React$Component) {
    (0, _inherits3['default'])(ScrollableTabBar, _React$Component);
    function ScrollableTabBar() {
        (0, _classCallCheck3['default'])(this, ScrollableTabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBar.__proto__ || Object.getPrototypeOf(ScrollableTabBar)).apply(this, arguments));
    }
    (0, _createClass3['default'])(ScrollableTabBar, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                return _react2['default'].createElement(_SaveRef2['default'], null, function (saveRef, getRef) {
                    return _react2['default'].createElement(_TabBarRootNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props), _react2['default'].createElement(_ScrollableTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props), _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props))));
                });
            }
        }]);
    return ScrollableTabBar;
}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */
exports['default'] = ScrollableTabBar;
module.exports = exports['default'];


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(188), now = __webpack_require__(376), toNumber = __webpack_require__(378);
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
            (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) {
            clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
        }
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(189);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function () {
    return root.Date.now();
};
module.exports = now;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(188), isSymbol = __webpack_require__(379);
/** Used as references for various `Number` constants. */
var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
    if (typeof value == 'number') {
        return value;
    }
    if (isSymbol(value)) {
        return NAN;
    }
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
    }
    if (typeof value != 'string') {
        return value === 0 ? value : +value;
    }
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
}
module.exports = toNumber;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(380), isObjectLike = __webpack_require__(383);
/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
}
module.exports = isSymbol;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(190), getRawTag = __webpack_require__(381), objectToString = __webpack_require__(382);
/** `Object#toString` result references. */
var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
}
module.exports = baseGetTag;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(190);
/** Used for built-in method references. */
var objectProto = Object.prototype;
/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    }
    catch (e) { }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
module.exports = getRawTag;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;


/***/ }),
/* 383 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _SwipeableTabBarNode = __webpack_require__(385);
var _SwipeableTabBarNode2 = _interopRequireDefault(_SwipeableTabBarNode);
var _TabBarSwipeableTabs = __webpack_require__(388);
var _TabBarSwipeableTabs2 = _interopRequireDefault(_TabBarSwipeableTabs);
var _TabBarRootNode = __webpack_require__(72);
var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
var _InkTabBarNode = __webpack_require__(154);
var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);
var _SaveRef = __webpack_require__(73);
var _SaveRef2 = _interopRequireDefault(_SaveRef);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
/* eslint-disable react/prefer-stateless-function */
var SwipeableInkTabBar = function (_React$Component) {
    (0, _inherits3['default'])(SwipeableInkTabBar, _React$Component);
    function SwipeableInkTabBar() {
        (0, _classCallCheck3['default'])(this, SwipeableInkTabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (SwipeableInkTabBar.__proto__ || Object.getPrototypeOf(SwipeableInkTabBar)).apply(this, arguments));
    }
    (0, _createClass3['default'])(SwipeableInkTabBar, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                return _react2['default'].createElement(_SaveRef2['default'], null, function (saveRef, getRef) {
                    return _react2['default'].createElement(_TabBarRootNode2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props), _react2['default'].createElement(_SwipeableTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props), _react2['default'].createElement(_TabBarSwipeableTabs2['default'], (0, _extends3['default'])({ saveRef: saveRef }, _this2.props)), _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, _this2.props))));
                });
            }
        }]);
    return SwipeableInkTabBar;
}(_react2['default'].Component);
exports['default'] = SwipeableInkTabBar;
module.exports = exports['default'];


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames3 = __webpack_require__(32);
var _classnames4 = _interopRequireDefault(_classnames3);
var _rcHammerjs = __webpack_require__(191);
var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);
var _reactDom = __webpack_require__(17);
var _reactDom2 = _interopRequireDefault(_reactDom);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var SwipeableTabBarNode = function (_React$Component) {
    (0, _inherits3['default'])(SwipeableTabBarNode, _React$Component);
    function SwipeableTabBarNode(props) {
        (0, _classCallCheck3['default'])(this, SwipeableTabBarNode);
        var _this = (0, _possibleConstructorReturn3['default'])(this, (SwipeableTabBarNode.__proto__ || Object.getPrototypeOf(SwipeableTabBarNode)).call(this, props));
        _initialiseProps.call(_this);
        var _this$checkPagination = _this.checkPaginationByKey(_this.props.activeKey), hasPrevPage = _this$checkPagination.hasPrevPage, hasNextPage = _this$checkPagination.hasNextPage;
        _this.state = {
            hasPrevPage: hasPrevPage,
            hasNextPage: hasNextPage
        };
        return _this;
    }
    (0, _createClass3['default'])(SwipeableTabBarNode, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var swipe = this.props.getRef('swipe');
                var nav = this.props.getRef('nav');
                var activeKey = this.props.activeKey;
                this.swipeNode = _reactDom2['default'].findDOMNode(swipe); // dom which scroll (9999px)
                this.realNode = _reactDom2['default'].findDOMNode(nav); // dom which visiable in screen (viewport)
                this.setCache();
                this.setSwipePositionByKey(activeKey);
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                this.setCache();
                if (this.props.activeKey && this.props.activeKey !== prevProps.activeKey || this.props.panels.length !== prevProps.panels.length || this.props.pageSize !== prevProps.pageSize) {
                    this.setSwipePositionByKey(this.props.activeKey);
                }
            }
        }, {
            key: 'setCache',
            value: function setCache() {
                var _props = this.props, tabBarPosition = _props.tabBarPosition, pageSize = _props.pageSize, panels = _props.panels;
                var _isVertical = (0, _utils.isVertical)(tabBarPosition);
                var _viewSize = (0, _utils.getStyle)(this.realNode, _isVertical ? 'height' : 'width');
                var _tabWidth = _viewSize / pageSize;
                this.cache = (0, _extends3['default'])({}, this.cache, {
                    vertical: _isVertical,
                    totalAvaliableDelta: _tabWidth * panels.length - _viewSize,
                    tabWidth: _tabWidth
                });
            }
            /**
             * used for props.activeKey setting, not for swipe callback
             */
        }, {
            key: 'getDeltaByKey',
            value: function getDeltaByKey(activeKey) {
                var pageSize = this.props.pageSize;
                var index = this.getIndexByKey(activeKey);
                var centerTabCount = Math.floor(pageSize / 2);
                var tabWidth = this.cache.tabWidth;
                var delta = (index - centerTabCount) * tabWidth * -1;
                return delta;
            }
        }, {
            key: 'getIndexByKey',
            value: function getIndexByKey(activeKey) {
                var panels = this.props.panels;
                var length = panels.length;
                for (var i = 0; i < length; i++) {
                    if (panels[i].key === activeKey) {
                        return i;
                    }
                }
                return -1;
            }
        }, {
            key: 'setSwipePositionByKey',
            value: function setSwipePositionByKey(activeKey) {
                var _checkPaginationByKey = this.checkPaginationByKey(activeKey), hasPrevPage = _checkPaginationByKey.hasPrevPage, hasNextPage = _checkPaginationByKey.hasNextPage;
                var totalAvaliableDelta = this.cache.totalAvaliableDelta;
                this.setState({
                    hasPrevPage: hasPrevPage,
                    hasNextPage: hasNextPage
                });
                var delta = void 0;
                if (!hasPrevPage) {
                    // the first page
                    delta = 0;
                }
                else if (!hasNextPage) {
                    // the last page
                    delta = -totalAvaliableDelta;
                }
                else if (hasNextPage) {
                    // the middle page
                    delta = this.getDeltaByKey(activeKey);
                }
                this.cache.totalDelta = delta;
                this.setSwipePosition();
            }
        }, {
            key: 'setSwipePosition',
            value: function setSwipePosition() {
                var _cache = this.cache, totalDelta = _cache.totalDelta, vertical = _cache.vertical;
                (0, _utils.setPxStyle)(this.swipeNode, totalDelta, vertical);
            }
        }, {
            key: 'checkPaginationByKey',
            value: function checkPaginationByKey(activeKey) {
                var _props2 = this.props, panels = _props2.panels, pageSize = _props2.pageSize;
                var index = this.getIndexByKey(activeKey);
                var centerTabCount = Math.floor(pageSize / 2);
                // the basic rule is to make activeTab be shown in the center of TabBar viewport
                return {
                    hasPrevPage: index - centerTabCount > 0,
                    hasNextPage: index + centerTabCount < panels.length
                };
            }
        }, {
            key: 'checkPaginationByDelta',
            value: function checkPaginationByDelta(delta) {
                var totalAvaliableDelta = this.cache.totalAvaliableDelta;
                return {
                    hasPrevPage: delta < 0,
                    hasNextPage: -delta < totalAvaliableDelta
                };
            }
        }, {
            key: 'render',
            value: function render() {
                var _classnames2;
                var _props3 = this.props, prefixCls = _props3.prefixCls, hammerOptions = _props3.hammerOptions, tabBarPosition = _props3.tabBarPosition;
                var _state = this.state, hasPrevPage = _state.hasPrevPage, hasNextPage = _state.hasNextPage;
                var navClassName = prefixCls + '-nav';
                var navClasses = (0, _classnames4['default'])((0, _defineProperty3['default'])({}, navClassName, true));
                var events = {
                    onPan: this.onPan
                };
                return _react2['default'].createElement('div', {
                    className: (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-swipe-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-prevpage', hasPrevPage), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nextpage', hasNextPage), _classnames2)),
                    key: 'container',
                    ref: this.props.saveRef('container')
                }, _react2['default'].createElement('div', { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') }, _react2['default'].createElement(_rcHammerjs2['default'], (0, _extends3['default'])({}, events, {
                    direction: (0, _utils.isVertical)(tabBarPosition) ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL',
                    options: hammerOptions
                }), _react2['default'].createElement('div', { className: prefixCls + '-nav-swipe', ref: this.props.saveRef('swipe') }, _react2['default'].createElement('div', { className: navClasses, ref: this.props.saveRef('nav') }, this.props.children)))));
            }
        }]);
    return SwipeableTabBarNode;
}(_react2['default'].Component);
var _initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.onPan = function (e) {
        var _cache2 = _this2.cache, vertical = _cache2.vertical, totalAvaliableDelta = _cache2.totalAvaliableDelta, totalDelta = _cache2.totalDelta;
        var speed = _this2.props.speed;
        // calculate touch distance
        var nowDelta = vertical ? e.deltaY : e.deltaX;
        nowDelta *= speed / 10;
        // calculate distance dom need transform
        var _nextDelta = nowDelta + totalDelta;
        if (_nextDelta >= 0) {
            _nextDelta = 0;
        }
        else if (_nextDelta <= -totalAvaliableDelta) {
            _nextDelta = -totalAvaliableDelta;
        }
        _this2.cache.totalDelta = _nextDelta;
        _this2.setSwipePosition();
        // calculate pagination display
        var _checkPaginationByDel = _this2.checkPaginationByDelta(_this2.cache.totalDelta), hasPrevPage = _checkPaginationByDel.hasPrevPage, hasNextPage = _checkPaginationByDel.hasNextPage;
        if (hasPrevPage !== _this2.state.hasPrevPage || hasNextPage !== _this2.state.hasNextPage) {
            _this2.setState({
                hasPrevPage: hasPrevPage,
                hasNextPage: hasNextPage
            });
        }
    };
};
exports['default'] = SwipeableTabBarNode;
SwipeableTabBarNode.propTypes = {
    activeKey: _propTypes2['default'].string,
    panels: _propTypes2['default'].node,
    pageSize: _propTypes2['default'].number,
    tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
    prefixCls: _propTypes2['default'].string,
    children: _propTypes2['default'].node,
    hammerOptions: _propTypes2['default'].object,
    speed: _propTypes2['default'].number,
    saveRef: _propTypes2['default'].func,
    getRef: _propTypes2['default'].func
};
SwipeableTabBarNode.defaultProps = {
    panels: null,
    tabBarPosition: 'top',
    prefixCls: '',
    children: null,
    hammerOptions: {},
    pageSize: 5,
    speed: 7,
    saveRef: function saveRef() { },
    getRef: function getRef() { }
};
module.exports = exports['default'];


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);







// https://github.com/hammerjs/hammer.js/issues/930
// https://github.com/JedWatson/react-hammerjs/issues/14
// require('hammerjs') when in a browser. This is safe because Hammer is only
// invoked in componentDidMount, which is not executed on the server.
var Hammer = typeof window !== 'undefined' ? __webpack_require__(387) : undefined;
var privateProps = {
    children: true,
    direction: true,
    options: true,
    recognizeWith: true,
    vertical: true
};
/**
 * Hammer Component
 * ================
 */
var handlerToEvent = {
    action: 'tap press',
    onDoubleTap: 'doubletap',
    onPan: 'pan',
    onPanCancel: 'pancancel',
    onPanEnd: 'panend',
    onPanStart: 'panstart',
    onPinch: 'pinch',
    onPinchCancel: 'pinchcancel',
    onPinchEnd: 'pinchend',
    onPinchIn: 'pinchin',
    onPinchOut: 'pinchout',
    onPinchStart: 'pinchstart',
    onPress: 'press',
    onPressUp: 'pressup',
    onRotate: 'rotate',
    onRotateCancel: 'rotatecancel',
    onRotateEnd: 'rotateend',
    onRotateMove: 'rotatemove',
    onRotateStart: 'rotatestart',
    onSwipe: 'swipe',
    onSwipeRight: 'swiperight',
    onSwipeLeft: 'swipeleft',
    onSwipeUp: 'swipeup',
    onSwipeDown: 'swipedown',
    onTap: 'tap'
};
Object.keys(handlerToEvent).forEach(function (i) {
    privateProps[i] = true;
});
function updateHammer(hammer, props) {
    var _this = this;
    if (props.hasOwnProperty('vertical')) {
        console.warn('vertical is deprecated, please use `direction` instead');
    }
    var directionProp = props.direction;
    if (directionProp || props.hasOwnProperty('vertical')) {
        var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
        hammer.get('pan').set({ direction: Hammer[direction] });
        hammer.get('swipe').set({ direction: Hammer[direction] });
    }
    if (props.options) {
        Object.keys(props.options).forEach(function (option) {
            if (option === 'recognizers') {
                Object.keys(props.options.recognizers).forEach(function (gesture) {
                    var recognizer = hammer.get(gesture);
                    recognizer.set(props.options.recognizers[gesture]);
                    if (props.options.recognizers[gesture].requireFailure) {
                        recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
                    }
                }, _this);
            }
            else {
                var key = option;
                var optionObj = {};
                optionObj[key] = props.options[option];
                hammer.set(optionObj);
            }
        }, this);
    }
    if (props.recognizeWith) {
        Object.keys(props.recognizeWith).forEach(function (gesture) {
            var recognizer = hammer.get(gesture);
            recognizer.recognizeWith(props.recognizeWith[gesture]);
        }, this);
    }
    Object.keys(props).forEach(function (p) {
        var e = handlerToEvent[p];
        if (e) {
            hammer.off(e);
            hammer.on(e, props[p]);
        }
    });
}
var HammerComponent = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(HammerComponent, _React$Component);
    function HammerComponent() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HammerComponent);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HammerComponent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.hammer = new Hammer(__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this));
                updateHammer(this.hammer, this.props);
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.hammer) {
                    updateHammer(this.hammer, this.props);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this.hammer) {
                    this.hammer.stop();
                    this.hammer.destroy();
                }
                this.hammer = null;
            }
        }, {
            key: 'render',
            value: function render() {
                var props = {};
                Object.keys(this.props).forEach(function (i) {
                    if (!privateProps[i]) {
                        props[i] = this.props[i];
                    }
                }, this);
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(this.props.children), props);
            }
        }]);
    return HammerComponent;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
HammerComponent.displayName = 'Hammer';
HammerComponent.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (HammerComponent);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function (window, document, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
    var TEST_ELEMENT = document.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
     * set a timeout with a given scope
     * @param {Function} fn
     * @param {Number} timeout
     * @param {Object} context
     * @returns {number}
     */
    function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
     * if the argument is an array, we want to execute the fn on each entry
     * if it aint an array we don't want to do a thing.
     * this is used by all the methods that accept a single and array argument.
     * @param {*|Array} arg
     * @param {String} fn
     * @param {Object} [context]
     * @returns {Boolean}
     */
    function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
     * walk objects and arrays
     * @param {Object} obj
     * @param {Function} iterator
     * @param {Object} context
     */
    function each(obj, iterator, context) {
        var i;
        if (!obj) {
            return;
        }
        if (obj.forEach) {
            obj.forEach(iterator, context);
        }
        else if (obj.length !== undefined) {
            i = 0;
            while (i < obj.length) {
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        }
        else {
            for (i in obj) {
                obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
            }
        }
    }
    /**
     * wrap a method with a deprecation warning and stack trace
     * @param {Function} method
     * @param {String} name
     * @param {String} message
     * @returns {Function} A new function wrapping the supplied method.
     */
    function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function () {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
                .replace(/^\s+at\s+/gm, '')
                .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window.console && (window.console.warn || window.console.log);
            if (log) {
                log.call(window.console, deprecationMessage, stack);
            }
            return method.apply(this, arguments);
        };
    }
    /**
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} target
     * @param {...Object} objects_to_assign
     * @returns {Object} target
     */
    var assign;
    if (typeof Object.assign !== 'function') {
        assign = function assign(target) {
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }
            var output = Object(target);
            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];
                if (source !== undefined && source !== null) {
                    for (var nextKey in source) {
                        if (source.hasOwnProperty(nextKey)) {
                            output[nextKey] = source[nextKey];
                        }
                    }
                }
            }
            return output;
        };
    }
    else {
        assign = Object.assign;
    }
    /**
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} dest
     * @param {Object} src
     * @param {Boolean} [merge=false]
     * @returns {Object} dest
     */
    var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while (i < keys.length) {
            if (!merge || (merge && dest[keys[i]] === undefined)) {
                dest[keys[i]] = src[keys[i]];
            }
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
     * merge the values from src in the dest.
     * means that properties that exist in dest will not be overwritten by src
     * @param {Object} dest
     * @param {Object} src
     * @returns {Object} dest
     */
    var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
     * simple class inheritance
     * @param {Function} child
     * @param {Function} base
     * @param {Object} [properties]
     */
    function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) {
            assign(childP, properties);
        }
    }
    /**
     * simple function bind
     * @param {Function} fn
     * @param {Object} context
     * @returns {Function}
     */
    function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
     * let a boolean value also be a function that must return a boolean
     * this first item in args will be used as the context
     * @param {Boolean|Function} val
     * @param {Array} [args]
     * @returns {Boolean}
     */
    function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) {
            return val.apply(args ? args[0] || undefined : undefined, args);
        }
        return val;
    }
    /**
     * use the val2 when val1 is undefined
     * @param {*} val1
     * @param {*} val2
     * @returns {*}
     */
    function ifUndefined(val1, val2) {
        return (val1 === undefined) ? val2 : val1;
    }
    /**
     * addEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */
    function addEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
     * removeEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */
    function removeEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
     * find if a node is in the given parent
     * @method hasParent
     * @param {HTMLElement} node
     * @param {HTMLElement} parent
     * @return {Boolean} found
     */
    function hasParent(node, parent) {
        while (node) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }
    /**
     * small indexOf wrapper
     * @param {String} str
     * @param {String} find
     * @returns {Boolean} found
     */
    function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
     * split string on whitespace
     * @param {String} str
     * @returns {Array} words
     */
    function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
     * find if a array contains the object using indexOf or a simple polyFill
     * @param {Array} src
     * @param {String} find
     * @param {String} [findByKey]
     * @return {Boolean|Number} false when not found, or the index
     */
    function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) {
            return src.indexOf(find);
        }
        else {
            var i = 0;
            while (i < src.length) {
                if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                    return i;
                }
                i++;
            }
            return -1;
        }
    }
    /**
     * convert array-like objects to real arrays
     * @param {Object} obj
     * @returns {Array}
     */
    function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
     * unique array with objects based on a key (like 'id') or just by the array's value
     * @param {Array} src [{id:1},{id:2},{id:1}]
     * @param {String} [key]
     * @param {Boolean} [sort=False]
     * @returns {Array} [{id:1},{id:2}]
     */
    function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while (i < src.length) {
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) {
                results.push(src[i]);
            }
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) {
                results = results.sort();
            }
            else {
                results = results.sort(function sortUniqueArray(a, b) {
                    return a[key] > b[key];
                });
            }
        }
        return results;
    }
    /**
     * get the prefixed property
     * @param {Object} obj
     * @param {String} property
     * @returns {String|Undefined} prefixed
     */
    function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while (i < VENDOR_PREFIXES.length) {
            prefix = VENDOR_PREFIXES[i];
            prop = (prefix) ? prefix + camelProp : property;
            if (prop in obj) {
                return prop;
            }
            i++;
        }
        return undefined;
    }
    /**
     * get a unique id
     * @returns {number} uniqueId
     */
    var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
     * get the window object of an element
     * @param {HTMLElement} element
     * @returns {DocumentView|Window}
     */
    function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return (doc.defaultView || doc.parentWindow || window);
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = ('ontouchstart' in window);
    var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ['x', 'y'];
    var PROPS_CLIENT_XY = ['clientX', 'clientY'];
    /**
     * create new input type manager
     * @param {Manager} manager
     * @param {Function} callback
     * @returns {Input}
     * @constructor
     */
    function Input(manager, callback) {
        var self = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function (ev) {
            if (boolOrFn(manager.options.enable, [manager])) {
                self.handler(ev);
            }
        };
        this.init();
    }
    Input.prototype = {
        /**
         * should handle the inputEvent data and trigger the callback
         * @virtual
         */
        handler: function () { },
        /**
         * bind the events
         */
        init: function () {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
         * unbind the events
         */
        destroy: function () {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
     * create new input type manager
     * called by the Manager constructor
     * @param {Hammer} manager
     * @returns {Input}
     */
    function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) {
            Type = inputClass;
        }
        else if (SUPPORT_POINTER_EVENTS) {
            Type = PointerEventInput;
        }
        else if (SUPPORT_ONLY_TOUCH) {
            Type = TouchInput;
        }
        else if (!SUPPORT_TOUCH) {
            Type = MouseInput;
        }
        else {
            Type = TouchMouseInput;
        }
        return new (Type)(manager, inputHandler);
    }
    /**
     * handle input events
     * @param {Manager} manager
     * @param {String} eventType
     * @param {Object} input
     */
    function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
        var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) {
            manager.session = {};
        }
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
     * extend the data with some usable properties like scale, rotate, velocity etc
     * @param {Object} manager
     * @param {Object} input
     */
    function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) {
            session.firstInput = simpleCloneInputData(input);
        }
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) {
            session.firstMultiple = simpleCloneInputData(input);
        }
        else if (pointersLength === 1) {
            session.firstMultiple = false;
        }
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
            session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) {
            target = input.srcEvent.target;
        }
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
     * velocity is calculated every x ms
     * @param {Object} session
     * @param {Object} input
     */
    function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        }
        else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
     * create a simple clone from the input used for storage of firstInput and firstMultiple
     * @param {Object} input
     * @returns {Object} clonedInputData
     */
    function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while (i < input.pointers.length) {
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
     * get the center of all the pointers
     * @param {Array} pointers
     * @return {Object} center contains `x` and `y` properties
     */
    function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) {
            return {
                x: round(pointers[0].clientX),
                y: round(pointers[0].clientY)
            };
        }
        var x = 0, y = 0, i = 0;
        while (i < pointersLength) {
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
     * calculate the velocity between two points. unit is in px per ms.
     * @param {Number} deltaTime
     * @param {Number} x
     * @param {Number} y
     * @return {Object} velocity `x` and `y`
     */
    function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
     * get the direction between two points
     * @param {Number} x
     * @param {Number} y
     * @return {Number} direction
     */
    function getDirection(x, y) {
        if (x === y) {
            return DIRECTION_NONE;
        }
        if (abs(x) >= abs(y)) {
            return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        }
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
     * calculate the absolute distance between two points
     * @param {Object} p1 {x, y}
     * @param {Object} p2 {x, y}
     * @param {Array} [props] containing x and y keys
     * @return {Number} distance
     */
    function getDistance(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt((x * x) + (y * y));
    }
    /**
     * calculate the angle between two coordinates
     * @param {Object} p1
     * @param {Object} p2
     * @param {Array} [props] containing x and y keys
     * @return {Number} angle
     */
    function getAngle(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
     * calculate the rotation degrees between two pointersets
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} rotation
     */
    function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
     * calculate the scale factor between two pointersets
     * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} scale
     */
    function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
     * Mouse events input
     * @constructor
     * @extends Input
     */
    function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) {
                this.pressed = true;
            }
            if (eventType & INPUT_MOVE && ev.which !== 1) {
                eventType = INPUT_END;
            }
            // mouse must be down
            if (!this.pressed) {
                return;
            }
            if (eventType & INPUT_END) {
                this.pressed = false;
            }
            this.callback(this.manager, eventType, {
                pointers: [ev],
                changedPointers: [ev],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window.MSPointerEvent && !window.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
     * Pointer events input
     * @constructor
     * @extends Input
     */
    function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = (this.manager.session.pointerEvents = []);
    }
    inherit(PointerEventInput, Input, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = (pointerType == INPUT_TYPE_TOUCH);
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            }
            else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                removePointer = true;
            }
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) {
                return;
            }
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [ev],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) {
                // remove from the store
                store.splice(storeIndex, 1);
            }
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * Touch events input
     * @constructor
     * @extends Input
     */
    function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) {
                this.started = true;
            }
            if (!this.started) {
                return;
            }
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
                this.started = false;
            }
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
     * @this {TouchInput}
     * @param {Object} ev
     * @param {Number} type flag
     * @returns {undefined|Array} [all, changed]
     */
    function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) {
            all = uniqueArray(all.concat(changed), 'identifier', true);
        }
        return [all, changed];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * Multi-user touch events input
     * @constructor
     * @extends Input
     */
    function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) {
                return;
            }
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
     * @this {TouchInput}
     * @param {Object} ev
     * @param {Number} type flag
     * @returns {undefined|Array} [all, changed]
     */
    function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [allTouches, allTouches];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function (touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while (i < targetTouches.length) {
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while (i < changedTouches.length) {
            if (targetIds[changedTouches[i].identifier]) {
                changedTargetTouches.push(changedTouches[i]);
            }
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) {
                delete targetIds[changedTouches[i].identifier];
            }
            i++;
        }
        if (!changedTargetTouches.length) {
            return;
        }
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
     * Combined touch and mouse input
     *
     * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
     * This because touch devices also emit mouse events while doing a touch.
     *
     * @constructor
     * @extends Input
     */
    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
         * handle mouse and touch events
         * @param {Hammer} manager
         * @param {String} inputEvent
         * @param {Object} inputData
         */
        handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH), isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
                return;
            }
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) {
                recordTouches.call(this, inputEvent, inputData);
            }
            else if (isMouse && isSyntheticEvent.call(this, inputData)) {
                return;
            }
            this.callback(manager, inputEvent, inputData);
        },
        /**
         * remove the event listeners
         */
        destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        }
        else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            setLastTouch.call(this, eventData);
        }
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = { x: touch.clientX, y: touch.clientY };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function () {
                var i = lts.indexOf(lastTouch);
                if (i > -1) {
                    lts.splice(i, 1);
                }
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for (var i = 0; i < this.lastTouches.length; i++) {
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
                return true;
            }
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
     * Touch Action
     * sets the touchAction property or uses the js alternative
     * @param {Manager} manager
     * @param {String} value
     * @constructor
     */
    function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
         * set the touchAction value on the element or enable the polyfill
         * @param {String} value
         */
        set: function (value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) {
                value = this.compute();
            }
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
                this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            }
            this.actions = value.toLowerCase().trim();
        },
        /**
         * just re-set the touchAction value
         */
        update: function () {
            this.set(this.manager.options.touchAction);
        },
        /**
         * compute the value for the touchAction property based on the recognizer's settings
         * @returns {String} value
         */
        compute: function () {
            var actions = [];
            each(this.manager.recognizers, function (recognizer) {
                if (boolOrFn(recognizer.options.enable, [recognizer])) {
                    actions = actions.concat(recognizer.getTouchAction());
                }
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
         * this method is called on each input cycle and provides the preventing of the browser behavior
         * @param {Object} input
         */
        preventDefaults: function (input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) {
                    return;
                }
            }
            if (hasPanX && hasPanY) {
                // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
                return;
            }
            if (hasNone ||
                (hasPanY && direction & DIRECTION_HORIZONTAL) ||
                (hasPanX && direction & DIRECTION_VERTICAL)) {
                return this.preventSrc(srcEvent);
            }
        },
        /**
         * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
         * @param {Object} srcEvent
         */
        preventSrc: function (srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
     * when the touchActions are collected they are not a valid value, so we need to clean things up. *
     * @param {String} actions
     * @returns {*}
     */
    function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) {
            return TOUCH_ACTION_NONE;
        }
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) {
            return TOUCH_ACTION_NONE;
        }
        // pan-x OR pan-y
        if (hasPanX || hasPanY) {
            return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        }
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
            return TOUCH_ACTION_MANIPULATION;
        }
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) {
            return false;
        }
        var touchMap = {};
        var cssSupports = window.CSS && window.CSS.supports;
        ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
     * Recognizer flow explained; *
     * All recognizers have the initial state of POSSIBLE when a input session starts.
     * The definition of a input session is from the first input until the last input, with all it's movement in it. *
     * Example session for mouse-input: mousedown -> mousemove -> mouseup
     *
     * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
     * which determines with state it should be.
     *
     * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
     * POSSIBLE to give it another change on the next cycle.
     *
     *               Possible
     *                  |
     *            +-----+---------------+
     *            |                     |
     *      +-----+-----+               |
     *      |           |               |
     *   Failed      Cancelled          |
     *                          +-------+------+
     *                          |              |
     *                      Recognized       Began
     *                                         |
     *                                      Changed
     *                                         |
     *                                  Ended/Recognized
     */
    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
     * Recognizer
     * Every recognizer needs to extend from this class.
     * @constructor
     * @param {Object} options
     */
    function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
         * @virtual
         * @type {Object}
         */
        defaults: {},
        /**
         * set options
         * @param {Object} options
         * @return {Recognizer}
         */
        set: function (options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
         * recognize simultaneous with an other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        recognizeWith: function (otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
                return this;
            }
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
         * drop the simultaneous link. it doesnt remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRecognizeWith: function (otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
                return this;
            }
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
         * recognizer can only run when an other is failing
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        requireFailure: function (otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
                return this;
            }
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
         * drop the requireFailure link. it does not remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRequireFailure: function (otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
                return this;
            }
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) {
                this.requireFail.splice(index, 1);
            }
            return this;
        },
        /**
         * has require failures boolean
         * @returns {boolean}
         */
        hasRequireFailures: function () {
            return this.requireFail.length > 0;
        },
        /**
         * if the recognizer can recognize simultaneous with an other recognizer
         * @param {Recognizer} otherRecognizer
         * @returns {Boolean}
         */
        canRecognizeWith: function (otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
         * You should use `tryEmit` instead of `emit` directly to check
         * that all the needed recognizers has failed before emitting.
         * @param {Object} input
         */
        emit: function (input) {
            var self = this;
            var state = this.state;
            function emit(event) {
                self.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }
            emit(self.options.event); // simple 'eventName' events
            if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
                emit(input.additionalEvent);
            }
            // panend and pancancel
            if (state >= STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }
        },
        /**
         * Check that all the require failure recognizers has failed,
         * if true, it emits a gesture event,
         * otherwise, setup the state to FAILED.
         * @param {Object} input
         */
        tryEmit: function (input) {
            if (this.canEmit()) {
                return this.emit(input);
            }
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
         * can we emit?
         * @returns {boolean}
         */
        canEmit: function () {
            var i = 0;
            while (i < this.requireFail.length) {
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                    return false;
                }
                i++;
            }
            return true;
        },
        /**
         * update the recognizer
         * @param {Object} inputData
         */
        recognize: function (inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
                this.state = STATE_POSSIBLE;
            }
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
                this.tryEmit(inputDataClone);
            }
        },
        /**
         * return the state of the recognizer
         * the actual recognizing happens in this method
         * @virtual
         * @param {Object} inputData
         * @returns {Const} STATE
         */
        process: function (inputData) { },
        /**
         * return the preferred touch-action
         * @virtual
         * @returns {Array}
         */
        getTouchAction: function () { },
        /**
         * called when the gesture isn't allowed to recognize
         * like when another is being recognized or it is disabled
         * @virtual
         */
        reset: function () { }
    };
    /**
     * get a usable string, used as event postfix
     * @param {Const} state
     * @returns {String} state
     */
    function stateStr(state) {
        if (state & STATE_CANCELLED) {
            return 'cancel';
        }
        else if (state & STATE_ENDED) {
            return 'end';
        }
        else if (state & STATE_CHANGED) {
            return 'move';
        }
        else if (state & STATE_BEGAN) {
            return 'start';
        }
        return '';
    }
    /**
     * direction cons to string
     * @param {Const} direction
     * @returns {String}
     */
    function directionStr(direction) {
        if (direction == DIRECTION_DOWN) {
            return 'down';
        }
        else if (direction == DIRECTION_UP) {
            return 'up';
        }
        else if (direction == DIRECTION_LEFT) {
            return 'left';
        }
        else if (direction == DIRECTION_RIGHT) {
            return 'right';
        }
        return '';
    }
    /**
     * get a recognizer by name if it is bound to a manager
     * @param {Recognizer|String} otherRecognizer
     * @param {Recognizer} recognizer
     * @returns {Recognizer}
     */
    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) {
            return manager.get(otherRecognizer);
        }
        return otherRecognizer;
    }
    /**
     * This recognizer is just used as a base for the simple attribute recognizers.
     * @constructor
     * @extends Recognizer
     */
    function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof AttrRecognizer
         */
        defaults: {
            /**
             * @type {Number}
             * @default 1
             */
            pointers: 1
        },
        /**
         * Used to check if it the recognizer receives valid input, like input.distance > 10.
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {Boolean} recognized
         */
        attrTest: function (input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
         * Process the input and return the state for the recognizer
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {*} State
         */
        process: function (input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
                return state | STATE_CANCELLED;
            }
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) {
                    return state | STATE_ENDED;
                }
                else if (!(state & STATE_BEGAN)) {
                    return STATE_BEGAN;
                }
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
     * Pan
     * Recognized when the pointer is down and moved in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */
    function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof PanRecognizer
         */
        defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function () {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) {
                actions.push(TOUCH_ACTION_PAN_Y);
            }
            if (direction & DIRECTION_VERTICAL) {
                actions.push(TOUCH_ACTION_PAN_X);
            }
            return actions;
        },
        directionTest: function (input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                }
                else {
                    direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function (input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) &&
                (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
        },
        emit: function (input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) {
                input.additionalEvent = this.options.event + direction;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
     * Pinch
     * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
     * @constructor
     * @extends AttrRecognizer
     */
    function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function () {
            return [TOUCH_ACTION_NONE];
        },
        attrTest: function (input) {
            return this._super.attrTest.call(this, input) &&
                (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function (input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
     * Press
     * Recognized when the pointer is down for x ms without any movement.
     * @constructor
     * @extends Recognizer
     */
    function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof PressRecognizer
         */
        defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function () {
            return [TOUCH_ACTION_AUTO];
        },
        process: function (input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
                this.reset();
            }
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function () {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            }
            else if (input.eventType & INPUT_END) {
                return STATE_RECOGNIZED;
            }
            return STATE_FAILED;
        },
        reset: function () {
            clearTimeout(this._timer);
        },
        emit: function (input) {
            if (this.state !== STATE_RECOGNIZED) {
                return;
            }
            if (input && (input.eventType & INPUT_END)) {
                this.manager.emit(this.options.event + 'up', input);
            }
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
     * Rotate
     * Recognized when two or more pointer are moving in a circular motion.
     * @constructor
     * @extends AttrRecognizer
     */
    function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof RotateRecognizer
         */
        defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function () {
            return [TOUCH_ACTION_NONE];
        },
        attrTest: function (input) {
            return this._super.attrTest.call(this, input) &&
                (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
     * Swipe
     * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */
    function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
         * @namespace
         * @memberof SwipeRecognizer
         */
        defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function () {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function (input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
                velocity = input.overallVelocity;
            }
            else if (direction & DIRECTION_HORIZONTAL) {
                velocity = input.overallVelocityX;
            }
            else if (direction & DIRECTION_VERTICAL) {
                velocity = input.overallVelocityY;
            }
            return this._super.attrTest.call(this, input) &&
                direction & input.offsetDirection &&
                input.distance > this.options.threshold &&
                input.maxPointers == this.options.pointers &&
                abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function (input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) {
                this.manager.emit(this.options.event + direction, input);
            }
            this.manager.emit(this.options.event, input);
        }
    });
    /**
     * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
     * between the given interval and position. The delay option can be used to recognize multi-taps without firing
     * a single tap.
     *
     * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
     * multi-taps being recognized.
     * @constructor
     * @extends Recognizer
     */
    function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function () {
            return [TOUCH_ACTION_MANIPULATION];
        },
        process: function (input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if ((input.eventType & INPUT_START) && (this.count === 0)) {
                return this.failTimeout();
            }
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) {
                    return this.failTimeout();
                }
                var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) {
                    this.count = 1;
                }
                else {
                    this.count += 1;
                }
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) {
                        return STATE_RECOGNIZED;
                    }
                    else {
                        this._timer = setTimeoutContext(function () {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function () {
            this._timer = setTimeoutContext(function () {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function () {
            clearTimeout(this._timer);
        },
        emit: function () {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
     * Simple way to create a manager with a default set of recognizers.
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */
    function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
     * @const {string}
     */
    Hammer.VERSION = '2.0.7';
    /**
     * default settings
     * @namespace
     */
    Hammer.defaults = {
        /**
         * set if DOM events are being triggered.
         * But this is slower and unused by simple implementations, so disabled by default.
         * @type {Boolean}
         * @default false
         */
        domEvents: false,
        /**
         * The value for the touchAction property/fallback.
         * When set to `compute` it will magically set the correct value based on the added recognizers.
         * @type {String}
         * @default compute
         */
        touchAction: TOUCH_ACTION_COMPUTE,
        /**
         * @type {Boolean}
         * @default true
         */
        enable: true,
        /**
         * EXPERIMENTAL FEATURE -- can be removed/changed
         * Change the parent input target element.
         * If Null, then it is being set the to main element.
         * @type {Null|EventTarget}
         * @default null
         */
        inputTarget: null,
        /**
         * force an input class
         * @type {Null|Function}
         * @default null
         */
        inputClass: null,
        /**
         * Default recognizer setup when calling `Hammer()`
         * When creating a new Manager these will be skipped.
         * @type {Array}
         */
        preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [RotateRecognizer, { enable: false }],
            [PinchRecognizer, { enable: false }, ['rotate']],
            [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
            [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ['swipe']],
            [TapRecognizer],
            [TapRecognizer, { event: 'doubletap', taps: 2 }, ['tap']],
            [PressRecognizer]
        ],
        /**
         * Some CSS properties can be used to improve the working of Hammer.
         * Add them to this method and they will be set when creating a new Manager.
         * @namespace
         */
        cssProps: {
            /**
             * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userSelect: 'none',
            /**
             * Disable the Windows Phone grippers when pressing an element.
             * @type {String}
             * @default 'none'
             */
            touchSelect: 'none',
            /**
             * Disables the default callout shown when you touch and hold a touch target.
             * On iOS, when you touch and hold a touch target such as a link, Safari displays
             * a callout containing information about the link. This property allows you to disable that callout.
             * @type {String}
             * @default 'none'
             */
            touchCallout: 'none',
            /**
             * Specifies whether zooming is enabled. Used by IE10>
             * @type {String}
             * @default 'none'
             */
            contentZooming: 'none',
            /**
             * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userDrag: 'none',
            /**
             * Overrides the highlight color shown when the user taps a link or a JavaScript
             * clickable element in iOS. This property obeys the alpha value, if specified.
             * @type {String}
             * @default 'rgba(0,0,0,0)'
             */
            tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
     * Manager
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */
    function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function (item) {
            var recognizer = this.add(new (item[0])(item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
         * set options
         * @param {Object} options
         * @returns {Manager}
         */
        set: function (options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) {
                this.touchAction.update();
            }
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
         * stop recognizing for this session.
         * This session will be discarded, when a new [input]start event is fired.
         * When forced, the recognizer cycle is stopped immediately.
         * @param {Boolean} [force]
         */
        stop: function (force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
         * run the recognizers!
         * called by the inputHandler function on every movement of the pointers (touches)
         * it walks through all the recognizers and tries to detect the gesture that is being made
         * @param {Object} inputData
         */
        recognize: function (inputData) {
            var session = this.session;
            if (session.stopped) {
                return;
            }
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
                curRecognizer = session.curRecognizer = null;
            }
            var i = 0;
            while (i < recognizers.length) {
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && ( // 1
                !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                    recognizer.recognize(inputData);
                }
                else {
                    recognizer.reset();
                }
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                    curRecognizer = session.curRecognizer = recognizer;
                }
                i++;
            }
        },
        /**
         * get a recognizer by its event name.
         * @param {Recognizer|String} recognizer
         * @returns {Recognizer|Null}
         */
        get: function (recognizer) {
            if (recognizer instanceof Recognizer) {
                return recognizer;
            }
            var recognizers = this.recognizers;
            for (var i = 0; i < recognizers.length; i++) {
                if (recognizers[i].options.event == recognizer) {
                    return recognizers[i];
                }
            }
            return null;
        },
        /**
         * add a recognizer to the manager
         * existing recognizers with the same event name will be removed
         * @param {Recognizer} recognizer
         * @returns {Recognizer|Manager}
         */
        add: function (recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) {
                return this;
            }
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) {
                this.remove(existing);
            }
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
         * remove a recognizer by name or instance
         * @param {Recognizer|String} recognizer
         * @returns {Manager}
         */
        remove: function (recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) {
                return this;
            }
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
         * bind event
         * @param {String} events
         * @param {Function} handler
         * @returns {EventEmitter} this
         */
        on: function (events, handler) {
            if (events === undefined) {
                return;
            }
            if (handler === undefined) {
                return;
            }
            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
         * unbind event, leave emit blank to remove all handlers
         * @param {String} events
         * @param {Function} [handler]
         * @returns {EventEmitter} this
         */
        off: function (events, handler) {
            if (events === undefined) {
                return;
            }
            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                if (!handler) {
                    delete handlers[event];
                }
                else {
                    handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
                }
            });
            return this;
        },
        /**
         * emit event to the listeners
         * @param {String} event
         * @param {Object} data
         */
        emit: function (event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) {
                triggerDomEvent(event, data);
            }
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) {
                return;
            }
            data.type = event;
            data.preventDefault = function () {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while (i < handlers.length) {
                handlers[i](data);
                i++;
            }
        },
        /**
         * destroy the manager and unbinds all events
         * it doesn't unbind dom events, that is the user own responsibility
         */
        destroy: function () {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
     * add/remove the css properties as defined in manager.options.cssProps
     * @param {Manager} manager
     * @param {Boolean} add
     */
    function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) {
            return;
        }
        var prop;
        each(manager.options.cssProps, function (value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            }
            else {
                element.style[prop] = manager.oldCssProps[prop] || '';
            }
        });
        if (!add) {
            manager.oldCssProps = {};
        }
    }
    /**
     * trigger dom event
     * @param {String} event
     * @param {Object} data
     */
    function triggerDomEvent(event, data) {
        var gestureEvent = document.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return Hammer;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else if (typeof module != 'undefined' && module.exports) {
        module.exports = Hammer;
    }
    else {
        window[exportName] = Hammer;
    }
})(window, document, 'Hammer');


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _defineProperty2 = __webpack_require__(14);
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames2 = __webpack_require__(32);
var _classnames3 = _interopRequireDefault(_classnames2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var TabBarSwipeableTabs = function (_React$Component) {
    (0, _inherits3['default'])(TabBarSwipeableTabs, _React$Component);
    function TabBarSwipeableTabs() {
        (0, _classCallCheck3['default'])(this, TabBarSwipeableTabs);
        return (0, _possibleConstructorReturn3['default'])(this, (TabBarSwipeableTabs.__proto__ || Object.getPrototypeOf(TabBarSwipeableTabs)).apply(this, arguments));
    }
    (0, _createClass3['default'])(TabBarSwipeableTabs, [{
            key: 'render',
            value: function render() {
                var _this2 = this;
                var props = this.props;
                var children = props.panels;
                var activeKey = props.activeKey;
                var rst = [];
                var prefixCls = props.prefixCls;
                var _flexWidth = 1 / props.pageSize * 100 + '%';
                var tabStyle = {
                    WebkitFlexBasis: _flexWidth,
                    flexBasis: _flexWidth
                };
                _react2['default'].Children.forEach(children, function (child) {
                    var _classnames;
                    if (!child) {
                        return;
                    }
                    var key = child.key;
                    var cls = (0, _classnames3['default'])(prefixCls + '-tab', (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-active', activeKey === key), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-disabled', child.props.disabled), _classnames));
                    var events = {};
                    if (!child.props.disabled) {
                        events = {
                            onClick: _this2.props.onTabClick.bind(_this2, key)
                        };
                    }
                    var refProps = {};
                    if (activeKey === key) {
                        refProps.ref = _this2.props.saveRef('activeTab');
                    }
                    rst.push(_react2['default'].createElement('div', (0, _extends3['default'])({
                        role: 'tab',
                        style: tabStyle,
                        'aria-disabled': child.props.disabled ? 'true' : 'false',
                        'aria-selected': activeKey === key ? 'true' : 'false'
                    }, events, {
                        className: cls,
                        key: key
                    }, refProps), child.props.tab));
                });
                return rst;
            }
        }]);
    return TabBarSwipeableTabs;
}(_react2['default'].Component);
exports['default'] = TabBarSwipeableTabs;
TabBarSwipeableTabs.propTypes = {
    pageSize: _propTypes2['default'].number,
    onTabClick: _propTypes2['default'].func,
    saveRef: _propTypes2['default'].func
};
TabBarSwipeableTabs.defaultProps = {
    pageSize: 5,
    onTabClick: function onTabClick() { },
    saveRef: function saveRef() { }
};
module.exports = exports['default'];


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends2 = __webpack_require__(5);
var _extends3 = _interopRequireDefault(_extends2);
var _classCallCheck2 = __webpack_require__(1);
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = __webpack_require__(4);
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = __webpack_require__(2);
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = __webpack_require__(3);
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(6);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _rcHammerjs = __webpack_require__(191);
var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);
var _reactDom = __webpack_require__(17);
var _reactDom2 = _interopRequireDefault(_reactDom);
var _TabContent = __webpack_require__(164);
var _TabContent2 = _interopRequireDefault(_TabContent);
var _utils = __webpack_require__(53);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var RESISTANCE_COEF = 0.6;
function computeIndex(_ref) {
    var maxIndex = _ref.maxIndex, startIndex = _ref.startIndex, delta = _ref.delta, viewSize = _ref.viewSize;
    var index = startIndex + -delta / viewSize;
    if (index < 0) {
        index = Math.exp(index * RESISTANCE_COEF) - 1;
    }
    else if (index > maxIndex) {
        index = maxIndex + 1 - Math.exp((maxIndex - index) * RESISTANCE_COEF);
    }
    return index;
}
function getIndexByDelta(e) {
    var delta = (0, _utils.isVertical)(this.props.tabBarPosition) ? e.deltaY : e.deltaX;
    var otherDelta = (0, _utils.isVertical)(this.props.tabBarPosition) ? e.deltaX : e.deltaY;
    if (Math.abs(delta) < Math.abs(otherDelta)) {
        return undefined;
    }
    var currentIndex = computeIndex({
        maxIndex: this.maxIndex,
        viewSize: this.viewSize,
        startIndex: this.startIndex,
        delta: delta
    });
    var showIndex = delta < 0 ? Math.floor(currentIndex + 1) : Math.floor(currentIndex);
    if (showIndex < 0) {
        showIndex = 0;
    }
    else if (showIndex > this.maxIndex) {
        showIndex = this.maxIndex;
    }
    if (this.children[showIndex].props.disabled) {
        return undefined;
    }
    return currentIndex;
}
var SwipeableTabContent = function (_React$Component) {
    (0, _inherits3['default'])(SwipeableTabContent, _React$Component);
    function SwipeableTabContent() {
        var _ref2;
        var _temp, _this, _ret;
        (0, _classCallCheck3['default'])(this, SwipeableTabContent);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref2 = SwipeableTabContent.__proto__ || Object.getPrototypeOf(SwipeableTabContent)).call.apply(_ref2, [this].concat(args))), _this), _this.onPanStart = function () {
            var _this$props = _this.props, tabBarPosition = _this$props.tabBarPosition, children = _this$props.children, activeKey = _this$props.activeKey, animated = _this$props.animated;
            _this.startIndex = (0, _utils.getActiveIndex)(children, activeKey);
            var startIndex = _this.startIndex;
            if (startIndex === -1) {
                return;
            }
            if (animated) {
                (0, _utils.setTransition)(_this.rootNode.style, 'none');
            }
            _this.startDrag = true;
            _this.children = (0, _utils.toArray)(children);
            _this.maxIndex = _this.children.length - 1;
            _this.viewSize = (0, _utils.isVertical)(tabBarPosition) ? _this.rootNode.offsetHeight : _this.rootNode.offsetWidth;
        }, _this.onPan = function (e) {
            if (!_this.startDrag) {
                return;
            }
            var tabBarPosition = _this.props.tabBarPosition;
            var currentIndex = getIndexByDelta.call(_this, e);
            if (currentIndex !== undefined) {
                (0, _utils.setTransform)(_this.rootNode.style, (0, _utils.getTransformByIndex)(currentIndex, tabBarPosition));
            }
        }, _this.onPanEnd = function (e) {
            if (!_this.startDrag) {
                return;
            }
            _this.end(e);
        }, _this.onSwipe = function (e) {
            _this.end(e, true);
        }, _this.end = function (e, swipe) {
            var _this$props2 = _this.props, tabBarPosition = _this$props2.tabBarPosition, animated = _this$props2.animated;
            _this.startDrag = false;
            if (animated) {
                (0, _utils.setTransition)(_this.rootNode.style, '');
            }
            var currentIndex = getIndexByDelta.call(_this, e);
            var finalIndex = _this.startIndex;
            if (currentIndex !== undefined) {
                if (currentIndex < 0) {
                    finalIndex = 0;
                }
                else if (currentIndex > _this.maxIndex) {
                    finalIndex = _this.maxIndex;
                }
                else if (swipe) {
                    var delta = (0, _utils.isVertical)(tabBarPosition) ? e.deltaY : e.deltaX;
                    finalIndex = delta < 0 ? Math.ceil(currentIndex) : Math.floor(currentIndex);
                }
                else {
                    var floorIndex = Math.floor(currentIndex);
                    if (currentIndex - floorIndex > 0.6) {
                        finalIndex = floorIndex + 1;
                    }
                    else {
                        finalIndex = floorIndex;
                    }
                }
            }
            if (_this.children[finalIndex].props.disabled) {
                return;
            }
            if (_this.startIndex === finalIndex) {
                if (animated) {
                    (0, _utils.setTransform)(_this.rootNode.style, (0, _utils.getTransformByIndex)(finalIndex, _this.props.tabBarPosition));
                }
            }
            else {
                _this.props.onChange((0, _utils.getActiveKey)(_this.props.children, finalIndex));
            }
        }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
    }
    (0, _createClass3['default'])(SwipeableTabContent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.rootNode = _reactDom2['default'].findDOMNode(this);
            }
        }, {
            key: 'render',
            value: function render() {
                var _props = this.props, tabBarPosition = _props.tabBarPosition, hammerOptions = _props.hammerOptions, animated = _props.animated;
                var events = {
                    onSwipe: this.onSwipe,
                    onPanStart: this.onPanStart
                };
                if (animated !== false) {
                    events = (0, _extends3['default'])({}, events, {
                        onPan: this.onPan,
                        onPanEnd: this.onPanEnd
                    });
                }
                return _react2['default'].createElement(_rcHammerjs2['default'], (0, _extends3['default'])({}, events, {
                    direction: (0, _utils.isVertical)(tabBarPosition) ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL',
                    options: hammerOptions
                }), _react2['default'].createElement(_TabContent2['default'], this.props));
            }
        }]);
    return SwipeableTabContent;
}(_react2['default'].Component);
exports['default'] = SwipeableTabContent;
SwipeableTabContent.propTypes = {
    tabBarPosition: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func,
    children: _propTypes2['default'].node,
    hammerOptions: _propTypes2['default'].any,
    animated: _propTypes2['default'].bool,
    activeKey: _propTypes2['default'].string
};
SwipeableTabContent.defaultProps = {
    animated: true
};
module.exports = exports['default'];


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _rcMenu=__webpack_require__(391);var _rcMenu2=_interopRequireDefault(_rcMenu);__webpack_require__(203);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WeaPortalRcMenu={Menu:_rcMenu2.default,SubMenu:_rcMenu.SubMenu,MenuItem:_rcMenu.MenuItem,ItemGroup:_rcMenu.ItemGroup,Divider:_rcMenu.Divider};exports.default=WeaPortalRcMenu;

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubMenu__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuItem__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Divider__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubMenu", function() { return __WEBPACK_IMPORTED_MODULE_1__SubMenu__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuItem__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__MenuItemGroup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_4__Divider__["a"]; });






/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Menu__["a" /* default */]);


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(74);










var Menu = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _React$Component);
    function Menu(props) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Menu);
        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        _this.isRootMenu = true;
        var selectedKeys = props.defaultSelectedKeys;
        var openKeys = props.defaultOpenKeys;
        if ('selectedKeys' in props) {
            selectedKeys = props.selectedKeys || [];
        }
        if ('openKeys' in props) {
            openKeys = props.openKeys || [];
        }
        _this.store = Object(__WEBPACK_IMPORTED_MODULE_7_mini_store__["create"])({
            selectedKeys: selectedKeys,
            openKeys: openKeys,
            activeKey: { '0-menu-': Object(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["b" /* getActiveKey */])(props, props.activeKey) }
        });
        return _this;
    }
    Menu.prototype.componentDidMount = function componentDidMount() {
        this.updateMiniStore();
    };
    Menu.prototype.componentDidUpdate = function componentDidUpdate() {
        this.updateMiniStore();
    };
    // onKeyDown needs to be exposed as a instance method
    // e.g., in rc-select, we need to navigate menu item while
    // current active item is rc-select input box rather than the menu itself
    Menu.prototype.updateMiniStore = function updateMiniStore() {
        if ('selectedKeys' in this.props) {
            this.store.setState({
                selectedKeys: this.props.selectedKeys || []
            });
        }
        if ('openKeys' in this.props) {
            this.store.setState({
                openKeys: this.props.openKeys || []
            });
        }
    };
    Menu.prototype.render = function render() {
        var _this2 = this;
        var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);
        props.className += ' ' + props.prefixCls + '-root';
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
            onClick: this.onClick,
            onOpenChange: this.onOpenChange,
            onDeselect: this.onDeselect,
            onSelect: this.onSelect,
            openTransitionName: this.getOpenTransitionName(),
            parentMenu: this
        });
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_mini_store__["Provider"], { store: this.store }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SubPopupMenu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { ref: function ref(c) {
                return _this2.innerMenu = c;
            } }), this.props.children));
    };
    return Menu;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
Menu.propTypes = {
    defaultSelectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    defaultOpenKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string),
    mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
    getPopupContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    openTransitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    openAnimation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
    subMenuOpenDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    subMenuCloseDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    forceSubMenuRender: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    level: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    selectable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
Menu.defaultProps = {
    selectable: true,
    onClick: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
    onSelect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
    onOpenChange: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
    onDeselect: __WEBPACK_IMPORTED_MODULE_9__util__["f" /* noop */],
    defaultSelectedKeys: [],
    defaultOpenKeys: [],
    subMenuOpenDelay: 0.1,
    subMenuCloseDelay: 0.1,
    triggerSubMenuAction: 'hover',
    prefixCls: 'rc-menu',
    className: '',
    mode: 'vertical',
    style: {},
    builtinPlacements: {}
};
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onSelect = function (selectInfo) {
        var props = _this3.props;
        if (props.selectable) {
            // root menu
            var selectedKeys = _this3.store.getState().selectedKeys;
            var selectedKey = selectInfo.key;
            if (props.multiple) {
                selectedKeys = selectedKeys.concat([selectedKey]);
            }
            else {
                selectedKeys = [selectedKey];
            }
            if (!('selectedKeys' in props)) {
                _this3.store.setState({
                    selectedKeys: selectedKeys
                });
            }
            props.onSelect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
                selectedKeys: selectedKeys
            }));
        }
    };
    this.onClick = function (e) {
        _this3.props.onClick(e);
    };
    this.onKeyDown = function (e, callback) {
        _this3.innerMenu.getWrappedInstance().onKeyDown(e, callback);
    };
    this.onOpenChange = function (event) {
        var props = _this3.props;
        var openKeys = _this3.store.getState().openKeys.concat();
        var changed = false;
        var processSingle = function processSingle(e) {
            var oneChanged = false;
            if (e.open) {
                oneChanged = openKeys.indexOf(e.key) === -1;
                if (oneChanged) {
                    openKeys.push(e.key);
                }
            }
            else {
                var index = openKeys.indexOf(e.key);
                oneChanged = index !== -1;
                if (oneChanged) {
                    openKeys.splice(index, 1);
                }
            }
            changed = changed || oneChanged;
        };
        if (Array.isArray(event)) {
            // batch change call
            event.forEach(processSingle);
        }
        else {
            processSingle(event);
        }
        if (changed) {
            if (!('openKeys' in _this3.props)) {
                _this3.store.setState({ openKeys: openKeys });
            }
            props.onOpenChange(openKeys);
        }
    };
    this.onDeselect = function (selectInfo) {
        var props = _this3.props;
        if (props.selectable) {
            var selectedKeys = _this3.store.getState().selectedKeys.concat();
            var selectedKey = selectInfo.key;
            var index = selectedKeys.indexOf(selectedKey);
            if (index !== -1) {
                selectedKeys.splice(index, 1);
            }
            if (!('selectedKeys' in props)) {
                _this3.store.setState({
                    selectedKeys: selectedKeys
                });
            }
            props.onDeselect(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, selectInfo, {
                selectedKeys: selectedKeys
            }));
        }
    };
    this.getOpenTransitionName = function () {
        var props = _this3.props;
        var transitionName = props.openTransitionName;
        var animationName = props.openAnimation;
        if (!transitionName && typeof animationName === 'string') {
            transitionName = props.prefixCls + '-open-' + animationName;
        }
        return transitionName;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Menu);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _PropTypes = __webpack_require__(193);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
var Provider = function (_Component) {
    _inherits(Provider, _Component);
    function Provider() {
        _classCallCheck(this, Provider);
        return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }
    _createClass(Provider, [{
            key: 'getChildContext',
            value: function getChildContext() {
                return {
                    miniStore: this.props.store
                };
            }
        }, {
            key: 'render',
            value: function render() {
                return _react.Children.only(this.props.children);
            }
        }]);
    return Provider;
}(_react.Component);
Provider.propTypes = {
    store: _PropTypes.storeShape.isRequired
};
Provider.childContextTypes = {
    miniStore: _PropTypes.storeShape.isRequired
};
exports.default = Provider;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} } return function (Constructor, protoProps, staticProps) { if (protoProps)
    defineProperties(Constructor.prototype, protoProps); if (staticProps)
    defineProperties(Constructor, staticProps); return Constructor; }; }();
exports.default = connect;
var _react = __webpack_require__(0);
var _react2 = _interopRequireDefault(_react);
var _shallowequal = __webpack_require__(395);
var _shallowequal2 = _interopRequireDefault(_shallowequal);
var _hoistNonReactStatics = __webpack_require__(396);
var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
var _reactLifecyclesCompat = __webpack_require__(194);
var _PropTypes = __webpack_require__(193);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _possibleConstructorReturn(self, call) { if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return call && (typeof call === "object" || typeof call === "function") ? call : self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function isStateless(Component) {
    return !Component.prototype.render;
}
var defaultMapStateToProps = function defaultMapStateToProps() {
    return {};
};
function connect(mapStateToProps) {
    var shouldSubscribe = !!mapStateToProps;
    var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;
    return function wrapWithConnect(WrappedComponent) {
        var Connect = function (_Component) {
            _inherits(Connect, _Component);
            _createClass(Connect, null, [{
                    key: 'getDerivedStateFromProps',
                    value: function getDerivedStateFromProps(props, prevState) {
                        // using ownProps
                        if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
                            return {
                                subscribed: finnalMapStateToProps(prevState.store.getState(), props),
                                props: props
                            };
                        }
                        return { props: props };
                    }
                }]);
            function Connect(props, context) {
                _classCallCheck(this, Connect);
                var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));
                _this.handleChange = function () {
                    if (!_this.unsubscribe) {
                        return;
                    }
                    var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
                    if (!(0, _shallowequal2.default)(_this.state.subscribed, nextState)) {
                        _this.setState({ subscribed: nextState });
                    }
                };
                _this.store = context.miniStore;
                _this.state = {
                    subscribed: finnalMapStateToProps(_this.store.getState(), props),
                    store: _this.store,
                    props: props
                };
                return _this;
            }
            _createClass(Connect, [{
                    key: 'componentDidMount',
                    value: function componentDidMount() {
                        this.trySubscribe();
                    }
                }, {
                    key: 'componentWillUnmount',
                    value: function componentWillUnmount() {
                        this.tryUnsubscribe();
                    }
                }, {
                    key: 'trySubscribe',
                    value: function trySubscribe() {
                        if (shouldSubscribe) {
                            this.unsubscribe = this.store.subscribe(this.handleChange);
                            this.handleChange();
                        }
                    }
                }, {
                    key: 'tryUnsubscribe',
                    value: function tryUnsubscribe() {
                        if (this.unsubscribe) {
                            this.unsubscribe();
                            this.unsubscribe = null;
                        }
                    }
                }, {
                    key: 'getWrappedInstance',
                    value: function getWrappedInstance() {
                        return this.wrappedInstance;
                    }
                }, {
                    key: 'render',
                    value: function render() {
                        var _this2 = this;
                        var props = _extends({}, this.props, this.state.subscribed, {
                            store: this.store
                        });
                        if (!isStateless(WrappedComponent)) {
                            props = _extends({}, props, {
                                ref: function ref(c) {
                                    return _this2.wrappedInstance = c;
                                }
                            });
                        }
                        return _react2.default.createElement(WrappedComponent, props);
                    }
                }]);
            return Connect;
        }(_react.Component);
        Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
        Connect.contextTypes = {
            miniStore: _PropTypes.storeShape.isRequired
        };
        (0, _reactLifecyclesCompat.polyfill)(Connect);
        return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
    };
}


/***/ }),
/* 395 */
/***/ (function(module, exports) {

//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) {
        return !!ret;
    }
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for (var idx = 0; idx < keysA.length; idx++) {
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || (ret === void 0 && valueA !== valueB)) {
            return false;
        }
    }
    return true;
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                }
                catch (e) { }
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
exports.default = create;
function create(initialState) {
    var state = initialState;
    var listeners = [];
    function setState(partial) {
        state = _extends({}, state, partial);
        for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
        }
    }
    function getState() {
        return state;
    }
    function subscribe(listener) {
        listeners.push(listener);
        return function unsubscribe() {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    }
    return {
        setState: setState,
        getState: getState,
        subscribe: subscribe
    };
}


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
    var args = [].slice.call(arguments, 0);
    if (args.length === 1) {
        return args[0];
    }
    return function chainedFunction() {
        for (var i = 0; i < args.length; i++) {
            if (args[i] && args[i].apply) {
                args[i].apply(this, arguments);
            }
        }
    };
}


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);






var DOMWrap = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DOMWrap, _React$Component);
    function DOMWrap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DOMWrap);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }
    DOMWrap.prototype.render = function render() {
        var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
        if (!props.visible) {
            props.className += ' ' + props.hiddenClassName;
        }
        var Tag = props.tag;
        delete props.tag;
        delete props.hiddenClassName;
        delete props.visible;
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Tag, props);
    };
    return DOMWrap;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
DOMWrap.propTypes = {
    tag: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
DOMWrap.defaultProps = {
    tag: 'div',
    className: ''
};
/* harmony default export */ __webpack_exports__["a"] = (DOMWrap);


/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SubMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__placements__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rc_animate__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util__ = __webpack_require__(74);















var guid = 0;
var popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
    var _extends2;
    var menuId = Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(eventKey);
    var state = store.getState();
    store.setState({
        defaultActiveFirst: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, state.defaultActiveFirst, (_extends2 = {}, _extends2[menuId] = defaultActiveFirst, _extends2))
    });
};
var SubMenu = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SubMenu, _React$Component);
    function SubMenu(props) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SubMenu);
        var _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        var store = props.store;
        var eventKey = props.eventKey;
        var defaultActiveFirst = store.getState().defaultActiveFirst;
        _this.isRootMenu = false;
        var value = false;
        if (defaultActiveFirst) {
            value = defaultActiveFirst[eventKey];
        }
        updateDefaultActiveFirst(store, eventKey, value);
        return _this;
    }
    SubMenu.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate();
    };
    SubMenu.prototype.componentDidUpdate = function componentDidUpdate() {
        var _this2 = this;
        var _props = this.props, mode = _props.mode, parentMenu = _props.parentMenu, manualRef = _props.manualRef;
        // invoke customized ref to expose component to mixin
        if (manualRef) {
            manualRef(this);
        }
        if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
            return;
        }
        this.minWidthTimeout = setTimeout(function () {
            return _this2.adjustWidth();
        }, 0);
    };
    SubMenu.prototype.componentWillUnmount = function componentWillUnmount() {
        var _props2 = this.props, onDestroy = _props2.onDestroy, eventKey = _props2.eventKey;
        if (onDestroy) {
            onDestroy(eventKey);
        }
        /* istanbul ignore if */
        if (this.minWidthTimeout) {
            clearTimeout(this.minWidthTimeout);
        }
        /* istanbul ignore if */
        if (this.mouseenterTimeout) {
            clearTimeout(this.mouseenterTimeout);
        }
    };
    SubMenu.prototype.renderChildren = function renderChildren(children) {
        var props = this.props;
        var baseProps = {
            mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
            visible: this.props.isOpen,
            level: props.level + 1,
            inlineIndent: props.inlineIndent,
            focusable: false,
            onClick: this.onSubMenuClick,
            onSelect: this.onSelect,
            onDeselect: this.onDeselect,
            onDestroy: this.onDestroy,
            selectedKeys: props.selectedKeys,
            eventKey: props.eventKey + '-menu-',
            openKeys: props.openKeys,
            openTransitionName: props.openTransitionName,
            openAnimation: props.openAnimation,
            onOpenChange: this.onOpenChange,
            subMenuOpenDelay: props.subMenuOpenDelay,
            parentMenu: this,
            subMenuCloseDelay: props.subMenuCloseDelay,
            forceSubMenuRender: props.forceSubMenuRender,
            triggerSubMenuAction: props.triggerSubMenuAction,
            builtinPlacements: props.builtinPlacements,
            defaultActiveFirst: props.store.getState().defaultActiveFirst[Object(__WEBPACK_IMPORTED_MODULE_14__util__["b" /* getMenuIdFromSubMenuEventKey */])(props.eventKey)],
            multiple: props.multiple,
            prefixCls: props.rootPrefixCls,
            id: this._menuId,
            manualRef: this.saveMenuInstance
        };
        var haveRendered = this.haveRendered;
        this.haveRendered = true;
        this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender;
        // never rendered not planning to, don't render
        if (!this.haveOpened) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null);
        }
        // don't show transition on first rendering (no animation for opened menu)
        // show appear transition if it's not visible (not sure why)
        // show appear transition if it's not inline mode
        var transitionAppear = haveRendered || !baseProps.visible || !baseProps.mode === 'inline';
        baseProps.className = ' ' + baseProps.prefixCls + '-sub';
        var animProps = {};
        if (baseProps.openTransitionName) {
            animProps.transitionName = baseProps.openTransitionName;
        }
        else if (typeof baseProps.openAnimation === 'object') {
            animProps.animation = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps.openAnimation);
            if (!transitionAppear) {
                delete animProps.animation.appear;
            }
        }
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_rc_animate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, animProps, {
            showProp: 'visible',
            component: '',
            transitionAppear: transitionAppear
        }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SubPopupMenu__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, baseProps, { id: this._menuId }), children));
    };
    SubMenu.prototype.render = function render() {
        var _classNames;
        var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);
        var isOpen = props.isOpen;
        var prefixCls = this.getPrefixCls();
        var isInlineMode = props.mode === 'inline';
        var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));
        if (!this._menuId) {
            if (props.eventKey) {
                this._menuId = props.eventKey + '$Menu';
            }
            else {
                this._menuId = '$__$' + ++guid + '$Menu';
            }
        }
        var mouseEvents = {};
        var titleClickEvents = {};
        var titleMouseEvents = {};
        if (!props.disabled) {
            mouseEvents = {
                onMouseLeave: this.onMouseLeave,
                onMouseEnter: this.onMouseEnter
            };
            // only works in title, not outer li
            titleClickEvents = {
                onClick: this.onTitleClick
            };
            titleMouseEvents = {
                onMouseEnter: this.onTitleMouseEnter,
                onMouseLeave: this.onTitleMouseLeave
            };
        }
        var style = {};
        if (isInlineMode) {
            style.paddingLeft = props.inlineIndent * props.level;
        }
        var ariaOwns = {};
        // only set aria-owns when menu is open
        // otherwise it would be an invalid aria-owns value
        // since corresponding node cannot be found
        if (this.props.isOpen) {
            ariaOwns = {
                'aria-owns': this._menuId
            };
        }
        var title = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            ref: this.saveSubMenuTitle,
            style: style,
            className: prefixCls + '-title'
        }, titleMouseEvents, titleClickEvents, {
            'aria-expanded': isOpen
        }, ariaOwns, {
            'aria-haspopup': 'true',
            title: typeof props.title === 'string' ? props.title : undefined
        }), props.title, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', { className: prefixCls + '-arrow' }));
        var children = this.renderChildren(props.children);
        var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
            return triggerNode.parentNode;
        };
        var popupPlacement = popupPlacementMap[props.mode];
        var popupAlign = props.popupOffset ? { offset: props.popupOffset } : {};
        var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
        var disabled = props.disabled, triggerSubMenuAction = props.triggerSubMenuAction, subMenuOpenDelay = props.subMenuOpenDelay, forceSubMenuRender = props.forceSubMenuRender, subMenuCloseDelay = props.subMenuCloseDelay, builtinPlacements = props.builtinPlacements;
        __WEBPACK_IMPORTED_MODULE_14__util__["e" /* menuAllProps */].forEach(function (key) {
            return delete props[key];
        });
        // Set onClick to null, to ignore propagated onClick event
        delete props.onClick;
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, props, mouseEvents, {
            className: className,
            role: 'menuitem'
        }), isInlineMode && title, isInlineMode && children, !isInlineMode && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */], {
            prefixCls: prefixCls,
            popupClassName: prefixCls + '-popup ' + popupClassName,
            getPopupContainer: getPopupContainer,
            builtinPlacements: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_12__placements__["a" /* default */], builtinPlacements),
            popupPlacement: popupPlacement,
            popupVisible: isOpen,
            popupAlign: popupAlign,
            popup: children,
            action: disabled ? [] : [triggerSubMenuAction],
            mouseEnterDelay: subMenuOpenDelay,
            mouseLeaveDelay: subMenuCloseDelay,
            onPopupVisibleChange: this.onPopupVisibleChange,
            forceRender: forceSubMenuRender
        }, title));
    };
    return SubMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
SubMenu.propTypes = {
    parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    openKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onOpenChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    triggerSubMenuAction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onTitleClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    popupOffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    isOpen: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    store: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    mode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
    manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
SubMenu.defaultProps = {
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    onTitleMouseEnter: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    onTitleMouseLeave: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    onTitleClick: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    manualRef: __WEBPACK_IMPORTED_MODULE_14__util__["f" /* noop */],
    mode: 'vertical',
    title: ''
};
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onDestroy = function (key) {
        _this3.props.onDestroy(key);
    };
    this.onKeyDown = function (e) {
        var keyCode = e.keyCode;
        var menu = _this3.menuInstance;
        var _props3 = _this3.props, isOpen = _props3.isOpen, store = _props3.store;
        if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].ENTER) {
            _this3.onTitleClick(e);
            updateDefaultActiveFirst(store, _this3.props.eventKey, true);
            return true;
        }
        if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].RIGHT) {
            if (isOpen) {
                menu.onKeyDown(e);
            }
            else {
                _this3.triggerOpenChange(true);
                // need to update current menu's defaultActiveFirst value
                updateDefaultActiveFirst(store, _this3.props.eventKey, true);
            }
            return true;
        }
        if (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].LEFT) {
            var handled = void 0;
            if (isOpen) {
                handled = menu.onKeyDown(e);
            }
            else {
                return undefined;
            }
            if (!handled) {
                _this3.triggerOpenChange(false);
                handled = true;
            }
            return handled;
        }
        if (isOpen && (keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].UP || keyCode === __WEBPACK_IMPORTED_MODULE_8_rc_util_es_KeyCode__["a" /* default */].DOWN)) {
            return menu.onKeyDown(e);
        }
    };
    this.onOpenChange = function (e) {
        _this3.props.onOpenChange(e);
    };
    this.onPopupVisibleChange = function (visible) {
        _this3.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
    };
    this.onMouseEnter = function (e) {
        var _props4 = _this3.props, key = _props4.eventKey, onMouseEnter = _props4.onMouseEnter, store = _props4.store;
        updateDefaultActiveFirst(store, _this3.props.eventKey, false);
        onMouseEnter({
            key: key,
            domEvent: e
        });
    };
    this.onMouseLeave = function (e) {
        var _props5 = _this3.props, parentMenu = _props5.parentMenu, eventKey = _props5.eventKey, onMouseLeave = _props5.onMouseLeave;
        parentMenu.subMenuInstance = _this3;
        onMouseLeave({
            key: eventKey,
            domEvent: e
        });
    };
    this.onTitleMouseEnter = function (domEvent) {
        var _props6 = _this3.props, key = _props6.eventKey, onItemHover = _props6.onItemHover, onTitleMouseEnter = _props6.onTitleMouseEnter;
        onItemHover({
            key: key,
            hover: true
        });
        onTitleMouseEnter({
            key: key,
            domEvent: domEvent
        });
    };
    this.onTitleMouseLeave = function (e) {
        var _props7 = _this3.props, parentMenu = _props7.parentMenu, eventKey = _props7.eventKey, onItemHover = _props7.onItemHover, onTitleMouseLeave = _props7.onTitleMouseLeave;
        parentMenu.subMenuInstance = _this3;
        onItemHover({
            key: eventKey,
            hover: false
        });
        onTitleMouseLeave({
            key: eventKey,
            domEvent: e
        });
    };
    this.onTitleClick = function (e) {
        var props = _this3.props;
        props.onTitleClick({
            key: props.eventKey,
            domEvent: e
        });
        if (props.triggerSubMenuAction === 'hover') {
            return;
        }
        _this3.triggerOpenChange(!props.isOpen, 'click');
        updateDefaultActiveFirst(props.store, _this3.props.eventKey, false);
    };
    this.onSubMenuClick = function (info) {
        _this3.props.onClick(_this3.addKeyPath(info));
    };
    this.onSelect = function (info) {
        _this3.props.onSelect(info);
    };
    this.onDeselect = function (info) {
        _this3.props.onDeselect(info);
    };
    this.getPrefixCls = function () {
        return _this3.props.rootPrefixCls + '-submenu';
    };
    this.getActiveClassName = function () {
        return _this3.getPrefixCls() + '-active';
    };
    this.getDisabledClassName = function () {
        return _this3.getPrefixCls() + '-disabled';
    };
    this.getSelectedClassName = function () {
        return _this3.getPrefixCls() + '-selected';
    };
    this.getOpenClassName = function () {
        return _this3.props.rootPrefixCls + '-submenu-open';
    };
    this.saveMenuInstance = function (c) {
        // children menu instance
        _this3.menuInstance = c;
    };
    this.addKeyPath = function (info) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, info, {
            keyPath: (info.keyPath || []).concat(_this3.props.eventKey)
        });
    };
    this.triggerOpenChange = function (open, type) {
        var key = _this3.props.eventKey;
        var openChange = function openChange() {
            _this3.onOpenChange({
                key: key,
                item: _this3,
                trigger: type,
                open: open
            });
        };
        if (type === 'mouseenter') {
            // make sure mouseenter happen after other menu item's mouseleave
            _this3.mouseenterTimeout = setTimeout(function () {
                openChange();
            }, 0);
        }
        else {
            openChange();
        }
    };
    this.isChildrenSelected = function () {
        var ret = { find: false };
        Object(__WEBPACK_IMPORTED_MODULE_14__util__["d" /* loopMenuItemRecursively */])(_this3.props.children, _this3.props.selectedKeys, ret);
        return ret.find;
    };
    this.isOpen = function () {
        return _this3.props.openKeys.indexOf(_this3.props.eventKey) !== -1;
    };
    this.adjustWidth = function () {
        /* istanbul ignore if */
        if (!_this3.subMenuTitle || !_this3.menuInstance) {
            return;
        }
        var popupMenu = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(_this3.menuInstance);
        if (popupMenu.offsetWidth >= _this3.subMenuTitle.offsetWidth) {
            return;
        }
        /* istanbul ignore next */
        popupMenu.style.minWidth = _this3.subMenuTitle.offsetWidth + 'px';
    };
    this.saveSubMenuTitle = function (subMenuTitle) {
        _this3.subMenuTitle = subMenuTitle;
    };
};
var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
    var openKeys = _ref.openKeys, activeKey = _ref.activeKey, selectedKeys = _ref.selectedKeys;
    var eventKey = _ref2.eventKey, subMenuKey = _ref2.subMenuKey;
    return {
        isOpen: openKeys.indexOf(eventKey) > -1,
        active: activeKey[subMenuKey] === eventKey,
        selectedKeys: selectedKeys
    };
})(SubMenu);
connected.isSubMenu = true;
/* harmony default export */ __webpack_exports__["a"] = (connected);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(407);















function noop() { }
function returnEmptyString() {
    return '';
}
function returnDocument() {
    return window.document;
}
var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];
var contextTypes = {
    rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
        onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
    })
};
var Trigger = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);
    function Trigger(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);
        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
        _initialiseProps.call(_this);
        var popupVisible = void 0;
        if ('popupVisible' in props) {
            popupVisible = !!props.popupVisible;
        }
        else {
            popupVisible = !!props.defaultPopupVisible;
        }
        _this.state = {
            prevPopupVisible: popupVisible,
            popupVisible: popupVisible
        };
        ALL_HANDLERS.forEach(function (h) {
            _this['fire' + h] = function (e) {
                _this.fireEvents(h, e);
            };
        });
        return _this;
    }
    Trigger.prototype.getChildContext = function getChildContext() {
        return {
            rcTrigger: {
                onPopupMouseDown: this.onPopupMouseDown
            }
        };
    };
    Trigger.prototype.componentDidMount = function componentDidMount() {
        this.componentDidUpdate({}, {
            popupVisible: this.state.popupVisible
        });
    };
    Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
        var props = this.props;
        var state = this.state;
        var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
            if (prevState.popupVisible !== state.popupVisible) {
                props.afterPopupVisibleChange(state.popupVisible);
            }
        };
        if (!IS_REACT_16) {
            this.renderComponent(null, triggerAfterPopupVisibleChange);
        }
        // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50
        if (state.popupVisible) {
            var currentDocument = void 0;
            if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                currentDocument = props.getDocument();
                this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
            }
            // always hide on mobile
            if (!this.touchOutsideHandler) {
                currentDocument = currentDocument || props.getDocument();
                this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
            }
            // close popup when trigger type contains 'onContextMenu' and document is scrolling.
            if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                currentDocument = currentDocument || props.getDocument();
                this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
            }
            // close popup when trigger type contains 'onContextMenu' and window is blur.
            if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
                this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
            }
            return;
        }
        this.clearOutsideHandler();
    };
    Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
    };
    Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};
        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
            newState.popupVisible = popupVisible;
            newState.prevPopupVisible = prevState.popupVisible;
        }
        return newState;
    };
    Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
        // for test
        if (this._component && this._component.getPopupDomNode) {
            return this._component.getPopupDomNode();
        }
        return null;
    };
    Trigger.prototype.getPopupAlign = function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
        if (popupPlacement && builtinPlacements) {
            return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
        }
        return popupAlign;
    };
    /**
     * @param popupVisible    Show or not the popup element
     * @param event           SyntheticEvent, used for `pointAlign`
     */
    Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();
        if (prevPopupVisible !== popupVisible) {
            if (!('popupVisible' in this.props)) {
                this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
            }
            this.props.onPopupVisibleChange(popupVisible);
        }
        // Always record the point position since mouseEnterDelay will delay the show
        if (alignPoint && event) {
            this.setPoint(event);
        }
    };
    Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;
        var delay = delayS * 1000;
        this.clearDelayTimer();
        if (delay) {
            var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
            this.delayTimer = setTimeout(function () {
                _this2.setPopupVisible(visible, point);
                _this2.clearDelayTimer();
            }, delay);
        }
        else {
            this.setPopupVisible(visible, event);
        }
    };
    Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
        if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
        }
    };
    Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
            this.clickOutsideHandler.remove();
            this.clickOutsideHandler = null;
        }
        if (this.contextMenuOutsideHandler1) {
            this.contextMenuOutsideHandler1.remove();
            this.contextMenuOutsideHandler1 = null;
        }
        if (this.contextMenuOutsideHandler2) {
            this.contextMenuOutsideHandler2.remove();
            this.contextMenuOutsideHandler2 = null;
        }
        if (this.touchOutsideHandler) {
            this.touchOutsideHandler.remove();
            this.touchOutsideHandler = null;
        }
    };
    Trigger.prototype.createTwoChains = function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;
        if (childPros[event] && props[event]) {
            return this['fire' + event];
        }
        return childPros[event] || props[event];
    };
    Trigger.prototype.isClickToShow = function isClickToShow() {
        var _props = this.props, action = _props.action, showAction = _props.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
    };
    Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
        var _props2 = this.props, action = _props2.action, showAction = _props2.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
    };
    Trigger.prototype.isClickToHide = function isClickToHide() {
        var _props3 = this.props, action = _props3.action, hideAction = _props3.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
    };
    Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
        var _props4 = this.props, action = _props4.action, showAction = _props4.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
    };
    Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
        var _props5 = this.props, action = _props5.action, hideAction = _props5.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
    };
    Trigger.prototype.isFocusToShow = function isFocusToShow() {
        var _props6 = this.props, action = _props6.action, showAction = _props6.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
    };
    Trigger.prototype.isBlurToHide = function isBlurToHide() {
        var _props7 = this.props, action = _props7.action, hideAction = _props7.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
    };
    Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
        if (this.state.popupVisible && this._component && this._component.alignInstance) {
            this._component.alignInstance.forceAlign();
        }
    };
    Trigger.prototype.fireEvents = function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];
        if (childCallback) {
            childCallback(e);
        }
        var callback = this.props[type];
        if (callback) {
            callback(e);
        }
    };
    Trigger.prototype.close = function close() {
        this.setPopupVisible(false);
    };
    Trigger.prototype.render = function render() {
        var _this3 = this;
        var popupVisible = this.state.popupVisible;
        var _props8 = this.props, children = _props8.children, forceRender = _props8.forceRender, alignPoint = _props8.alignPoint, className = _props8.className;
        var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
        var newChildProps = { key: 'trigger' };
        if (this.isContextMenuToShow()) {
            newChildProps.onContextMenu = this.onContextMenu;
        }
        else {
            newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        }
        if (this.isClickToHide() || this.isClickToShow()) {
            newChildProps.onClick = this.onClick;
            newChildProps.onMouseDown = this.onMouseDown;
            newChildProps.onTouchStart = this.onTouchStart;
        }
        else {
            newChildProps.onClick = this.createTwoChains('onClick');
            newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
            newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        }
        if (this.isMouseEnterToShow()) {
            newChildProps.onMouseEnter = this.onMouseEnter;
            if (alignPoint) {
                newChildProps.onMouseMove = this.onMouseMove;
            }
        }
        else {
            newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        }
        if (this.isMouseLeaveToHide()) {
            newChildProps.onMouseLeave = this.onMouseLeave;
        }
        else {
            newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        }
        if (this.isFocusToShow() || this.isBlurToHide()) {
            newChildProps.onFocus = this.onFocus;
            newChildProps.onBlur = this.onBlur;
        }
        else {
            newChildProps.onFocus = this.createTwoChains('onFocus');
            newChildProps.onBlur = this.createTwoChains('onBlur');
        }
        var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
        if (childrenClassName) {
            newChildProps.className = childrenClassName;
        }
        var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);
        if (!IS_REACT_16) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */], {
                parent: this,
                visible: popupVisible,
                autoMount: false,
                forceRender: forceRender,
                getComponent: this.getComponent,
                getContainer: this.getContainer
            }, function (_ref2) {
                var renderComponent = _ref2.renderComponent;
                _this3.renderComponent = renderComponent;
                return trigger;
            });
        }
        var portal = void 0;
        // prevent unmounting after it's rendered
        if (popupVisible || this._component || forceRender) {
            portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */], { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate }, this.getComponent());
        }
        return [trigger, portal];
    };
    return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
Trigger.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
    showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
    popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
    popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
    maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop,
    afterPopupVisibleChange: noop,
    onPopupAlign: noop,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: []
};
var _initialiseProps = function _initialiseProps() {
    var _this4 = this;
    this.onMouseEnter = function (e) {
        var mouseEnterDelay = _this4.props.mouseEnterDelay;
        _this4.fireEvents('onMouseEnter', e);
        _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
    };
    this.onMouseMove = function (e) {
        _this4.fireEvents('onMouseMove', e);
        _this4.setPoint(e);
    };
    this.onMouseLeave = function (e) {
        _this4.fireEvents('onMouseLeave', e);
        _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onPopupMouseEnter = function () {
        _this4.clearDelayTimer();
    };
    this.onPopupMouseLeave = function (e) {
        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
            return;
        }
        _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
    };
    this.onFocus = function (e) {
        _this4.fireEvents('onFocus', e);
        // incase focusin and focusout
        _this4.clearDelayTimer();
        if (_this4.isFocusToShow()) {
            _this4.focusTime = Date.now();
            _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
        }
    };
    this.onMouseDown = function (e) {
        _this4.fireEvents('onMouseDown', e);
        _this4.preClickTime = Date.now();
    };
    this.onTouchStart = function (e) {
        _this4.fireEvents('onTouchStart', e);
        _this4.preTouchTime = Date.now();
    };
    this.onBlur = function (e) {
        _this4.fireEvents('onBlur', e);
        _this4.clearDelayTimer();
        if (_this4.isBlurToHide()) {
            _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
        }
    };
    this.onContextMenu = function (e) {
        e.preventDefault();
        _this4.fireEvents('onContextMenu', e);
        _this4.setPopupVisible(true, e);
    };
    this.onContextMenuClose = function () {
        if (_this4.isContextMenuToShow()) {
            _this4.close();
        }
    };
    this.onClick = function (event) {
        _this4.fireEvents('onClick', event);
        // focus will trigger click
        if (_this4.focusTime) {
            var preTime = void 0;
            if (_this4.preClickTime && _this4.preTouchTime) {
                preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
            }
            else if (_this4.preClickTime) {
                preTime = _this4.preClickTime;
            }
            else if (_this4.preTouchTime) {
                preTime = _this4.preTouchTime;
            }
            if (Math.abs(preTime - _this4.focusTime) < 20) {
                return;
            }
            _this4.focusTime = 0;
        }
        _this4.preClickTime = 0;
        _this4.preTouchTime = 0;
        // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291
        if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
            event.preventDefault();
        }
        var nextVisible = !_this4.state.popupVisible;
        if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
            _this4.setPopupVisible(!_this4.state.popupVisible, event);
        }
    };
    this.onPopupMouseDown = function () {
        var _context$rcTrigger = _this4.context.rcTrigger, rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
        _this4.hasPopupMouseDown = true;
        clearTimeout(_this4.mouseDownTimeout);
        _this4.mouseDownTimeout = setTimeout(function () {
            _this4.hasPopupMouseDown = false;
        }, 0);
        if (rcTrigger.onPopupMouseDown) {
            rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
        }
    };
    this.onDocumentClick = function (event) {
        if (_this4.props.mask && !_this4.props.maskClosable) {
            return;
        }
        var target = event.target;
        var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
        if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
            _this4.close();
        }
    };
    this.getRootDomNode = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    };
    this.getPopupClassNameFromAlign = function (align) {
        var className = [];
        var _props9 = _this4.props, popupPlacement = _props9.popupPlacement, builtinPlacements = _props9.builtinPlacements, prefixCls = _props9.prefixCls, alignPoint = _props9.alignPoint, getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
        if (popupPlacement && builtinPlacements) {
            className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
        }
        if (getPopupClassNameFromAlign) {
            className.push(getPopupClassNameFromAlign(align));
        }
        return className.join(' ');
    };
    this.getComponent = function () {
        var _props10 = _this4.props, prefixCls = _props10.prefixCls, destroyPopupOnHide = _props10.destroyPopupOnHide, popupClassName = _props10.popupClassName, action = _props10.action, onPopupAlign = _props10.onPopupAlign, popupAnimation = _props10.popupAnimation, popupTransitionName = _props10.popupTransitionName, popupStyle = _props10.popupStyle, mask = _props10.mask, maskAnimation = _props10.maskAnimation, maskTransitionName = _props10.maskTransitionName, zIndex = _props10.zIndex, popup = _props10.popup, stretch = _props10.stretch, alignPoint = _props10.alignPoint;
        var _state = _this4.state, popupVisible = _state.popupVisible, point = _state.point;
        var align = _this4.getPopupAlign();
        var mouseProps = {};
        if (_this4.isMouseEnterToShow()) {
            mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
        }
        if (_this4.isMouseLeaveToHide()) {
            mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
        }
        mouseProps.onMouseDown = _this4.onPopupMouseDown;
        mouseProps.onTouchStart = _this4.onPopupMouseDown;
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            prefixCls: prefixCls,
            destroyPopupOnHide: destroyPopupOnHide,
            visible: popupVisible,
            point: alignPoint && point,
            className: popupClassName,
            action: action,
            align: align,
            onAlign: onPopupAlign,
            animation: popupAnimation,
            getClassNameFromAlign: _this4.getPopupClassNameFromAlign
        }, mouseProps, {
            stretch: stretch,
            getRootDomNode: _this4.getRootDomNode,
            style: popupStyle,
            mask: mask,
            zIndex: zIndex,
            transitionName: popupTransitionName,
            maskAnimation: maskAnimation,
            maskTransitionName: maskTransitionName,
            ref: _this4.savePopup
        }), typeof popup === 'function' ? popup() : popup);
    };
    this.getContainer = function () {
        var props = _this4.props;
        var popupContainer = document.createElement('div');
        // Make sure default popup container will never cause scrollbar appearing
        // https://github.com/react-component/trigger/issues/41
        popupContainer.style.position = 'absolute';
        popupContainer.style.top = '0';
        popupContainer.style.left = '0';
        popupContainer.style.width = '100%';
        var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
        mountNode.appendChild(popupContainer);
        return popupContainer;
    };
    this.setPoint = function (point) {
        var alignPoint = _this4.props.alignPoint;
        if (!alignPoint || !point)
            return;
        _this4.setState({
            point: {
                pageX: point.pageX,
                pageY: point.pageY
            }
        });
    };
    this.handlePortalUpdate = function () {
        if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
            _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
        }
    };
    this.savePopup = function (node) {
        _this4._component = node;
    };
};
Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);
/* harmony default export */ __webpack_exports__["a"] = (Trigger);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = addEventListener;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var _EventObject = __webpack_require__(403);
var _EventObject2 = _interopRequireDefault(_EventObject);
function addEventListener(target, eventType, callback, option) {
    function wrapCallback(e) {
        var ne = new _EventObject2['default'](e);
        callback.call(target, ne);
    }
    if (target.addEventListener) {
        var _ret = (function () {
            var useCapture = false;
            if (typeof option === 'object') {
                useCapture = option.capture || false;
            }
            else if (typeof option === 'boolean') {
                useCapture = option;
            }
            target.addEventListener(eventType, wrapCallback, option || false);
            return {
                v: {
                    remove: function remove() {
                        target.removeEventListener(eventType, wrapCallback, useCapture);
                    }
                }
            };
        })();
        if (typeof _ret === 'object')
            return _ret.v;
    }
    else if (target.attachEvent) {
        target.attachEvent('on' + eventType, wrapCallback);
        return {
            remove: function remove() {
                target.detachEvent('on' + eventType, wrapCallback);
            }
        };
    }
}
module.exports = exports['default'];


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */

Object.defineProperty(exports, '__esModule', {
    value: true
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
var _EventBaseObject = __webpack_require__(404);
var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
var _objectAssign = __webpack_require__(94);
var _objectAssign2 = _interopRequireDefault(_objectAssign);
var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
function isNullOrUndefined(w) {
    return w === null || w === undefined;
}
var eventNormalizers = [{
        reg: /^key/,
        props: ['char', 'charCode', 'key', 'keyCode', 'which'],
        fix: function fix(event, nativeEvent) {
            if (isNullOrUndefined(event.which)) {
                event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
            }
            // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
            if (event.metaKey === undefined) {
                event.metaKey = event.ctrlKey;
            }
        }
    }, {
        reg: /^touch/,
        props: ['touches', 'changedTouches', 'targetTouches']
    }, {
        reg: /^hashchange$/,
        props: ['newURL', 'oldURL']
    }, {
        reg: /^gesturechange$/i,
        props: ['rotation', 'scale']
    }, {
        reg: /^(mousewheel|DOMMouseScroll)$/,
        props: [],
        fix: function fix(event, nativeEvent) {
            var deltaX = undefined;
            var deltaY = undefined;
            var delta = undefined;
            var wheelDelta = nativeEvent.wheelDelta;
            var axis = nativeEvent.axis;
            var wheelDeltaY = nativeEvent.wheelDeltaY;
            var wheelDeltaX = nativeEvent.wheelDeltaX;
            var detail = nativeEvent.detail;
            // ie/webkit
            if (wheelDelta) {
                delta = wheelDelta / 120;
            }
            // gecko
            if (detail) {
                // press control e.detail == 1 else e.detail == 3
                delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
            }
            // Gecko
            if (axis !== undefined) {
                if (axis === event.HORIZONTAL_AXIS) {
                    deltaY = 0;
                    deltaX = 0 - delta;
                }
                else if (axis === event.VERTICAL_AXIS) {
                    deltaX = 0;
                    deltaY = delta;
                }
            }
            // Webkit
            if (wheelDeltaY !== undefined) {
                deltaY = wheelDeltaY / 120;
            }
            if (wheelDeltaX !== undefined) {
                deltaX = -1 * wheelDeltaX / 120;
            }
            // 默认 deltaY (ie)
            if (!deltaX && !deltaY) {
                deltaY = delta;
            }
            if (deltaX !== undefined) {
                /**
                 * deltaX of mousewheel event
                 * @property deltaX
                 * @member Event.DomEvent.Object
                 */
                event.deltaX = deltaX;
            }
            if (deltaY !== undefined) {
                /**
                 * deltaY of mousewheel event
                 * @property deltaY
                 * @member Event.DomEvent.Object
                 */
                event.deltaY = deltaY;
            }
            if (delta !== undefined) {
                /**
                 * delta of mousewheel event
                 * @property delta
                 * @member Event.DomEvent.Object
                 */
                event.delta = delta;
            }
        }
    }, {
        reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
        props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
        fix: function fix(event, nativeEvent) {
            var eventDoc = undefined;
            var doc = undefined;
            var body = undefined;
            var target = event.target;
            var button = nativeEvent.button;
            // Calculate pageX/Y if missing and clientX/Y available
            if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
                eventDoc = target.ownerDocument || document;
                doc = eventDoc.documentElement;
                body = eventDoc.body;
                event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
                event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
            }
            // which for click: 1 === left; 2 === middle; 3 === right
            // do not use button
            if (!event.which && button !== undefined) {
                if (button & 1) {
                    event.which = 1;
                }
                else if (button & 2) {
                    event.which = 3;
                }
                else if (button & 4) {
                    event.which = 2;
                }
                else {
                    event.which = 0;
                }
            }
            // add relatedTarget, if necessary
            if (!event.relatedTarget && event.fromElement) {
                event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
            }
            return event;
        }
    }];
function retTrue() {
    return TRUE;
}
function retFalse() {
    return FALSE;
}
function DomEventObject(nativeEvent) {
    var type = nativeEvent.type;
    var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
    _EventBaseObject2['default'].call(this);
    this.nativeEvent = nativeEvent;
    // in case dom event has been mark as default prevented by lower dom node
    var isDefaultPrevented = retFalse;
    if ('defaultPrevented' in nativeEvent) {
        isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
    }
    else if ('getPreventDefault' in nativeEvent) {
        // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
        isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
    }
    else if ('returnValue' in nativeEvent) {
        isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
    }
    this.isDefaultPrevented = isDefaultPrevented;
    var fixFns = [];
    var fixFn = undefined;
    var l = undefined;
    var prop = undefined;
    var props = commonProps.concat();
    eventNormalizers.forEach(function (normalizer) {
        if (type.match(normalizer.reg)) {
            props = props.concat(normalizer.props);
            if (normalizer.fix) {
                fixFns.push(normalizer.fix);
            }
        }
    });
    l = props.length;
    // clone properties of the original event object
    while (l) {
        prop = props[--l];
        this[prop] = nativeEvent[prop];
    }
    // fix target property, if necessary
    if (!this.target && isNative) {
        this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
    }
    // check if target is a text node (safari)
    if (this.target && this.target.nodeType === 3) {
        this.target = this.target.parentNode;
    }
    l = fixFns.length;
    while (l) {
        fixFn = fixFns[--l];
        fixFn(this, nativeEvent);
    }
    this.timeStamp = nativeEvent.timeStamp || Date.now();
}
var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
    constructor: DomEventObject,
    preventDefault: function preventDefault() {
        var e = this.nativeEvent;
        // if preventDefault exists run it on the original event
        if (e.preventDefault) {
            e.preventDefault();
        }
        else {
            // otherwise set the returnValue property of the original event to FALSE (IE)
            e.returnValue = FALSE;
        }
        EventBaseObjectProto.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
        var e = this.nativeEvent;
        // if stopPropagation exists run it on the original event
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        else {
            // otherwise set the cancelBubble property of the original event to TRUE (IE)
            e.cancelBubble = TRUE;
        }
        EventBaseObjectProto.stopPropagation.call(this);
    }
});
exports['default'] = DomEventObject;
module.exports = exports['default'];


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});
function returnFalse() {
    return false;
}
function returnTrue() {
    return true;
}
function EventBaseObject() {
    this.timeStamp = Date.now();
    this.target = undefined;
    this.currentTarget = undefined;
}
EventBaseObject.prototype = {
    isEventObject: 1,
    constructor: EventBaseObject,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    preventDefault: function preventDefault() {
        this.isDefaultPrevented = returnTrue;
    },
    stopPropagation: function stopPropagation() {
        this.isPropagationStopped = returnTrue;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
        this.isImmediatePropagationStopped = returnTrue;
        // fixed 1.2
        // call stopPropagation implicitly
        this.stopPropagation();
    },
    halt: function halt(immediate) {
        if (immediate) {
            this.stopImmediatePropagation();
        }
        else {
            this.stopPropagation();
        }
        this.preventDefault();
    }
};
exports["default"] = EventBaseObject;
module.exports = exports["default"];


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) { return typeof obj; };
    }
    else {
        _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var ContainerRender = /*#__PURE__*/ function (_React$Component) {
    _inherits(ContainerRender, _React$Component);
    var _super = _createSuper(ContainerRender);
    function ContainerRender() {
        var _this;
        _classCallCheck(this, ContainerRender);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _this.removeContainer = function () {
            if (_this.container) {
                __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);
                _this.container.parentNode.removeChild(_this.container);
                _this.container = null;
            }
        };
        _this.renderComponent = function (props, ready) {
            var _this$props = _this.props, visible = _this$props.visible, getComponent = _this$props.getComponent, forceRender = _this$props.forceRender, getContainer = _this$props.getContainer, parent = _this$props.parent;
            if (visible || parent._component || forceRender) {
                if (!_this.container) {
                    _this.container = getContainer();
                }
                __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
                    if (ready) {
                        ready.call(this);
                    }
                });
            }
        };
        return _this;
    }
    _createClass(ContainerRender, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.autoMount) {
                    this.renderComponent();
                }
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.autoMount) {
                    this.renderComponent();
                }
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.props.autoDestroy) {
                    this.removeContainer();
                }
            }
        }, {
            key: "render",
            value: function render() {
                return this.props.children({
                    renderComponent: this.renderComponent,
                    removeContainer: this.removeContainer
                });
            }
        }]);
    return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
ContainerRender.propTypes = {
    autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
    autoMount: true,
    autoDestroy: true,
    forceRender: false
};



/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) { return typeof obj; };
    }
    else {
        _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    }
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var Portal = /*#__PURE__*/ function (_React$Component) {
    _inherits(Portal, _React$Component);
    var _super = _createSuper(Portal);
    function Portal() {
        _classCallCheck(this, Portal);
        return _super.apply(this, arguments);
    }
    _createClass(Portal, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createContainer();
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var didUpdate = this.props.didUpdate;
                if (didUpdate) {
                    didUpdate(prevProps);
                }
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeContainer();
            }
        }, {
            key: "createContainer",
            value: function createContainer() {
                this._container = this.props.getContainer();
                this.forceUpdate();
            }
        }, {
            key: "removeContainer",
            value: function removeContainer() {
                if (this._container) {
                    this._container.parentNode.removeChild(this._container);
                }
            }
        }, {
            key: "render",
            value: function render() {
                if (this._container) {
                    return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
                }
                return null;
            }
        }]);
    return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Portal.propTypes = {
    getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
    didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};



/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(198);












var Popup = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);
    function Popup(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);
        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));
        _initialiseProps.call(_this);
        _this.state = {
            // Used for stretch
            stretchChecked: false,
            targetWidth: undefined,
            targetHeight: undefined
        };
        _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
        _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
        return _this;
    }
    Popup.prototype.componentDidMount = function componentDidMount() {
        this.rootNode = this.getPopupDomNode();
        this.setStretchSize();
    };
    Popup.prototype.componentDidUpdate = function componentDidUpdate() {
        this.setStretchSize();
    };
    // Record size if stretch needed
    Popup.prototype.getPopupDomNode = function getPopupDomNode() {
        return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
    };
    // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
        var props = this.props;
        var transitionName = props.maskTransitionName;
        var animation = props.maskAnimation;
        if (!transitionName && animation) {
            transitionName = props.prefixCls + '-' + animation;
        }
        return transitionName;
    };
    Popup.prototype.getTransitionName = function getTransitionName() {
        var props = this.props;
        var transitionName = props.transitionName;
        if (!transitionName && props.animation) {
            transitionName = props.prefixCls + '-' + props.animation;
        }
        return transitionName;
    };
    Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
        return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
    };
    Popup.prototype.getPopupElement = function getPopupElement() {
        var _this2 = this;
        var savePopupRef = this.savePopupRef;
        var _state = this.state, stretchChecked = _state.stretchChecked, targetHeight = _state.targetHeight, targetWidth = _state.targetWidth;
        var _props = this.props, align = _props.align, visible = _props.visible, prefixCls = _props.prefixCls, style = _props.style, getClassNameFromAlign = _props.getClassNameFromAlign, destroyPopupOnHide = _props.destroyPopupOnHide, stretch = _props.stretch, children = _props.children, onMouseEnter = _props.onMouseEnter, onMouseLeave = _props.onMouseLeave, onMouseDown = _props.onMouseDown, onTouchStart = _props.onTouchStart;
        var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
        var hiddenClassName = prefixCls + '-hidden';
        if (!visible) {
            this.currentAlignClassName = null;
        }
        var sizeStyle = {};
        if (stretch) {
            // Stretch with target
            if (stretch.indexOf('height') !== -1) {
                sizeStyle.height = targetHeight;
            }
            else if (stretch.indexOf('minHeight') !== -1) {
                sizeStyle.minHeight = targetHeight;
            }
            if (stretch.indexOf('width') !== -1) {
                sizeStyle.width = targetWidth;
            }
            else if (stretch.indexOf('minWidth') !== -1) {
                sizeStyle.minWidth = targetWidth;
            }
            // Delay force align to makes ui smooth
            if (!stretchChecked) {
                sizeStyle.visibility = 'hidden';
                setTimeout(function () {
                    if (_this2.alignInstance) {
                        _this2.alignInstance.forceAlign();
                    }
                }, 0);
            }
        }
        var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());
        var popupInnerProps = {
            className: className,
            prefixCls: prefixCls,
            ref: savePopupRef,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onTouchStart: onTouchStart,
            style: newStyle
        };
        if (destroyPopupOnHide) {
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */], {
                component: '',
                exclusive: true,
                transitionAppear: true,
                transitionName: this.getTransitionName()
            }, visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */], {
                target: this.getAlignTarget(),
                key: 'popup',
                ref: this.saveAlignRef,
                monitorWindowResize: true,
                align: align,
                onAlign: this.onAlign
            }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                visible: true
            }, popupInnerProps), children)) : null);
        }
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */], {
            component: '',
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName(),
            showProp: 'xVisible'
        }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */], {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: { visible: 'xVisible' },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
        }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
        }, popupInnerProps), children)));
    };
    Popup.prototype.getZIndexStyle = function getZIndexStyle() {
        var style = {};
        var props = this.props;
        if (props.zIndex !== undefined) {
            style.zIndex = props.zIndex;
        }
        return style;
    };
    Popup.prototype.getMaskElement = function getMaskElement() {
        var props = this.props;
        var maskElement = void 0;
        if (props.mask) {
            var maskTransition = this.getMaskTransitionName();
            maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
                style: this.getZIndexStyle(),
                key: 'mask',
                className: props.prefixCls + '-mask',
                hiddenClassName: props.prefixCls + '-mask-hidden',
                visible: props.visible
            });
            if (maskTransition) {
                maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */], {
                    key: 'mask',
                    showProp: 'visible',
                    transitionAppear: true,
                    component: '',
                    transitionName: maskTransition
                }, maskElement);
            }
        }
        return maskElement;
    };
    Popup.prototype.render = function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, this.getMaskElement(), this.getPopupElement());
    };
    return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);
Popup.propTypes = {
    visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
    point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
        pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
        pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    })
};
var _initialiseProps = function _initialiseProps() {
    var _this3 = this;
    this.onAlign = function (popupDomNode, align) {
        var props = _this3.props;
        var currentAlignClassName = props.getClassNameFromAlign(align);
        // FIX: https://github.com/react-component/trigger/issues/56
        // FIX: https://github.com/react-component/tooltip/issues/79
        if (_this3.currentAlignClassName !== currentAlignClassName) {
            _this3.currentAlignClassName = currentAlignClassName;
            popupDomNode.className = _this3.getClassName(currentAlignClassName);
        }
        props.onAlign(popupDomNode, align);
    };
    this.setStretchSize = function () {
        var _props2 = _this3.props, stretch = _props2.stretch, getRootDomNode = _props2.getRootDomNode, visible = _props2.visible;
        var _state2 = _this3.state, stretchChecked = _state2.stretchChecked, targetHeight = _state2.targetHeight, targetWidth = _state2.targetWidth;
        if (!stretch || !visible) {
            if (stretchChecked) {
                _this3.setState({ stretchChecked: false });
            }
            return;
        }
        var $ele = getRootDomNode();
        if (!$ele)
            return;
        var height = $ele.offsetHeight;
        var width = $ele.offsetWidth;
        if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
            _this3.setState({
                stretchChecked: true,
                targetHeight: height,
                targetWidth: width
            });
        }
    };
    this.getTargetElement = function () {
        return _this3.props.getRootDomNode();
    };
    this.getAlignTarget = function () {
        var point = _this3.props.point;
        if (point) {
            return point;
        }
        return _this3.getTargetElement;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (Popup);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(409);
// export this package's api

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(411);










function getElement(func) {
    if (typeof func !== 'function' || !func)
        return null;
    return func();
}
function getPoint(point) {
    if (typeof point !== 'object' || !point)
        return null;
    return point;
}
var Align = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);
    function Align() {
        var _ref;
        var _temp, _this, _ret;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
            var _this$props = _this.props, disabled = _this$props.disabled, target = _this$props.target, align = _this$props.align, onAlign = _this$props.onAlign;
            if (!disabled && target) {
                var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);
                var result = void 0;
                var element = getElement(target);
                var point = getPoint(target);
                // IE lose focus after element realign
                // We should record activeElement and restore later
                var activeElement = document.activeElement;
                if (element) {
                    result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
                }
                else if (point) {
                    result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
                }
                Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);
                if (onAlign) {
                    onAlign(source, result);
                }
            }
        }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                var props = this.props;
                // if parent ref not attached .... use document.getElementById
                this.forceAlign();
                if (!props.disabled && props.monitorWindowResize) {
                    this.startMonitorWindowResize();
                }
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var reAlign = false;
                var props = this.props;
                if (!props.disabled) {
                    var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
                    var sourceRect = source ? source.getBoundingClientRect() : null;
                    if (prevProps.disabled) {
                        reAlign = true;
                    }
                    else {
                        var lastElement = getElement(prevProps.target);
                        var currentElement = getElement(props.target);
                        var lastPoint = getPoint(prevProps.target);
                        var currentPoint = getPoint(props.target);
                        if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
                            // Skip if is window
                            reAlign = false;
                        }
                        else if (lastElement !== currentElement || // Element change
                            lastElement && !currentElement && currentPoint || // Change from element to point
                            lastPoint && currentPoint && currentElement || // Change from point to element
                            currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
                            reAlign = true;
                        }
                        // If source element size changed
                        var preRect = this.sourceRect || {};
                        if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
                            reAlign = true;
                        }
                    }
                    this.sourceRect = sourceRect;
                }
                if (reAlign) {
                    this.forceAlign();
                }
                if (props.monitorWindowResize && !props.disabled) {
                    this.startMonitorWindowResize();
                }
                else {
                    this.stopMonitorWindowResize();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.stopMonitorWindowResize();
            }
        }, {
            key: 'startMonitorWindowResize',
            value: function startMonitorWindowResize() {
                if (!this.resizeHandler) {
                    this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
                    this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
                }
            }
        }, {
            key: 'stopMonitorWindowResize',
            value: function stopMonitorWindowResize() {
                if (this.resizeHandler) {
                    this.bufferMonitor.clear();
                    this.resizeHandler.remove();
                    this.resizeHandler = null;
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, childrenProps = _props.childrenProps, children = _props.children;
                var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
                if (childrenProps) {
                    var newProps = {};
                    var propList = Object.keys(childrenProps);
                    propList.forEach(function (prop) {
                        newProps[prop] = _this2.props[childrenProps[prop]];
                    });
                    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
                }
                return child;
            }
        }]);
    return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);
Align.propTypes = {
    childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
    align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
    target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
            clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
            clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
            pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
            pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
        })]),
    onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
    target: function target() {
        return window;
    },
    monitorBufferTime: 50,
    monitorWindowResize: false,
    disabled: false
};
/* harmony default export */ __webpack_exports__["a"] = (Align);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function (obj) {
            return typeof obj;
        };
    }
    else {
        _typeof = function (obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
    }
    return _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly)
            symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) {
            ownKeys(source, true).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        }
        else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        }
        else {
            ownKeys(source).forEach(function (key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    }
    return target;
}
var vendorPrefix;
var jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function getVendorPrefix() {
    if (vendorPrefix !== undefined) {
        return vendorPrefix;
    }
    vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for (var key in jsCssMap) {
        if (key + testProp in style) {
            vendorPrefix = key;
        }
    }
    return vendorPrefix;
}
function getTransitionName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
    return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
    var name = getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') {
            node.style.transitionProperty = value;
        }
    }
}
function setTransform(node, value) {
    var name = getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') {
            node.style.transform = value;
        }
    }
}
function getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match(matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function (item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            setTransform(node, "matrix(".concat(arr.join(','), ")"));
        }
        else {
            var match3d = transform.match(matrix3d)[1];
            arr = match3d.split(',').map(function (item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    }
    else {
        setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
    }
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function css(el, name, v) {
    var value = v;
    if (_typeof(name) === 'object') {
        for (var i in name) {
            if (name.hasOwnProperty(i)) {
                css(el, i, name[i]);
            }
        }
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') {
            value = "".concat(value, "px");
        }
        el.style[name] = value;
        return undefined;
    }
    return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = box.left;
    y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document; // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
        }
    }
    return ret;
}
function getScrollLeft(w) {
    return getScroll(w);
}
function getScrollTop(w) {
    return getScroll(w, true);
}
function getOffset(el) {
    var pos = getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScrollLeft(w);
    pos.top += getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */
    return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
    if (isWindow(node)) {
        return node.document;
    }
    if (node.nodeType === 9) {
        return node;
    }
    return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) {
        val = computedStyle.getPropertyValue(name) || computedStyle[name];
    }
    return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[LEFT];
        var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content
        elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out
        style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + PX; // Revert the changed values
        style[LEFT] = left;
        elem[RUNTIME_STYLE][LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
    getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
    if (dir === 'left') {
        return option.useCssRight ? 'right' : dir;
    }
    return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
    if (dir === 'left') {
        return 'right';
    }
    else if (dir === 'right') {
        return 'left';
    }
    else if (dir === 'top') {
        return 'bottom';
    }
    else if (dir === 'bottom') {
        return 'top';
    }
} // 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if (css(elem, 'position') === 'static') {
        elem.style.position = 'relative';
    }
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = getOffsetDirection('left', option);
    var verticalProperty = getOffsetDirection('top', option);
    var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') {
        presetH = 999;
    }
    if (verticalProperty !== 'top') {
        presetV = 999;
    }
    var originalTransition = '';
    var originalOffset = getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = getTransitionProperty(elem) || '';
        setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    } // force relayout
    forceRelayout(elem);
    var old = getOffset(elem);
    var originalStyle = {};
    for (var key in offset) {
        if (offset.hasOwnProperty(key)) {
            var dir = getOffsetDirection(key, option);
            var preset = key === 'left' ? presetH : presetV;
            var off = originalOffset[key] - old[key];
            if (dir === key) {
                originalStyle[dir] = preset + off;
            }
            else {
                originalStyle[dir] = preset - off;
            }
        }
    }
    css(elem, originalStyle); // force relayout
    forceRelayout(elem);
    if ('left' in offset || 'top' in offset) {
        setTransitionProperty(elem, originalTransition);
    }
    var ret = {};
    for (var _key in offset) {
        if (offset.hasOwnProperty(_key)) {
            var _dir = getOffsetDirection(_key, option);
            var _off = offset[_key] - originalOffset[_key];
            if (_key === _dir) {
                ret[_dir] = originalStyle[_dir] + _off;
            }
            else {
                ret[_dir] = originalStyle[_dir] - _off;
            }
        }
    }
    css(elem, ret);
}
function setTransform$1(elem, offset) {
    var originalOffset = getOffset(elem);
    var originalXY = getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) {
        resultXY.x = originalXY.x + offset.left - originalOffset.left;
    }
    if ('top' in offset) {
        resultXY.y = originalXY.y + offset.top - originalOffset.top;
    }
    setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) {
            return;
        }
    }
    if (option.useCssRight || option.useCssBottom) {
        setLeftTop(elem, offset, option);
    }
    else if (option.useCssTransform && getTransformName() in document.body.style) {
        setTransform$1(elem, offset);
    }
    else {
        setLeftTop(elem, offset, option);
    }
}
function each(arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i]);
    }
}
function isBorderBoxFn(elem) {
    return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name; // Remember the old values, and insert the new ones
    for (name in options) {
        if (options.hasOwnProperty(name)) {
            old[name] = style[name];
            style[name] = options[name];
        }
    }
    callback.call(elem); // Revert the old values
    for (name in options) {
        if (options.hasOwnProperty(name)) {
            style[name] = old[name];
        }
    }
}
function getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for (j = 0; j < props.length; j++) {
        prop = props[j];
        if (prop) {
            for (i = 0; i < which.length; i++) {
                var cssProp = void 0;
                if (prop === 'border') {
                    cssProp = "".concat(prop).concat(which[i], "Width");
                }
                else {
                    cssProp = prop + which[i];
                }
                value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
            }
        }
    }
    return value;
}
var domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do {
            if (parent.nodeType === 11 && parent.host) {
                parent = parent.host;
            }
            else {
                parent = parent.parentNode;
            }
        } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
each(['Width', 'Height'], function (name) {
    domUtils["doc".concat(name)] = function (refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
    };
    domUtils["viewport".concat(name)] = function (win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
    var extra = ex;
    if (isWindow(elem)) {
        return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
    }
    else if (elem.nodeType === 9) {
        return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
    }
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
    var computedStyle = getComputedStyleX(elem);
    var isBorderBox = isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined; // Fall back to computed then un computed css if necessary
        cssBoxValue = getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
            cssBoxValue = elem.style[name] || 0;
        } // Normalize '', auto, and prepare for extra
        cssBoxValue = parseFloat(cssBoxValue) || 0;
    }
    if (extra === undefined) {
        extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
    }
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) {
            return val - getPBMWidth(elem, ['border', 'padding'], which);
        }
        return cssBoxValue;
    }
    else if (borderBoxValueOrIsBorderBox) {
        if (extra === BORDER_INDEX) {
            return val;
        }
        return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
    }
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
    }
    var val;
    var elem = args[0]; // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) {
        val = getWH.apply(undefined, args);
    }
    else {
        swap(elem, cssShow, function () {
            val = getWH.apply(undefined, args);
        });
    }
    return val;
}
each(['width', 'height'], function (name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    domUtils["outer".concat(first)] = function (el, includeMargin) {
        return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
    };
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    domUtils[name] = function (elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var computedStyle = getComputedStyleX(elem);
                var isBorderBox = isBorderBoxFn(elem);
                if (isBorderBox) {
                    val += getPBMWidth(elem, ['padding', 'border'], which);
                }
                return css(elem, name, val);
            }
            return undefined;
        }
        return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
    };
});
function mix(to, from) {
    for (var i in from) {
        if (from.hasOwnProperty(i)) {
            to[i] = from[i];
        }
    }
    return to;
}
var utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) {
            return node;
        }
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') {
            setOffset(el, value, option || {});
        }
        else {
            return getOffset(el);
        }
    },
    isWindow: isWindow,
    each: each,
    css: css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for (i in obj) {
            if (obj.hasOwnProperty(i)) {
                ret[i] = obj[i];
            }
        }
        var overflow = obj.overflow;
        if (overflow) {
            for (i in obj) {
                if (obj.hasOwnProperty(i)) {
                    ret.overflow[i] = obj.overflow[i];
                }
            }
        }
        return ret;
    },
    mix: mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for (var i = 0; i < arguments.length; i++) {
            utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        }
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
mix(utils, domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
    if (utils.isWindow(element) || element.nodeType === 9) {
        return null;
    } // ie 这个也不是完全可行
    /*
     <div style="width: 50px;height: 100px;overflow: hidden">
     <div style="width: 50px;height: 100px;position: relative;" id="d6">
     元素 6 高 100px 宽 50px<br/>
     </div>
     </div>
     */
    // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) {
        return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
    }
    for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
        positionStyle = utils.css(parent, 'position');
        if (positionStyle !== 'static') {
            return parent;
        }
    }
    return null;
}
var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
    if (utils.isWindow(element) || element.nodeType === 9) {
        return false;
    }
    var doc = utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
        var positionStyle = utils.css(parent, 'position');
        if (positionStyle === 'fixed') {
            return true;
        }
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = getOffsetParent(element);
    var doc = utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while (el) {
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
            // viewport. In some browsers, el.offsetParent may be
            // document.documentElement, so check for that too.
            el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
            var pos = utils.offset(el); // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        }
        else if (el === body || el === documentElement) {
            break;
        }
        el = getOffsetParent(el);
    } // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = utils.css(element, 'position');
        if (position === 'absolute') {
            element.style.position = 'fixed';
        }
    }
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') {
        documentWidth = win.innerWidth;
    }
    if (bodyStyle.overflowY === 'hidden') {
        documentHeight = win.innerHeight;
    } // Reset element position after calculate the visible area
    if (element.style) {
        element.style.position = originalPosition;
    }
    if (alwaysByViewport || isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    }
    else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) {
        pos.left = visibleRect.left;
    } // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
        size.width -= pos.left + size.width - visibleRect.right;
    } // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
        // 保证左边界和可视区域左边界对齐
        pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    } // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) {
        pos.top = visibleRect.top;
    } // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
        size.height -= pos.top + size.height - visibleRect.bottom;
    } // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
        // 保证上边界和可视区域上边界对齐
        pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    }
    return utils.mix(pos, size);
}
function getRegion(node) {
    var offset;
    var w;
    var h;
    if (!utils.isWindow(node) && node.nodeType !== 9) {
        offset = utils.offset(node);
        w = utils.outerWidth(node);
        h = utils.outerHeight(node);
    }
    else {
        var win = utils.getWindow(node);
        offset = {
            left: utils.getWindowScrollLeft(win),
            top: utils.getWindowScrollTop(win)
        };
        w = utils.viewportWidth(win);
        h = utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') {
        y += h / 2;
    }
    else if (V === 'b') {
        y += h;
    }
    if (H === 'c') {
        x += w / 2;
    }
    else if (H === 'r') {
        x += w;
    }
    return {
        left: x,
        top: y
    };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = getAlignOffset(refNodeRegion, points[1]);
    var p2 = getAlignOffset(elRegion, points[0]);
    var diff = [p2.left - p1.left, p2.top - p1.top];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */
function isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
    var ret = [];
    utils.each(points, function (p) {
        ret.push(p.replace(reg, function (m) {
            return map[m];
        }));
    });
    return ret;
}
function flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) {
        n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    }
    else {
        n = parseInt(str, 10);
    }
    return n || 0;
}
function normalizeOffset(offset, el) {
    offset[0] = convertOffset(offset[0], el.width);
    offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [0, 0];
    var targetOffset = align.targetOffset || [0, 0];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域
    var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height
    var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比
    normalizeOffset(offset, elRegion);
    normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置
    var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域
    var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) {
            // 如果横向不能放下
            if (isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                }); // 偏移量也反下
                var newOffset = flipOffset(offset, 0);
                var newTargetOffset = flipOffset(targetOffset, 0);
                var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) {
            // 如果纵向不能放下
            if (isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                }); // 偏移量也反下
                var _newOffset = flipOffset(offset, 1);
                var _newTargetOffset = flipOffset(targetOffset, 1);
                var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        } // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points; // 重置对应部分的翻转逻辑
            if (isStillFailX) {
                _newPoints2 = flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
            }
            if (isStillFailY) {
                _newPoints2 = flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
            }
            points = _newPoints2;
            offset = align.offset || [0, 0];
            targetOffset = align.targetOffset || [0, 0];
        } // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
            newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
        }
    } // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) {
        utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
    }
    if (newElRegion.height !== elRegion.height) {
        utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
    } // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/
function isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = getRegion(target);
    var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */
function alignPoint(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = utils.getWindowScrollLeft(win);
    var scrollY = utils.getWindowScrollTop(win);
    var viewportWidth = utils.viewportWidth(win);
    var viewportHeight = utils.viewportHeight(win);
    if ('pageX' in tgtPoint) {
        pageX = tgtPoint.pageX;
    }
    else {
        pageX = scrollX + tgtPoint.clientX;
    }
    if ('pageY' in tgtPoint) {
        pageY = tgtPoint.pageY;
    }
    else {
        pageY = scrollY + tgtPoint.clientY;
    }
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point
    var points = [align.points[0], 'cc'];
    return doAlign(el, tgtRegion, _objectSpread2({}, align, {
        points: points
    }), pointInView);
}
/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);




/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(196);

function buffer(fn, ms) {
    var timer = void 0;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function bufferFn() {
        clear();
        timer = setTimeout(fn, ms);
    }
    bufferFn.clear = clear;
    return bufferFn;
}
function isSamePoint(prev, next) {
    if (prev === next)
        return true;
    if (!prev || !next)
        return false;
    if ('pageX' in next && 'pageY' in next) {
        return prev.pageX === next.pageX && prev.pageY === next.pageY;
    }
    if ('clientX' in next && 'clientY' in next) {
        return prev.clientX === next.clientX && prev.clientY === next.clientY;
    }
    return false;
}
function isWindow(obj) {
    return obj && typeof obj === 'object' && obj.window === obj;
}
function isSimilarValue(val1, val2) {
    var int1 = Math.floor(val1);
    var int2 = Math.floor(val2);
    return Math.abs(int1 - int2) <= 1;
}
function restoreFocus(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
        activeElement.focus();
    }
}


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) {
        throw new Error('Can only polyfill class components');
    } // only handle componentWillReceiveProps
    if (typeof prototype.componentWillReceiveProps !== 'function') {
        return Component;
    } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
    // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
        return Component;
    } // Here polyfill get started
    prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
    delete prototype.componentWillReceiveProps;
    return Component;
};
/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function toArrayChildren(children) {
    var ret = [];
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
        ret.push(child);
    });
    return ret;
}
function findChildInChildrenByKey(children, key) {
    var ret = null;
    if (children) {
        children.forEach(function (child) {
            if (ret) {
                return;
            }
            if (child && child.key === key) {
                ret = child;
            }
        });
    }
    return ret;
}
function findShownChildInChildrenByKey(children, key, showProp) {
    var ret = null;
    if (children) {
        children.forEach(function (child) {
            if (child && child.key === key && child.props[showProp]) {
                if (ret) {
                    throw new Error('two child with same key for <rc-animate> children');
                }
                ret = child;
            }
        });
    }
    return ret;
}
function findHiddenChildInChildrenByKey(children, key, showProp) {
    var found = 0;
    if (children) {
        children.forEach(function (child) {
            if (found) {
                return;
            }
            found = child && child.key === key && !child.props[showProp];
        });
    }
    return found;
}
function isSameChildren(c1, c2, showProp) {
    var same = c1.length === c2.length;
    if (same) {
        c1.forEach(function (child, index) {
            var child2 = c2[index];
            if (child && child2) {
                if (child && !child2 || !child && child2) {
                    same = false;
                }
                else if (child.key !== child2.key) {
                    same = false;
                }
                else if (showProp && child.props[showProp] !== child2.props[showProp]) {
                    same = false;
                }
            }
        });
    }
    return same;
}
function mergeChildren(prev, next) {
    var ret = [];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextChildrenPending = {};
    var pendingChildren = [];
    prev.forEach(function (child) {
        if (child && findChildInChildrenByKey(next, child.key)) {
            if (pendingChildren.length) {
                nextChildrenPending[child.key] = pendingChildren;
                pendingChildren = [];
            }
        }
        else {
            pendingChildren.push(child);
        }
    });
    next.forEach(function (child) {
        if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
            ret = ret.concat(nextChildrenPending[child.key]);
        }
        ret.push(child);
    });
    ret = ret.concat(pendingChildren);
    return ret;
}


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(201);









var transitionMap = {
    enter: 'transitionEnter',
    appear: 'transitionAppear',
    leave: 'transitionLeave'
};
var AnimateChild = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);
    function AnimateChild() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
    }
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.stop();
            }
        }, {
            key: 'componentWillEnter',
            value: function componentWillEnter(done) {
                if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
                    this.transition('enter', done);
                }
                else {
                    done();
                }
            }
        }, {
            key: 'componentWillAppear',
            value: function componentWillAppear(done) {
                if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
                    this.transition('appear', done);
                }
                else {
                    done();
                }
            }
        }, {
            key: 'componentWillLeave',
            value: function componentWillLeave(done) {
                if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
                    this.transition('leave', done);
                }
                else {
                    // always sync, do not interupt with react component life cycle
                    // update hidden -> animate hidden ->
                    // didUpdate -> animate leave -> unmount (if animate is none)
                    done();
                }
            }
        }, {
            key: 'transition',
            value: function transition(animationType, finishCallback) {
                var _this2 = this;
                var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
                var props = this.props;
                var transitionName = props.transitionName;
                var nameIsObj = typeof transitionName === 'object';
                this.stop();
                var end = function end() {
                    _this2.stopper = null;
                    finishCallback();
                };
                if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
                    var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
                    var activeName = name + '-active';
                    if (nameIsObj && transitionName[animationType + 'Active']) {
                        activeName = transitionName[animationType + 'Active'];
                    }
                    this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
                        name: name,
                        active: activeName
                    }, end);
                }
                else {
                    this.stopper = props.animation[animationType](node, end);
                }
            }
        }, {
            key: 'stop',
            value: function stop() {
                var stopper = this.stopper;
                if (stopper) {
                    this.stopper = null;
                    stopper.stop();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }]);
    return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
AnimateChild.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);



var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
    // ms is special .... !
    'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
function getStyleProperty(node, name) {
    // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
    var style = window.getComputedStyle(node, null);
    var ret = '';
    for (var i = 0; i < prefixes.length; i++) {
        ret = style.getPropertyValue(prefixes[i] + name);
        if (ret) {
            break;
        }
    }
    return ret;
}
function fixBrowserByTimeout(node) {
    if (isCssAnimationSupported) {
        var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
        var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
        var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
        var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
        var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
        // sometimes, browser bug
        node.rcEndAnimTimeout = setTimeout(function () {
            node.rcEndAnimTimeout = null;
            if (node.rcEndListener) {
                node.rcEndListener();
            }
        }, time * 1000 + 200);
    }
}
function clearBrowserBugTimeout(node) {
    if (node.rcEndAnimTimeout) {
        clearTimeout(node.rcEndAnimTimeout);
        node.rcEndAnimTimeout = null;
    }
}
var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
    var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
    var className = nameIsObj ? transitionName.name : transitionName;
    var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
    var end = endCallback;
    var start = void 0;
    var active = void 0;
    var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);
    if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
        end = endCallback.end;
        start = endCallback.start;
        active = endCallback.active;
    }
    if (node.rcEndListener) {
        node.rcEndListener();
    }
    node.rcEndListener = function (e) {
        if (e && e.target !== node) {
            return;
        }
        if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node);
        nodeClasses.remove(className);
        nodeClasses.remove(activeClassName);
        __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
        node.rcEndListener = null;
        // Usually this optional end is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (end) {
            end();
        }
    };
    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);
    if (start) {
        start();
    }
    nodeClasses.add(className);
    node.rcAnimTimeout = setTimeout(function () {
        node.rcAnimTimeout = null;
        nodeClasses.add(activeClassName);
        if (active) {
            setTimeout(active, 0);
        }
        fixBrowserByTimeout(node);
        // 30ms for firefox
    }, 30);
    return {
        stop: function stop() {
            if (node.rcEndListener) {
                node.rcEndListener();
            }
        }
    };
};
cssAnimation.style = function (node, style, callback) {
    if (node.rcEndListener) {
        node.rcEndListener();
    }
    node.rcEndListener = function (e) {
        if (e && e.target !== node) {
            return;
        }
        if (node.rcAnimTimeout) {
            clearTimeout(node.rcAnimTimeout);
            node.rcAnimTimeout = null;
        }
        clearBrowserBugTimeout(node);
        __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
        node.rcEndListener = null;
        // Usually this optional callback is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (callback) {
            callback();
        }
    };
    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);
    node.rcAnimTimeout = setTimeout(function () {
        for (var s in style) {
            if (style.hasOwnProperty(s)) {
                node.style[s] = style[s];
            }
        }
        node.rcAnimTimeout = null;
        fixBrowserByTimeout(node);
    }, 0);
};
cssAnimation.setTransition = function (node, p, value) {
    var property = p;
    var v = value;
    if (value === undefined) {
        v = property;
        property = '';
    }
    property = property || '';
    capitalPrefixes.forEach(function (prefix) {
        node.style[prefix + 'Transition' + property] = v;
    });
};
cssAnimation.isCssAnimationSupported = isCssAnimationSupported;

/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
    transitionstart: {
        transition: 'transitionstart',
        WebkitTransition: 'webkitTransitionStart',
        MozTransition: 'mozTransitionStart',
        OTransition: 'oTransitionStart',
        msTransition: 'MSTransitionStart'
    },
    animationstart: {
        animation: 'animationstart',
        WebkitAnimation: 'webkitAnimationStart',
        MozAnimation: 'mozAnimationStart',
        OAnimation: 'oAnimationStart',
        msAnimation: 'MSAnimationStart'
    }
};
var END_EVENT_NAME_MAP = {
    transitionend: {
        transition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'mozTransitionEnd',
        OTransition: 'oTransitionEnd',
        msTransition: 'MSTransitionEnd'
    },
    animationend: {
        animation: 'animationend',
        WebkitAnimation: 'webkitAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        OAnimation: 'oAnimationEnd',
        msAnimation: 'MSAnimationEnd'
    }
};
var startEvents = [];
var endEvents = [];
function detectEvents() {
    var testEl = document.createElement('div');
    var style = testEl.style;
    if (!('AnimationEvent' in window)) {
        delete START_EVENT_NAME_MAP.animationstart.animation;
        delete END_EVENT_NAME_MAP.animationend.animation;
    }
    if (!('TransitionEvent' in window)) {
        delete START_EVENT_NAME_MAP.transitionstart.transition;
        delete END_EVENT_NAME_MAP.transitionend.transition;
    }
    function process(EVENT_NAME_MAP, events) {
        for (var baseEventName in EVENT_NAME_MAP) {
            if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
                var baseEvents = EVENT_NAME_MAP[baseEventName];
                for (var styleName in baseEvents) {
                    if (styleName in style) {
                        events.push(baseEvents[styleName]);
                        break;
                    }
                }
            }
        }
    }
    process(START_EVENT_NAME_MAP, startEvents);
    process(END_EVENT_NAME_MAP, endEvents);
}
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    detectEvents();
}
function addEventListener(node, eventName, eventListener) {
    node.addEventListener(eventName, eventListener, false);
}
function removeEventListener(node, eventName, eventListener) {
    node.removeEventListener(eventName, eventListener, false);
}
var TransitionEvents = {
    // Start events
    startEvents: startEvents,
    addStartEventListener: function addStartEventListener(node, eventListener) {
        if (startEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
        }
        startEvents.forEach(function (startEvent) {
            addEventListener(node, startEvent, eventListener);
        });
    },
    removeStartEventListener: function removeStartEventListener(node, eventListener) {
        if (startEvents.length === 0) {
            return;
        }
        startEvents.forEach(function (startEvent) {
            removeEventListener(node, startEvent, eventListener);
        });
    },
    // End events
    endEvents: endEvents,
    addEndEventListener: function addEndEventListener(node, eventListener) {
        if (endEvents.length === 0) {
            window.setTimeout(eventListener, 0);
            return;
        }
        endEvents.forEach(function (endEvent) {
            addEventListener(node, endEvent, eventListener);
        });
    },
    removeEndEventListener: function removeEndEventListener(node, eventListener) {
        if (endEvents.length === 0) {
            return;
        }
        endEvents.forEach(function (endEvent) {
            removeEventListener(node, endEvent, eventListener);
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */
try {
    var index = __webpack_require__(200);
}
catch (err) {
    var index = __webpack_require__(200);
}
/**
 * Whitespace regexp.
 */
var re = /\s+/;
/**
 * toString reference.
 */
var toString = Object.prototype.toString;
/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */
module.exports = function (el) {
    return new ClassList(el);
};
/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */
function ClassList(el) {
    if (!el || !el.nodeType) {
        throw new Error('A DOM element reference is required');
    }
    this.el = el;
    this.list = el.classList;
}
/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */
ClassList.prototype.add = function (name) {
    // classList
    if (this.list) {
        this.list.add(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (!~i)
        arr.push(name);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */
ClassList.prototype.remove = function (name) {
    if ('[object RegExp]' == toString.call(name)) {
        return this.removeMatching(name);
    }
    // classList
    if (this.list) {
        this.list.remove(name);
        return this;
    }
    // fallback
    var arr = this.array();
    var i = index(arr, name);
    if (~i)
        arr.splice(i, 1);
    this.el.className = arr.join(' ');
    return this;
};
/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */
ClassList.prototype.removeMatching = function (re) {
    var arr = this.array();
    for (var i = 0; i < arr.length; i++) {
        if (re.test(arr[i])) {
            this.remove(arr[i]);
        }
    }
    return this;
};
/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */
ClassList.prototype.toggle = function (name, force) {
    // classList
    if (this.list) {
        if ("undefined" !== typeof force) {
            if (force !== this.list.toggle(name, force)) {
                this.list.toggle(name); // toggle again to correct
            }
        }
        else {
            this.list.toggle(name);
        }
        return this;
    }
    // fallback
    if ("undefined" !== typeof force) {
        if (!force) {
            this.remove(name);
        }
        else {
            this.add(name);
        }
    }
    else {
        if (this.has(name)) {
            this.remove(name);
        }
        else {
            this.add(name);
        }
    }
    return this;
};
/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */
ClassList.prototype.array = function () {
    var className = this.el.getAttribute('class') || '';
    var str = className.replace(/^\s+|\s+$/g, '');
    var arr = str.split(re);
    if ('' === arr[0])
        arr.shift();
    return arr;
};
/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */
ClassList.prototype.has =
    ClassList.prototype.contains = function (name) {
        return this.list
            ? this.list.contains(name)
            : !!~index(this.array(), name);
    };


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(202);






var PopupInner = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);
    function PopupInner() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }
    PopupInner.prototype.render = function render() {
        var props = this.props;
        var className = props.className;
        if (!props.visible) {
            className += ' ' + props.hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', {
            className: className,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            onMouseDown: props.onMouseDown,
            onTouchStart: props.onTouchStart,
            style: props.style
        }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */], { className: props.prefixCls + '-content', visible: props.visible }, props.children));
    };
    return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);
PopupInner.propTypes = {
    hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (PopupInner);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export placements */
var autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var placements = {
    topLeft: {
        points: ['bl', 'tl'],
        overflow: autoAdjustOverflow,
        offset: [0, -7]
    },
    bottomLeft: {
        points: ['tl', 'bl'],
        overflow: autoAdjustOverflow,
        offset: [0, 7]
    },
    leftTop: {
        points: ['tr', 'tl'],
        overflow: autoAdjustOverflow,
        offset: [-4, 0]
    },
    rightTop: {
        points: ['tl', 'tr'],
        overflow: autoAdjustOverflow,
        offset: [4, 0]
    }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mini_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mini_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(74);












/* eslint react/no-is-mounted:0 */
var MenuItem = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);
    function MenuItem(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);
        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));
        _this.onKeyDown = function (e) {
            var keyCode = e.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ENTER) {
                _this.onClick(e);
                return true;
            }
        };
        _this.onMouseLeave = function (e) {
            var _this$props = _this.props, eventKey = _this$props.eventKey, onItemHover = _this$props.onItemHover, onMouseLeave = _this$props.onMouseLeave;
            onItemHover({
                key: eventKey,
                hover: false
            });
            onMouseLeave({
                key: eventKey,
                domEvent: e
            });
        };
        _this.onMouseEnter = function (e) {
            var _this$props2 = _this.props, eventKey = _this$props2.eventKey, onItemHover = _this$props2.onItemHover, onMouseEnter = _this$props2.onMouseEnter;
            onItemHover({
                key: eventKey,
                hover: true
            });
            onMouseEnter({
                key: eventKey,
                domEvent: e
            });
        };
        _this.onClick = function (e) {
            var _this$props3 = _this.props, eventKey = _this$props3.eventKey, multiple = _this$props3.multiple, onClick = _this$props3.onClick, onSelect = _this$props3.onSelect, onDeselect = _this$props3.onDeselect, isSelected = _this$props3.isSelected;
            var info = {
                key: eventKey,
                keyPath: [eventKey],
                item: _this,
                domEvent: e
            };
            onClick(info);
            if (multiple) {
                if (isSelected) {
                    onDeselect(info);
                }
                else {
                    onSelect(info);
                }
            }
            else if (!isSelected) {
                onSelect(info);
            }
        };
        return _this;
    }
    MenuItem.prototype.componentDidMount = function componentDidMount() {
        // invoke customized ref to expose component to mixin
        this.callRef();
    };
    MenuItem.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.props.active) {
            __WEBPACK_IMPORTED_MODULE_9_dom_scroll_into_view___default()(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this), __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this.props.parentMenu), {
                onlyScrollIfNeeded: true
            });
        }
        this.callRef();
    };
    MenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
        var props = this.props;
        if (props.onDestroy) {
            props.onDestroy(props.eventKey);
        }
    };
    MenuItem.prototype.getPrefixCls = function getPrefixCls() {
        return this.props.rootPrefixCls + '-item';
    };
    MenuItem.prototype.getActiveClassName = function getActiveClassName() {
        return this.getPrefixCls() + '-active';
    };
    MenuItem.prototype.getSelectedClassName = function getSelectedClassName() {
        return this.getPrefixCls() + '-selected';
    };
    MenuItem.prototype.getDisabledClassName = function getDisabledClassName() {
        return this.getPrefixCls() + '-disabled';
    };
    MenuItem.prototype.callRef = function callRef() {
        if (this.props.manualRef) {
            this.props.manualRef(this);
        }
    };
    MenuItem.prototype.render = function render() {
        var _classNames;
        var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
        var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = props.isSelected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
        var attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.attribute, {
            title: props.title,
            className: className,
            // set to menuitem by default
            role: props.role || 'menuitem',
            'aria-disabled': props.disabled
        });
        if (props.role === 'option') {
            // overwrite to option
            attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, attrs, {
                role: 'option',
                'aria-selected': props.isSelected
            });
        }
        else if (props.role === null || props.role === 'none') {
            // sometimes we want to specify role inside <li/> element
            // <li><a role='menuitem'>Link</a></li> would be a good example
            // in this case the role on <li/> should be "none" to
            // remove the implied listitem role.
            // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
            attrs.role = 'none';
        }
        // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
        var mouseEvent = {
            onClick: props.disabled ? null : this.onClick,
            onMouseLeave: props.disabled ? null : this.onMouseLeave,
            onMouseEnter: props.disabled ? null : this.onMouseEnter
        };
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props.style);
        if (props.mode === 'inline') {
            style.paddingLeft = props.inlineIndent * props.level;
        }
        __WEBPACK_IMPORTED_MODULE_11__util__["e" /* menuAllProps */].forEach(function (key) {
            return delete props[key];
        });
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, attrs, mouseEvent, {
            style: style
        }), props.children);
    };
    return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
MenuItem.propTypes = {
    attribute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    selectedKeys: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array,
    disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onItemHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onDeselect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    parentMenu: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
    onDestroy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    multiple: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    isSelected: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    manualRef: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
MenuItem.defaultProps = {
    onSelect: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */],
    manualRef: __WEBPACK_IMPORTED_MODULE_11__util__["f" /* noop */]
};
MenuItem.isMenuItem = true;
var connected = Object(__WEBPACK_IMPORTED_MODULE_10_mini_store__["connect"])(function (_ref, _ref2) {
    var activeKey = _ref.activeKey, selectedKeys = _ref.selectedKeys;
    var eventKey = _ref2.eventKey, subMenuKey = _ref2.subMenuKey;
    return {
        active: activeKey[subMenuKey] === eventKey,
        isSelected: selectedKeys.indexOf(eventKey) !== -1
    };
})(MenuItem);
/* harmony default export */ __webpack_exports__["a"] = (connected);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(422);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var util = __webpack_require__(423);
function scrollIntoView(elem, container, config) {
    config = config || {};
    // document 归一化到 window
    if (container.nodeType === 9) {
        container = util.getWindow(container);
    }
    var allowHorizontalScroll = config.allowHorizontalScroll;
    var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
    var alignWithTop = config.alignWithTop;
    var alignWithLeft = config.alignWithLeft;
    var offsetTop = config.offsetTop || 0;
    var offsetLeft = config.offsetLeft || 0;
    var offsetBottom = config.offsetBottom || 0;
    var offsetRight = config.offsetRight || 0;
    allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
    var isWin = util.isWindow(container);
    var elemOffset = util.offset(elem);
    var eh = util.outerHeight(elem);
    var ew = util.outerWidth(elem);
    var containerOffset = undefined;
    var ch = undefined;
    var cw = undefined;
    var containerScroll = undefined;
    var diffTop = undefined;
    var diffBottom = undefined;
    var win = undefined;
    var winScroll = undefined;
    var ww = undefined;
    var wh = undefined;
    if (isWin) {
        win = container;
        wh = util.height(win);
        ww = util.width(win);
        winScroll = {
            left: util.scrollLeft(win),
            top: util.scrollTop(win)
        };
        // elem 相对 container 可视视窗的距离
        diffTop = {
            left: elemOffset.left - winScroll.left - offsetLeft,
            top: elemOffset.top - winScroll.top - offsetTop
        };
        diffBottom = {
            left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
            top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
        };
        containerScroll = winScroll;
    }
    else {
        containerOffset = util.offset(container);
        ch = container.clientHeight;
        cw = container.clientWidth;
        containerScroll = {
            left: container.scrollLeft,
            top: container.scrollTop
        };
        // elem 相对 container 可视视窗的距离
        // 注意边框, offset 是边框到根节点
        diffTop = {
            left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
            top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
        };
        diffBottom = {
            left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
            top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
        };
    }
    if (diffTop.top < 0 || diffBottom.top > 0) {
        // 强制向上
        if (alignWithTop === true) {
            util.scrollTop(container, containerScroll.top + diffTop.top);
        }
        else if (alignWithTop === false) {
            util.scrollTop(container, containerScroll.top + diffBottom.top);
        }
        else {
            // 自动调整
            if (diffTop.top < 0) {
                util.scrollTop(container, containerScroll.top + diffTop.top);
            }
            else {
                util.scrollTop(container, containerScroll.top + diffBottom.top);
            }
        }
    }
    else {
        if (!onlyScrollIfNeeded) {
            alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
            if (alignWithTop) {
                util.scrollTop(container, containerScroll.top + diffTop.top);
            }
            else {
                util.scrollTop(container, containerScroll.top + diffBottom.top);
            }
        }
    }
    if (allowHorizontalScroll) {
        if (diffTop.left < 0 || diffBottom.left > 0) {
            // 强制向上
            if (alignWithLeft === true) {
                util.scrollLeft(container, containerScroll.left + diffTop.left);
            }
            else if (alignWithLeft === false) {
                util.scrollLeft(container, containerScroll.left + diffBottom.left);
            }
            else {
                // 自动调整
                if (diffTop.left < 0) {
                    util.scrollLeft(container, containerScroll.left + diffTop.left);
                }
                else {
                    util.scrollLeft(container, containerScroll.left + diffBottom.left);
                }
            }
        }
        else {
            if (!onlyScrollIfNeeded) {
                alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
                if (alignWithLeft) {
                    util.scrollLeft(container, containerScroll.left + diffTop.left);
                }
                else {
                    util.scrollLeft(container, containerScroll.left + diffBottom.left);
                }
            }
        }
    }
}
module.exports = scrollIntoView;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; };
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
function getClientPosition(elem) {
    var box = undefined;
    var x = undefined;
    var y = undefined;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = box.left;
    y = box.top;
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            // quirks mode
            ret = d.body[method];
        }
    }
    return ret;
}
function getScrollLeft(w) {
    return getScroll(w);
}
function getScrollTop(w) {
    return getScroll(w, true);
}
function getOffset(el) {
    var pos = getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScrollLeft(w);
    pos.top += getScrollTop(w);
    return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
    var val = '';
    var d = elem.ownerDocument;
    var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) {
        val = computedStyle.getPropertyValue(name) || computedStyle[name];
    }
    return val;
}
var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[LEFT];
        var rsLeft = elem[RUNTIME_STYLE][LEFT];
        // prevent flashing of content
        elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
        // Put in the new values to get a computed value out
        style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + PX;
        // Revert the changed values
        style[LEFT] = left;
        elem[RUNTIME_STYLE][LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
    getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function each(arr, fn) {
    for (var i = 0; i < arr.length; i++) {
        fn(arr[i]);
    }
}
function isBorderBoxFn(elem) {
    return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name = undefined;
    // Remember the old values, and insert the new ones
    for (name in options) {
        if (options.hasOwnProperty(name)) {
            old[name] = style[name];
            style[name] = options[name];
        }
    }
    callback.call(elem);
    // Revert the old values
    for (name in options) {
        if (options.hasOwnProperty(name)) {
            style[name] = old[name];
        }
    }
}
function getPBMWidth(elem, props, which) {
    var value = 0;
    var prop = undefined;
    var j = undefined;
    var i = undefined;
    for (j = 0; j < props.length; j++) {
        prop = props[j];
        if (prop) {
            for (i = 0; i < which.length; i++) {
                var cssProp = undefined;
                if (prop === 'border') {
                    cssProp = prop + which[i] + 'Width';
                }
                else {
                    cssProp = prop + which[i];
                }
                value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
            }
        }
    }
    return value;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */
    return obj != null && obj == obj.window;
}
var domUtils = {};
each(['Width', 'Height'], function (name) {
    domUtils['doc' + name] = function (refWin) {
        var d = refWin.document;
        return Math.max(
        // firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement['scroll' + name], 
        // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body['scroll' + name], domUtils['viewport' + name](d));
    };
    domUtils['viewport' + name] = function (win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = 'client' + name;
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
    if (isWindow(elem)) {
        return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
    }
    else if (elem.nodeType === 9) {
        return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
    }
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
    var computedStyle = getComputedStyleX(elem);
    var isBorderBox = isBorderBoxFn(elem, computedStyle);
    var cssBoxValue = 0;
    if (borderBoxValue == null || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = getComputedStyleX(elem, name);
        if (cssBoxValue == null || Number(cssBoxValue) < 0) {
            cssBoxValue = elem.style[name] || 0;
        }
        // Normalize '', auto, and prepare for extra
        cssBoxValue = parseFloat(cssBoxValue) || 0;
    }
    if (extra === undefined) {
        extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
    }
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) {
            return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
        }
        return cssBoxValue;
    }
    if (borderBoxValueOrIsBorderBox) {
        var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
        return val + (extra === BORDER_INDEX ? 0 : padding);
    }
    return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}
var cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
    var val = undefined;
    var args = arguments;
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) {
        val = getWH.apply(undefined, args);
    }
    else {
        swap(elem, cssShow, function () {
            val = getWH.apply(undefined, args);
        });
    }
    return val;
}
function css(el, name, v) {
    var value = v;
    if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        for (var i in name) {
            if (name.hasOwnProperty(i)) {
                css(el, i, name[i]);
            }
        }
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') {
            value += 'px';
        }
        el.style[name] = value;
        return undefined;
    }
    return getComputedStyleX(el, name);
}
each(['width', 'height'], function (name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    domUtils['outer' + first] = function (el, includeMargin) {
        return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
    };
    var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
    domUtils[name] = function (elem, val) {
        if (val !== undefined) {
            if (elem) {
                var computedStyle = getComputedStyleX(elem);
                var isBorderBox = isBorderBoxFn(elem);
                if (isBorderBox) {
                    val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
                }
                return css(elem, name, val);
            }
            return undefined;
        }
        return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
    };
});
// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
    // set position first, in-case top/left are set even on static elem
    if (css(elem, 'position') === 'static') {
        elem.style.position = 'relative';
    }
    var old = getOffset(elem);
    var ret = {};
    var current = undefined;
    var key = undefined;
    for (key in offset) {
        if (offset.hasOwnProperty(key)) {
            current = parseFloat(css(elem, key)) || 0;
            ret[key] = current + offset[key] - old[key];
        }
    }
    css(elem, ret);
}
module.exports = _extends({
    getWindow: function getWindow(node) {
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    offset: function offset(el, value) {
        if (typeof value !== 'undefined') {
            setOffset(el, value);
        }
        else {
            return getOffset(el);
        }
    },
    isWindow: isWindow,
    each: each,
    css: css,
    clone: function clone(obj) {
        var ret = {};
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                ret[i] = obj[i];
            }
        }
        var overflow = obj.overflow;
        if (overflow) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    ret.overflow[i] = obj.overflow[i];
                }
            }
        }
        return ret;
    },
    scrollLeft: function scrollLeft(w, v) {
        if (isWindow(w)) {
            if (v === undefined) {
                return getScrollLeft(w);
            }
            window.scrollTo(v, getScrollTop(w));
        }
        else {
            if (v === undefined) {
                return w.scrollLeft;
            }
            w.scrollLeft = v;
        }
    },
    scrollTop: function scrollTop(w, v) {
        if (isWindow(w)) {
            if (v === undefined) {
                return getScrollTop(w);
            }
            window.scrollTo(getScrollLeft(w), v);
        }
        else {
            if (v === undefined) {
                return w.scrollTop;
            }
            w.scrollTop = v;
        }
    },
    viewportWidth: 0,
    viewportHeight: 0
}, domUtils);


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(74);








var MenuItemGroup = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItemGroup, _React$Component);
    function MenuItemGroup() {
        var _temp, _this, _ret;
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItemGroup);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderInnerMenuItem = function (item) {
            var _this$props = _this.props, renderMenuItem = _this$props.renderMenuItem, index = _this$props.index;
            return renderMenuItem(item, index, _this.props.subMenuKey);
        }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }
    MenuItemGroup.prototype.render = function render() {
        var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);
        var _props$className = props.className, className = _props$className === undefined ? '' : _props$className, rootPrefixCls = props.rootPrefixCls;
        var titleClassName = rootPrefixCls + '-item-group-title';
        var listClassName = rootPrefixCls + '-item-group-list';
        var title = props.title, children = props.children;
        __WEBPACK_IMPORTED_MODULE_7__util__["e" /* menuAllProps */].forEach(function (key) {
            return delete props[key];
        });
        // Set onClick to null, to ignore propagated onClick event
        delete props.onClick;
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: className + ' ' + rootPrefixCls + '-item-group' }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', {
            className: titleClassName,
            title: typeof title === 'string' ? title : undefined
        }, title), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('ul', { className: listClassName }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, this.renderInnerMenuItem)));
    };
    return MenuItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);
MenuItemGroup.propTypes = {
    renderMenuItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
    className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    subMenuKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    rootPrefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
MenuItemGroup.defaultProps = {
    disabled: true
};
MenuItemGroup.isMenuItemGroup = true;
/* harmony default export */ __webpack_exports__["a"] = (MenuItemGroup);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);





var Divider = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Divider, _React$Component);
    function Divider() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Divider);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }
    Divider.prototype.render = function render() {
        var _props = this.props, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className, rootPrefixCls = _props.rootPrefixCls;
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
    };
    return Divider;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);
Divider.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    rootPrefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
};
Divider.defaultProps = {
    // To fix keyboard UX.
    disabled: true
};
/* harmony default export */ __webpack_exports__["a"] = (Divider);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends2=__webpack_require__(5);var _extends3=_interopRequireDefault(_extends2);var _defineProperty2=__webpack_require__(14);var _defineProperty3=_interopRequireDefault(_defineProperty2);var _assign=__webpack_require__(57);var _assign2=_interopRequireDefault(_assign);var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _ecCom=__webpack_require__(15);var _loginutil=__webpack_require__(427);var _mobx=__webpack_require__(93);var _E9Login=__webpack_require__(429);var _E9Login2=_interopRequireDefault(_E9Login);__webpack_require__(438);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getLabel=_ecCom.WeaLocaleProvider.getLabel;var Index=function(_React$Component){(0,_inherits3.default)(Index,_React$Component);function Index(props){(0,_classCallCheck3.default)(this,Index);var _this=(0,_possibleConstructorReturn3.default)(this,(Index.__proto__||(0,_getPrototypeOf2.default)(Index)).call(this,props));_this.onShow=function(){_this.setState({visible:true,dialoading:true});var params=_this.state.queryParams;_this.getLoginInfo(params);};_this.state={visible:false,dialoading:false,loading:true,updatestatus:'',casstatus:'',afterLoginRenderEventStatus:false,multiLangs:(0,_loginutil.getLSValue)('login','multiLangs')||[],qrcodeValidTime:30,qrcodeReqTime:1,qrcodeIsInvalid:false,customloading:false,queryParams:_ecCom.WeaTools.ls.getJSONObj('login-pop-params')||{},locationparams:_ecCom.WeaTools.ls.getJSONObj('login-pop-window.location')||{},loginFormDataLoading:false,dynamicPasswordTime:0,dynamicPasswordInterval:0,seriesnum_:0,emobileDownloadUrl:'',loginstate:(0,_assign2.default)({},{isLogging:false,hasMultiLang:false,multiLangVisible:false,loginFormItems:[],loginFormHiddenItems:[],loginSetting:{},qrCode:{},validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_=0',labelInfo:[]},(0,_assign2.default)({},(0,_loginutil.getLSValue)('login','loginCache'),{loginType:(0,_loginutil.getLSValue)('login','loginType')||'form',langId:(0,_loginutil.getLSValue)('login','langId')||'',langText:(0,_loginutil.getLSValue)('login','langText')||'',isRememberAccount:(0,_loginutil.getLSValue)('login','isRememberAccount')||(0,_loginutil.getCookieValue)('isRememberAccount')||false,isRememberPassword:(0,_loginutil.getLSValue)('login','isRememberPassword')||(0,_loginutil.getCookieValue)('isRememberPassword')||false,cacheAccount:(0,_loginutil.getLSValue)('login','cacheAccount')||(0,_loginutil.getCookieValue)('cacheAccount')||'',cachePassword:(0,_loginutil.getLSValue)('login','cachePassword')||(0,_loginutil.getCookieValue)('cachePassword')||''}))};_this.loginsetState=_this.loginsetState.bind(_this);_this.getLoginForm=_this.getLoginForm.bind(_this);_this.getLoginInfo=_this.getLoginInfo.bind(_this);_this.getMultiLangs=_this.getMultiLangs.bind(_this);_this.setStateAndCache=_this.setStateAndCache.bind(_this);_this.doAfterLoginRenderEvent=_this.doAfterLoginRenderEvent.bind(_this);_this.onPasswordForget=_this.onPasswordForget.bind(_this);_this.onRememberChange=_this.onRememberChange.bind(_this);_this.onValidateCodeChange=_this.onValidateCodeChange.bind(_this);_this.getDynamicPassword=_this.getDynamicPassword.bind(_this);_this.onLogin=_this.onLogin.bind(_this);_this.onQCLoginStart=_this.onQCLoginStart.bind(_this);_this.onQCLoginEnd=_this.onQCLoginEnd.bind(_this);_this.onQCLogin=_this.onQCLogin.bind(_this);_this.onPollingStart=_this.onPollingStart.bind(_this);_this.qrcodeUsedTime=0;//二维码
return _this;}(0,_createClass3.default)(Index,[{key:'loginsetState',value:function loginsetState(newstate){this.setState({loginstate:(0,_assign2.default)({},this.state.loginstate,newstate)});}},{key:'setStateAndCache',value:function setStateAndCache(key,value){this.loginsetState((0,_defineProperty3.default)({},key,value));(0,_loginutil.setLSValue)('login',key,value);}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var visible=this.props.visible;if(window.doLoginAction){if(visible){window.hasloginpop=true;this.onShow();}}else{loadjs.isDefined("login-pop")?loadjs.ready('login-pop',function(){}):loadjs(['/spa/hrm/staticLoginNew/loginNew.js'],'login-pop',function(){if(visible){window.hasloginpop=true;_this2.onShow();}});}}},{key:'doAfterLoginRenderEvent',value:function doAfterLoginRenderEvent(){var _this3=this;// 防止重复执行
if(!this.state.afterLoginRenderEventStatus){(0,_loginutil.doEvent)('afterLoginRender',function(){return _this3.setState({afterLoginRenderEventStatus:true});});}}},{key:'getMultiLangs',value:function getMultiLangs(){var _this4=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_ecCom.WeaTools.callApi('/api/system/language/base/getActiveLanguage','GET',params).then(function(result){if(result.status=='1'){var activeLanguageInfo=result.activeLanguageInfo,activeLanguageIds=result.activeLanguageIds,languageIdentify=result.languageIdentify,_result$systemDefault=result.systemDefaultLang,systemDefaultLang=_result$systemDefault===undefined?{}:_result$systemDefault;_this4.setState({multiLangs:activeLanguageInfo});(0,_loginutil.setLSValue)('login','multiLangs',activeLanguageInfo);_ecCom.WeaTools.ls.set('activeLanguageIds',activeLanguageIds);_ecCom.WeaTools.ls.set('languageIdentify',languageIdentify);_this4.getLoginForm({langId:_this4.state.loginstate.langId});if(!_this4.state.loginstate.langId){var language={};for(var key in systemDefaultLang){language={id:key,language:systemDefaultLang[key]};}var _language=language,_language$id=_language.id,langId=_language$id===undefined?'7':_language$id,_language$language=_language.language,langText=_language$language===undefined?'简体中文':_language$language;_this4.loginsetState({langId:langId,langText:langText});_this4.getLoginForm({langId:langId});}}});}},{key:'getLoginInfo',value:function getLoginInfo(){var _this5=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var callBack=arguments[1];this.setState({updatestatus:'0',casstatus:'0',loading:true});// 获取多语言
this.getMultiLangs(params);_ecCom.WeaTools.callApi('/api/portal/login/logininfo','POST',params).then(function(result){// 缓存登录日期
var date=new Date();var loginDate=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();_ecCom.WeaTools.ls.set('loginDate',loginDate);if(result.status!='2'){var settingversion=result.settingversion,templateId=result.id,templateType=result.templateType,_result$loginSettingI=result.loginSettingInfo,loginSettingInfo=_result$loginSettingI===undefined?{}:_result$loginSettingI,isRememberAccount=result.isRememberAccount,isRememberPassword=result.isRememberPassword,_result$cacheAccount=result.cacheAccount,cacheAccount=_result$cacheAccount===undefined?'':_result$cacheAccount,_result$cachePassword=result.cachePassword,cachePassword=_result$cachePassword===undefined?'':_result$cachePassword,emobileDownloadUrl=result.emobileDownloadUrl;var _loginSettingInfo$log=loginSettingInfo.loginInfo,loginInfo=_loginSettingInfo$log===undefined?{}:_loginSettingInfo$log;var showQrcode=loginInfo.showQrcode,_loginInfo$qrcodeVali=loginInfo.qrcodeValidTime,qrcodeValidTime=_loginInfo$qrcodeVali===undefined?30:_loginInfo$qrcodeVali,_loginInfo$qrcodeReqT=loginInfo.qrcodeReqTime,qrcodeReqTime=_loginInfo$qrcodeReqT===undefined?1:_loginInfo$qrcodeReqT,defaultQrcode=loginInfo.defaultQrcode,onlyQrcode=loginInfo.onlyQrcode;// 判断接口返回的设置版本和缓存的设置版本是否一致
var _settingversion=(0,_loginutil.getLSValue)('login','settingversion');var _templateId=(0,_loginutil.getLSValue)('login','templateId');var isNewVersion=settingversion!=_settingversion||templateId!=_templateId;// 获取登录方式
_this5.setState({qrcodeValidTime:qrcodeValidTime,qrcodeReqTime:qrcodeReqTime,emobileDownloadUrl:emobileDownloadUrl});var loginType='form';if(showQrcode){if(onlyQrcode){loginType='QRCode';}else{var _loginType=(0,_loginutil.getLSValue)('login','loginType')||'';loginType=_loginType||(defaultQrcode?'QRCode':'form');}}(0,_loginutil.setLSValue)('login','loginType',loginType);// 获取记住的账号和密码
if(isRememberAccount!=undefined){(0,_loginutil.setLSValue)('login','isRememberAccount',isRememberAccount);(0,_loginutil.setLSValue)('login','isRememberPassword',isRememberPassword);(0,_loginutil.setLSValue)('login','cacheAccount',cacheAccount);(0,_loginutil.setLSValue)('login','cachePassword',cachePassword);_this5.loginsetState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});}var state=(0,_assign2.default)({},result,{loginType:loginType});(0,_loginutil.setLSValue)('login','loginCache',state);if(isNewVersion){(0,_loginutil.setLSValue)('login','settingversion',settingversion);(0,_loginutil.setLSValue)('login','templateId',templateId);(0,_loginutil.setLSValue)('login','templateType',templateType);(0,_loginutil.setLSValue)('login','loginBgImage',loginInfo.imgsrc);(0,_loginutil.setLSValue)('login','loginBgImageWidth',loginInfo.width);(0,_loginutil.setLSValue)('login','loginBgImageHeight',loginInfo.height);_this5.loginsetState(state);}}else{_antd.message.error(result.errormsg);}if(callBack){callBack();}_this5.setState({loading:false,dialoading:false});});}// 获取登录表单
},{key:'getLoginForm',value:function getLoginForm(){var _this6=this;var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _callback=arguments[1];var queryParams=this.state.queryParams;var _queryParams$logintyp=queryParams.logintype,logintype=_queryParams$logintyp===undefined?'1':_queryParams$logintyp;var _params$loginId=params.loginId,loginId=_params$loginId===undefined?'':_params$loginId,_params$langId=params.langId,langId=_params$langId===undefined?this.state.loginstate.langId:_params$langId;if(langId){window.doLoginAction&&window.doLoginAction('getLoginForm',{queryParams:queryParams,logintype:logintype,loginid:loginId,langid:langId,callback:function callback(result){var _result$hasMultiLang=result.hasMultiLang,hasMultiLang=_result$hasMultiLang===undefined?false:_result$hasMultiLang,_result$loginFormItem=result.loginFormItems,loginFormItems=_result$loginFormItem===undefined?[]:_result$loginFormItem,_result$loginFormHidd=result.loginFormHiddenItems,loginFormHiddenItems=_result$loginFormHidd===undefined?[]:_result$loginFormHidd,_result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,_result$qrCode=result.qrCode,qrCode=_result$qrCode===undefined?{}:_result$qrCode;_this6.loginsetState({hasMultiLang:hasMultiLang,loginFormItems:loginFormItems,loginFormHiddenItems:loginFormHiddenItems,loginSetting:loginSetting,qrCode:qrCode});if(_callback&&typeof _callback=='function'){_callback(result);}// 登录表单数据加载完成
_this6.setState({loginFormDataLoading:true,dialoading:false});}});}}},{key:'onPasswordForget',value:function onPasswordForget(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _params$langId2=params.langId,langId=_params$langId2===undefined?this.state.loginstate.langId:_params$langId2;window.doLoginAction&&window.doLoginAction('forgetPassword',{langid:langId});}},{key:'onValidateCodeChange',value:function onValidateCodeChange(){var _this7=this;setTimeout(function(){return _this7.loginsetState({validateCode:'/weaver/weaver.file.MakeValidateCode?seriesnum_='+ ++_this7.state.seriesnum_});},50);}},{key:'onRememberChange',value:function onRememberChange(type,checked){var _state$loginstate=this.state.loginstate,isRememberAccount=_state$loginstate.isRememberAccount,isRememberPassword=_state$loginstate.isRememberPassword;if(type=='account'){this.loginsetState({isRememberAccount:checked,isRememberPassword:!checked?checked:isRememberPassword});}else if(type=='password'){this.loginsetState({isRememberAccount:checked||isRememberAccount,isRememberPassword:checked});}}},{key:'getDynamicPassword',value:function getDynamicPassword(){var _this8=this;var queryParams=this.state.queryParams;var _queryParams$logintyp2=queryParams.logintype,logintype=_queryParams$logintyp2===undefined?'1':_queryParams$logintyp2;var _state$loginstate2=this.state.loginstate,langId=_state$loginstate2.langId,loginSetting=_state$loginstate2.loginSetting;window.doLoginAction&&window.doLoginAction('getDynamicPassword',{logintype:logintype,langid:langId,loginSetting:loginSetting,success:function success(params){var _params$validitySec=params.validitySec,validitySec=_params$validitySec===undefined?60:_params$validitySec;_this8.setState({dynamicPasswordTime:validitySec});var _interval=setInterval(function(){var time=_this8.state.dynamicPasswordTime;if(time==1){window.clearInterval(_this8.state.dynamicPasswordInterval);}_this8.setState({dynamicPasswordTime:time-1});},1000);_this8.setState({dynamicPasswordInterval:_interval});}});}},{key:'onLogin',value:function onLogin(){var _this9=this;var _state=this.state,queryParams=_state.queryParams,locationparams=_state.locationparams;var _queryParams$logintyp3=queryParams.logintype,logintype=_queryParams$logintyp3===undefined?'1':_queryParams$logintyp3;var _state$loginstate3=this.state.loginstate,langId=_state$loginstate3.langId,langText=_state$loginstate3.langText,isRememberAccount=_state$loginstate3.isRememberAccount,isRememberPassword=_state$loginstate3.isRememberPassword,loginSetting=_state$loginstate3.loginSetting;this.loginsetState({isLogging:true});(0,_loginutil.doEvent)('beforLogin',function(){window.doLoginAction&&window.doLoginAction('login',{queryParams:_ecCom.WeaTools.getUrlParams?_ecCom.WeaTools.getUrlParams(locationparams):queryParams,logintype:logintype,langid:langId,loginSetting:loginSetting,isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,success:function success(username,password){var params=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();var cacheAccount='';var cachePassword='';if(isRememberAccount)cacheAccount=username;if(isRememberPassword)cachePassword=password;_this9.loginsetState({isRememberAccount:isRememberAccount,isRememberPassword:isRememberPassword,cacheAccount:cacheAccount,cachePassword:cachePassword});(0,_loginutil.initLSValue)(username,langId);(0,_loginutil.setLSValue)('login','loginId',username);(0,_loginutil.setLSValue)('login','langId',langId);(0,_loginutil.setLSValue)('login','langText',langText);(0,_loginutil.setLSValue)('login','cacheAccount',cacheAccount);(0,_loginutil.setLSValue)('login','cachePassword',cachePassword);(0,_loginutil.setLSValue)('login','isRememberAccount',isRememberAccount);(0,_loginutil.setLSValue)('login','isRememberPassword',isRememberPassword);window.clearInterval(_this9.state.dynamicPasswordInterval);_this9.setState({dynamicPasswordTime:0,visible:false});_this9.loginsetState({isLogging:false});window.hasloginpop=false;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(533975,'是否刷新页面？'),onOk:function onOk(){window.location.reload();}});},failure:function failure(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_this9.loginsetState({isLogging:false});if(params.reflashValidateCode){_this9.onValidateCodeChange();}_this9.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting2=result.loginSetting,loginSetting=_result$loginSetting2===undefined?{}:_result$loginSetting2,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);_this9.setStateAndCache('loginType','QRCode');}});}});});}},{key:'onQCLoginStart',value:function onQCLoginStart(cusQrcodeValidTime,cusQrcodeReqTime){var _this10=this;this.setState({qrcodeIsInvalid:false});var qrcodeValidTime=cusQrcodeValidTime||this.state.qrcodeValidTime;var qrcodeReqTime=cusQrcodeReqTime||this.state.qrcodeReqTime==1?2:this.state.qrcodeReqTime;this.qrcodeCdInterval=window.setInterval(function(){if(_this10.qrcodeUsedTime>=qrcodeValidTime){_this10.onQCLoginEnd();}_this10.qrcodeUsedTime++;},1000);// this.qrcodeLoginInterval = window.setInterval(() => this.onQCLogin(), qrcodeReqTime * 1000);
this.onPollingStart(cusQrcodeValidTime,cusQrcodeReqTime);}},{key:'onPollingStart',value:function onPollingStart(cusQrcodeValidTime,cusQrcodeReqTime){var qrcodeValidTime=cusQrcodeValidTime||this.state.qrcodeValidTime;//二维码有效时间或者叫做次数,30
if(this.qrcodeUsedTime>=qrcodeValidTime){this.onQCLoginEnd();}this.onQCLogin(cusQrcodeValidTime,cusQrcodeReqTime);}},{key:'onQCLoginEnd',value:function onQCLoginEnd(){this.setState({qrcodeIsInvalid:true});this.qrcodeUsedTime=0;// 扫描次数恢复默认
window.clearInterval(this.qrcodeCdInterval);// window.clearInterval(this.qrcodeLoginInterval);
}},{key:'onQCLogin',value:function onQCLogin(cusQrcodeValidTime,cusQrcodeReqTime){var _this11=this;// 二维码已失效
if(this.state.qrcodeIsInvalid)return;var _state$loginstate4=this.state.loginstate,langId=_state$loginstate4.langId,langText=_state$loginstate4.langText,qrCode=_state$loginstate4.qrCode;var queryParams=_ecCom.WeaTools.getUrlParams?_ecCom.WeaTools.getUrlParams(this.state.locationparams):this.state.queryParams;queryParams=(0,_mobx.toJS)(queryParams);var reqStart=new Date();_ecCom.WeaTools.callApi('/api/hrm/login/qrcode/getQCLoginStatus','POST',(0,_extends3.default)({langid:langId,loginkey:qrCode.loginkey,isie:ua.browser==='IE'},queryParams)).then(function(result){if(result.status=='1'){jQuery.setSessionTimeZone&&jQuery.setSessionTimeZone();_ecCom.WeaTools.ls.set('languageidweaver',langId);(0,_loginutil.setLSValue)('login','langId',langId);(0,_loginutil.setLSValue)('login','langText',langText);// 处理sso 扫码登录
if(queryParams&&queryParams.appid&&queryParams.service){queryParams.authenticationType=2;jQuery('body').append("<form name='ssoForm'></form>");var form=jQuery("form[name='ssoForm']");form.attr('action','/login/VerifyLoginWeaversso.jsp');form.attr('method','post');form.attr('style','display:none');for(var key in queryParams){form.append('<input type=\'text\' name=\''+key+'\' value = \''+queryParams[key]+'\'></input>');}// 跳转到sso
form.submit();return;}_this11.setState({visible:false});window.hasloginpop=false;_antd.Modal.confirm({title:getLabel(15172,'系统提示'),content:getLabel(533975,'是否刷新页面？'),onOk:function onOk(){window.location.reload();}});}else if(result.status=='-1'){_antd.message.error(result.msg);_this11.onQCLoginEnd();}else{var reqEnd=new Date();var qrcodeReqTime=cusQrcodeReqTime||_this11.state.qrcodeReqTime==1?2:_this11.state.qrcodeReqTime;//扫码频率
var timeSpend=reqEnd-reqStart;if(timeSpend>=qrcodeReqTime*1000){_this11.onPollingStart(cusQrcodeValidTime,cusQrcodeReqTime);}else{if(_this11.pollingTimeout){window.clearTimeout(_this11.pollingTimeout);}_this11.pollingTimeout=setTimeout(function(){_this11.onPollingStart(cusQrcodeValidTime,cusQrcodeReqTime);},qrcodeReqTime*1000-timeSpend);}}});}},{key:'render',value:function render(){var _state2=this.state,visible=_state2.visible,loading=_state2.loading,dialoading=_state2.dialoading,updatestatus=_state2.updatestatus,casstatus=_state2.casstatus,multiLangs=_state2.multiLangs,qrcodeValidTime=_state2.qrcodeValidTime,afterLoginRenderEventStatus=_state2.afterLoginRenderEventStatus,emobileDownloadUrl=_state2.emobileDownloadUrl,qrcodeReqTime=_state2.qrcodeReqTime,qrcodeIsInvalid=_state2.qrcodeIsInvalid,customloading=_state2.customloading,queryParams=_state2.queryParams,locationparams=_state2.locationparams,loginFormDataLoading=_state2.loginFormDataLoading,loginstate=_state2.loginstate,dynamicPasswordTime=_state2.dynamicPasswordTime,dynamicPasswordInterval=_state2.dynamicPasswordInterval;var labelInfo=loginstate.labelInfo,langId=loginstate.langId;var labelObj=labelInfo['langid'+langId]||{};return _react2.default.createElement(_ecCom.WeaDialog,{visible:visible,loading:dialoading,title:labelObj.loginpoptitle,icon:'icon-coms-Prompt',iconBgcolor:'transparent',parentClassName:'wea-login-pop',style:{width:450},zIndex:100,closable:false,destroyBodyOnClose:true},_react2.default.createElement('div',{className:'login-pop-body'},_react2.default.createElement(_E9Login2.default,(0,_extends3.default)({visible:visible,loading:loading,dialoading:dialoading,updatestatus:updatestatus,casstatus:casstatus,multiLangs:multiLangs,afterLoginRenderEventStatus:afterLoginRenderEventStatus,qrcodeValidTime:qrcodeValidTime,qrcodeReqTime:qrcodeReqTime,qrcodeIsInvalid:qrcodeIsInvalid,customloading:customloading,queryParams:queryParams,locationparams:locationparams,loginFormDataLoading:loginFormDataLoading,loginstate:loginstate,dynamicPasswordTime:dynamicPasswordTime,dynamicPasswordInterval:dynamicPasswordInterval,emobileDownloadUrl:emobileDownloadUrl,getLoginForm:this.getLoginForm,loginsetState:this.loginsetState,setStateAndCache:this.setStateAndCache,doAfterLoginRenderEvent:this.doAfterLoginRenderEvent,onPasswordForget:this.onPasswordForget,onRememberChange:this.onRememberChange,onValidateCodeChange:this.onValidateCodeChange,getDynamicPassword:this.getDynamicPassword,onLogin:this.onLogin,onQCLoginStart:this.onQCLoginStart,onQCLoginEnd:this.onQCLoginEnd,onQCLogin:this.onQCLogin},this.props))));}}]);return Index;}(_react2.default.Component);exports.default=Index;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.initLSValue=exports.setLSValue=exports.getLSValue=exports.getCookieValue=exports.doEvent=undefined;var _ecCom=__webpack_require__(15);var _antd=__webpack_require__(16);var _loadjs2=__webpack_require__(428);var _loadjs3=_interopRequireDefault(_loadjs2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var devModuleCustomFiles=['css!/cloudstore/config/devStatic/devModuleStyle.css?v='+Date.now(),'/cloudstore/config/devStatic/devModuleCustom.js?v='+Date.now()];/**
 * 执行事件回调
 *
 * @param {*} callback
 */var doEventCallback=function doEventCallback(callback){if(callback&&typeof callback=='function'){callback();}};/**
 * 执行事件回调
 *
 * @param {*} eventName
 * @param {*} callback
 */var doEventSuccess=function doEventSuccess(eventName,callback){var _eventRegister=window.eventRegister;if(_eventRegister&&_eventRegister.startList&&typeof _eventRegister.startList=='function'){try{_eventRegister.startList(eventName,function(){return doEventCallback(callback);},function(){return doEventCallback(callback);});}catch(e){_antd.message.error(e.message);doEventCallback(callback);}}else{doEventCallback(callback);}};var doEvent=exports.doEvent=function doEvent(eventName,callback){var loadjs=window.loadjs||_loadjs3.default;loadjs.isDefined('devModuleCustom')?loadjs.ready('devModuleCustom',{success:function success(){return doEventSuccess(eventName,callback);},error:function error(){return doEventSuccess(eventName,callback);}}):loadjs(devModuleCustomFiles,'devModuleCustom',{async:true,success:function success(){return doEventSuccess(eventName,callback);},error:function error(){return doEventSuccess(eventName,callback);}});};/**
 * 获取本地Cookie数据
 *
 */var getCookieValue=exports.getCookieValue=function getCookieValue(name){var value='';var cookie=document.cookie;var list=cookie.split('; ');for(var i=0,len=list.length;i<len;i++){var arr=list[i].split('=');if(arr[0]==name){value=arr[1];}}if(value=='true'){value=true;}else if(value=='false'){value=false;}return value;};/**
 * 获取本地缓存数据
 *
 */var getLSValue=exports.getLSValue=function getLSValue(key1,key2){var obj=_ecCom.WeaTools.ls.getJSONObj(key1);return obj&&obj[key2];};/**
 * 设置本地缓存数据
 *
 */var setLSValue=exports.setLSValue=function setLSValue(key1,key2,value){var obj=_ecCom.WeaTools.ls.getJSONObj(key1)||{};obj[key2]=value;_ecCom.WeaTools.ls.set(key1,obj);};/**
 * 初始化本地缓存数据
 *
 */var initLSValue=exports.initLSValue=function initLSValue(loginId,langId){var _loginId=getLSValue('login','loginId');var _langId=getLSValue('login','langId');var ls=window.localStorage;var keys=[];if(!_loginId||!_langId||loginId!=_loginId||langId!=_langId){keys.push('e9_locale');for(var i=0,len=ls.length;i<len;i++){var key=ls.key(i);if(/^theme-/.test(key)||/^portal-/.test(key)||/^edata-/.test(key)||/^tabdata-/.test(key)){keys.push(key);}}}for(var _i=0,_len=keys.length;_i<_len;_i++){ls.removeItem(keys[_i]);}_ecCom.WeaTools.ls.set('isInitLSValue',true);};

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_428__;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _E9Form=__webpack_require__(430);var _E9Form2=_interopRequireDefault(_E9Form);var _E9QRCode=__webpack_require__(431);var _E9QRCode2=_interopRequireDefault(_E9QRCode);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Login=function(_React$Component){(0,_inherits3.default)(E9Login,_React$Component);function E9Login(props){(0,_classCallCheck3.default)(this,E9Login);return(0,_possibleConstructorReturn3.default)(this,(E9Login.__proto__||(0,_getPrototypeOf2.default)(E9Login)).call(this,props));}(0,_createClass3.default)(E9Login,[{key:'render',value:function render(){var _this2=this;var _props=this.props,loading=_props.loading,loginstate=_props.loginstate;var _loginstate$loginSett=loginstate.loginSettingInfo,loginSettingInfo=_loginstate$loginSett===undefined?{}:_loginstate$loginSett,loginType=loginstate.loginType,langId=loginstate.langId,labelInfo=loginstate.labelInfo;var loginInfo=loginSettingInfo.loginInfo;if(loginInfo!=undefined){var showQrcode=loginInfo.showQrcode,onlyQrcode=loginInfo.onlyQrcode;var labelObj=labelInfo['langid'+langId]||{};return _react2.default.createElement('div',{id:'LoginPopContainer',className:'e9login-pop-container',onClick:function onClick(){_this2.props.loginsetState({multiLangVisible:false});}},_react2.default.createElement('div',{className:'e9login-pop-content'},!loading&&_react2.default.createElement(_react2.default.Fragment,null,showQrcode&&!onlyQrcode?_react2.default.createElement('div',{className:'e9login-pop-qrcode e9login-pop-element'},loginType=='form'?_react2.default.createElement('i',{className:'icon-coms-Scan',title:labelObj.smdl,onClick:function onClick(e){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();_this2.props.setStateAndCache('loginType','QRCode');}}):_react2.default.createElement('i',{className:'icon-coms-Revoke2',title:labelObj.fh,onClick:function onClick(e){e.preventDefault&&e.preventDefault();e.stopPropagation&&e.stopPropagation();_this2.props.setStateAndCache('loginType','form');}})):'',_react2.default.createElement('div',{className:'e9login-pop-form-box e9login-pop-element'},loginType=='form'?_react2.default.createElement(_E9Form2.default,this.props):_react2.default.createElement(_E9QRCode2.default,this.props)),_react2.default.createElement('div',{className:'e9login-pop-form-message'},labelObj.popmessage))));}else{return _react2.default.createElement('div',null);}}}]);return E9Login;}(_react2.default.Component);exports.default=E9Login;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _antd=__webpack_require__(16);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9Form=function(_React$Component){(0,_inherits3.default)(E9Form,_React$Component);function E9Form(props){(0,_classCallCheck3.default)(this,E9Form);var _this2=(0,_possibleConstructorReturn3.default)(this,(E9Form.__proto__||(0,_getPrototypeOf2.default)(E9Form)).call(this,props));_this2.getLoginForm=_this2.getLoginForm.bind(_this2);_this2.onLabelClick=_this2.onLabelClick.bind(_this2);_this2.onInputChange=_this2.onInputChange.bind(_this2);_this2.onClear=_this2.onClear.bind(_this2);_this2.getDynamicPassword=_this2.getDynamicPassword.bind(_this2);_this2.onLogin=_this2.onLogin.bind(_this2);return _this2;}(0,_createClass3.default)(E9Form,[{key:'componentDidMount',value:function componentDidMount(){var _props$loginstate=this.props.loginstate,loginstate=_props$loginstate===undefined?{}:_props$loginstate;var loginId=loginstate.cacheAccount,langId=loginstate.langId;this.props.getLoginForm({loginId:loginId,langId:langId});}},{key:'componentDidUpdate',value:function componentDidUpdate(){var loginFormDataLoading=this.props.loginFormDataLoading;if(loginFormDataLoading){this.props.doAfterLoginRenderEvent();}var _this=this;jQuery('.e9login-pop-form-input').unbind().keydown(function(e){e=e||window.event;var key=e.keyCode||e.which||e.charCode;if(key==13){var inputs=jQuery('.e9login-pop-form-input');var idx=inputs.index(this);var nxtIdx=idx+1;var nxtInput=jQuery('.e9login-pop-form-input:eq('+nxtIdx+')');if(nxtInput.length>0){nxtInput.focus();}else{_this.onLogin();}}});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,loginstate=_props.loginstate,dynamicPasswordTime=_props.dynamicPasswordTime;var isLogging=loginstate.isLogging,isRememberPW=loginstate.isRememberPW,isRememberAccount=loginstate.isRememberAccount,isRememberPassword=loginstate.isRememberPassword,cacheAccount=loginstate.cacheAccount,cachePassword=loginstate.cachePassword,loginFormItems=loginstate.loginFormItems,loginFormHiddenItems=loginstate.loginFormHiddenItems,_loginstate$loginSett=loginstate.loginSetting,loginSetting=_loginstate$loginSett===undefined?{}:_loginstate$loginSett,validateCode=loginstate.validateCode,labelInfo=loginstate.labelInfo,langId=loginstate.langId;var labelObj=labelInfo['langid'+langId]||{};var needforgotpassword=loginSetting.needforgotpassword,_loginSetting$validat=loginSetting.validateCodeKey,validateCodeKey=_loginSetting$validat===undefined?'':_loginSetting$validat;var validateCodeSrc=validateCode+'&validateCodeKey='+validateCodeKey;var style=loginFormItems&&loginFormItems.length>2?{marginTop:'30px'}:{};return _react2.default.createElement('div',{className:'e9login-pop-form'},loginFormItems.map(function(item,index){var defaultValue='';if(item.atype=='account'){defaultValue=cacheAccount;}else if(item.atype=='password'){defaultValue=cachePassword;}var itemComp=_react2.default.createElement('div',{key:index,className:'e9login-pop-form-item'},_react2.default.createElement('i',{className:'icon-coms-'+(item.atype=='account'?'yonghu':'locking')}),_react2.default.createElement('label',{className:'e9login-pop-form-label '+(defaultValue?'e9login-pop-display-hidden':''),onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e9login-pop-form-input',defaultValue:defaultValue,onBlur:function onBlur(){item.atype=='account'&&_this3.getLoginForm();},onChange:_this3.onInputChange}),_react2.default.createElement('i',{className:'icon-coms-Clear','data-value':defaultValue?'true':'false',onClick:_this3.onClear}));if(item.atype=='dynamicPassword'){itemComp=_react2.default.createElement('div',{key:index,className:'e9login-pop-form-item'},_react2.default.createElement('i',{className:'icon-coms-locking'}),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,autoComplete:'new-password',className:'e9login-pop-form-input',onChange:_this3.onInputChange}),_react2.default.createElement('label',{className:'e9login-pop-form-label',onClick:_this3.onLabelClick},item.label),_react2.default.createElement('div',{className:'e9login-pop-form-dynamic'},dynamicPasswordTime>0?_react2.default.createElement('span',{className:'e9login-pop-form-dynamic-text'},labelObj.resend,'(',dynamicPasswordTime,'s)'):_react2.default.createElement('span',{className:'e9login-pop-form-dynamic-text',onClick:_this3.getDynamicPassword},labelObj.send)));}if(item.atype=='validatecode'){itemComp=_react2.default.createElement('div',{key:index,className:'e9login-pop-form-item'},_react2.default.createElement('i',{className:'icon-coms02-verification-code'}),_react2.default.createElement('label',{className:'e9login-pop-form-label e9login-pop-form-label-vc',onClick:_this3.onLabelClick},item.label),_react2.default.createElement('input',{type:item.type,id:item.id,name:item.name,className:'e9login-pop-form-input e9login-pop-form-input-vc',onChange:_this3.onInputChange}),_react2.default.createElement('div',{className:'e9login-pop-form-vc-img'},_react2.default.createElement('img',{src:(0,_pathUtil.addContentPath)(validateCodeSrc),alt:'',onClick:_this3.props.onValidateCodeChange})));}return itemComp;}),loginFormHiddenItems.map(function(item,index){return _react2.default.createElement('div',{key:index,dangerouslySetInnerHTML:{__html:item.html}});}),_react2.default.createElement('div',{className:'e9login-pop-form-remember'},needforgotpassword=='1'&&_react2.default.createElement('div',{className:'e9login-pop-form-remember-forget',title:labelObj.forgetPassword},_react2.default.createElement('span',{onClick:function onClick(){return _this3.props.onPasswordForget();}},labelObj.forgetPassword)),_react2.default.createElement('div',{className:'e9login-pop-form-remember-content '+(isRememberPW=='1'?'':'e9login-pop-display-hidden')},_react2.default.createElement('div',{className:'e9login-pop-form-remember-account',title:labelObj.rememberAccount},_react2.default.createElement(_antd.Checkbox,{checked:isRememberAccount,onChange:function onChange(e){return _this3.props.onRememberChange('account',e.target.checked);}},labelObj.rememberAccount)),_react2.default.createElement('div',{className:'e9login-pop-form-remember-password',title:labelObj.rememberPassword},_react2.default.createElement(_antd.Checkbox,{checked:isRememberPassword,onChange:function onChange(e){return _this3.props.onRememberChange('password',e.target.checked);}},labelObj.rememberPassword))),_react2.default.createElement('div',{className:'e9login-pop-form-clear'})),_react2.default.createElement('div',{className:'e9login-pop-form-submit',style:style},_react2.default.createElement(_antd.Button,{type:'primary',loading:isLogging,id:'submit',name:'submit',className:'e9login-pop-form-submit-btn',onClick:this.onLogin},labelObj.login)));}},{key:'getLoginForm',value:function getLoginForm(){var _this4=this;this.props.getLoginForm({},function(){var result=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var _result$loginSetting=result.loginSetting,loginSetting=_result$loginSetting===undefined?{}:_result$loginSetting,warningMsg=result.message;var userUsbType=loginSetting.userUsbType;if(userUsbType=='6'){warningMsg&&_antd.message.warning(warningMsg);_this4.props.setStateAndCache('loginType','QRCode');}});}},{key:'onLabelClick',value:function onLabelClick(e){jQuery(e.target.parentNode).find('input').focus();}},{key:'onInputChange',value:function onInputChange(e){var parentNode=jQuery(e.target.parentNode);if(e.target.value){parentNode.find('.e9login-pop-form-label').addClass('e9login-pop-display-hidden');parentNode.find('.icon-coms-Clear').attr('data-value','true');}else{parentNode.find('.e9login-pop-form-label').removeClass('e9login-pop-display-hidden');parentNode.find('.icon-coms-Clear').attr('data-value','false');}}},{key:'onClear',value:function onClear(e){var parentNode=jQuery(e.target.parentNode);parentNode.find('input').val('');parentNode.find('input').focus();parentNode.find('.icon-coms-Clear').attr('data-value','false');parentNode.find('.e9login-pop-form-label').removeClass('e9login-pop-display-hidden');}},{key:'getDynamicPassword',value:function getDynamicPassword(){this.props.getDynamicPassword();}},{key:'onLogin',value:function onLogin(){this.props.onLogin();}}]);return E9Form;}(_react2.default.Component);exports.default=E9Form;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _getPrototypeOf=__webpack_require__(7);var _getPrototypeOf2=_interopRequireDefault(_getPrototypeOf);var _classCallCheck2=__webpack_require__(1);var _classCallCheck3=_interopRequireDefault(_classCallCheck2);var _createClass2=__webpack_require__(4);var _createClass3=_interopRequireDefault(_createClass2);var _possibleConstructorReturn2=__webpack_require__(2);var _possibleConstructorReturn3=_interopRequireDefault(_possibleConstructorReturn2);var _inherits2=__webpack_require__(3);var _inherits3=_interopRequireDefault(_inherits2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _qrcode=__webpack_require__(432);var _qrcode2=_interopRequireDefault(_qrcode);var _pathUtil=__webpack_require__(34);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var E9QRCode=function(_React$Component){(0,_inherits3.default)(E9QRCode,_React$Component);function E9QRCode(props){(0,_classCallCheck3.default)(this,E9QRCode);var _this=(0,_possibleConstructorReturn3.default)(this,(E9QRCode.__proto__||(0,_getPrototypeOf2.default)(E9QRCode)).call(this,props));_this.onRefresh=_this.onRefresh.bind(_this);_this.onDownload=_this.onDownload.bind(_this);return _this;}(0,_createClass3.default)(E9QRCode,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var _props$loginstate=this.props.loginstate,loginstate=_props$loginstate===undefined?{}:_props$loginstate;var loginId=loginstate.cacheAccount,langId=loginstate.langId;this.props.getLoginForm({loginId:loginId,langId:langId},function(){return _this2.props.onQCLoginStart();});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.onQCLoginEnd();}},{key:'render',value:function render(){var _props=this.props,_props$loginstate2=_props.loginstate,loginstate=_props$loginstate2===undefined?{}:_props$loginstate2,qrcodeIsInvalid=_props.qrcodeIsInvalid,emobileDownloadUrl=_props.emobileDownloadUrl;var _loginstate$loginSett=loginstate.loginSettingInfo,loginSettingInfo=_loginstate$loginSett===undefined?{}:_loginstate$loginSett,labelInfo=loginstate.labelInfo,langId=loginstate.langId,qrCode=loginstate.qrCode;var labelObj=labelInfo['langid'+langId]||{};var size=200;return _react2.default.createElement('div',{className:'e9login-pop-QRCode'},_react2.default.createElement('div',{className:'e9login-pop-QRCode-area'},qrcodeIsInvalid&&_react2.default.createElement('div',{className:'e9login-pop-QRCode-timeout'},_react2.default.createElement('div',{className:'e9login-pop-QRCode-timeout-mask'}),_react2.default.createElement('div',{className:'e9login-pop-QRCode-timeout-tips'},labelObj.qrcodeisinvalid),_react2.default.createElement('i',{className:'icon-coms-Refresh e9login-pop-QRCode-timeout-refresh',title:labelObj.refresh,onClick:this.onRefresh})),qrCode.text?_react2.default.createElement(_qrcode2.default,{value:qrCode.text,size:size,fgColor:'#404549',bgColor:'#ffffff'}):''),_react2.default.createElement('div',{className:'e9login-pop-QRCode-describe'},labelObj.qrcode),emobileDownloadUrl&&_react2.default.createElement('div',{className:'e9login-pop-QRCode-download',onClick:this.onDownload},labelObj.download));}},{key:'onRefresh',value:function onRefresh(){var _this3=this;var _props$loginstate3=this.props.loginstate,loginstate=_props$loginstate3===undefined?{}:_props$loginstate3;var loginId=loginstate.cacheAccount,langId=loginstate.langId;this.props.getLoginForm({loginId:loginId,langId:langId},function(){return _this3.props.onQCLoginStart();});}},{key:'onDownload',value:function onDownload(){var emobileDownloadUrl=this.props.emobileDownloadUrl;window.open((0,_pathUtil.addContentPath)(emobileDownloadUrl));}}]);return E9QRCode;}(_react2.default.Component);exports.default=E9QRCode;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) { return typeof obj; };
}
else {
    _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
} return _typeof(obj); }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
} return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); return Constructor; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
} if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(6); // qr.js doesn't handle error level of zero (M) so we need to do it right,
// thus the deep require.
var QRCodeImpl = __webpack_require__(433);
var ErrorCorrectLevel = __webpack_require__(205);
function getBackingStorePixelRatio(ctx) {
    return ( // $FlowFixMe
    ctx.webkitBackingStorePixelRatio || // $FlowFixMe
        ctx.mozBackingStorePixelRatio || // $FlowFixMe
        ctx.msBackingStorePixelRatio || // $FlowFixMe
        ctx.oBackingStorePixelRatio || // $FlowFixMe
        ctx.backingStorePixelRatio || 1);
} // Convert from UTF-16, forcing the use of byte-mode encoding in our QR Code.
// This allows us to encode Hanji, Kanji, emoji, etc. Ideally we'd do more
// detection and not resort to byte-mode if possible, but we're trading off
// a smaller library for a smaller amount of data we can potentially encode.
// Based on http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
function convertStr(str) {
    var out = '';
    for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x0080) {
            out += String.fromCharCode(charcode);
        }
        else if (charcode < 0x0800) {
            out += String.fromCharCode(0xc0 | charcode >> 6);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            out += String.fromCharCode(0xe0 | charcode >> 12);
            out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        }
        else {
            // This is a surrogate pair, so we'll reconsitute the pieces and work
            // from that
            i++;
            charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
            out += String.fromCharCode(0xf0 | charcode >> 18);
            out += String.fromCharCode(0x80 | charcode >> 12 & 0x3f);
            out += String.fromCharCode(0x80 | charcode >> 6 & 0x3f);
            out += String.fromCharCode(0x80 | charcode & 0x3f);
        }
    }
    return out;
}
var DEFAULT_PROPS = {
    size: 128,
    level: 'L',
    bgColor: '#FFFFFF',
    fgColor: '#000000'
};
var PROP_TYPES = {
    value: PropTypes.string.isRequired,
    size: PropTypes.number,
    level: PropTypes.oneOf(['L', 'M', 'Q', 'H']),
    bgColor: PropTypes.string,
    fgColor: PropTypes.string
};
var QRCodeCanvas = 
/*#__PURE__*/
function (_React$Component) {
    _inherits(QRCodeCanvas, _React$Component);
    function QRCodeCanvas() {
        var _ref;
        var _temp, _this;
        _classCallCheck(this, QRCodeCanvas);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }
        return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = QRCodeCanvas.__proto__ || Object.getPrototypeOf(QRCodeCanvas)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "_canvas", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: void 0
        }), _temp));
    }
    _createClass(QRCodeCanvas, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this2 = this;
                return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
                    return _this2.props[k] !== nextProps[k];
                });
            }
        }, {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.update();
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.update();
            }
        }, {
            key: "update",
            value: function update() {
                var _props = this.props, value = _props.value, size = _props.size, level = _props.level, bgColor = _props.bgColor, fgColor = _props.fgColor; // We'll use type===-1 to force QRCode to automatically pick the best type
                var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
                qrcode.addData(convertStr(value));
                qrcode.make();
                if (this._canvas != null) {
                    var canvas = this._canvas;
                    var ctx = canvas.getContext('2d');
                    if (!ctx) {
                        return;
                    }
                    var cells = qrcode.modules;
                    if (cells === null) {
                        return;
                    }
                    var tileW = size / cells.length;
                    var tileH = size / cells.length;
                    var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
                    canvas.height = canvas.width = size * scale;
                    ctx.scale(scale, scale);
                    cells.forEach(function (row, rdx) {
                        row.forEach(function (cell, cdx) {
                            ctx && (ctx.fillStyle = cell ? fgColor : bgColor);
                            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
                            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
                            ctx && ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
                        });
                    });
                }
            }
        }, {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props2 = this.props, value = _props2.value, size = _props2.size, level = _props2.level, bgColor = _props2.bgColor, fgColor = _props2.fgColor, style = _props2.style, otherProps = _objectWithoutProperties(_props2, ["value", "size", "level", "bgColor", "fgColor", "style"]);
                var canvasStyle = _extends({
                    height: size,
                    width: size
                }, style);
                return React.createElement("canvas", _extends({
                    style: canvasStyle,
                    height: size,
                    width: size,
                    ref: function ref(_ref2) {
                        return _this3._canvas = _ref2;
                    }
                }, otherProps));
            }
        }]);
    return QRCodeCanvas;
}(React.Component);
Object.defineProperty(QRCodeCanvas, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeCanvas, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: PROP_TYPES
});
var QRCodeSVG = 
/*#__PURE__*/
function (_React$Component2) {
    _inherits(QRCodeSVG, _React$Component2);
    function QRCodeSVG() {
        _classCallCheck(this, QRCodeSVG);
        return _possibleConstructorReturn(this, (QRCodeSVG.__proto__ || Object.getPrototypeOf(QRCodeSVG)).apply(this, arguments));
    }
    _createClass(QRCodeSVG, [{
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this4 = this;
                return Object.keys(QRCodeCanvas.propTypes).some(function (k) {
                    return _this4.props[k] !== nextProps[k];
                });
            }
        }, {
            key: "render",
            value: function render() {
                var _props3 = this.props, value = _props3.value, size = _props3.size, level = _props3.level, bgColor = _props3.bgColor, fgColor = _props3.fgColor, otherProps = _objectWithoutProperties(_props3, ["value", "size", "level", "bgColor", "fgColor"]); // We'll use type===-1 to force QRCode to automatically pick the best type
                var qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
                qrcode.addData(convertStr(value));
                qrcode.make();
                var cells = qrcode.modules;
                if (cells === null) {
                    return;
                } // Drawing strategy: instead of a rect per module, we're going to create a
                // single path for the dark modules and layer that on top of a light rect,
                // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
                // way faster than DOM ops.
                // For level 1, 441 nodes -> 2
                // For level 40, 31329 -> 2
                var ops = [];
                cells.forEach(function (row, y) {
                    var lastIsDark = false;
                    var start = null;
                    row.forEach(function (cell, x) {
                        if (!cell && start !== null) {
                            // M0 0h7v1H0z injects the space with the move and dropd the comma,
                            // saving a char per operation
                            ops.push("M".concat(start, " ").concat(y, "h").concat(x - start, "v1H").concat(start, "z"));
                            start = null;
                            return;
                        } // end of row, clean up or skip
                        if (x === row.length - 1) {
                            if (!cell) {
                                // We would have closed the op above already so this can only mean
                                // 2+ light modules in a row.
                                return;
                            }
                            if (start === null) {
                                // Just a single dark module.
                                ops.push("M".concat(x, ",").concat(y, " h1v1H").concat(x, "z"));
                            }
                            else {
                                // Otherwise finish the current line.
                                ops.push("M".concat(start, ",").concat(y, " h").concat(x + 1 - start, "v1H").concat(start, "z"));
                            }
                            return;
                        }
                        if (cell && start === null) {
                            start = x;
                        }
                    });
                });
                return React.createElement("svg", _extends({
                    shapeRendering: "crispEdges",
                    height: size,
                    width: size,
                    viewBox: "0 0 ".concat(cells.length, " ").concat(cells.length)
                }, otherProps), React.createElement("path", {
                    fill: bgColor,
                    d: "M0,0 h".concat(cells.length, "v").concat(cells.length, "H0z")
                }), React.createElement("path", {
                    fill: fgColor,
                    d: ops.join('')
                }));
            }
        }]);
    return QRCodeSVG;
}(React.Component);
Object.defineProperty(QRCodeSVG, "defaultProps", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: DEFAULT_PROPS
});
Object.defineProperty(QRCodeSVG, "propTypes", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: PROP_TYPES
});
var QRCode = function QRCode(props) {
    var renderAs = props.renderAs, otherProps = _objectWithoutProperties(props, ["renderAs"]);
    var Component = renderAs === 'svg' ? QRCodeSVG : QRCodeCanvas;
    return React.createElement(Component, otherProps);
};
QRCode.defaultProps = _extends({
    renderAs: 'canvas'
}, DEFAULT_PROPS);
module.exports = QRCode;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var BitByte = __webpack_require__(434);
var RSBlock = __webpack_require__(435);
var BitBuffer = __webpack_require__(436);
var util = __webpack_require__(437);
var Polynomial = __webpack_require__(206);
function QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var proto = QRCode.prototype;
proto.addData = function (data) {
    var newData = new BitByte(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
proto.isDark = function (row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
        throw new Error(row + "," + col);
    }
    return this.modules[row][col];
};
proto.getModuleCount = function () {
    return this.moduleCount;
};
proto.make = function () {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for (typeNumber = 1; typeNumber < 40; typeNumber++) {
            var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new BitBuffer();
            var totalDataCount = 0;
            for (var i = 0; i < rsBlocks.length; i++) {
                totalDataCount += rsBlocks[i].dataCount;
            }
            for (var i = 0; i < this.dataList.length; i++) {
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8)
                break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
proto.makeImpl = function (test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for (var row = 0; row < this.moduleCount; row++) {
        this.modules[row] = new Array(this.moduleCount);
        for (var col = 0; col < this.moduleCount; col++) {
            this.modules[row][col] = null; //(col + row) % 3;
        }
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) {
        this.setupTypeNumber(test);
    }
    if (this.dataCache == null) {
        this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    }
    this.mapData(this.dataCache, maskPattern);
};
proto.setupPositionProbePattern = function (row, col) {
    for (var r = -1; r <= 7; r++) {
        if (row + r <= -1 || this.moduleCount <= row + r)
            continue;
        for (var c = -1; c <= 7; c++) {
            if (col + c <= -1 || this.moduleCount <= col + c)
                continue;
            if ((0 <= r && r <= 6 && (c == 0 || c == 6))
                || (0 <= c && c <= 6 && (r == 0 || r == 6))
                || (2 <= r && r <= 4 && 2 <= c && c <= 4)) {
                this.modules[row + r][col + c] = true;
            }
            else {
                this.modules[row + r][col + c] = false;
            }
        }
    }
};
proto.getBestMaskPattern = function () {
    var minLostPoint = 0;
    var pattern = 0;
    for (var i = 0; i < 8; i++) {
        this.makeImpl(true, i);
        var lostPoint = util.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
proto.createMovieClip = function (target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for (var row = 0; row < this.modules.length; row++) {
        var y = row * cs;
        for (var col = 0; col < this.modules[row].length; col++) {
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
proto.setupTimingPattern = function () {
    for (var r = 8; r < this.moduleCount - 8; r++) {
        if (this.modules[r][6] != null) {
            continue;
        }
        this.modules[r][6] = (r % 2 == 0);
    }
    for (var c = 8; c < this.moduleCount - 8; c++) {
        if (this.modules[6][c] != null) {
            continue;
        }
        this.modules[6][c] = (c % 2 == 0);
    }
};
proto.setupPositionAdjustPattern = function () {
    var pos = util.getPatternPosition(this.typeNumber);
    for (var i = 0; i < pos.length; i++) {
        for (var j = 0; j < pos.length; j++) {
            var row = pos[i];
            var col = pos[j];
            if (this.modules[row][col] != null) {
                continue;
            }
            for (var r = -2; r <= 2; r++) {
                for (var c = -2; c <= 2; c++) {
                    if (r == -2 || r == 2 || c == -2 || c == 2
                        || (r == 0 && c == 0)) {
                        this.modules[row + r][col + c] = true;
                    }
                    else {
                        this.modules[row + r][col + c] = false;
                    }
                }
            }
        }
    }
};
proto.setupTypeNumber = function (test) {
    var bits = util.getBCHTypeNumber(this.typeNumber);
    for (var i = 0; i < 18; i++) {
        var mod = (!test && ((bits >> i) & 1) == 1);
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for (var i = 0; i < 18; i++) {
        var mod = (!test && ((bits >> i) & 1) == 1);
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
proto.setupTypeInfo = function (test, maskPattern) {
    var data = (this.errorCorrectLevel << 3) | maskPattern;
    var bits = util.getBCHTypeInfo(data);
    // vertical		
    for (var i = 0; i < 15; i++) {
        var mod = (!test && ((bits >> i) & 1) == 1);
        if (i < 6) {
            this.modules[i][8] = mod;
        }
        else if (i < 8) {
            this.modules[i + 1][8] = mod;
        }
        else {
            this.modules[this.moduleCount - 15 + i][8] = mod;
        }
    }
    // horizontal
    for (var i = 0; i < 15; i++) {
        var mod = (!test && ((bits >> i) & 1) == 1);
        if (i < 8) {
            this.modules[8][this.moduleCount - i - 1] = mod;
        }
        else if (i < 9) {
            this.modules[8][15 - i - 1 + 1] = mod;
        }
        else {
            this.modules[8][15 - i - 1] = mod;
        }
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = (!test);
};
proto.mapData = function (data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for (var col = this.moduleCount - 1; col > 0; col -= 2) {
        if (col == 6)
            col--;
        while (true) {
            for (var c = 0; c < 2; c++) {
                if (this.modules[row][col - c] == null) {
                    var dark = false;
                    if (byteIndex < data.length) {
                        dark = (((data[byteIndex] >>> bitIndex) & 1) == 1);
                    }
                    var mask = util.getMask(maskPattern, row, col - c);
                    if (mask) {
                        dark = !dark;
                    }
                    this.modules[row][col - c] = dark;
                    bitIndex--;
                    if (bitIndex == -1) {
                        byteIndex++;
                        bitIndex = 7;
                    }
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;
QRCode.createData = function (typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new BitBuffer();
    for (var i = 0; i < dataList.length; i++) {
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
    }
    if (buffer.getLengthInBits() > totalDataCount * 8) {
        throw new Error("code length overflow. ("
            + buffer.getLengthInBits()
            + ">"
            + totalDataCount * 8
            + ")");
    }
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
        buffer.put(0, 4);
    }
    // padding
    while (buffer.getLengthInBits() % 8 != 0) {
        buffer.putBit(false);
    }
    // padding
    while (true) {
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
            break;
        }
        buffer.put(QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
            break;
        }
        buffer.put(QRCode.PAD1, 8);
    }
    return QRCode.createBytes(buffer, rsBlocks);
};
QRCode.createBytes = function (buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for (var r = 0; r < rsBlocks.length; r++) {
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for (var i = 0; i < dcdata[r].length; i++) {
            dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        }
        offset += dcCount;
        var rsPoly = util.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = (modIndex >= 0) ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for (var i = 0; i < rsBlocks.length; i++) {
        totalCodeCount += rsBlocks[i].totalCount;
    }
    var data = new Array(totalCodeCount);
    var index = 0;
    for (var i = 0; i < maxDcCount; i++) {
        for (var r = 0; r < rsBlocks.length; r++) {
            if (i < dcdata[r].length) {
                data[index++] = dcdata[r][i];
            }
        }
    }
    for (var i = 0; i < maxEcCount; i++) {
        for (var r = 0; r < rsBlocks.length; r++) {
            if (i < ecdata[r].length) {
                data[index++] = ecdata[r][i];
            }
        }
    }
    return data;
};
module.exports = QRCode;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var mode = __webpack_require__(204);
function QR8bitByte(data) {
    this.mode = mode.MODE_8BIT_BYTE;
    this.data = data;
}
QR8bitByte.prototype = {
    getLength: function (buffer) {
        return this.data.length;
    },
    write: function (buffer) {
        for (var i = 0; i < this.data.length; i++) {
            // not JIS ...
            buffer.put(this.data.charCodeAt(i), 8);
        }
    }
};
module.exports = QR8bitByte;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// ErrorCorrectLevel
var ECL = __webpack_require__(205);
function QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [1, 26, 19],
    [1, 26, 16],
    [1, 26, 13],
    [1, 26, 9],
    // 2
    [1, 44, 34],
    [1, 44, 28],
    [1, 44, 22],
    [1, 44, 16],
    // 3
    [1, 70, 55],
    [1, 70, 44],
    [2, 35, 17],
    [2, 35, 13],
    // 4		
    [1, 100, 80],
    [2, 50, 32],
    [2, 50, 24],
    [4, 25, 9],
    // 5
    [1, 134, 108],
    [2, 67, 43],
    [2, 33, 15, 2, 34, 16],
    [2, 33, 11, 2, 34, 12],
    // 6
    [2, 86, 68],
    [4, 43, 27],
    [4, 43, 19],
    [4, 43, 15],
    // 7		
    [2, 98, 78],
    [4, 49, 31],
    [2, 32, 14, 4, 33, 15],
    [4, 39, 13, 1, 40, 14],
    // 8
    [2, 121, 97],
    [2, 60, 38, 2, 61, 39],
    [4, 40, 18, 2, 41, 19],
    [4, 40, 14, 2, 41, 15],
    // 9
    [2, 146, 116],
    [3, 58, 36, 2, 59, 37],
    [4, 36, 16, 4, 37, 17],
    [4, 36, 12, 4, 37, 13],
    // 10		
    [2, 86, 68, 2, 87, 69],
    [4, 69, 43, 1, 70, 44],
    [6, 43, 19, 2, 44, 20],
    [6, 43, 15, 2, 44, 16],
    // 11
    [4, 101, 81],
    [1, 80, 50, 4, 81, 51],
    [4, 50, 22, 4, 51, 23],
    [3, 36, 12, 8, 37, 13],
    // 12
    [2, 116, 92, 2, 117, 93],
    [6, 58, 36, 2, 59, 37],
    [4, 46, 20, 6, 47, 21],
    [7, 42, 14, 4, 43, 15],
    // 13
    [4, 133, 107],
    [8, 59, 37, 1, 60, 38],
    [8, 44, 20, 4, 45, 21],
    [12, 33, 11, 4, 34, 12],
    // 14
    [3, 145, 115, 1, 146, 116],
    [4, 64, 40, 5, 65, 41],
    [11, 36, 16, 5, 37, 17],
    [11, 36, 12, 5, 37, 13],
    // 15
    [5, 109, 87, 1, 110, 88],
    [5, 65, 41, 5, 66, 42],
    [5, 54, 24, 7, 55, 25],
    [11, 36, 12],
    // 16
    [5, 122, 98, 1, 123, 99],
    [7, 73, 45, 3, 74, 46],
    [15, 43, 19, 2, 44, 20],
    [3, 45, 15, 13, 46, 16],
    // 17
    [1, 135, 107, 5, 136, 108],
    [10, 74, 46, 1, 75, 47],
    [1, 50, 22, 15, 51, 23],
    [2, 42, 14, 17, 43, 15],
    // 18
    [5, 150, 120, 1, 151, 121],
    [9, 69, 43, 4, 70, 44],
    [17, 50, 22, 1, 51, 23],
    [2, 42, 14, 19, 43, 15],
    // 19
    [3, 141, 113, 4, 142, 114],
    [3, 70, 44, 11, 71, 45],
    [17, 47, 21, 4, 48, 22],
    [9, 39, 13, 16, 40, 14],
    // 20
    [3, 135, 107, 5, 136, 108],
    [3, 67, 41, 13, 68, 42],
    [15, 54, 24, 5, 55, 25],
    [15, 43, 15, 10, 44, 16],
    // 21
    [4, 144, 116, 4, 145, 117],
    [17, 68, 42],
    [17, 50, 22, 6, 51, 23],
    [19, 46, 16, 6, 47, 17],
    // 22
    [2, 139, 111, 7, 140, 112],
    [17, 74, 46],
    [7, 54, 24, 16, 55, 25],
    [34, 37, 13],
    // 23
    [4, 151, 121, 5, 152, 122],
    [4, 75, 47, 14, 76, 48],
    [11, 54, 24, 14, 55, 25],
    [16, 45, 15, 14, 46, 16],
    // 24
    [6, 147, 117, 4, 148, 118],
    [6, 73, 45, 14, 74, 46],
    [11, 54, 24, 16, 55, 25],
    [30, 46, 16, 2, 47, 17],
    // 25
    [8, 132, 106, 4, 133, 107],
    [8, 75, 47, 13, 76, 48],
    [7, 54, 24, 22, 55, 25],
    [22, 45, 15, 13, 46, 16],
    // 26
    [10, 142, 114, 2, 143, 115],
    [19, 74, 46, 4, 75, 47],
    [28, 50, 22, 6, 51, 23],
    [33, 46, 16, 4, 47, 17],
    // 27
    [8, 152, 122, 4, 153, 123],
    [22, 73, 45, 3, 74, 46],
    [8, 53, 23, 26, 54, 24],
    [12, 45, 15, 28, 46, 16],
    // 28
    [3, 147, 117, 10, 148, 118],
    [3, 73, 45, 23, 74, 46],
    [4, 54, 24, 31, 55, 25],
    [11, 45, 15, 31, 46, 16],
    // 29
    [7, 146, 116, 7, 147, 117],
    [21, 73, 45, 7, 74, 46],
    [1, 53, 23, 37, 54, 24],
    [19, 45, 15, 26, 46, 16],
    // 30
    [5, 145, 115, 10, 146, 116],
    [19, 75, 47, 10, 76, 48],
    [15, 54, 24, 25, 55, 25],
    [23, 45, 15, 25, 46, 16],
    // 31
    [13, 145, 115, 3, 146, 116],
    [2, 74, 46, 29, 75, 47],
    [42, 54, 24, 1, 55, 25],
    [23, 45, 15, 28, 46, 16],
    // 32
    [17, 145, 115],
    [10, 74, 46, 23, 75, 47],
    [10, 54, 24, 35, 55, 25],
    [19, 45, 15, 35, 46, 16],
    // 33
    [17, 145, 115, 1, 146, 116],
    [14, 74, 46, 21, 75, 47],
    [29, 54, 24, 19, 55, 25],
    [11, 45, 15, 46, 46, 16],
    // 34
    [13, 145, 115, 6, 146, 116],
    [14, 74, 46, 23, 75, 47],
    [44, 54, 24, 7, 55, 25],
    [59, 46, 16, 1, 47, 17],
    // 35
    [12, 151, 121, 7, 152, 122],
    [12, 75, 47, 26, 76, 48],
    [39, 54, 24, 14, 55, 25],
    [22, 45, 15, 41, 46, 16],
    // 36
    [6, 151, 121, 14, 152, 122],
    [6, 75, 47, 34, 76, 48],
    [46, 54, 24, 10, 55, 25],
    [2, 45, 15, 64, 46, 16],
    // 37
    [17, 152, 122, 4, 153, 123],
    [29, 74, 46, 14, 75, 47],
    [49, 54, 24, 10, 55, 25],
    [24, 45, 15, 46, 46, 16],
    // 38
    [4, 152, 122, 18, 153, 123],
    [13, 74, 46, 32, 75, 47],
    [48, 54, 24, 14, 55, 25],
    [42, 45, 15, 32, 46, 16],
    // 39
    [20, 147, 117, 4, 148, 118],
    [40, 75, 47, 7, 76, 48],
    [43, 54, 24, 22, 55, 25],
    [10, 45, 15, 67, 46, 16],
    // 40
    [19, 148, 118, 6, 149, 119],
    [18, 75, 47, 31, 76, 48],
    [34, 54, 24, 34, 55, 25],
    [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
    var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) {
        throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    }
    var length = rsBlock.length / 3;
    var list = new Array();
    for (var i = 0; i < length; i++) {
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for (var j = 0; j < count; j++) {
            list.push(new QRRSBlock(totalCount, dataCount));
        }
    }
    return list;
};
QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
    switch (errorCorrectLevel) {
        case ECL.L:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case ECL.M:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case ECL.Q:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case ECL.H:
            return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
module.exports = QRRSBlock;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

function QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
QRBitBuffer.prototype = {
    get: function (index) {
        var bufIndex = Math.floor(index / 8);
        return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) == 1;
    },
    put: function (num, length) {
        for (var i = 0; i < length; i++) {
            this.putBit(((num >>> (length - i - 1)) & 1) == 1);
        }
    },
    getLengthInBits: function () {
        return this.length;
    },
    putBit: function (bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) {
            this.buffer.push(0);
        }
        if (bit) {
            this.buffer[bufIndex] |= (0x80 >>> (this.length % 8));
        }
        this.length++;
    }
};
module.exports = QRBitBuffer;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(204);
var Polynomial = __webpack_require__(206);
var math = __webpack_require__(207);
var QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [6, 18],
        [6, 22],
        [6, 26],
        [6, 30],
        [6, 34],
        [6, 22, 38],
        [6, 24, 42],
        [6, 26, 46],
        [6, 28, 50],
        [6, 30, 54],
        [6, 32, 58],
        [6, 34, 62],
        [6, 26, 46, 66],
        [6, 26, 48, 70],
        [6, 26, 50, 74],
        [6, 30, 54, 78],
        [6, 30, 56, 82],
        [6, 30, 58, 86],
        [6, 34, 62, 90],
        [6, 28, 50, 72, 94],
        [6, 26, 50, 74, 98],
        [6, 30, 54, 78, 102],
        [6, 28, 54, 80, 106],
        [6, 32, 58, 84, 110],
        [6, 30, 58, 86, 114],
        [6, 34, 62, 90, 118],
        [6, 26, 50, 74, 98, 122],
        [6, 30, 54, 78, 102, 126],
        [6, 26, 52, 78, 104, 130],
        [6, 30, 56, 82, 108, 134],
        [6, 34, 60, 86, 112, 138],
        [6, 30, 58, 86, 114, 142],
        [6, 34, 62, 90, 118, 146],
        [6, 30, 54, 78, 102, 126, 150],
        [6, 24, 50, 76, 102, 128, 154],
        [6, 28, 54, 80, 106, 132, 158],
        [6, 32, 58, 84, 110, 136, 162],
        [6, 26, 54, 82, 110, 138, 166],
        [6, 30, 58, 86, 114, 142, 170]
    ],
    G15: (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18: (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK: (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1),
    getBCHTypeInfo: function (data) {
        var d = data << 10;
        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
            d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15)));
        }
        return ((data << 10) | d) ^ QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function (data) {
        var d = data << 12;
        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
            d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18)));
        }
        return (data << 12) | d;
    },
    getBCHDigit: function (data) {
        var digit = 0;
        while (data != 0) {
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function (typeNumber) {
        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function (maskPattern, i, j) {
        switch (maskPattern) {
            case QRMaskPattern.PATTERN000: return (i + j) % 2 == 0;
            case QRMaskPattern.PATTERN001: return i % 2 == 0;
            case QRMaskPattern.PATTERN010: return j % 3 == 0;
            case QRMaskPattern.PATTERN011: return (i + j) % 3 == 0;
            case QRMaskPattern.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case QRMaskPattern.PATTERN101: return (i * j) % 2 + (i * j) % 3 == 0;
            case QRMaskPattern.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 == 0;
            case QRMaskPattern.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function (errorCorrectLength) {
        var a = new Polynomial([1], 0);
        for (var i = 0; i < errorCorrectLength; i++) {
            a = a.multiply(new Polynomial([1, math.gexp(i)], 0));
        }
        return a;
    },
    getLengthInBits: function (mode, type) {
        if (1 <= type && type < 10) {
            // 1 - 9
            switch (mode) {
                case Mode.MODE_NUMBER: return 10;
                case Mode.MODE_ALPHA_NUM: return 9;
                case Mode.MODE_8BIT_BYTE: return 8;
                case Mode.MODE_KANJI: return 8;
                default:
                    throw new Error("mode:" + mode);
            }
        }
        else if (type < 27) {
            // 10 - 26
            switch (mode) {
                case Mode.MODE_NUMBER: return 12;
                case Mode.MODE_ALPHA_NUM: return 11;
                case Mode.MODE_8BIT_BYTE: return 16;
                case Mode.MODE_KANJI: return 10;
                default:
                    throw new Error("mode:" + mode);
            }
        }
        else if (type < 41) {
            // 27 - 40
            switch (mode) {
                case Mode.MODE_NUMBER: return 14;
                case Mode.MODE_ALPHA_NUM: return 13;
                case Mode.MODE_8BIT_BYTE: return 16;
                case Mode.MODE_KANJI: return 12;
                default:
                    throw new Error("mode:" + mode);
            }
        }
        else {
            throw new Error("type:" + type);
        }
    },
    getLostPoint: function (qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for (var row = 0; row < moduleCount; row++) {
            for (var col = 0; col < moduleCount; col++) {
                var sameCount = 0;
                var dark = qrCode.isDark(row, col);
                for (var r = -1; r <= 1; r++) {
                    if (row + r < 0 || moduleCount <= row + r) {
                        continue;
                    }
                    for (var c = -1; c <= 1; c++) {
                        if (col + c < 0 || moduleCount <= col + c) {
                            continue;
                        }
                        if (r == 0 && c == 0) {
                            continue;
                        }
                        if (dark == qrCode.isDark(row + r, col + c)) {
                            sameCount++;
                        }
                    }
                }
                if (sameCount > 5) {
                    lostPoint += (3 + sameCount - 5);
                }
            }
        }
        // LEVEL2
        for (var row = 0; row < moduleCount - 1; row++) {
            for (var col = 0; col < moduleCount - 1; col++) {
                var count = 0;
                if (qrCode.isDark(row, col))
                    count++;
                if (qrCode.isDark(row + 1, col))
                    count++;
                if (qrCode.isDark(row, col + 1))
                    count++;
                if (qrCode.isDark(row + 1, col + 1))
                    count++;
                if (count == 0 || count == 4) {
                    lostPoint += 3;
                }
            }
        }
        // LEVEL3
        for (var row = 0; row < moduleCount; row++) {
            for (var col = 0; col < moduleCount - 6; col++) {
                if (qrCode.isDark(row, col)
                    && !qrCode.isDark(row, col + 1)
                    && qrCode.isDark(row, col + 2)
                    && qrCode.isDark(row, col + 3)
                    && qrCode.isDark(row, col + 4)
                    && !qrCode.isDark(row, col + 5)
                    && qrCode.isDark(row, col + 6)) {
                    lostPoint += 40;
                }
            }
        }
        for (var col = 0; col < moduleCount; col++) {
            for (var row = 0; row < moduleCount - 6; row++) {
                if (qrCode.isDark(row, col)
                    && !qrCode.isDark(row + 1, col)
                    && qrCode.isDark(row + 2, col)
                    && qrCode.isDark(row + 3, col)
                    && qrCode.isDark(row + 4, col)
                    && !qrCode.isDark(row + 5, col)
                    && qrCode.isDark(row + 6, col)) {
                    lostPoint += 40;
                }
            }
        }
        // LEVEL4
        var darkCount = 0;
        for (var col = 0; col < moduleCount; col++) {
            for (var row = 0; row < moduleCount; row++) {
                if (qrCode.isDark(row, col)) {
                    darkCount++;
                }
            }
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
module.exports = QRUtil;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(192);__webpack_require__(203);__webpack_require__(238);__webpack_require__(239);__webpack_require__(240);__webpack_require__(241);__webpack_require__(242);__webpack_require__(221);__webpack_require__(222);

/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(247);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(209)(true);
// imports


// module
exports.push([module.i, ".rc-tabs,.rc-tabs-bar,.rc-tabs-nav-container{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;overflow:hidden}.rc-tabs-bar,.rc-tabs-nav-container{font-size:14px;line-height:1.5;white-space:nowrap;outline:none;zoom:1;-webkit-transition:padding .45s;-o-transition:padding .45s;transition:padding .45s}.rc-tabs-ink-bar{z-index:1;position:absolute;-webkit-box-sizing:border-box;box-sizing:border-box;margin-top:-3px;background-color:#108ee9;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0;width:0;height:0}.rc-tabs-ink-bar-animated{-webkit-transition:left .3s cubic-bezier(.35,0,.25,1),top .3s cubic-bezier(.35,0,.25,1),height .3s cubic-bezier(.35,0,.25,1),width .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1);transition:left .3s cubic-bezier(.35,0,.25,1),top .3s cubic-bezier(.35,0,.25,1),height .3s cubic-bezier(.35,0,.25,1),width .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1);-o-transition:transform .3s cubic-bezier(.35,0,.25,1),left .3s cubic-bezier(.35,0,.25,1),top .3s cubic-bezier(.35,0,.25,1),height .3s cubic-bezier(.35,0,.25,1),width .3s cubic-bezier(.35,0,.25,1);transition:transform .3s cubic-bezier(.35,0,.25,1),left .3s cubic-bezier(.35,0,.25,1),top .3s cubic-bezier(.35,0,.25,1),height .3s cubic-bezier(.35,0,.25,1),width .3s cubic-bezier(.35,0,.25,1);transition:transform .3s cubic-bezier(.35,0,.25,1),left .3s cubic-bezier(.35,0,.25,1),top .3s cubic-bezier(.35,0,.25,1),height .3s cubic-bezier(.35,0,.25,1),width .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1)}.rc-tabs-tab-next,.rc-tabs-tab-prev{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1;line-height:36px;cursor:pointer;border:none;background-color:transparent;position:absolute}.rc-tabs-tab-next-icon,.rc-tabs-tab-prev-icon{position:relative;display:inline-block;font-style:normal;font-weight:400;font-variant:normal;line-height:inherit;vertical-align:baseline;text-align:center;text-transform:none;font-smoothing:antialiased;text-stroke-width:0;font-family:sans-serif}.rc-tabs-tab-next-icon:before,.rc-tabs-tab-prev-icon:before{display:block}.rc-tabs-tab-btn-disabled{cursor:default;color:#ccc}.rc-tabs-nav-wrap{overflow:hidden}.rc-tabs-nav{-webkit-box-sizing:border-box;box-sizing:border-box;padding-left:0;position:relative;margin:0;float:left;list-style:none;display:inline-block;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0}.rc-tabs-nav-animated{-webkit-transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);transition:-webkit-transform .5s cubic-bezier(.35,0,.25,1);-o-transition:transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1);transition:transform .5s cubic-bezier(.35,0,.25,1),-webkit-transform .5s cubic-bezier(.35,0,.25,1)}.rc-tabs-nav:after,.rc-tabs-nav:before{display:table;content:\" \"}.rc-tabs-nav:after{clear:both}.rc-tabs-tab{-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;-webkit-transition:color .3s cubic-bezier(.35,0,.25,1);-o-transition:color .3s cubic-bezier(.35,0,.25,1);transition:color .3s cubic-bezier(.35,0,.25,1);padding:8px 20px;font-weight:500;cursor:pointer}.rc-tabs-tab:hover{color:#23c0fa}.rc-tabs-tab-active,.rc-tabs-tab-active:hover{color:#108ee9;cursor:default;-webkit-transform:translateZ(0);transform:translateZ(0)}.rc-tabs-tab-disabled{cursor:default;color:#ccc}.rc-tabs-tab-disabled:hover{color:#ccc}.rc-tabs-content{zoom:1}.rc-tabs-content .rc-tabs-tabpane{overflow:auto}.rc-tabs-content-animated{-webkit-transition:margin-left .3s cubic-bezier(.35,0,.25,1),margin-top .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1);transition:margin-left .3s cubic-bezier(.35,0,.25,1),margin-top .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1);-o-transition:transform .3s cubic-bezier(.35,0,.25,1),margin-left .3s cubic-bezier(.35,0,.25,1),margin-top .3s cubic-bezier(.35,0,.25,1);transition:transform .3s cubic-bezier(.35,0,.25,1),margin-left .3s cubic-bezier(.35,0,.25,1),margin-top .3s cubic-bezier(.35,0,.25,1);transition:transform .3s cubic-bezier(.35,0,.25,1),margin-left .3s cubic-bezier(.35,0,.25,1),margin-top .3s cubic-bezier(.35,0,.25,1),-webkit-transform .3s cubic-bezier(.35,0,.25,1);display:-ms-flexbox;display:flex;will-change:transform}.rc-tabs-content-animated .rc-tabs-tabpane{-ms-flex-negative:0;flex-shrink:0}.no-flexbox .rc-tabs-content{-webkit-transform:none!important;-ms-transform:none!important;transform:none!important;overflow:auto}.no-csstransitions .rc-tabs-tabpane-inactive,.no-flexbox .rc-tabs-tabpane-inactive,.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive{display:none}.rc-tabs-left{border-right:2px solid #f3f3f3}.rc-tabs-left .rc-tabs-bar{float:left;height:100%;margin-right:10px;border-right:1px solid #f3f3f3}.rc-tabs-left .rc-tabs-nav-container{height:100%}.rc-tabs-left .rc-tabs-nav-container-scrolling{padding-top:32px;padding-bottom:32px}.rc-tabs-left .rc-tabs-nav-wrap{height:100%}.rc-tabs-left .rc-tabs-content-animated{-ms-flex-direction:column;flex-direction:column}.rc-tabs-left .rc-tabs-content-animated .rc-tabs-tabpane{height:100%}.rc-tabs-left .rc-tabs-nav-scroll{height:99999px}.rc-tabs-left .rc-tabs-nav-swipe{position:relative;top:0}.rc-tabs-left .rc-tabs-nav-swipe .rc-tabs-nav{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1 1;-ms-flex-direction:column;flex-direction:column;height:100%}.rc-tabs-left .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-ms-flex-pack:center;justify-content:center}.rc-tabs-left .rc-tabs-tab-next,.rc-tabs-left .rc-tabs-tab-prev{margin-top:-2px;height:0;line-height:32px;width:0;display:block;text-align:center;opacity:0;-webkit-transition:width .3s,height .3s,opacity .3s;-o-transition:width .3s,height .3s,opacity .3s;transition:width .3s,height .3s,opacity .3s}.rc-tabs-bottom .rc-tabs-tab-arrow-show,.rc-tabs-left .rc-tabs-tab-arrow-show,.rc-tabs-right .rc-tabs-tab-arrow-show,.rc-tabs-top .rc-tabs-tab-arrow-show{opacity:1;width:100%;height:32px}.rc-tabs-left .rc-tabs-tab-next{bottom:0}.rc-tabs-left .rc-tabs-tab-next-icon{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1)}.rc-tabs-left .rc-tabs-tab-next-icon:before{content:\">\"}.rc-tabs-left .rc-tabs-tab-prev{top:2px}.rc-tabs-left .rc-tabs-tab-prev-icon{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3)}.rc-tabs-left .rc-tabs-tab-prev-icon:before{content:\">\"}.rc-tabs-left .rc-tabs-ink-bar{width:2px;right:0;top:0}.rc-tabs-left .rc-tabs-tab{padding:16px 24px}.rc-tabs-right{border-left:2px solid #f3f3f3}.rc-tabs-right .rc-tabs-bar{float:right;height:100%;margin-left:10px;border-left:1px solid #f3f3f3}.rc-tabs-right .rc-tabs-nav-container{height:100%}.rc-tabs-right .rc-tabs-nav-container-scrolling{padding-top:32px;padding-bottom:32px}.rc-tabs-right .rc-tabs-nav-wrap{height:100%}.rc-tabs-right .rc-tabs-nav-scroll{height:99999px}.rc-tabs-right .rc-tabs-nav-swipe{position:relative}.rc-tabs-right .rc-tabs-nav-swipe .rc-tabs-nav{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1 1;-ms-flex-direction:column;flex-direction:column;height:100%}.rc-tabs-right .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;-ms-flex-pack:center;justify-content:center}.rc-tabs-right .rc-tabs-tab-next,.rc-tabs-right .rc-tabs-tab-prev{margin-top:-2px;height:0;width:0;display:block;text-align:center;line-height:32px;opacity:0;-webkit-transition:width .3s,height .3s,opacity .3s;-o-transition:width .3s,height .3s,opacity .3s;transition:width .3s,height .3s,opacity .3s}.rc-tabs-top .rc-tabs-tab-arrow-show{width:100%;height:32px}.rc-tabs-right .rc-tabs-tab-next{bottom:0}.rc-tabs-right .rc-tabs-tab-next-icon{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1)}.rc-tabs-right .rc-tabs-tab-next-icon:before{content:\">\"}.rc-tabs-right .rc-tabs-tab-prev{top:2px}.rc-tabs-right .rc-tabs-tab-prev-icon{-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg);filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3)}.rc-tabs-right .rc-tabs-tab-prev-icon:before{content:\">\"}.rc-tabs-right .rc-tabs-content-animated{-ms-flex-direction:column;flex-direction:column}.rc-tabs-right .rc-tabs-content-animated .rc-tabs-tabpane{height:100%}.rc-tabs-right .rc-tabs-ink-bar{width:2px;left:0;top:0}.rc-tabs-right .rc-tabs-tab{padding:16px 24px}.rc-tabs-bottom{border-top:2px solid #f3f3f3}.rc-tabs-bottom .rc-tabs-content{width:100%}.rc-tabs-bottom .rc-tabs-bar{border-top:1px solid #f3f3f3}.rc-tabs-bottom .rc-tabs-nav-container-scrolling{padding-left:32px;padding-right:32px}.rc-tabs-bottom .rc-tabs-nav-scroll{width:99999px}.rc-tabs-bottom .rc-tabs-nav-swipe{position:relative;left:0}.rc-tabs-bottom .rc-tabs-nav-swipe .rc-tabs-nav{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1 1;width:100%}.rc-tabs-bottom .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;margin-right:0;padding:8px 0;-ms-flex-pack:center;justify-content:center}.rc-tabs-bottom .rc-tabs-nav-wrap{width:100%}.rc-tabs-bottom .rc-tabs-content-animated{-ms-flex-direction:row;flex-direction:row}.rc-tabs-bottom .rc-tabs-content-animated .rc-tabs-tabpane{width:100%}.rc-tabs-bottom .rc-tabs-tab-next{right:2px}.rc-tabs-bottom .rc-tabs-tab-next-icon:before{content:\">\"}.rc-tabs-bottom .rc-tabs-tab-prev{left:0}.rc-tabs-bottom .rc-tabs-tab-prev-icon:before{content:\"<\"}.rc-tabs-bottom .rc-tabs-tab-next,.rc-tabs-bottom .rc-tabs-tab-prev{margin-right:-2px;width:32px;height:100%;top:0;text-align:center}.rc-tabs-bottom .rc-tabs-ink-bar{height:2px;top:3px;left:0}.rc-tabs-bottom .rc-tabs-tab{float:left;height:100%;margin-right:30px}.rc-tabs-bottom .rc-tabs-tabpane-inactive{height:0;overflow:visible}.rc-tabs-top{border-bottom:2px solid #f3f3f3}.rc-tabs-top .rc-tabs-content{width:100%}.rc-tabs-top .rc-tabs-bar{border-bottom:1px solid #f3f3f3}.rc-tabs-top .rc-tabs-nav-container-scrolling{padding-left:32px;padding-right:32px}.rc-tabs-top .rc-tabs-nav-scroll{width:99999px}.rc-tabs-top .rc-tabs-nav-swipe{position:relative;left:0}.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1 1;width:100%}.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab{display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;margin-right:0;padding:8px 0;-ms-flex-pack:center;justify-content:center}.rc-tabs-top .rc-tabs-nav-wrap{width:100%}.rc-tabs-top .rc-tabs-content-animated{-ms-flex-direction:row;flex-direction:row}.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane{width:100%}.rc-tabs-top .rc-tabs-tab-next{right:2px}.rc-tabs-top .rc-tabs-tab-next-icon:before{content:\">\"}.rc-tabs-top .rc-tabs-tab-prev{left:0}.rc-tabs-top .rc-tabs-tab-prev-icon:before{content:\"<\"}.rc-tabs-top .rc-tabs-tab-next,.rc-tabs-top .rc-tabs-tab-prev{margin-right:-2px;width:0;height:0;top:0;text-align:center;opacity:0;-webkit-transition:width .3s,height .3s,opacity .3s;-o-transition:width .3s,height .3s,opacity .3s;transition:width .3s,height .3s,opacity .3s}.rc-tabs-top .rc-tabs-tab-arrow-show{opacity:1;width:32px;height:100%}.rc-tabs-top .rc-tabs-ink-bar{height:2px;bottom:0;left:0}.rc-tabs-top .rc-tabs-tab{float:left;height:100%;margin-right:30px}.rc-tabs-top .rc-tabs-tabpane-inactive{height:0;overflow:visible}", "", {"version":3,"sources":["/weaver/ecology/src4js-pctool-v1/node_modules/rc-tabs/assets/index.css"],"names":[],"mappings":"AAMA,6CALE,8BAA+B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,eAAiB,CAgBlB,AAdD,oCAEE,eAAgB,AAChB,gBAAiB,AAKjB,mBAAoB,AACpB,aAAc,AACd,OAAQ,AACR,gCAAiC,AACjC,2BAA4B,AAC5B,uBAAyB,CAC1B,AACD,iBACE,UAAW,AACX,kBAAmB,AACnB,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAiB,AACjB,yBAA0B,AAC1B,6BAA8B,AAC1B,yBAA0B,AACtB,qBAAsB,AAC9B,QAAS,AACT,QAAU,CACX,AACD,0BACE,iNAAoP,AACpP,yMAA4O,AAC5O,oMAAuO,AACvO,iMAAoO,AACpO,gPAA2R,CAC5R,AACD,oCAEE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,UAAW,AACX,iBAAkB,AAClB,eAAgB,AAChB,YAAa,AACb,6BAA8B,AAC9B,iBAAmB,CACpB,AACD,8CAEE,kBAAmB,AACnB,qBAAsB,AACtB,kBAAmB,AACnB,gBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,wBAAyB,AACzB,kBAAmB,AACnB,oBAAqB,AACrB,2BAA4B,AAC5B,oBAAqB,AACrB,sBAAwB,CACzB,AACD,4DAEE,aAAe,CAChB,AACD,0BACE,eAAgB,AAChB,UAAY,CACb,AACD,kBACE,eAAiB,CAClB,AACD,aACE,8BAA+B,AACvB,sBAAuB,AAC/B,eAAgB,AAChB,kBAAmB,AACnB,SAAU,AACV,WAAY,AACZ,gBAAiB,AACjB,qBAAsB,AACtB,6BAA8B,AAC1B,yBAA0B,AACtB,oBAAsB,CAC/B,AACD,sBACE,mEAA0E,AAC1E,2DAAkE,AAClE,sDAA6D,AAC7D,mDAA0D,AAC1D,kGAAiH,CAClH,AACD,uCAEE,cAAe,AACf,WAAa,CACd,AACD,mBACE,UAAY,CACb,AACD,aACE,8BAA+B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,cAAe,AACf,uDAA8D,AAC9D,kDAAyD,AACzD,+CAAsD,AACtD,iBAAkB,AAClB,gBAAiB,AACjB,cAAgB,CACjB,AACD,mBACE,aAAe,CAChB,AACD,8CAEE,cAAe,AACf,eAAgB,AAChB,gCAAiC,AACzB,uBAAyB,CAClC,AACD,sBACE,eAAgB,AAChB,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,iBACE,MAAQ,CACT,AACD,kCACE,aAAe,CAChB,AACD,0BACE,sJAA2K,AAC3K,8IAAmK,AACnK,yIAA8J,AAC9J,sIAA2J,AAC3J,sLAAkN,AAClN,oBAAqB,AACrB,aAAc,AACd,qBAAuB,CACxB,AACD,2CACE,oBAAqB,AACjB,aAAe,CACpB,AACD,6BACE,iCAAmC,AAC/B,6BAA+B,AAC3B,yBAA2B,AACnC,aAAe,CAChB,AACD,0IAGE,YAAc,CACf,AACD,cACE,8BAAgC,CACjC,AACD,2BACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,8BAAgC,CACjC,AACD,qCACE,WAAa,CACd,AACD,+CACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,gCACE,WAAa,CACd,AACD,wCACE,0BAA2B,AACvB,qBAAuB,CAC5B,AACD,yDACE,WAAa,CACd,AACD,kCACE,cAAgB,CACjB,AACD,iCACE,kBAAmB,AACnB,KAAO,CACR,AACD,8CACE,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,SAAU,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,WAAa,CACd,AACD,2DACE,oBAAqB,AACrB,aAAc,AACd,oBAAqB,AACjB,cAAe,AACnB,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,gEAEE,gBAAiB,AACjB,SAAU,AACV,iBAAkB,AAClB,QAAS,AACT,cAAe,AACf,kBAAmB,AACnB,UAAW,AACX,oDAAuD,AACvD,+CAAkD,AAClD,2CAA+C,CAChD,AACD,0JAIE,UAAW,AACX,WAAY,AACZ,WAAa,CACd,AACD,gCACE,QAAU,CACX,AACD,qCACE,gCAAiC,AAC7B,4BAA6B,AACzB,wBAAyB,AACjC,+DAAiE,CAClE,AACD,4CACE,WAAa,CACd,AACD,gCACE,OAAS,CACV,AACD,qCACE,iCAAkC,AAC9B,6BAA8B,AAC1B,yBAA0B,AAClC,+DAAiE,CAClE,AACD,4CACE,WAAa,CACd,AACD,+BACE,UAAW,AACX,QAAS,AACT,KAAO,CACR,AACD,2BACE,iBAAmB,CACpB,AACD,eACE,6BAA+B,CAChC,AACD,4BACE,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,6BAA+B,CAChC,AACD,sCACE,WAAa,CACd,AACD,gDACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,iCACE,WAAa,CACd,AACD,mCACE,cAAgB,CACjB,AACD,kCACE,iBAAmB,CACpB,AACD,+CACE,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,SAAU,AACd,0BAA2B,AACvB,sBAAuB,AAC3B,WAAa,CACd,AACD,4DACE,oBAAqB,AACrB,aAAc,AACd,oBAAqB,AACjB,cAAe,AACnB,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,kEAEE,gBAAiB,AACjB,SAAU,AACV,QAAS,AACT,cAAe,AACf,kBAAmB,AACnB,iBAAkB,AAClB,UAAW,AACX,oDAAuD,AACvD,+CAAkD,AAClD,2CAA+C,CAChD,AACD,qCAEE,WAAY,AACZ,WAAa,CACd,AACD,iCACE,QAAU,CACX,AACD,sCACE,gCAAiC,AAC7B,4BAA6B,AACzB,wBAAyB,AACjC,+DAAiE,CAClE,AACD,6CACE,WAAa,CACd,AACD,iCACE,OAAS,CACV,AACD,sCACE,iCAAkC,AAC9B,6BAA8B,AAC1B,yBAA0B,AAClC,+DAAiE,CAClE,AACD,6CACE,WAAa,CACd,AACD,yCACE,0BAA2B,AACvB,qBAAuB,CAC5B,AACD,0DACE,WAAa,CACd,AACD,gCACE,UAAW,AACX,OAAQ,AACR,KAAO,CACR,AACD,4BACE,iBAAmB,CACpB,AACD,gBACE,4BAA8B,CAC/B,AACD,iCACE,UAAY,CACb,AACD,6BACE,4BAA8B,CAC/B,AACD,iDACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,oCACE,aAAe,CAChB,AACD,mCACE,kBAAmB,AACnB,MAAQ,CACT,AACD,gDACE,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,SAAU,AACd,UAAY,CACb,AACD,6DACE,oBAAqB,AACrB,aAAc,AACd,oBAAqB,AACjB,cAAe,AACnB,eAAgB,AAChB,cAAe,AACf,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,kCACE,UAAY,CACb,AACD,0CACE,uBAAwB,AACpB,kBAAoB,CACzB,AACD,2DACE,UAAY,CACb,AACD,kCACE,SAAW,CACZ,AACD,8CACE,WAAa,CACd,AACD,kCACE,MAAQ,CACT,AACD,8CACE,WAAa,CACd,AACD,oEAEE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,MAAO,AACP,iBAAmB,CACpB,AACD,iCACE,WAAY,AACZ,QAAS,AACT,MAAQ,CACT,AACD,6BACE,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,0CACE,SAAU,AACV,gBAAkB,CACnB,AACD,aACE,+BAAiC,CAClC,AACD,8BACE,UAAY,CACb,AACD,0BACE,+BAAiC,CAClC,AACD,8CACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,iCACE,aAAe,CAChB,AACD,gCACE,kBAAmB,AACnB,MAAQ,CACT,AACD,6CACE,oBAAqB,AACrB,aAAc,AACd,WAAY,AACR,SAAU,AACd,UAAY,CACb,AACD,0DACE,oBAAqB,AACrB,aAAc,AACd,oBAAqB,AACjB,cAAe,AACnB,eAAgB,AAChB,cAAe,AACf,qBAAsB,AAClB,sBAAwB,CAC7B,AACD,+BACE,UAAY,CACb,AACD,uCACE,uBAAwB,AACpB,kBAAoB,CACzB,AACD,wDACE,UAAY,CACb,AACD,+BACE,SAAW,CACZ,AACD,2CACE,WAAa,CACd,AACD,+BACE,MAAQ,CACT,AACD,2CACE,WAAa,CACd,AACD,8DAEE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,MAAO,AACP,kBAAmB,AACnB,UAAW,AACX,oDAAuD,AACvD,+CAAkD,AAClD,2CAA+C,CAChD,AACD,qCACE,UAAW,AACX,WAAY,AACZ,WAAa,CACd,AACD,8BACE,WAAY,AACZ,SAAU,AACV,MAAQ,CACT,AACD,0BACE,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,uCACE,SAAU,AACV,gBAAkB,CACnB","file":"index.css","sourcesContent":[".rc-tabs {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  -webkit-transition: padding .45s;\n  -o-transition: padding .45s;\n  transition: padding .45s;\n}\n.rc-tabs-ink-bar {\n  z-index: 1;\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin-top: -3px;\n  background-color: #108ee9;\n  -webkit-transform-origin: 0 0;\n      -ms-transform-origin: 0 0;\n          transform-origin: 0 0;\n  width: 0;\n  height: 0;\n}\n.rc-tabs-ink-bar-animated {\n  -webkit-transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), height 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), height 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  -o-transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), height 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), height 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), left 0.3s cubic-bezier(0.35, 0, 0.25, 1), top 0.3s cubic-bezier(0.35, 0, 0.25, 1), height 0.3s cubic-bezier(0.35, 0, 0.25, 1), width 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n}\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: #ccc;\n}\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n.rc-tabs-nav {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  -webkit-transform-origin: 0 0;\n      -ms-transform-origin: 0 0;\n          transform-origin: 0 0;\n}\n.rc-tabs-nav-animated {\n  -webkit-transition: -webkit-transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: -webkit-transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n  -o-transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n.rc-tabs-nav:after {\n  clear: both;\n}\n.rc-tabs-tab {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  position: relative;\n  display: block;\n  -webkit-transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  -o-transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.rc-tabs-tab:hover {\n  color: #23c0fa;\n}\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: #108ee9;\n  cursor: default;\n  -webkit-transform: translateZ(0);\n          transform: translateZ(0);\n}\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: #ccc;\n}\n.rc-tabs-tab-disabled:hover {\n  color: #ccc;\n}\n.rc-tabs-content {\n  zoom: 1;\n}\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: auto;\n}\n.rc-tabs-content-animated {\n  -webkit-transition: margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  -o-transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1), -webkit-transform 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.no-flexbox .rc-tabs-content {\n  -webkit-transform: none !important;\n      -ms-transform: none !important;\n          transform: none !important;\n  overflow: auto;\n}\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n.rc-tabs-left {\n  border-right: 2px solid #f3f3f3;\n}\n.rc-tabs-left .rc-tabs-bar {\n  float: left;\n  height: 100%;\n  margin-right: 10px;\n  border-right: 1px solid #f3f3f3;\n}\n.rc-tabs-left .rc-tabs-nav-container {\n  height: 100%;\n}\n.rc-tabs-left .rc-tabs-nav-container-scrolling {\n  padding-top: 32px;\n  padding-bottom: 32px;\n}\n.rc-tabs-left .rc-tabs-nav-wrap {\n  height: 100%;\n}\n.rc-tabs-left .rc-tabs-content-animated {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.rc-tabs-left .rc-tabs-content-animated .rc-tabs-tabpane {\n  height: 100%;\n}\n.rc-tabs-left .rc-tabs-nav-scroll {\n  height: 99999px;\n}\n.rc-tabs-left .rc-tabs-nav-swipe {\n  position: relative;\n  top: 0;\n}\n.rc-tabs-left .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1 1;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100%;\n}\n.rc-tabs-left .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.rc-tabs-left .rc-tabs-tab-prev,\n.rc-tabs-left .rc-tabs-tab-next {\n  margin-top: -2px;\n  height: 0;\n  line-height: 32px;\n  width: 0;\n  display: block;\n  text-align: center;\n  opacity: 0;\n  -webkit-transition: width .3s, height .3s, opacity .3s;\n  -o-transition: width .3s, height .3s, opacity .3s;\n  transition: width .3s, height .3s, opacity .3s;\n}\n.rc-tabs-top .rc-tabs-tab-arrow-show,\n.rc-tabs-left .rc-tabs-tab-arrow-show,\n.rc-tabs-bottom .rc-tabs-tab-arrow-show,\n.rc-tabs-right .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 32px;\n}\n.rc-tabs-left .rc-tabs-tab-next {\n  bottom: 0;\n}\n.rc-tabs-left .rc-tabs-tab-next-icon {\n  -webkit-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n          transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n.rc-tabs-left .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n.rc-tabs-left .rc-tabs-tab-prev {\n  top: 2px;\n}\n.rc-tabs-left .rc-tabs-tab-prev-icon {\n  -webkit-transform: rotate(270deg);\n      -ms-transform: rotate(270deg);\n          transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n.rc-tabs-left .rc-tabs-tab-prev-icon:before {\n  content: \">\";\n}\n.rc-tabs-left .rc-tabs-ink-bar {\n  width: 2px;\n  right: 0;\n  top: 0;\n}\n.rc-tabs-left .rc-tabs-tab {\n  padding: 16px 24px;\n}\n.rc-tabs-right {\n  border-left: 2px solid #f3f3f3;\n}\n.rc-tabs-right .rc-tabs-bar {\n  float: right;\n  height: 100%;\n  margin-left: 10px;\n  border-left: 1px solid #f3f3f3;\n}\n.rc-tabs-right .rc-tabs-nav-container {\n  height: 100%;\n}\n.rc-tabs-right .rc-tabs-nav-container-scrolling {\n  padding-top: 32px;\n  padding-bottom: 32px;\n}\n.rc-tabs-right .rc-tabs-nav-wrap {\n  height: 100%;\n}\n.rc-tabs-right .rc-tabs-nav-scroll {\n  height: 99999px;\n}\n.rc-tabs-right .rc-tabs-nav-swipe {\n  position: relative;\n}\n.rc-tabs-right .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1 1;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 100%;\n}\n.rc-tabs-right .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.rc-tabs-right .rc-tabs-tab-prev,\n.rc-tabs-right .rc-tabs-tab-next {\n  margin-top: -2px;\n  height: 0;\n  width: 0;\n  display: block;\n  text-align: center;\n  line-height: 32px;\n  opacity: 0;\n  -webkit-transition: width .3s, height .3s, opacity .3s;\n  -o-transition: width .3s, height .3s, opacity .3s;\n  transition: width .3s, height .3s, opacity .3s;\n}\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 32px;\n}\n.rc-tabs-right .rc-tabs-tab-next {\n  bottom: 0;\n}\n.rc-tabs-right .rc-tabs-tab-next-icon {\n  -webkit-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n          transform: rotate(90deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n}\n.rc-tabs-right .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n.rc-tabs-right .rc-tabs-tab-prev {\n  top: 2px;\n}\n.rc-tabs-right .rc-tabs-tab-prev-icon {\n  -webkit-transform: rotate(270deg);\n      -ms-transform: rotate(270deg);\n          transform: rotate(270deg);\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n}\n.rc-tabs-right .rc-tabs-tab-prev-icon:before {\n  content: \">\";\n}\n.rc-tabs-right .rc-tabs-content-animated {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.rc-tabs-right .rc-tabs-content-animated .rc-tabs-tabpane {\n  height: 100%;\n}\n.rc-tabs-right .rc-tabs-ink-bar {\n  width: 2px;\n  left: 0;\n  top: 0;\n}\n.rc-tabs-right .rc-tabs-tab {\n  padding: 16px 24px;\n}\n.rc-tabs-bottom {\n  border-top: 2px solid #f3f3f3;\n}\n.rc-tabs-bottom .rc-tabs-content {\n  width: 100%;\n}\n.rc-tabs-bottom .rc-tabs-bar {\n  border-top: 1px solid #f3f3f3;\n}\n.rc-tabs-bottom .rc-tabs-nav-container-scrolling {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n.rc-tabs-bottom .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n.rc-tabs-bottom .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n.rc-tabs-bottom .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1 1;\n  width: 100%;\n}\n.rc-tabs-bottom .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.rc-tabs-bottom .rc-tabs-nav-wrap {\n  width: 100%;\n}\n.rc-tabs-bottom .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n.rc-tabs-bottom .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n.rc-tabs-bottom .rc-tabs-tab-next {\n  right: 2px;\n}\n.rc-tabs-bottom .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n.rc-tabs-bottom .rc-tabs-tab-prev {\n  left: 0;\n}\n.rc-tabs-bottom .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n.rc-tabs-bottom .rc-tabs-tab-prev,\n.rc-tabs-bottom .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 32px;\n  height: 100%;\n  top: 0;\n  text-align: center;\n}\n.rc-tabs-bottom .rc-tabs-ink-bar {\n  height: 2px;\n  top: 3px;\n  left: 0;\n}\n.rc-tabs-bottom .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  margin-right: 30px;\n}\n.rc-tabs-bottom .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n.rc-tabs-top {\n  border-bottom: 2px solid #f3f3f3;\n}\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n.rc-tabs-top .rc-tabs-bar {\n  border-bottom: 1px solid #f3f3f3;\n}\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 32px;\n  padding-right: 32px;\n}\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n      flex: 1 1;\n  width: 100%;\n}\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n}\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  -webkit-transition: width .3s, height .3s, opacity .3s;\n  -o-transition: width .3s, height .3s, opacity .3s;\n  transition: width .3s, height .3s, opacity .3s;\n}\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 32px;\n  height: 100%;\n}\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 2px;\n  bottom: 0;\n  left: 0;\n}\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  margin-right: 30px;\n}\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);

// exports


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js?v=e9310642